import { Component, OnInit, ViewChild, OnDestroy, ViewContainerRef, Output, EventEmitter, OnChanges, Input } from '@angular/core';
import {DemoService} from '../../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router} from '@angular/router';

// import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';

// ag- table component

import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
// import { CustomiszedCellComponent } from '../customiszed-cell/customiszed-cell.component';
// import { CustomCellJobTypeComponent } from '../custom-cell-job-type/custom-cell-job-type.component';
// import { CustomCellJobLinkComponent } from '../custom-cell-job-link/custom-cell-job-link.component';
// import { CustomCellDateComponent } from '../custom-cell-date/custom-cell-date.component';

// 
import { forkJoin } from 'rxjs';
import { enableRipple } from '@syncfusion/ej2-base';
// enable ripple effects
enableRipple(true);
import { DataManager, ODataAdaptor, WebApiAdaptor, UrlAdaptor,Query, ReturnOption  } from '@syncfusion/ej2-data';
import { MenuItemModel } from '@syncfusion/ej2-angular-navigations';
import { PageSettingsModel, FilterSettingsModel } from '@syncfusion/ej2-grids';

import { ChangeEventArgs } from '@syncfusion/ej2-inputs';
import { createElement } from '@syncfusion/ej2-base';
import {  IFilter, PdfExportService, PageService, SearchSettingsModel, RowSelectEventArgs, GroupService } from '@syncfusion/ej2-angular-grids';
import { GridComponent, ToolbarItems, ToolbarService, ExcelExportService, GroupSettingsModel,
RowDataBoundEventArgs, FilterType } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';
import { delay } from 'rxjs';

import { FilterService, IFilterUI, Column, DateFilterUI } from '@syncfusion/ej2-angular-grids';
import { DatePicker, DateRangePicker } from '@syncfusion/ej2-calendars';
import { EditService, SortService,  SelectionSettingsModel } from '@syncfusion/ej2-angular-grids';
import { DataUtil } from '@syncfusion/ej2-data'; 
import { ButtonComponent } from '@syncfusion/ej2-angular-buttons';


import { parentsUntil } from '@syncfusion/ej2-grids';
import { pipe, Observable, Subject, map } from 'rxjs';
import { MysqlService } from './../../../services/mysql.service';

// import {JobsAgentUpdateRequestComponent} from '../jobs-urgent/jobs-agent-update-request/jobs-agent-update-request.component';

import { GlobalFunctionsService } from './../../../services/global-functions.service';
import { LegalDateTimeService } from './../../../services/legal-datetime.service';
import { SearchContact } from 'src/app/shared/models/searchContact.model';
import { JobSubject } from 'src/app/shared/models/jobSubject.model';

import * as moment from 'moment';
// Using Loadash in Angular
// ::@ https://edupala.com/how-to-use-lodash-in-angular/
import * as _ from 'lodash';
import { SubjectUrgentOutcomeTemplate } from 'src/app/shared/models/subjectUrgentOutcomeTemplate.model';
import { Brand } from 'src/app/shared/models/brand.model';


@Component({
  selector: 'app-jobs-urgent-timeframes',
  templateUrl: './jobs-urgent-timeframes.component.html',
  styleUrls: ['./jobs-urgent-timeframes.component.scss'],
    providers: [ToolbarService, ExcelExportService, EditService, ToolbarService, PageService, FilterService, SortService, GroupService]
})
export class JobsUrgentTimeframesComponent implements OnInit {


// added to be included as a component as well
@Input() item_id?; // impliments on changes.
@Input() item_data?; // if data.model is sent : Observable<any[]>;
@Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
@Input() item_user_level_id? = '5'; // default to agent just in case
@Input() item_brand_type_id? = '';
@Input() show_buttons? = 'no'; // yes | no
@Input() widget_title? = '';
@Input() widget_size? = 'full'; // side | abstract | full


isShow_note_template = false;
isShow_email_template = false;

  job_table: any;
  result: any;
  client_name: any;
  persons: any;
  job_table2: any;
  client_name_value: any;
 responseDelay = 2000;
  clients: any;
  clientLocalRecord: any;
  job_types: any;
  subjects: any;
  agents_assigned: any;
  staffList: any;
  items: Object[];
  data_subjects2: any;
  initialPage: PageSettingsModel;

  jobTypesLocalRecord: any;
  changeObject: any;

  subjectLocalRecord: any;

  createdAt: any;
  nextDateLocalRecord: any;

  agentsAssignedLocalRecord: any;
  allocated_agents_list: any;

  public data: DataManager;
  public data_subjects: DataManager;
  public pageSettings: Object;
  public pageOptions = { pageSize: 25 }; 
  public filterOptions: FilterSettingsModel;
  public filterOptions_2022: FilterSettingsModel;
  public formatOptions: Object;
  // public filterOptions: FilterSettingsModel;
  public filter : IFilter;
  public toolbarOptions: ToolbarItems[] | object;
  @ViewChild('grid')
  public grid: GridComponent;

  public groupOptions: GroupSettingsModel;
  public templateOptionsDate: IFilterUI;
  public elem1: HTMLElement;
  public datePickerObj: DatePicker;

  job_table3: any; // filtered results of job table2 to load properly
  brands: any;
  brandsLocalRecord: any;
  brandLocalRecord: any;
  subject_agents_assigned: any;
  subjectsAssignedLocalRecord: any;
  allocated_agents_subject_list: any;
  brandAgentsList: any;
  assignedBrandList: any;
  public toolbar: ToolbarItems[] | object;

  search_results: any;
  search_results_processed: Array<{subject_id: number, email_sent: string}> = [];

httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  filterSettings: Object;
  public templateOptions: IFilter;
  public dateRangePicker: DateRangePicker;
  
  combo_model: Brand;

// Evemt Emmitter to child Component
  eventsSubject: Subject<void> = new Subject<void>();
  search_resultsO: any;
  subject_sent: any;
  currentUserVAR: any;
  sessionUserId: any;
  sessionBrandId: any;
  brand_id: any;
  subject_id: any;
  get_latest_subject_note_id: Object;
  sessionUserUserName: any;
  sr: any;
  subjects_urgent: any;
  formatoptions: { type: string; format: string; };
  dateFormat: string;

  today = new Date();

  sessionUsername: any;
  all_router_details: string;
  subjects_urgent_table: any;
  assignedAgentsList: any;
  allRecipients: any;
  assigned_to_agents: string;
  user_levels: Object;
  brand_types: Object;
  brand_user_join_results: any[];
  brand_search: Object;
  brand_search_results: any;
  user_search: Object;
  user_search_results: any;
  users: Object;
  usersPrimary: Object;
  todaySetFormat: any;
  rule_text_OPEN: string;
  rule_email_text_OPEN: any;
  rule_text_UPDREQ: string;
  rule_email_text_UPDREQ: string;
  selectedrecords: Object[];
  rule_text_UPDSENT: string;
  rule_email_text_UPDSENT: string;
  rule_text_AOA: string;
  rule_email_text_AOA: string;
  subject_urgent_outcome_template: any;
  job_service_rule_paragraphs: Object;
  selected_job_service_rule_description: string;
  job_service_timeframe_paragraphs: Object;
  subject_service_type_model_paragraphs: Object;
  subject_contact_numbers_paragraphs: any;
  subject_contact_numbers: string;
  subject_contact_emails_paragraphs: any;
  subject_contact_emails: string;
  assignedBrandList_paragraphs: Object;
  subject_service_list_paragraphs: Object;
  attempts_paragraphs_model: any;
  service_paragraphs_model: any;
  subject_service_agent: any;
  job_type_locations_paragraphs: Object;
  job_type_location_paragraphs: Object;
  job_type_paragraphs: Object;
  job_type_courts_paragraphs: Object;
  job_type_court_paragraphs: Object;
  job_type_document_type_paragraphs: Object;
  job_type_affidavit_type_paragraphs: Object;
  job_report_client_user_paragraphs: Object;
  current_user_paragraphs: Object;
  job_data_paragraphs: any;
  registry_name: any;
  job_registry_name_Upper: any;
  job_subject_type: Object;
  subject_job_subject_type: any;
  job_report_client: any;
  brand_data: Object;
  allClientEmailRecipients: Object;
  brand_account_data: Object;
  brand_user_data: Object;
  allLoginEmailRecipients: Object;
  allClientInvoiceEmailRecipients: Object;
  job_type_name: any;
  job_type_name_Upper: any;
  job_type_location_name: any;
  job_type_location_name_Upper: any;
  job_type_court_name: any;
  job_type_court_name_Upper: any;
  job_type_document_type_name: any;
  job_type_document_type_name_Upper: any;
  job_service_rule_name: any;
  job_service_rule_description: any;
  job_service_timeframe_name: any;
  job_service_timeframe_text: any;
  subject_service_type_name: any;
  subject_service_type_description: any;
  subject_service_type_staff_instructions: any;
  subject_service_type_agent_instructions: any;
  subject_service_type_instructions: any;
  job_type_affidavit_type_name: any;
  job_type_affidavit_type_name_Upper: any;
  job_subject_type_name: any;
  job_subject_type_name_Upper: any;
  subject_gender_descriptor: string;
  message_subject_var: string;
  subject_number: string;
  client_reference: string;
  doc_name_var: any;
  doc_check: any;
  job_invoice_client_paragraphs: any;
  job_owner_client_paragraphs: any;
  user_brand_paragraphs: any;
  job_special_instructions_HTML: any;
  message_subject: any;
  var_subject_attempt_type_name_Upper: any;
  person_spoken_with_advised_HTML: any;
  vehicles_notes_HTML: any;
  neighbours_notes_HTML: any;
  calling_card_notes_HTML: any;
  postal_mail_notes_HTML: any;
  phone_call_notes_HTML: any;
  attempts_notes_HTML: any;
  email_contents_HTML: any;
  set_general_notes: any;
  property_forsale_or_lease_sign_details_HTML: any;
  property_mail_details_HTML: any;
  property_vehicles_sighted_details_HTML: any;
  property_pets_details_HTML: any;
  property_occupancy_details_HTML: any;
  property_condition_HTML: any;
  property_occupied_details_HTML: any;
  set_property_type_details_HTML: any;
  set_service_paragraph_rendered: string;
  property_images: any;
  propery_image_0: string;
  propery_image_1: string;
  propery_image_2: string;
  propery_image_3: string;
  propery_image_4: string;
  propery_image_5: string;
  propery_image_6: string;
  propery_image_7: string;
  propery_image_8: string;
  propery_image_9: string;
  propery_image_10: string;
  propery_image_11: string;
  propery_image_12: string;
  propery_image_13: string;
  propery_image_14: string;
  propery_image_15: string;
  propery_image_16: string;
  propery_image_17: string;
  propery_image_18: string;
  propery_image_19: string;
  propery_image_20: string;
  propery_image_21: string;
  propery_image_22: string;
  propery_image_23: string;
  propery_image_24: string;
  propery_image_25: string;
  property_sign_images: any;
  property_sign_image_0: string;
  property_sign_image_1: string;
  property_sign_image_2: string;
  property_sign_image_3: string;
  property_sign_image_4: string;
  property_sign_image_5: string;
  property_sign_image_6: string;
  property_sign_image_7: string;
  property_sign_image_8: string;
  property_sign_image_9: string;
  property_sign_image_10: string;
  property_sign_image_11: string;
  property_sign_image_12: string;
  property_sign_image_13: string;
  property_sign_image_14: string;
  property_sign_image_15: string;
  property_sign_image_16: string;
  property_sign_image_17: string;
  property_sign_image_18: string;
  property_sign_image_19: string;
  property_sign_image_20: string;
  property_sign_image_21: string;
  property_sign_image_22: string;
  property_sign_image_23: string;
  property_sign_image_24: string;
  property_sign_image_25: string;
  property_mail_images: any;
  property_mail_image_0: string;
  property_mail_image_1: string;
  property_mail_image_2: string;
  property_mail_image_3: string;
  property_mail_image_4: string;
  property_mail_image_5: string;
  property_mail_image_6: string;
  property_mail_image_7: string;
  property_mail_image_8: string;
  property_mail_image_9: string;
  property_mail_image_10: string;
  property_mail_image_11: string;
  property_mail_image_12: string;
  property_mail_image_13: string;
  property_mail_image_14: string;
  property_mail_image_15: string;
  property_mail_image_16: string;
  property_mail_image_17: string;
  property_mail_image_18: string;
  property_mail_image_19: string;
  property_mail_image_20: string;
  property_mail_image_21: string;
  property_mail_image_22: string;
  property_mail_image_23: string;
  property_mail_image_24: string;
  property_mail_image_25: string;
  property_vehicles_images: any;
  property_vehicles_image_0: string;
  property_vehicles_image_1: string;
  property_vehicles_image_2: string;
  property_vehicles_image_3: string;
  property_vehicles_image_4: string;
  property_vehicles_image_5: string;
  property_vehicles_image_6: string;
  property_vehicles_image_7: string;
  property_vehicles_image_8: string;
  property_vehicles_image_9: string;
  property_vehicles_image_10: string;
  property_vehicles_image_11: string;
  property_vehicles_image_12: string;
  property_vehicles_image_13: string;
  property_vehicles_image_14: string;
  property_vehicles_image_15: string;
  property_vehicles_image_16: string;
  property_vehicles_image_17: string;
  property_vehicles_image_18: string;
  property_vehicles_image_19: string;
  property_vehicles_image_20: string;
  property_vehicles_image_21: string;
  property_vehicles_image_22: string;
  property_vehicles_image_23: string;
  property_vehicles_image_24: string;
  property_vehicles_image_25: string;
  property_pets_images: any;
  property_pets_image_0: string;
  property_pets_image_1: string;
  property_pets_image_2: string;
  property_pets_image_3: string;
  property_pets_image_4: string;
  property_pets_image_5: string;
  property_pets_image_6: string;
  property_pets_image_7: string;
  property_pets_image_8: string;
  property_pets_image_9: string;
  property_pets_image_10: string;
  property_pets_image_11: string;
  property_pets_image_12: string;
  property_pets_image_13: string;
  property_pets_image_14: string;
  property_pets_image_15: string;
  property_pets_image_16: string;
  property_pets_image_17: string;
  property_pets_image_18: string;
  property_pets_image_19: string;
  property_pets_image_20: string;
  property_pets_image_21: string;
  property_pets_image_22: string;
  property_pets_image_23: string;
  property_pets_image_24: string;
  property_pets_image_25: string;
  property_occupancy_images: any;
  property_occupancy_image_0: string;
  property_occupancy_image_1: string;
  property_occupancy_image_2: string;
  property_occupancy_image_3: string;
  property_occupancy_image_4: string;
  property_occupancy_image_5: string;
  property_occupancy_image_6: string;
  property_occupancy_image_7: string;
  property_occupancy_image_8: string;
  property_occupancy_image_9: string;
  property_occupancy_image_10: string;
  property_occupancy_image_11: string;
  property_occupancy_image_12: string;
  property_occupancy_image_13: string;
  property_occupancy_image_14: string;
  property_occupancy_image_15: string;
  property_occupancy_image_16: string;
  property_occupancy_image_17: string;
  property_occupancy_image_18: string;
  property_occupancy_image_19: string;
  property_occupancy_image_20: string;
  property_occupancy_image_21: string;
  property_occupancy_image_22: string;
  property_occupancy_image_23: string;
  property_occupancy_image_24: string;
  property_occupancy_image_25: string;
  property_condition_images: any;
  property_condition_image_0: string;
  property_condition_image_1: string;
  property_condition_image_2: string;
  property_condition_image_3: string;
  property_condition_image_4: string;
  property_condition_image_5: string;
  property_condition_image_6: string;
  property_condition_image_7: string;
  property_condition_image_8: string;
  property_condition_image_9: string;
  property_condition_image_10: string;
  property_condition_image_11: string;
  property_condition_image_12: string;
  property_condition_image_13: string;
  property_condition_image_14: string;
  property_condition_image_15: string;
  property_condition_image_16: string;
  property_condition_image_17: string;
  property_condition_image_18: string;
  property_condition_image_19: string;
  property_condition_image_20: string;
  property_condition_image_21: string;
  property_condition_image_22: string;
  property_condition_image_23: string;
  property_condition_image_24: string;
  property_condition_image_25: string;
  property_type_images: any;
  property_type_image_0: string;
  property_type_image_1: string;
  property_type_image_2: string;
  property_type_image_3: string;
  property_type_image_4: string;
  property_type_image_5: string;
  property_type_image_6: string;
  property_type_image_7: string;
  property_type_image_8: string;
  property_type_image_9: string;
  property_type_image_10: string;
  property_type_image_11: string;
  property_type_image_12: string;
  property_type_image_13: string;
  property_type_image_14: string;
  property_type_image_15: string;
  property_type_image_16: string;
  property_type_image_17: string;
  property_type_image_18: string;
  property_type_image_19: string;
  property_type_image_20: string;
  property_type_image_21: string;
  property_type_image_22: string;
  property_type_image_23: string;
  property_type_image_24: string;
  property_type_image_25: string;
  service_file_array_images: any;
  service_file_array_image_0: string;
  service_file_array_image_1: string;
  service_file_array_image_2: string;
  service_file_array_image_3: string;
  service_file_array_image_4: string;
  service_file_array_image_5: string;
  service_file_array_image_6: string;
  service_file_array_image_7: string;
  service_file_array_image_8: string;
  service_file_array_image_9: string;
  service_file_array_image_10: string;
  service_file_array_image_11: string;
  service_file_array_image_12: string;
  service_file_array_image_13: string;
  service_file_array_image_14: string;
  service_file_array_image_15: string;
  service_file_array_image_16: string;
  service_file_array_image_17: string;
  service_file_array_image_18: string;
  service_file_array_image_19: string;
  service_file_array_image_20: string;
  service_file_array_image_21: string;
  service_file_array_image_22: string;
  service_file_array_image_23: string;
  service_file_array_image_24: string;
  service_file_array_image_25: string;
  rule_text_AOS: string;
  rule_email_text_AOS: string;
  job_status_run: any;
  asyncResult?;
  chosen_template: any;
  chosen_subject: any;
  chosen_template_private: any;
  chosen_subject_private: any;
  chosen_note_template: any;
  chosen_note_template_private: any;
  resultMessage: string;
  brands_client: any;
  brands_agent: any;
  sent_brand_id: any;
  brand_users: any;
  brand_users_data: Object;
  brand_report_selected: Object;
  selected_brand_data: any;
  new_special_instuctions: any;
  model: any;
  job_status: any;
  job_status_data: any;
  timeframe_surcharges: any;

  // target the submit button to auto submit the form

  emitEventToChild() {
    this.eventsSubject = this.search_results;
    this.eventsSubject.next();

    this.search_resultsO = this.search_results;
  }

  public searchOptions: SearchSettingsModel;

  // custom search
  // search_model: SearchContact;
  search_model: JobSubject;

 // Text editor Settings
 public simpleToolBar: object = {
  type: 'Expand',
  enableFloating: false,
  items: ['Bold', 'Italic', 'Underline', 'StrikeThrough',
  'FontName', 'FontSize', 'FontColor', 'BackgroundColor',
  'LowerCase', 'UpperCase', '|',
  'Formats', 'Alignments', 'OrderedList', 'UnorderedList',
  'Outdent', 'Indent', '|',
  'CreateLink', '|', 'ClearFormat', 'Print',
  'SourceCode', '|', 'Undo', 'Redo',
  // {
  //   tooltipText: 'Insert Promotion',
  //   undo: true,
  //   click: this.onClickPromotionButton.bind(this),
  //   template: '<button type="button" class="btn btn-default"><i class="fa fa-qrcode"></i></button>'
  // }
],
table: ['TableHeader', 'TableRows', 'TableColumns', 'TableCell', '-', 'BackgroundColor', 'TableRemove', 'TableCellVerticalAlign', 'Styles']
  };
  public pasteCleanupSettings: object = {
    prompt: true,
    plainText: false,
    keepFormat: false,
    deniedTags: ['a'],
    deniedAttrs: ['class', 'title', 'id'],
    allowedStyleProps: ['color', 'margin', 'font-size']
}; 

public selectionOptions: SelectionSettingsModel;

public brand_fields: Object = { text: 'NameAndAddress', value: 'brand_id' };
client_fields: Object = { text: 'user_full_name', value: 'user_id' };

  constructor(
    private http: HttpClient, private router: Router, route: ActivatedRoute, private _demoService: DemoService,
    public datepipe: DatePipe,
    public toastr: HotToastService,
    vcr: ViewContainerRef,
    private _mysqlService: MysqlService, 
    public gfunc: GlobalFunctionsService,
    public legalDate: LegalDateTimeService,
    
  ) {

    // yyyy-MM-dd
    this.todaySetFormat = this.legalDate.format(new Date(), 'DD/MM/YYYY');
    
//    this.mapJobTableLive(); // load the table data
// Set and Access login Session Variables
this.gfunc.setLoginSessionVars(); // set in a global function file
this.sessionUserId = this.gfunc.currentUserVAR.user_id;
this.sessionUsername = this.gfunc.currentUserVAR.username;
this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;

// need to add this as routes does not work globally
this.all_router_details = this.router.url;
this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));

this.rule_text_OPEN = 'If subject status OPEN, and final date null or not yet set, Status will be changed to UPDREQ and filinal date and next changed to now. If final date is less then the date and time now the next date will be set to the final date and final date remains. if the final date is greater than now the next date becomes now and the final date remains. '; // this will be the content for the actual rule for what happens so I can output to screens and test.
this.rule_email_text_OPEN = 'Agent will recieve First Email - Please provide an update in relation to the above named matter';

this.rule_text_UPDREQ = 'If subject status UPDREQ, and final date null or not yet set it to now, Status will be NOT be changed. If the final date is less than now set next date to now. Else the next date will stay unchanged. '; // this will be the content for the actual rule for what happens so I can output to screens and test.
this.rule_email_text_UPDREQ = 'Agent will recieve Update Email - We refer to our previous update request and now request an urgent update in relation to the above matter.';

this.rule_text_UPDSENT = 'If subject status UPDSENT, and final date null or not yet set it to now, final date unchanged. Status will be changed to UPDREQ. If the final date is less than now set next date to now. Else the next date will stay unchanged. '; // this will be the content for the actual rule for what happens so I can output to screens and test.
this.rule_email_text_UPDSENT = 'Agent will recieve Update Email - Please provide an update in relation to the above named matter.';

this.rule_text_AOS = 'Can you Please supply again... I cannot seem to find them from years ago '; // this will be the content for the actual rule for what happens so I can output to screens and test.
this.rule_email_text_AOS = 'Agent will recieve Update Email - We are yet to receive a swarn Affidavit of Service for this matter. Please advise as soon as possible when we can expect to receive the original copy';

this.rule_text_AOA = 'If subject status AOA, and final date null or not yet set it to now, final date unchanged, next date will be now. Status will be NOT be changed. If the final date is less than now set next date to the final date. '; // this will be the content for the actual rule for what happens so I can output to screens and test.
this.rule_email_text_AOA = 'Agent will recieve Update Email - We are yet to recieve a swarn Affidavit of Attempt of Service in this matter. Please advise as soon as possible....';




// // login vars
// this.currentUserVAR = JSON.parse(sessionStorage.getItem('currentUser'));
// // Set loggind in User Value (USER ID)
// this.sessionUserId = this.currentUserVAR.user_id;
// this.sessionUserUserName = this.currentUserVAR.username;
// this.sessionBrandId = this.currentUserVAR.brand_id;
this.brand_id = this.sessionBrandId;
// this.toastr.setRootViewContainerRef(vcr);


   }

  private normalizeLegalSearchModel(search_model: any): any {
    const normalized = { ...search_model };

    normalized.next_date_from = this.legalDate.toStartOfDayIso(search_model?.next_date_from);
    normalized.next_date_to = this.legalDate.toEndOfDayIso(search_model?.next_date_to);
    normalized.final_date_from = this.legalDate.toStartOfDayIso(search_model?.final_date_from);
    normalized.final_date_to = this.legalDate.toEndOfDayIso(search_model?.final_date_to);
    normalized.hearing_date_from = this.legalDate.toStartOfDayIso(search_model?.hearing_date_from);
    normalized.hearing_date_to = this.legalDate.toEndOfDayIso(search_model?.hearing_date_to);

    return normalized;
  }

  private normalizeLegalUpdateValue(value: unknown): unknown {
    if (value === null || value === undefined || value === '') {
      return null;
    }

    const pickerDate = this.legalDate.coercePickerDate(value);
    return pickerDate ? this.legalDate.fromPickerDate(pickerDate) : value;
  }

  private normalizeSubjectUpdatePayload(result: any): any {
    return {
      ...result,
      update_next_date: this.normalizeLegalUpdateValue(result?.update_next_date),
      update_final_date: this.normalizeLegalUpdateValue(result?.update_final_date)
    };
  }


  // check for changes. to load data.
  ngOnChanges(changes) {

   

    if (changes.item_id) {

// ... custom search
this.search_model = new JobSubject();
// this.search_model = new SearchContact();
this.getFormUserLevels();
this.getBrandBrandTypes();
this.getJobStatusNames() // load the drop down
this.getTimeframeSurcharges();

      this.getJobSubjectsUrgentTimeframeTable();
      // this.refreshGrid();
      
      // deal with asynchronous Observable result
      // this.job_id = changes.item_id.currentValue;
      // this.getJob(this.job_id);
    }
  }


  ngOnInit() {

// ... custom search
this.search_model = new JobSubject();
// this.search_model = new SearchContact();
this.getFormUserLevels();
this.getBrandBrandTypes();
this.getJobStatusNames() // load the drop down
this.getTimeframeSurcharges();


this.combo_model = new Brand(); // loads the Trace model into the model vars for the form.
    this.getBrandsComboBoxClients(this.combo_model);
    this.getBrandsComboBoxAgents(this.combo_model);
    this.getJobTypes();

   // this.toastr.info('Urgent Jobs Processor');
this.getJobSubjectsUrgentTimeframeTable();
    
  // 'ExcelExport', 'Search', 'PdfExport'

    this.toolbarOptions = ['ExcelExport', 'Search', { text: ' >: Filter Agents For Update Request',
     tooltipText: 'Submit Data to Send Agent Notifications', prefixIcon: 'e-test', id: 'Click'  }
  ];
   // this.toolbar = [
   // { text: 'Agent Update Request', tooltipText: 'Click', prefixIcon: 'e-expand', id: 'Click' }];

  this.initialPage = { pageSize:10 };
  // FilterBar, Menu, Excel Checkbox
   this.filterOptions = {
      type: 'Menu'
   };

  // FilterBar, Menu, Excel Checkbox
  this.filterOptions_2022 = {
    type: 'Menu'
 };
  this.groupOptions = { columns: ['job_id'] }; // sets auto grouping for the grid
  // this.formatoptions = {};
  //  this.dateFormat = '';
   this.filter = {  };

  // this.groupOptions = { columns: ['job_id'] }; // sets auto grouping for the grid
  //  this.formatoptions = {type:'date', format:'dd/MM/yyyy'};
   this.dateFormat = 'dd/MM/yyyy hh:mm a';
   this.filter = { params: { format: this.dateFormat } };

   this.selectionOptions = {type: 'Multiple', checkboxOnly: true,}; // type: 'Multiple', mode: 'Both // checkboxMode: 'ResetOnRowClick'



// :: To fix the issue of nothing loading from the jobs screen to urngent
// end date filter options
// This function is very important and now pauses then load the document correctly.
        // setTimeout(() => {  
        //   console.log("A Simple Pause!"); 
        //   this.refreshGrid();
        //   console.log("Now Ready to load...");
        // }, 2000);





  }




agentUpdateRequest(search_results) {
  console.log(search_results);
  // loop through each request to action 

this.sr = search_results;

  // for (let i = 0; i < search_results.length; i++) {
  //   this.sendAgentUpdateEmail(search_results.subject_id[i], search_results.job_status[i]);
 // }

console.log(this.sr.length);


for (let i = 0; i < this.sr.length; i++) {
      // add assigned_to_agents array! (Gets Currnt Assigned agents)
      // testing did not work
            // this.getSubjectAgentBrandsAssigned2(this.sr[i].subject_id);
            // this.assigned_to_agents = JSON.stringify(this.allRecipients);
            // console.log('result.assigned_to_agents: ', this.assigned_to_agents);
}



  (async () => {
let i = 0;
  for(let result of this.sr){

    console.log(result.job_id);
    console.log('Subject_ID', result.subject_id);
   // on success notify.

   console.log(result); // grabs the entire row in to a var
  
    // we need three functions

      // unly run these if a rule has been sert
    if(result.rule_rule && result.email_sent != 'yes' && result.allocated_to != "" && result.allocated_to_array[0].is_privacy_no_emails != 1){
    this.sendAgentUpdateEmail(result); // nov 2023 commented out for dates testing. -- now updated to send pre rendered content.
    }
      // commented out for teesting.
      //  this.updateSubjectAgentStatus(result.subject_id, result.job_status, result);
      
      // unly run these if a rule has been sert
      if(result.rule_rule && result.updated_status != 'yes'  && result.allocated_to != ""){
      this.updateSubjectStatusBulkBasic(result.subject_id, result.job_status, result); // now just updates exacly what is sent.
      }

      // unly run these if a rule has been sert && stops from running twice if still in list.
      if(result.rule_rule && result.note_added != 'yes' && result.allocated_to != "" && result.allocated_to_array[0].is_privacy_no_notes != 1){
      // Commented out for testing
       this.getSubjectAgentBrandsAssigned2(result.subject_id, result); // set here so variables are already loaded to add the note updates
      }
  
  
   //  this.createSubjectNote(result);

 // then maybe push to a sent array on page to show success of each record.??

   this.toastr.success('Processed and Finished Subject Rule Matrix + Updates for: ' + result.subject_number);
   await this.delay(900);
 //  i++;
 
 
 }

// this.refreshGrid(); // stop the refresh now that we have check boxes this make the items dissapear and uncheck after process... so do not turn on. feb 2023

})(); // end async function

};



// delay function
 delay(ms: number) {
  return new Promise( resolve => setTimeout(resolve, ms) );
}



sendAgentUpdateEmail(result) {
 
 console.log(result.job_status);



  if (result.job_status === 'OPEN'){
  this._mysqlService.sendAgentUpdateEmail(result.subject_id, result);
    this.toastr.info('Email Notification Sent');  
    // push to search_results array email_sent
    // https://stackoverflow.com/questions/4689856/how-to-change-value-of-object-which-is-inside-an-array-using-javascript-or-jquer/50504081
    const objIndex = this.search_results.findIndex((obj => obj.subject_id === result.subject_id));
    this.search_results[objIndex].email_sent = 'yes';
    // the above works!!
    // this was setup so that I could have another included component that pushed information accross.
this.subject_sent = result.subject_id;
    // testing push to another array
  //  this.search_results_processed.push({subject_id: this.subject_sent, email_sent: 'YES'});
  }// end if open


  if (result.job_status === 'UPDREQ'){
    this._mysqlService.sendAgentUpdateEmail(result.subject_id, result);
      this.toastr.info('Email Notification Sent');  
      // push to search_results array email_sent
   
      const objIndex = this.search_results.findIndex((obj => obj.subject_id === result.subject_id));
      this.search_results[objIndex].email_sent = 'yes';
      // the above works!!
      // this was setup so that I could have another included component that pushed information accross.
  this.subject_sent = result.subject_id;
      // testing push to another array
     // this.search_results_processed.push({subject_id: this.subject_sent, email_sent: 'YES'});
    }// end if updreq


   
    if (result.job_status === 'UPDSENT'){
      this._mysqlService.sendAgentUpdateEmail(result.subject_id, result);
        this.toastr.info('Email Notification Sent');  
        // push to search_results array email_sent
     
        const objIndex = this.search_results.findIndex((obj => obj.subject_id === result.subject_id));
        this.search_results[objIndex].email_sent = 'yes';
        // the above works!!
        // this was setup so that I could have another included component that pushed information accross.
    this.subject_sent = result.subject_id;
        // testing push to another array
       // this.search_results_processed.push({subject_id: this.subject_sent, email_sent: 'YES'});
      }// end if


      if (result.job_status === 'AOS'){
        this._mysqlService.sendAgentUpdateEmail(result.subject_id, result);
          this.toastr.info('Email Notification Sent');  
          // push to search_results array email_sent
       
          const objIndex = this.search_results.findIndex((obj => obj.subject_id === result.subject_id));
          this.search_results[objIndex].email_sent = 'yes';
          // the above works!!
          // this was setup so that I could have another included component that pushed information accross.
      this.subject_sent = result.subject_id;
          // testing push to another array
         // this.search_results_processed.push({subject_id: this.subject_sent, email_sent: 'YES'});
        }// end if


        
      if (result.job_status === 'AOA'){
        this._mysqlService.sendAgentUpdateEmail(result.subject_id, result);
          this.toastr.info('Email Notification Sent');  
          // push to search_results array email_sent
       
          const objIndex = this.search_results.findIndex((obj => obj.subject_id === result.subject_id));
          this.search_results[objIndex].email_sent = 'yes';
          // the above works!!
          // this was setup so that I could have another included component that pushed information accross.
      this.subject_sent = result.subject_id;
          // testing push to another array
         // this.search_results_processed.push({subject_id: this.subject_sent, email_sent: 'YES'});
        }// end if





  };


  updateSubjectStatusBulkBasic(subject_id, job_status, result){
    let new_status = result.update_job_status
    const payload = this.normalizeSubjectUpdatePayload(result);
    this._demoService.updateSubjectStatusBulkBasic(payload, new_status)
    // .pipe(
    //   this.toastr.observe({
    //     loading: 'Subject Updates...',
    //     success: '🚀.. ',
    //     error: '...😡 Error updating ...' + subject_id
    //  })
    //  )
    .subscribe(
      data => { // this.trace_candidate_update = data;
      this.toastr.success('Subject Status Updated');
      const objIndex = this.search_results.findIndex((obj => obj.subject_id === subject_id));
      this.search_results[objIndex].updated_status = 'yes';
      },
      error => {
        this.toastr.error('Error Changing Status of Subject');
       return console.log(error);
      }
  );
  }

  updateSubjectAgentStatus(subject_id, job_status, result){
    const payload = this.normalizeSubjectUpdatePayload(result);

// Esure of test first rule as I - put and override on the next date on open as it was reverting back to 1979 -- text and fix!

// as options in the upate request. 
// send emails
// changes status and dates per rules.
// Add simple check box so that can add items by simply checking withoug filter.
// Make warning and clear that dates will be updated,status changes as well as contents of the email being sent in a preview.


    if (job_status === 'OPEN'){
      // need to update status codes and dates
        const new_status = 'UPDREQ';



      this._demoService.updateSubjectStatusBulk(payload, new_status).subscribe(
        data => { // this.trace_candidate_update = data;
        this.toastr.success('Subject Status Updated');
        const objIndex = this.search_results.findIndex((obj => obj.subject_id === subject_id));
        this.search_results[objIndex].updated_status = 'yes';
        },
        error => {
          this.toastr.error('Error Changing Status of Subject');
         return console.log(error);
        }
    );
    } // end if open



    if (job_status === 'UPDREQ'){
      // need to update status codes and dates
        const new_status = 'UPDREQ'; // leave as same status

      this._demoService.updateSubjectStatusBulk(payload, new_status).subscribe(
        data => { // this.trace_candidate_update = data;
        this.toastr.success('Subject dates Changed');
        const objIndex = this.search_results.findIndex((obj => obj.subject_id === subject_id));
        this.search_results[objIndex].updated_status = 'yes';
        },
        error => {
          this.toastr.error('Error Changing Status of Subject');
         return console.log(error);
        }
    );
    } // end if 


    if (job_status === 'UPDSENT'){
      // need to update status codes and dates
        const new_status = 'UPDREQ'; // leave as same status

      this._demoService.updateSubjectStatusBulk(payload, new_status).subscribe(
        data => { // this.trace_candidate_update = data;
        this.toastr.success('Subject dates Changed');
        const objIndex = this.search_results.findIndex((obj => obj.subject_id === subject_id));
        this.search_results[objIndex].updated_status = 'yes';
        },
        error => {
          this.toastr.error('Error Changing Status of Subject');
         return console.log(error);
        }
    );
    } // end if 


    if (job_status === 'AOS'){
      // need to update status codes and dates
        const new_status = 'AOS'; // leave as same status

      this._demoService.updateSubjectStatusBulk(payload, new_status).subscribe(
        data => { // this.trace_candidate_update = data;
        this.toastr.success('Subject dates Changed');
        const objIndex = this.search_results.findIndex((obj => obj.subject_id === subject_id));
        this.search_results[objIndex].updated_status = 'yes';
        },
        error => {
          this.toastr.error('Error Changing Status of Subject');
         return console.log(error);
        }
    );
    } // end if 

    
    if (job_status === 'AOA'){
      // need to update status codes and dates
        const new_status = 'AOA'; // leave as same status

      this._demoService.updateSubjectStatusBulk(payload, new_status).subscribe(
        data => { // this.trace_candidate_update = data;
        this.toastr.success('Subject dates Changed');
        const objIndex = this.search_results.findIndex((obj => obj.subject_id === subject_id));
        this.search_results[objIndex].updated_status = 'yes';
        },
        error => {
          this.toastr.error('Error Changing Status of Subject');
         return console.log(error);
        }
    );
    } // end if 


  }


// need to get all associated agents of the job and push thier information to array
getSubjectAgentBrandsAssigned2(subject_id, result) {
  this.allRecipients = [];
  this._demoService.getSubjectAgentBrandsAssigned(subject_id).subscribe(
     data => { 
       this.assignedAgentsList = data;

       let newArr = data;
       let  count_of_items = Object.keys(newArr).length;
         // need to do a loop of subject_billing items (.length)
         for(let i=0;i < count_of_items; i++) {
         let res = newArr[i];
         this.allRecipients.push({
           recipient_name: res.name + '',
           recipient_email_address: res.email,
           recipient_brand_id: res.brand_id,
           recipient_subject_id: res.subject_id,
           recipient_brand_type_id: res.brand_type_id,
           recipient_user_id: null,
           recipient_user_level_id: null,
           recipient_type_name: 'Agent',
         });
         } // end for loop
       this.allRecipients = this.allRecipients; // ?? this may be causing errors.
       // set records to send to subject_notes data table
      //  this.model.assigned_to_agents = JSON.stringify(this.allRecipients);
      console.log('AllRecipients: ', JSON.stringify(this.allRecipients));

      // now insert the note as it would not load the recipeints outside function
   this.createSubjectNote(result);

    },
     err => console.error(err),
     // () => console.log('Loaded Assigned Agents Loaded.')
   );
 }






  createSubjectNote(result) {


    // this.getSubjectAgentBrandsAssigned2(result.subject_id); // set here so variables are already loaded to add the note updates

   // this.sendEmail(this.job_id, this.subject_id, this.sessionUserId, model);
   result.created_by = this.sessionUserId;
  //  result.note_content = 'First updated request emailed to the agent. Automated from Batch Urgent Jobs Screen.';
   result.note_content = this.transform2(result.note_template_HTML_rendered);
  
   result.brand_type_id = 3; // Agent
   result.note_type_id = 6; // bactch process
   result.user_level_id = 5;   // agent
   result.subject_com_type_id = 0; // empty string
   result.doc_id = 0;
   result.assigned_to_agents = JSON.stringify(this.allRecipients);
   console.log('AllRecipients AFTER: ', JSON.stringify(this.allRecipients));


   if (result.job_status === 'OPEN'){
    this._demoService.createSubjectNote(result).subscribe(
         data => {  this.get_latest_subject_note_id = data; // this is the retuned json upon creation.
          this.toastr.info('Note Added To Subject!');
          const objIndex = this.search_results.findIndex((obj => obj.subject_id === result.subject_id));
          this.search_results[objIndex].note_added = 'yes';
          this.gfunc.insertLog_UpdateSubjectUrgentAgentCommunication(result) // now lets log it, and create a trigger

         },
         error => {
           // console.log(Observable.throw(error));
           //return console.log(error);
         }
    );
  } // end if  open


          if (result.job_status === 'UPDREQ'){
            // result.note_content = 'Second and urgent update request emailed to agent. Automated from Batch Urgent Jobs Screen.';
            result.note_content = this.transform2(result.note_template_HTML_rendered);
            this._demoService.createSubjectNote(result).subscribe(
                 data => {  this.get_latest_subject_note_id = data; // this is the retuned json upon creation.
                  this.toastr.info('Note Added To Subject!');
                  const objIndex = this.search_results.findIndex((obj => obj.subject_id === result.subject_id));
                  this.search_results[objIndex].note_added = 'yes';
                  this.search_results[objIndex].x = 'yes';
          this.gfunc.insertLog_UpdateSubjectUrgentAgentCommunication(result) // now lets log it, and create a trigger

                 },
                 error => {
                  //  console.log(Observable.throw(error));
                  // return console.log(error);
                 }
            );
          } // end if  UPDREQ


          if (result.job_status === 'UPDSENT'){
            // result.note_content = 'Further update request emailed to agent. Automated from Batch Urgent Jobs Screen.';
            result.note_content = this.transform2(result.note_template_HTML_rendered);

            this._demoService.createSubjectNote(result).subscribe(
                 data => {  this.get_latest_subject_note_id = data; // this is the retuned json upon creation.
                  this.toastr.info('Note Added To Subject!');
                  const objIndex = this.search_results.findIndex((obj => obj.subject_id === result.subject_id));
                  this.search_results[objIndex].note_added = 'yes';
          this.gfunc.insertLog_UpdateSubjectUrgentAgentCommunication(result) // now lets log it, and create a trigger

                 },
                 error => {
                   // console.log(Observable.throw(error));
                   //return console.log(error);
                 }
            );
          } // end if  UPDREQ


          if (result.job_status === 'AOS'){
            result.note_content = this.transform2(result.note_template_HTML_rendered);

            // result.note_content = 'Update request emailed to agent regarding the return of the Affidavit of Service. Automated from Batch Urgent Jobs Screen.';
            this._demoService.createSubjectNote(result).subscribe(
                 data => {  this.get_latest_subject_note_id = data; // this is the retuned json upon creation.
                  this.toastr.info('Note Added To Subject!');
                  const objIndex = this.search_results.findIndex((obj => obj.subject_id === result.subject_id));
                  this.search_results[objIndex].note_added = 'yes';
          this.gfunc.insertLog_UpdateSubjectUrgentAgentCommunication(result) // now lets log it, and create a trigger

                 },
                 error => {
                   // console.log(Observable.throw(error));
                   //return console.log(error);
                 }
            );
          } // end if 


          if (result.job_status === 'AOA'){
            result.note_content = this.transform2(result.note_template_HTML_rendered);

            // result.note_content = 'Update request emailed to agent regarding the return of the Affidavit of Attempted Service. Automated from Batch Urgent Jobs Screen.';
            this._demoService.createSubjectNote(result).subscribe(
                 data => {  this.get_latest_subject_note_id = data; // this is the retuned json upon creation.
                  this.toastr.info('Note Added To Subject!');
                  const objIndex = this.search_results.findIndex((obj => obj.subject_id === result.subject_id));
                  this.search_results[objIndex].note_added = 'yes';
          this.gfunc.insertLog_UpdateSubjectUrgentAgentCommunication(result) // now lets log it, and create a trigger

                 },
                 error => {
                   // console.log(Observable.throw(error));
                   //return console.log(error);
                 }
            );
          } // end if  UPDREQ



    }




  // https://ej2.syncfusion.com/angular/documentation/grid/tool-bar/#built-in-and-custom-items-in-toolbar
  clickHandler(args: ClickEventArgs): void {
  
    if (args.item.id === 'grid_excelexport') { // 'Grid_excelexport' -> Grid component id + _ + toolbar item name
      this.grid.excelExport();
  }
  
  
    if (args.item.id === 'Click') {

    //  this.grid.showSpinner();

    //    alert('This function will trigger the action to Emails, and Status Notifications to Agents');
   //  console.log(args.data.items);
   






    let pdfdata;
    const query = this.grid.renderModule.data.generateQuery(); // get grid corresponding query
    for (let i = 0; i < query.queries.length; i++) {
      if (query.queries[i].fn === 'onPage') {
        query.queries.splice(i, 1);       // remove page query to get all records
        break;
      }
    }
    const fdata = new DataManager({ json: this.subjects_urgent }).executeQuery(query).then((e: any) => {
      pdfdata = e.result as object[];  // get all filtered records
      const exportProperties = {
        dataSource: pdfdata,
      };
      //console.log(pdfdata.results);
      
     // this.search_results = pdfdata.records; // need this if a grouping is set.
      this.search_results = pdfdata;
      this.toastr.info( this.search_results.length + ' subjects added to the update Request Que'); 
      this.toastr.success( "Press Start To Process Que"); 
     // this.grid.pdfExport(exportProperties);
    }).catch((e) => true);
    }

   //  this.grid.hideSpinner();

}


// New way of rendering table data
mapJobTableLive() {

  (async () => {
  this.getClients(); // load clients first
  this.getJobTypes();
  this.getJobSubjectsAll();
  this.getBrandUsers('94'); // for sharmans only
  this.getJobAgentsAllAssigned();
  this.getBrands(); //
  this.getJobAgentsAllAssigned();
  this.getSubjectAgentsAssignedAll();
  await this.delay(3000);
 })(); // end async function  

  this.http.get<any>(this.gfunc.apiURL + '/api/job/table/all/urgent')
 .pipe(map(data => {
  // do your transformations
  this.job_table2 = data;
 
  this.job_table2.forEach(element => {

// local Client Name
/*
this.clientLocalRecord = this.clients.filter(c => c.client_id === element.client_id);
let rs = this.clientLocalRecord;
this.changeObject = Object.assign(this.clientLocalRecord);
element.client_id  = this.changeObject[0].name;
*/
// get brand_report_id // client brand Name

this.brandLocalRecord = this.brands.filter(c => c.brand_id === element.brand_report_id);
this.changeObject = Object.assign(this.brandLocalRecord);
element.brand_report_id  = this.changeObject[0].name;


// Get Job Types
this.jobTypesLocalRecord = this.job_types.filter(c => c.job_type_id === element.job_type_id);
this.changeObject = Object.assign(this.jobTypesLocalRecord);
element.job_type_id  = this.changeObject[0].job_type_name;
// Get Job Subject Name
this.subjectLocalRecord = this.subjects.filter(c => c.subject_id === element.subject_id);
this.changeObject = Object.assign(this.subjectLocalRecord);
if (this.changeObject[0].first_name === null){
 // element.subject_id = '-';
  element.subject_name = '-';
}else{
 // element.subject_id  = this.changeObject[0].first_name + ' ' + this.changeObject[0].surname;
element.subject_name = this.changeObject[0].first_name + ' ' + this.changeObject[0].surname;
}

this.setLegalGridDateFields(element);
// Agents Assigned
// this.agentsAssignedLocalRecord = this.agents_assigned.filter(c => c.job_id === element.job_id); // old version
this.agentsAssignedLocalRecord = this.agents_assigned.filter(c => c.subject_id === element.subject_id);
this.changeObject = Object.assign(this.agentsAssignedLocalRecord);
let recordCount = this.changeObject.length;
console.log(recordCount);
this.allocated_agents_list = '';
if (recordCount < 1){
  this.allocated_agents_list = '-';
}else{
  for (let i = 0; i < recordCount; i++) {
// this.allocated_agents_list  += this.changeObject[i].first_name + ' ' + this.changeObject[i].surname + ', ';
this.allocated_agents_list  += this.changeObject[i].name + ', ';
} // end loop
}
element.allocated_to  = this.allocated_agents_list;



}); // end for each of all


return this.job_table2;

})
) // end pipe.map

  .subscribe(results => this.job_table2 = results
  );



}




// get the mapping stuff

getClients() {
  this._demoService.getClients().subscribe(
     data => { this.clients = data; },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }

// need to get new clients
getBrands() {
  this._demoService.getBrands().subscribe(
     data => { this.brands = data; },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }



 getJobTypes() {
  this._demoService.getJobTypes().subscribe(
     data => { this.job_types = data; },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }


 getJobSubjectsAll() {
  this._demoService.getJobSubjectsAll().subscribe(
     data => { this.subjects = data;
      let res = data[0];
    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }

 getJobAgentsAllAssigned() {
  this._demoService.getSubjectBrandAgentsAssignedAll().subscribe(
     data => { this.agents_assigned = data;
      let res = data[0];
    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }

 

 getSubjectAgentsAssignedAll(){
  this._demoService.getSubjectAgentsAssignedAll().subscribe(
    data => { this.subject_agents_assigned = data;
     let res = data[0];
   },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
 }


  // need to get brand agents.
  getBrandAgents() {
    this._demoService.getBrandAgents().subscribe(
       data => { this.brandAgentsList = data;
      },
       err => console.error(err),
       // () => console.log('Agent Brands Loaded.')
     );
   }



   getSubjectAgentBrandsAssigned(subject_id) {
    this._demoService.getSubjectAgentBrandsAssigned(subject_id).subscribe(
       data => { this.assignedBrandList = data;
      },
       err => console.error(err),
       // () => console.log('Loaded Assigned Agents Loaded.')
     );
   }


// gets the list of users assiciated for drop down.
getBrandUsers(brand_id) {
  this._demoService.getBrandUsers(brand_id).subscribe(
     data => { this.staffList = data;
    },
     err => console.error(err),
     () => console.log('Candidates Loaded.')
   );
 }




 toolbarClick(args: ClickEventArgs): void {
  if (args.item.id === 'Grid_excelexport') { // 'Grid_excelexport' -> Grid component id + _ + toolbar item name
      this.grid.excelExport();
  }
}


rowDataBound(args: RowDataBoundEventArgs) {
  const job_status = 'job_status';
  if (args.data[job_status] === 'CLOSED') {
      args.row.className = 'strikethrough';
  }
}



jobLink(job_id) {
  this.router.navigate(['/admin/jobs/create-job-3/' + job_id + '']);
}

jobView(job_id) {
  this.router.navigate(['/admin/jobs/view/' + job_id + '']);
}

subjectEdit(subject_id){
  this.router.navigate(['/admin/jobs/subject/edit/' + subject_id + '']);
}


refreshGrid(){ // refresh the databutton
 // this.mapJobTableLive();
// this.getJobSubjectsUrgentTable();
this.getJobSubjectsUrgentTimeframeTable();
  this.grid.refresh();
};



getJobSubjectsUrgentTimeframeTable() {
  this._demoService.getJobSubjectsUrgentTimeframeTable().subscribe(
    data => { this.subjects_urgent = data;
      let subjects_urgent_top_10 = this.subjects_urgent.slice(0, 10);
      this.subjects_urgent_table = this.subjects_urgent.slice(0, 10);
      // pass so that the dates are correct in Sync
      // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular







      // this.job_table2.forEach(element => {

      //   // local Client Name
      //   /*
      //   this.clientLocalRecord = this.clients.filter(c => c.client_id === element.client_id);
      //   let rs = this.clientLocalRecord;
      //   this.changeObject = Object.assign(this.clientLocalRecord);
      //   element.client_id  = this.changeObject[0].name;
      //   */
      //   // get brand_report_id // client brand Name
        
      //   this.brandLocalRecord = this.brands.filter(c => c.brand_id === element.brand_report_id);
      //   this.changeObject = Object.assign(this.brandLocalRecord);
      //   element.brand_report_id  = this.changeObject[0].name;
        
        
      //   // Get Job Types
      //   this.jobTypesLocalRecord = this.job_types.filter(c => c.job_type_id === element.job_type_id);
      //   this.changeObject = Object.assign(this.jobTypesLocalRecord);
      //   element.job_type_id  = this.changeObject[0].job_type_name;
      //   // Get Job Subject Name
      //   this.subjectLocalRecord = this.subjects.filter(c => c.subject_id === element.subject_id);
      //   this.changeObject = Object.assign(this.subjectLocalRecord);
      //   if (this.changeObject[0].first_name === null){
      //    // element.subject_id = '-';
      //     element.subject_name = '-';
      //   }else{
      //    // element.subject_id  = this.changeObject[0].first_name + ' ' + this.changeObject[0].surname;
      //   element.subject_name = this.changeObject[0].first_name + ' ' + this.changeObject[0].surname;
      //   }
        
      //   // Date Formatting (Before Load)
      //   // see: https://stackoverflow.com/questions/40377103/how-to-convert-date-into-this-yyyy-mm-dd-format-in-angular-2
      //   element.next_date  =  this.datepipe.transform(element.next_date, 'dd/MM/yyyy h:mm a');
      //   element.final_date  =  this.datepipe.transform(element.final_date, 'dd/MM/yyyy h:mm a');
      //   element.hearing_date  =  this.datepipe.transform(element.hearing_date, 'dd/MM/yyyy h:mm a');
      //   element.judgement_date  =  this.datepipe.transform(element.judgement_date, 'dd/MM/yyyy h:mm a');
      //   // Agents Assigned
      //   // this.agentsAssignedLocalRecord = this.agents_assigned.filter(c => c.job_id === element.job_id); // old version
      //   this.agentsAssignedLocalRecord = this.agents_assigned.filter(c => c.subject_id === element.subject_id);
      //   this.changeObject = Object.assign(this.agentsAssignedLocalRecord);
      //   let recordCount = this.changeObject.length;
      //   console.log(recordCount);
      //   this.allocated_agents_list = '';
      //   if (recordCount < 1){
      //     this.allocated_agents_list = '-';
      //   }else{
      //     for (let i = 0; i < recordCount; i++) {
      //   // this.allocated_agents_list  += this.changeObject[i].first_name + ' ' + this.changeObject[i].surname + ', ';
      //   this.allocated_agents_list  += this.changeObject[i].name + ', ';
      //   } // end loop
      //   }
      //   element.allocated_to  = this.allocated_agents_list;
        
        
        
      //   }); // end for each of all
        
        
      //   // return this.job_table2;















      // this.subjects_urgent = DataUtil.parse.parseJson(this.job_table2); 
      this.subjects_urgent = this.applyLegalGridDateFields(DataUtil.parse.parseJson(this.subjects_urgent)); 
      this.subjects_urgent_table = this.subjects_urgent.slice(0, 10);
      // this.grid.refresh();
     
      // console.log("Done loadng USER");
     // console.log(this.users);


    },
    error => {
    //  console.error('Error Loading User!');
    console.log(error);
    }
  ); }


// what does this do it counts maybe?
  counter(i: number) {
    return new Array(i);
}






clearSearchGrid() {
  this.grid.searchSettings.key = '';
  this.getJobSubjectsUrgentTimeframeTable();
}

searchGrid(name) {
  this.searchOptions = {  };
  this.grid.searchSettings.key = '';
  // const searchText: string = (document.getElementsByClassName('searchtext')[0] as any).value;
  const searchText: string = name;
  this.grid.search(searchText);

}

searchGridCol(name) {
// const searchText: string = (document.getElementsByClassName('searchtext')[0] as any).value;
// const searchText: string = name;
// this.grid.search(searchText);

// clear first
this.grid.searchSettings.key = '';
// now update the search uptions
this.searchOptions = { fields: ['note_type_name'], operator: 'contains', key: name, ignoreCase: true };
// now refresh the grid
this.grid.refresh();
}


searchGridColNextDate(name) {
  // const searchText: string = (document.getElementsByClassName('searchtext')[0] as any).value;
  // const searchText: string = name;
  // this.grid.search(searchText);
  
  // clear first
  this.grid.searchSettings.key = '';
  // now update the search uptions
  this.searchOptions = {
    fields: ['next_date_search'],
    operator: 'lessThan',
    key: this.toLegalGridSearchKey(name),
    ignoreCase: true,
  };
  // now refresh the grid
  this.grid.refresh();
  }



// NOT WORKING
searchGridMasters(name) {
this.grid.searchSettings.key = '';
// now update the search uptions
this.searchOptions = { 
  fields: ['assigned_to_subjects'], operator: 'equal', key: name
 
};
// now refresh the grid
this.grid.refresh();

}


getFormUserLevels() {
  this._demoService.getFormUserLevels().subscribe(
     data2 => { this.user_levels = data2;
      console.log(data2);
   },
     err => console.error(err),
     () => console.log('done loading User Levels')
   );
 }


 getBrandTypes() {
  this._demoService.getBrandBrandTypes().subscribe(
     data => { this.brand_types = data; },
     err => console.error(err),
     // () => console.log('done loading candidate for update')
   );
 }


  
// :: Reporting
getReportBrandsClientSearch(search_model) {
  this.brand_user_join_results = [];
  search_model.brand_type_id = 2;
  search_model.access_level = 9;
    this._demoService.getReportBrandsSearch(search_model).subscribe(
      data => { this.brand_search = data;
        // pass so that the dates are correct in Sync
        // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
        this.brand_search_results = DataUtil.parse.parseJson(data); 
  // get the users as well and join the records together
  this.getReportUsersSearch(search_model);
  
  // now how to join two arrays of objects.
  // maybe pass results in to a new model.
  
  // Count items of brand search to loop through
  let  count_of_brand_items = Object.keys(this.brand_search).length;
  // now loop and push to join model
  for(let i=0;i < count_of_brand_items; i++) {
    let res = this.brand_search_results[i];
  
      // push to holding list of invoice items, all current subject_billing_items. (no filtering as yet.)
      this.brand_user_join_results.push({
        email_address: res.email,
        first_name: res.name,
        surname: res.surname,
        company_name: res.name,
        created: res.created,
              });
  
  } // end brands loop.
  
  this.brand_user_join_results = this.brand_user_join_results;
  
       this.grid.refresh();
      },
      error => {
      console.error('Error Loading !' + error.error);
      console.log(error);
      // return Observable.throw(error);
      }

    ); }




    getReportUsersSearch(search_model) {

      this._demoService.getReportUsersSearch(search_model).subscribe(
        data => { this.user_search = data;
          // pass so that the dates are correct in Sync
          // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
          this.user_search_results = DataUtil.parse.parseJson(data);
  // Count items of users search to loop through
  let  count_of_user_items = Object.keys(this.user_search).length;
  // now loop and push to join model
  for(let i=0;i < count_of_user_items; i++) {
    let res = this.user_search_results[i];
  
  
      // push to holding list of invoice items, all current subject_billing_items. (no filtering as yet.)
      this.brand_user_join_results.push({
        email_address: res.email_address,
        first_name: res.first_name,
        surname: res.surname,
        company_name: res.company_name,
        created_date: res.created_date,
              });
  
  
  } // end users loop.
  
  this.brand_user_join_results = this.brand_user_join_results;
  this.grid.refresh();
  
  
      //   this.grid.refresh();
       //  this.agent_grid.refresh();
        },
        error => {
        console.error('Error Loading !' + error.error);
        console.log(error);
        // return Observable.throw(error);
        }
      ); }
  
  


      getReportSubjectsUrgentTimeframeSearch(search_model) {
        this.brand_user_join_results = [];
        this.subjects_urgent = [];
        this.grid.searchSettings.key = ''; // resets the grid filters and buttons
        
      //  search_model.brand_type_id = 2;
      //  search_model.access_level = 9;
         
        
      const normalizedSearchModel = this.normalizeLegalSearchModel(search_model);

      this._demoService.getReportSubjectsUrgentTimeframeSearch(normalizedSearchModel).subscribe(
            data => { this.brand_search = data;
              // pass so that the dates are correct in Sync
              // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
              this.brand_search_results = DataUtil.parse.parseJson(data); 
        // get the users as well and join the records together
     
        // Run this function and use the same json object and keep adding or removing to it if you wish.
        //    this.getReportUsersSearch(search_model);
        
        // now how to join two arrays of objects.
        // maybe pass results in to a new model.
        
        // Count items of brand search to loop through
        let  count_of_brand_items = Object.keys(this.brand_search).length;
        // now loop and push to join model
        for(let i=0;i < count_of_brand_items; i++) {
          let res = this.brand_search_results[i];
        
            // push to holding list of invoice items, all current subject_billing_items. (no filtering as yet.)
            this.brand_user_join_results.push({
              email_address: res.email,
              first_name: res.name,
              surname: res.surname,
              company_name: res.name,
              created: res.created,
                    });

this.subjects_urgent.push({
  // email_address: res.email,
  // first_name: res.name,
  // surname: res.surname,
  // company_name: res.name,
  // created: res.created,
  ...this.brand_search_results[i]
        });

        
        } // end brands loop.
        
        this.brand_user_join_results = this.brand_user_join_results;
        this.subjects_urgent = this.applyLegalGridDateFields(this.subjects_urgent);
        this.subjects_urgent = this.subjects_urgent;
        
             this.grid.refresh();
            },
            error => {
            console.error('Error Loading !' + error.error);
            console.log(error);
            // return Observable.throw(error);
            }
      
          ); }
      

      
  
  addDays(days : number): Date{
  let futureDate = new Date();
  futureDate.setDate(futureDate.getDate() + days);
  return futureDate;
  }
  
  
  removeDays(days : number): Date{
  let futureDate = new Date();
  futureDate.setDate(futureDate.getDate() - days);
  return futureDate;
  }


  async getAsyncData(row, subject_id) {
let url = 'https://dummy.restapiexample.com/api/v1/employee/21'
    this.asyncResult = await this.runReplaceAllVariableFunctions(row, subject_id) // Run all the functions first -- outside all ifs.
    // this.asyncResult = await this.http.get<SubjectUrgentOutcomeTemplate>(url).toPromise();
    // setTimeout(() => {   },3000); // enough time to load template above
    console.log('No issues, I will wait until promise is resolved..');
    

  }



  // async getData(row, subject_id, get_suot_id) {
  //   let url = 'https://dummy.restapiexample.com/api/v1/employee/21'
  //   try {
  //     // this.asyncResult = await this.http.get(url).toPromise();
  //     // this.asyncResult = await this.http.get(url).toPromise();
  //     // this.asyncResult = await this.runReplaceAllVariableFunctions(row, subject_id)
  //     // await this.runReplaceAllVariableFunctions_Observables(row, subject_id)
  //     this.runReplaceAllVariableFunctions_Observables(row, subject_id, get_suot_id)

  //     // this.getSubjectUrgentOutcomeTemplate(get_suot_id); // Move this to the folk join function

  //     return;
      
  //   } catch (error) {
  //     console.error(error);
  //   }
  // }



  // Get the Template Based on Status and then pass the subject and HTML to the model. - email to send.
  checkSubjectUrgentOutcometemplate(status, row, subject_id){
   


    let get_suot_id = null
    let chosen_template = null
    let chosen_subject = null
    let chosen_template_private = null
    let chosen_subject_private = null
    let chosen_note_template = null
    let chosen_note_template_private = null;


    // this.getAsyncData(row, subject_id);
    this.checkFinalDate(row.final_date, row.subject_id, row.job_status, row) // Run the rule checker and set UPDATE fields.

    // run the functins here once.

    // this.toastr.info('Chosen SUOT AgentID : ' + row.allocated_to_array[0].brand_id); // array sent back from subjects_urgent quierty in grid row.

    // if status set the ID of template to lookup
    if(status == 'OPEN' && row.allocated_to != ""){
      get_suot_id = 1;
   
      
     
      // this.getSubjectUrgentOutcomeTemplate(get_suot_id);
      // this.runReplaceAllVariableFunctions(row, subject_id) // Run all the functions first
   
    //  this.getData(row, subject_id, get_suot_id);
    this.runReplaceAllVariableFunctions_Observables(row, subject_id, get_suot_id)

      console.log('after data loaded... asyc');

// ERRORS are that its pucking the wrong template.... not loading FIRST!!!!!!!!!!!!!!! ERRORRS FOR LOOP with not TIMEOUT... 3500 timeput works GRHHH!@@
      
      // setTimeout(() => {    },0); // enough time to load template above
        // chosen_template = this.subject_urgent_outcome_template[0].email_template_primary_HTML;
        // chosen_subject = this.subject_urgent_outcome_template[0].email_subject_primary;
        // chosen_template_private = this.subject_urgent_outcome_template[0].email_template_private_HTML;
        // chosen_subject_private = this.subject_urgent_outcome_template[0].email_subject_private;

        // chosen_note_template = this.subject_urgent_outcome_template[0].note_template_HTML;
        // chosen_note_template_private = this.subject_urgent_outcome_template[0].note_template_HTML_private;
        
            // if(this.chosen_template != null){}
            //   chosen_template = this.chosen_template
            //   chosen_subject = this.chosen_subject
            //   chosen_template_private = this.chosen_template_private
            //   chosen_subject_private = this.chosen_subject_private

            //   chosen_note_template = this.chosen_note_template
            //   chosen_note_template_private = this.chosen_note_template_private
            

            //   // console.log('Assigned Agent: ' + this.assignedBrandList_paragraphs[0].name)
            //   // let is_privacy_emails = this.assignedBrandList_paragraphs[0].is_privacy_emails
            //   // let is_privacy_notes = this.assignedBrandList_paragraphs[0].is_privacy_notes

            //   console.log('Assigned Agent: ' + row.allocated_to_array[0].name)
            //   let is_privacy_emails = row.allocated_to_array[0].is_privacy_emails
            //   let is_privacy_notes = row.allocated_to_array[0].is_privacy_notes


            //   let email_template_primary_HTML_rendered = null;
            //   let email_subject_primary_rendered = null;
            //   let note_template_HTML_rendered = null;
        

            //       // Render/Run MergeReplace Functions
            //       if(is_privacy_emails == 1){
            //         email_template_primary_HTML_rendered =  this.runReplaceAllVariables(chosen_template_private, row)
            //         email_subject_primary_rendered =  this.runReplaceAllVariables(chosen_subject_private, row)
            //         }else{
            //           email_template_primary_HTML_rendered =  this.runReplaceAllVariables(chosen_template, row)
            //           email_subject_primary_rendered =  this.runReplaceAllVariables(chosen_subject, row)
            //         }
            
            //         note_template_HTML_rendered =  this.runReplaceAllVariables(chosen_note_template, row)
            
            //         console.log('Is privacy Notes: ' + is_privacy_notes)
            
            //         // if(is_privacy_notes == 1 || is_privacy_notes != null){
            //         //   note_template_HTML_rendered =  this.runReplaceAllVariables(chosen_note_template_private, row)
            //         //   }else{
            //         //   note_template_HTML_rendered =  this.runReplaceAllVariables(chosen_note_template, row)
            //         //   }


            //   // this.toastr.info('Chosen SUOT : ' + get_suot_id);

              
            //   const objIndex = this.search_results.findIndex((obj => obj.subject_id === subject_id));
            //   this.search_results[objIndex].email_template_primary_HTML_rendered = this.transform2(email_template_primary_HTML_rendered);
            //   this.search_results[objIndex].email_subject_primary_rendered = this.transform2(email_subject_primary_rendered);
            //   this.search_results[objIndex].note_template_HTML_rendered = this.transform2(note_template_HTML_rendered);
            //   this.search_results[objIndex].suot_id = this.subject_urgent_outcome_template[0].suot_id;
            //   this.search_results[objIndex].suot_agent_id = row.allocated_to_array[0].brand_id;
          
            //   // this.search_results[objIndex].email_template_primary_HTML = this.transform2(chosen_template);
          
    }

    if(status == 'UPDREQ' && row.allocated_to != ""){
        
      get_suot_id = 2;
          
         // this.getSubjectUrgentOutcomeTemplate(get_suot_id);
      // this.runReplaceAllVariableFunctions(row, subject_id) // Run all the functions first
   
      // this.getData(row, subject_id, get_suot_id);
      this.runReplaceAllVariableFunctions_Observables(row, subject_id, get_suot_id)

          console.log('after data loaded... asyc');
    
          
          // setTimeout(() => {  
          //   // chosen_template = this.subject_urgent_outcome_template[0].email_template_primary_HTML;
          //   // chosen_subject = this.subject_urgent_outcome_template[0].email_subject_primary;
          //   // chosen_template_private = this.subject_urgent_outcome_template[0].email_template_private_HTML;
          //   // chosen_subject_private = this.subject_urgent_outcome_template[0].email_subject_private;
    
          //   // chosen_note_template = this.subject_urgent_outcome_template[0].note_template_HTML;
          //   // chosen_note_template_private = this.subject_urgent_outcome_template[0].note_template_HTML_private;
            
          //   if(this.chosen_template != null){
          //     chosen_template = this.chosen_template
          //     chosen_subject = this.chosen_subject
          //     chosen_template_private = this.chosen_template_private
          //     chosen_subject_private = this.chosen_subject_private
      
          //     chosen_note_template = this.chosen_note_template
          //     chosen_note_template_private = this.chosen_note_template_private
          //   }


          //   // Need to load assigned agent to get privacy details for templates frirst.
          //   // console.log('Assigned Agent: ' + this.assignedBrandList_paragraphs[0].name)
          //   // let is_privacy_emails = this.assignedBrandList_paragraphs[0].is_privacy_emails
          //   // let is_privacy_notes = this.assignedBrandList_paragraphs[0].is_privacy_notes
          //   let is_privacy_emails = row.allocated_to_array[0].is_privacy_emails
          //   let is_privacy_notes = row.allocated_to_array[0].is_privacy_notes
          //   let email_template_primary_HTML_rendered = null;
          //   let email_subject_primary_rendered = null;
          //   let note_template_HTML_rendered = null;
    
    
          //   // Render/Run MergeReplace Functions
          //   if(is_privacy_emails == 1){
          //   email_template_primary_HTML_rendered =  this.runReplaceAllVariables(chosen_template_private, row)
          //   email_subject_primary_rendered =  this.runReplaceAllVariables(chosen_subject_private, row)
          //   }else{
          //     email_template_primary_HTML_rendered =  this.runReplaceAllVariables(chosen_template, row)
          //     email_subject_primary_rendered =  this.runReplaceAllVariables(chosen_subject, row)
          //   }
    
          //   note_template_HTML_rendered =  this.runReplaceAllVariables(chosen_note_template, row)
    
          //   // console.log('Is privacy Notes: ' + is_privacy_notes)
    
          //   // if(is_privacy_notes == 1 ){
          //   //   note_template_HTML_rendered =  this.runReplaceAllVariables(chosen_note_template_private, row)
          //   //   }else{
          //   //   note_template_HTML_rendered =  this.runReplaceAllVariables(chosen_note_template, row)
          //   //   }
    
    
          //   // this.toastr.info('Chosen SUOT : ' + get_suot_id);
          //   const objIndex = this.search_results.findIndex((obj => obj.subject_id === subject_id));
          //   this.search_results[objIndex].email_template_primary_HTML_rendered = this.transform2(email_template_primary_HTML_rendered);
          //   this.search_results[objIndex].email_subject_primary_rendered = this.transform2(email_subject_primary_rendered);
          //   this.search_results[objIndex].note_template_HTML_rendered = this.transform2(note_template_HTML_rendered);
          //   this.search_results[objIndex].suot_id = this.subject_urgent_outcome_template[0].suot_id;
          //   this.search_results[objIndex].suot_agent_id = row.allocated_to_array[0].brand_id;

          //   // this.search_results[objIndex].email_template_primary_HTML = this.transform2(chosen_template);
          // },0); // enough time to load template above
    }


    if(status == 'UPDSENT'  && row.allocated_to != ""){
        
      get_suot_id = 3;
          
      // this.getSubjectUrgentOutcomeTemplate(get_suot_id);
      // this.runReplaceAllVariableFunctions(row, subject_id) // Run all the functions first
   
      // this.getData(row, subject_id, get_suot_id);
      this.runReplaceAllVariableFunctions_Observables(row, subject_id, get_suot_id)

          console.log('after data loaded... asyc');
    
          
          // setTimeout(() => {  
          //   // chosen_template = this.subject_urgent_outcome_template[0].email_template_primary_HTML;
          //   // chosen_subject = this.subject_urgent_outcome_template[0].email_subject_primary;
          //   // chosen_template_private = this.subject_urgent_outcome_template[0].email_template_private_HTML;
          //   // chosen_subject_private = this.subject_urgent_outcome_template[0].email_subject_private;
    
          //   // chosen_note_template = this.subject_urgent_outcome_template[0].note_template_HTML;
          //   // chosen_note_template_private = this.subject_urgent_outcome_template[0].note_template_HTML_private;

          //   if(this.chosen_template != null){
          //     chosen_template = this.chosen_template
          //     chosen_subject = this.chosen_subject
          //     chosen_template_private = this.chosen_template_private
          //     chosen_subject_private = this.chosen_subject_private
      
          //     chosen_note_template = this.chosen_note_template
          //     chosen_note_template_private = this.chosen_note_template_private
          //   }
            
          //   // Need to load assigned agent to get privacy details for templates frirst.
          //   // console.log('Assigned Agent: ' + this.assignedBrandList_paragraphs[0].name)
          //   // let is_privacy_emails = this.assignedBrandList_paragraphs[0].is_privacy_emails
          //   // let is_privacy_notes = this.assignedBrandList_paragraphs[0].is_privacy_notes
          //   let is_privacy_emails = row.allocated_to_array[0].is_privacy_emails
          //   let is_privacy_notes = row.allocated_to_array[0].is_privacy_notes

          //   let email_template_primary_HTML_rendered = null;
          //   let email_subject_primary_rendered = null;
          //   let note_template_HTML_rendered = null;
    
    
          //   // Render/Run MergeReplace Functions
          //   if(is_privacy_emails == 1){
          //   email_template_primary_HTML_rendered =  this.runReplaceAllVariables(chosen_template_private, row)
          //   email_subject_primary_rendered =  this.runReplaceAllVariables(chosen_subject_private, row)
          //   }else{
          //     email_template_primary_HTML_rendered =  this.runReplaceAllVariables(chosen_template, row)
          //     email_subject_primary_rendered =  this.runReplaceAllVariables(chosen_subject, row)
          //   }
    
          //   note_template_HTML_rendered =  this.runReplaceAllVariables(chosen_note_template, row)
    
          //   // console.log('Is privacy Notes: ' + is_privacy_notes)
    
          //   // if(is_privacy_notes == 1 ){
          //   //   note_template_HTML_rendered =  this.runReplaceAllVariables(chosen_note_template_private, row)
          //   //   }else{
          //   //   note_template_HTML_rendered =  this.runReplaceAllVariables(chosen_note_template, row)
          //   //   }
    
    
          //   // this.toastr.info('Chosen SUOT : ' + get_suot_id);
          //   const objIndex = this.search_results.findIndex((obj => obj.subject_id === subject_id));
          //   this.search_results[objIndex].email_template_primary_HTML_rendered = this.transform2(email_template_primary_HTML_rendered);
          //   this.search_results[objIndex].email_subject_primary_rendered = this.transform2(email_subject_primary_rendered);
          //   this.search_results[objIndex].note_template_HTML_rendered = this.transform2(note_template_HTML_rendered);
          //   this.search_results[objIndex].suot_id = this.subject_urgent_outcome_template[0].suot_id;
          //   this.search_results[objIndex].suot_agent_id = row.allocated_to_array[0].brand_id;

          //   // this.search_results[objIndex].email_template_primary_HTML = this.transform2(chosen_template);
          // },0); // enough time to load template above
    }


   
    if(status == 'AOS'  && row.allocated_to != ""){
        
      get_suot_id = 4;
          
      // this.getSubjectUrgentOutcomeTemplate(get_suot_id);
      // this.runReplaceAllVariableFunctions(row, subject_id) // Run all the functions first
   
      // this.getData(row, subject_id, get_suot_id);
      this.runReplaceAllVariableFunctions_Observables(row, subject_id, get_suot_id)

          console.log('after data loaded... asyc');
    
          
          // setTimeout(() => {  
          //   // chosen_template = this.subject_urgent_outcome_template[0].email_template_primary_HTML;
          //   // chosen_subject = this.subject_urgent_outcome_template[0].email_subject_primary;
          //   // chosen_template_private = this.subject_urgent_outcome_template[0].email_template_private_HTML;
          //   // chosen_subject_private = this.subject_urgent_outcome_template[0].email_subject_private;
    
          //   // chosen_note_template = this.subject_urgent_outcome_template[0].note_template_HTML;
          //   // chosen_note_template_private = this.subject_urgent_outcome_template[0].note_template_HTML_private;
            
          //   if(this.chosen_template != null){
          //     chosen_template = this.chosen_template
          //     chosen_subject = this.chosen_subject
          //     chosen_template_private = this.chosen_template_private
          //     chosen_subject_private = this.chosen_subject_private
      
          //     chosen_note_template = this.chosen_note_template
          //     chosen_note_template_private = this.chosen_note_template_private
          //   }

          //   // Need to load assigned agent to get privacy details for templates frirst.
          //   // console.log('Assigned Agent: ' + this.assignedBrandList_paragraphs[0].name)
          //   // let is_privacy_emails = this.assignedBrandList_paragraphs[0].is_privacy_emails
          //   // let is_privacy_notes = this.assignedBrandList_paragraphs[0].is_privacy_notes
          //   let is_privacy_emails = row.allocated_to_array[0].is_privacy_emails
          //   let is_privacy_notes = row.allocated_to_array[0].is_privacy_notes
          //   let email_template_primary_HTML_rendered = null;
          //   let email_subject_primary_rendered = null;
          //   let note_template_HTML_rendered = null;
    
    
          //   // Render/Run MergeReplace Functions
          //   if(is_privacy_emails == 1){
          //   email_template_primary_HTML_rendered =  this.runReplaceAllVariables(chosen_template_private, row)
          //   email_subject_primary_rendered =  this.runReplaceAllVariables(chosen_subject_private, row)
          //   }else{
          //     email_template_primary_HTML_rendered =  this.runReplaceAllVariables(chosen_template, row)
          //     email_subject_primary_rendered =  this.runReplaceAllVariables(chosen_subject, row)
          //   }
    
          //   note_template_HTML_rendered =  this.runReplaceAllVariables(chosen_note_template, row)
    
          //   // console.log('Is privacy Notes: ' + is_privacy_notes)
    
          //   // if(is_privacy_notes == 1 ){
          //   //   note_template_HTML_rendered =  this.runReplaceAllVariables(chosen_note_template_private, row)
          //   //   }else{
          //   //   note_template_HTML_rendered =  this.runReplaceAllVariables(chosen_note_template, row)
          //   //   }
    
    
          //   // this.toastr.info('Chosen SUOT : ' + get_suot_id);
          //   const objIndex = this.search_results.findIndex((obj => obj.subject_id === subject_id));
          //   this.search_results[objIndex].email_template_primary_HTML_rendered = this.transform2(email_template_primary_HTML_rendered);
          //   this.search_results[objIndex].email_subject_primary_rendered = this.transform2(email_subject_primary_rendered);
          //   this.search_results[objIndex].note_template_HTML_rendered = this.transform2(note_template_HTML_rendered);
          //   this.search_results[objIndex].suot_id = this.subject_urgent_outcome_template[0].suot_id;
          //   this.search_results[objIndex].suot_agent_id = row.allocated_to_array[0].brand_id;

          //   // this.search_results[objIndex].email_template_primary_HTML = this.transform2(chosen_template);
          // },0); // enough time to load template above
    }
  


    if(status == 'AOA'  && row.allocated_to != ""){
        
      get_suot_id = 5;
          
      // this.getSubjectUrgentOutcomeTemplate(get_suot_id);
      // this.runReplaceAllVariableFunctions(row, subject_id) // Run all the functions first
   
      // this.getData(row, subject_id, get_suot_id);
      this.runReplaceAllVariableFunctions_Observables(row, subject_id, get_suot_id)

          console.log('after data loaded... asyc');
    
          
              //   setTimeout(() => {  
              //     // chosen_template = this.subject_urgent_outcome_template[0].email_template_primary_HTML;
              //     // chosen_subject = this.subject_urgent_outcome_template[0].email_subject_primary;
              //     // chosen_template_private = this.subject_urgent_outcome_template[0].email_template_private_HTML;
              //     // chosen_subject_private = this.subject_urgent_outcome_template[0].email_subject_private;
          
              //     // chosen_note_template = this.subject_urgent_outcome_template[0].note_template_HTML;
              //     // chosen_note_template_private = this.subject_urgent_outcome_template[0].note_template_HTML_private;
                
              //     if(this.chosen_template != null){
              //       chosen_template = this.chosen_template
              //       chosen_subject = this.chosen_subject
              //       chosen_template_private = this.chosen_template_private
              //       chosen_subject_private = this.chosen_subject_private
            
              //       chosen_note_template = this.chosen_note_template
              //       chosen_note_template_private = this.chosen_note_template_private
              //     }

              //     // Need to load assigned agent to get privacy details for templates frirst.
              //     // console.log('Assigned Agent: ' + this.assignedBrandList_paragraphs[0].name)
              //     // let is_privacy_emails = this.assignedBrandList_paragraphs[0].is_privacy_emails
              //     // let is_privacy_notes = this.assignedBrandList_paragraphs[0].is_privacy_notes
              //     let is_privacy_emails = row.allocated_to_array[0].is_privacy_emails
              //     let is_privacy_notes = row.allocated_to_array[0].is_privacy_notes
              //     let email_template_primary_HTML_rendered = null;
              //     let email_subject_primary_rendered = null;
              //     let note_template_HTML_rendered = null;
          
          
              //     // Render/Run MergeReplace Functions
              //     if(is_privacy_emails == 1){
              //     email_template_primary_HTML_rendered =  this.runReplaceAllVariables(chosen_template_private, row)
              //     email_subject_primary_rendered =  this.runReplaceAllVariables(chosen_subject_private, row)
              //     }else{
              //       email_template_primary_HTML_rendered =  this.runReplaceAllVariables(chosen_template, row)
              //       email_subject_primary_rendered =  this.runReplaceAllVariables(chosen_subject, row)
              //     }
          
              //     note_template_HTML_rendered =  this.runReplaceAllVariables(chosen_note_template, row)
          
              //     // console.log('Is privacy Notes: ' + is_privacy_notes)
          
              //     // if(is_privacy_notes == 1 ){
              //     //   note_template_HTML_rendered =  this.runReplaceAllVariables(chosen_note_template_private, row)
              //     //   }else{
              //     //   note_template_HTML_rendered =  this.runReplaceAllVariables(chosen_note_template, row)
              //     //   }
          
          
              //     // this.toastr.info('Chosen SUOT : ' + get_suot_id);
              //     const objIndex = this.search_results.findIndex((obj => obj.subject_id === subject_id));
              //     this.search_results[objIndex].email_template_primary_HTML_rendered = this.transform2(email_template_primary_HTML_rendered);
              //     this.search_results[objIndex].email_subject_primary_rendered = this.transform2(email_subject_primary_rendered);
              //     this.search_results[objIndex].note_template_HTML_rendered = this.transform2(note_template_HTML_rendered);
              //     this.search_results[objIndex].suot_id = this.subject_urgent_outcome_template[0].suot_id;
              // this.search_results[objIndex].suot_agent_id = row.allocated_to_array[0].brand_id;

              //     // this.search_results[objIndex].email_template_primary_HTML = this.transform2(chosen_template);
              //   },0); // enough time to load template above
    }

    // Lookup Template

  }


  // Check if final Date Exists
  checkFinalDate(final_date, subject_id, job_status, row){
    const nowDate = this.legalDate.toPickerDate(new Date()) ?? new Date();
    const finalDateComparison = final_date ? this.legalDate.compare(final_date, new Date()) : null;
  
    // If null or not exists
    if( job_status == 'OPEN' && (!final_date || final_date == null) ){
      // // this.toastr.success('Rule 1 : True');
      const objIndex = this.search_results.findIndex((obj => obj.subject_id === subject_id));
      this.search_results[objIndex].rule_1 = '1';
      this.search_results[objIndex].rule_rule = 'Job Status is ' + job_status + ' and Final Date Not Set';
      this.search_results[objIndex].rule_result ='Status will be changed to UPDREQ and and next changed to now. Final Date remians. ' // NO CHANGE UPGRADE
      this.search_results[objIndex].update_job_status = 'UPDREQ';
      this.search_results[objIndex].update_next_date = nowDate
      // this.search_results[objIndex].update_final_date = nowDate  //  NO CHANGE UPGRADE
      this.search_results[objIndex].update_final_date = row.final_date


      return 1;
    }


    // console.log('Now Date: ' + nowDate);
    // console.log('Final Date: ' + final_date)

    // if less than today.
    // :: @https://www.cloudhadoop.com/angular-compare-dates
    // 
   if (job_status == 'OPEN' && finalDateComparison !== null && finalDateComparison < 0) {
    console.log("date1 is before current date");

    // this.toastr.success('Rule 1b : True');
    const objIndex = this.search_results.findIndex((obj => obj.subject_id === subject_id));
    this.search_results[objIndex].rule_1b = '1';

    this.search_results[objIndex].rule_rule = 'Job Status is ' + job_status + ' and Final Date is in the past';
    this.search_results[objIndex].rule_result ='If final date is less then the date and time now; the next date will be set to the final date, and final date remains '
    this.search_results[objIndex].update_job_status = 'UPDREQ';
    this.search_results[objIndex].update_next_date = row.final_date
    this.search_results[objIndex].update_final_date = row.final_date


    return 1;

  }



  if (job_status == 'OPEN' && finalDateComparison !== null && finalDateComparison > 0) {
    console.log("date1 is after current date");

    // this.toastr.success('Rule 1c : True');
    const objIndex = this.search_results.findIndex((obj => obj.subject_id === subject_id));
    this.search_results[objIndex].rule_1c = '1';

    this.search_results[objIndex].rule_rule = 'Job Status is ' + job_status + ' and Final Date is in the future';
    this.search_results[objIndex].rule_result ='If the final date is greater than now the next date becomes now and the final date remains'
    this.search_results[objIndex].update_job_status = 'UPDREQ';
    this.search_results[objIndex].update_next_date = nowDate
    // this.search_results[objIndex].update_final_date = row.final_date // NO CHANGE UPGRADE
    this.search_results[objIndex].update_final_date = row.final_date 
    
    return 1;

  }


    // If null or not exists
    if( job_status == 'UPDREQ' && (!final_date || final_date == null) ){
      // this.toastr.success('Rule 2 : True');
      const objIndex = this.search_results.findIndex((obj => obj.subject_id === subject_id));
      this.search_results[objIndex].rule_2 = '1';
      this.search_results[objIndex].rule_rule = 'Job Status is ' + job_status + ' and Final Date Not Set';
      // this.search_results[objIndex].rule_result ='Status will NOT BE changed and if final date null or not yet set it to now. next date remains '
      this.search_results[objIndex].rule_result ='Status will NOT BE changed and final  will remain. next date remains '
      this.search_results[objIndex].update_job_status = 'UPDREQ';
      this.search_results[objIndex].update_next_date = row.next_date
      // this.search_results[objIndex].update_final_date = nowDate
      this.search_results[objIndex].update_final_date = row.final_date // NO CHANGE UPGRADE


      return 1;
    }
    if (job_status == 'UPDREQ' && finalDateComparison !== null && finalDateComparison < 0) {
      console.log("date1 is before current date");
  
      // this.toastr.success('Rule 2b : True');
      const objIndex = this.search_results.findIndex((obj => obj.subject_id === subject_id));
      this.search_results[objIndex].rule_2b = '1';
  
      this.search_results[objIndex].rule_rule = 'Job Status is ' + job_status + ' and Final Date is in the past';
      this.search_results[objIndex].rule_result ='If final date is less then the date and time now; set the next date to now. Final Date remains'
      this.search_results[objIndex].update_job_status = 'UPDREQ';
      this.search_results[objIndex].update_next_date = nowDate
      this.search_results[objIndex].update_final_date = row.final_date
  
  
      return 1;
  
    }


    if (job_status == 'UPDREQ' && finalDateComparison !== null && finalDateComparison > 0) {
      console.log("date1 is after current date");
  
      // this.toastr.success('Rule 2c : True');
      const objIndex = this.search_results.findIndex((obj => obj.subject_id === subject_id));
      this.search_results[objIndex].rule_2c = '1';
  
      this.search_results[objIndex].rule_rule = 'Job Status is ' + job_status + ' and Final Date is in the future';
      this.search_results[objIndex].rule_result ='If the final date is greater than now there will be no changes. Final date remains'
      this.search_results[objIndex].update_job_status = 'UPDREQ';
      this.search_results[objIndex].update_next_date = row.next_date
      this.search_results[objIndex].update_final_date = row.final_date
      
      return 1;
  
    }

// UPDSENT

    // If null or not exists
    if( job_status == 'UPDSENT' && (!final_date || final_date == null) ){
      // this.toastr.success('Rule 3 : True');
      const objIndex = this.search_results.findIndex((obj => obj.subject_id === subject_id));
      this.search_results[objIndex].rule_3 = '1';
      this.search_results[objIndex].rule_rule = 'Job Status is ' + job_status + ' and Final Date Not Set';
      this.search_results[objIndex].rule_result ='Status will changed to UPDREQ, and final date will remain unchanged.  '
      this.search_results[objIndex].update_job_status = 'UPDREQ';
      this.search_results[objIndex].update_next_date = row.next_date
      // this.search_results[objIndex].update_final_date = nowDate // NO CHANGE UPGRADE
      this.search_results[objIndex].update_final_date = row.final_date

      return 1;
    }


    if (job_status == 'UPDSENT' && finalDateComparison !== null && finalDateComparison < 0) {
      console.log("date1 is before current date");
  
      // this.toastr.success('Rule 3b : True');
      const objIndex = this.search_results.findIndex((obj => obj.subject_id === subject_id));
      this.search_results[objIndex].rule_3b = '1';
  
      this.search_results[objIndex].rule_rule = 'Job Status is ' + job_status + ' and Final Date is in the past';
      this.search_results[objIndex].rule_result =' If the final date is less than now set next date to now. Final Date remains '
      this.search_results[objIndex].update_job_status = 'UPDREQ';
      this.search_results[objIndex].update_next_date = nowDate
      this.search_results[objIndex].update_final_date = row.final_date
  
  
      return 1;
  
    }

    if (job_status == 'UPDSENT' && finalDateComparison !== null && finalDateComparison > 0) {
      console.log("date1 is after current date");
  
      // this.toastr.success('Rule 3c : True');
      const objIndex = this.search_results.findIndex((obj => obj.subject_id === subject_id));
      this.search_results[objIndex].rule_3c = '1';
  
      this.search_results[objIndex].rule_rule = 'Job Status is ' + job_status + ' and Final Date is in the future';
      this.search_results[objIndex].rule_result ='If the final date is greater than now there will be no changes. Final Date Remains'
      this.search_results[objIndex].update_job_status = 'UPDREQ';
      this.search_results[objIndex].update_next_date = row.next_date
      this.search_results[objIndex].update_final_date = row.final_date
      
      return 1;
  
  }
// AOS
    // If null or not exists
    if( job_status == 'AOS' && (!final_date || final_date == null) ){
      // this.toastr.success('Rule 4 : True');
      const objIndex = this.search_results.findIndex((obj => obj.subject_id === subject_id));
      this.search_results[objIndex].rule_4 = '1';
      this.search_results[objIndex].rule_rule = 'Job Status is ' + job_status + ' and Final Date Not Set.';
      this.search_results[objIndex].rule_result ='Status and dates will not be changed.'
      this.search_results[objIndex].update_job_status = 'AOS';
      this.search_results[objIndex].update_next_date = row.next_date
      this.search_results[objIndex].update_final_date = row.final_date

      return 1;
    }

    if (job_status == 'AOS' && finalDateComparison !== null && finalDateComparison < 0) {
      console.log("date1 is before current date");
  
      // this.toastr.success('Rule 4b : True');
      const objIndex = this.search_results.findIndex((obj => obj.subject_id === subject_id));
      this.search_results[objIndex].rule_4b = '1';
  
      this.search_results[objIndex].rule_rule = 'Job Status is ' + job_status + ' and Final Date is in the past';
      this.search_results[objIndex].rule_result ='Status and dates will not be changed.'
      this.search_results[objIndex].update_job_status = 'AOS';
      this.search_results[objIndex].update_next_date = row.next_date
      this.search_results[objIndex].update_final_date = row.final_date
  
  
      return 1;
  
    }
    if (job_status == 'AOS' && finalDateComparison !== null && finalDateComparison > 0) {
      console.log("date1 is after current date");
  
      // this.toastr.success('Rule 4c : True');
      const objIndex = this.search_results.findIndex((obj => obj.subject_id === subject_id));
      this.search_results[objIndex].rule_4c = '1';
  
      this.search_results[objIndex].rule_rule = 'Job Status is ' + job_status + ' and Final Date is in the future';
      this.search_results[objIndex].rule_result ='Status and dates will not be changed'
      this.search_results[objIndex].update_job_status = 'AOS';
      this.search_results[objIndex].update_next_date = row.next_date
      this.search_results[objIndex].update_final_date = row.final_date
      
      return 1;
  
  }

  // AOA
  if( job_status == 'AOA' && (!final_date || final_date == null) ){
    // this.toastr.success('Rule 5 : True');
    const objIndex = this.search_results.findIndex((obj => obj.subject_id === subject_id));
    this.search_results[objIndex].rule_5 = '1';
    this.search_results[objIndex].rule_rule = 'Job Status is ' + job_status + ' and Final Date Not Set';
    this.search_results[objIndex].rule_result ='If subject status AOA, and final date and next date is to remain unchanged'
    this.search_results[objIndex].update_job_status = 'AOA';
    this.search_results[objIndex].update_next_date = row.next_date
    // this.search_results[objIndex].update_final_date = nowDate  // NO CHANGE UPGRADE
    this.search_results[objIndex].update_final_date = row.final_date 


    return 1;
  }


  if (job_status == 'AOA' && finalDateComparison !== null && finalDateComparison < 0) {
    console.log("date1 is before current date");

    // this.toastr.success('Rule 5b : True');
    const objIndex = this.search_results.findIndex((obj => obj.subject_id === subject_id));
    this.search_results[objIndex].rule_5b = '1';

    this.search_results[objIndex].rule_rule = 'Job Status is ' + job_status + ' and Final Date is in the past';
    // this.search_results[objIndex].rule_result ='If the final date is less than now set next date to the final date.'
    this.search_results[objIndex].rule_result ='If the final date is less than now set next date to the final date.'
    this.search_results[objIndex].update_job_status = 'AOA';
    this.search_results[objIndex].update_next_date = row.final_date
    this.search_results[objIndex].update_final_date = row.final_date


    return 1;

  }

  if (job_status == 'AOA' && finalDateComparison !== null && finalDateComparison > 0) {
    console.log("date1 is after current date");

    // this.toastr.success('Rule 5c : True');
    const objIndex = this.search_results.findIndex((obj => obj.subject_id === subject_id));
    this.search_results[objIndex].rule_5c = '1';

    this.search_results[objIndex].rule_rule = 'Job Status is ' + job_status + ' and Final Date is in the future';
    this.search_results[objIndex].rule_result ='Status and dates will not be changed'
    this.search_results[objIndex].update_job_status = 'AOA';
    this.search_results[objIndex].update_next_date = row.next_date
    this.search_results[objIndex].update_final_date = row.final_date
    
    return 1;
  }

}

  // Else the next date will stay unchanged






//   // Check if final Date Exists
//   checkFinalDate(final_date, subject_id, job_status, row){
//     let nowDate = new Date();
  
//     // If null or not exists
//     if( job_status == 'OPEN' && (!final_date || final_date == null) ){
//       // // this.toastr.success('Rule 1 : True');
//       const objIndex = this.search_results.findIndex((obj => obj.subject_id === subject_id));
//       this.search_results[objIndex].rule_1 = '1';
//       this.search_results[objIndex].rule_rule = 'Job Status is ' + job_status + ' and Final Date Not Set';
//       this.search_results[objIndex].rule_result ='Status will be changed to UPDREQ and filinal date and next changed to now. '
//       this.search_results[objIndex].update_job_status = 'UPDREQ';
//       this.search_results[objIndex].update_next_date = nowDate
//       this.search_results[objIndex].update_final_date = nowDate

//       return 1;
//     }


//     // console.log('Now Date: ' + nowDate);
//     // console.log('Final Date: ' + final_date)

//     // if less than today.
//     // :: @https://www.cloudhadoop.com/angular-compare-dates
//     // 
//    let date1: Date = new Date(final_date);
//    let final_date_formatted: Date = new Date(final_date);
//    let currentDate: Date = new Date();

//    if (job_status == 'OPEN' && (final_date != null && final_date_formatted.getTime() < currentDate.getTime())) {
//     console.log("date1 is before current date");

//     // this.toastr.success('Rule 1b : True');
//     const objIndex = this.search_results.findIndex((obj => obj.subject_id === subject_id));
//     this.search_results[objIndex].rule_1b = '1';

//     this.search_results[objIndex].rule_rule = 'Job Status is ' + job_status + ' and Final Date is in the past';
//     this.search_results[objIndex].rule_result ='If final date is less then the date and time now; the next date will be set to the final date, and final date remains '
//     this.search_results[objIndex].update_job_status = 'UPDREQ';
//     this.search_results[objIndex].update_next_date = row.final_date
//     this.search_results[objIndex].update_final_date = row.final_date


//     return 1;

//   }



//   if (job_status == 'OPEN' && (final_date != null && final_date_formatted.getTime() > currentDate.getTime())) {
//     console.log("date1 is after current date");

//     // this.toastr.success('Rule 1c : True');
//     const objIndex = this.search_results.findIndex((obj => obj.subject_id === subject_id));
//     this.search_results[objIndex].rule_1c = '1';

//     this.search_results[objIndex].rule_rule = 'Job Status is ' + job_status + ' and Final Date is in the future';
//     this.search_results[objIndex].rule_result ='If the final date is greater than now the next date becomes now and the final date remains'
//     this.search_results[objIndex].update_job_status = 'UPDREQ';
//     this.search_results[objIndex].update_next_date = nowDate
//     this.search_results[objIndex].update_final_date = row.final_date
    
//     return 1;

//   }


//     // If null or not exists
//     if( job_status == 'UPDREQ' && (!final_date || final_date == null) ){
//       // this.toastr.success('Rule 2 : True');
//       const objIndex = this.search_results.findIndex((obj => obj.subject_id === subject_id));
//       this.search_results[objIndex].rule_2 = '1';
//       this.search_results[objIndex].rule_rule = 'Job Status is ' + job_status + ' and Final Date Not Set';
//       this.search_results[objIndex].rule_result ='Status will NOT BE changed and if final date null or not yet set it to now. next date remains '
//       this.search_results[objIndex].update_job_status = 'UPDREQ';
//       this.search_results[objIndex].update_next_date = row.next_date
//       this.search_results[objIndex].update_final_date = nowDate

//       return 1;
//     }
//     if (job_status == 'UPDREQ' && (final_date != null && final_date_formatted.getTime() < currentDate.getTime())) {
//       console.log("date1 is before current date");
  
//       // this.toastr.success('Rule 2b : True');
//       const objIndex = this.search_results.findIndex((obj => obj.subject_id === subject_id));
//       this.search_results[objIndex].rule_2b = '1';
  
//       this.search_results[objIndex].rule_rule = 'Job Status is ' + job_status + ' and Final Date is in the past';
//       this.search_results[objIndex].rule_result ='If final date is less then the date and time now; set the next date to now. '
//       this.search_results[objIndex].update_job_status = 'UPDREQ';
//       this.search_results[objIndex].update_next_date = nowDate
//       this.search_results[objIndex].update_final_date = row.final_date
  
  
//       return 1;
  
//     }


//     if (job_status == 'UPDREQ' && (final_date != null && final_date_formatted.getTime() > currentDate.getTime())) {
//       console.log("date1 is after current date");
  
//       // this.toastr.success('Rule 2c : True');
//       const objIndex = this.search_results.findIndex((obj => obj.subject_id === subject_id));
//       this.search_results[objIndex].rule_2c = '1';
  
//       this.search_results[objIndex].rule_rule = 'Job Status is ' + job_status + ' and Final Date is in the future';
//       this.search_results[objIndex].rule_result ='If the final date is greater than now there will be no changes.'
//       this.search_results[objIndex].update_job_status = 'UPDREQ';
//       this.search_results[objIndex].update_next_date = row.next_date
//       this.search_results[objIndex].update_final_date = row.final_date
      
//       return 1;
  
//     }

// // UPDSENT

//     // If null or not exists
//     if( job_status == 'UPDSENT' && (!final_date || final_date == null) ){
//       // this.toastr.success('Rule 3 : True');
//       const objIndex = this.search_results.findIndex((obj => obj.subject_id === subject_id));
//       this.search_results[objIndex].rule_3 = '1';
//       this.search_results[objIndex].rule_rule = 'Job Status is ' + job_status + ' and Final Date Not Set';
//       this.search_results[objIndex].rule_result ='Status will changed to UPDREQ, and final date null or not yet set it to now, otherwise final date will remain unchanged.  '
//       this.search_results[objIndex].update_job_status = 'UPDREQ';
//       this.search_results[objIndex].update_next_date = row.next_date
//       this.search_results[objIndex].update_final_date = nowDate

//       return 1;
//     }


//     if (job_status == 'UPDSENT' && (final_date != null && final_date_formatted.getTime() < currentDate.getTime())) {
//       console.log("date1 is before current date");
  
//       // this.toastr.success('Rule 3b : True');
//       const objIndex = this.search_results.findIndex((obj => obj.subject_id === subject_id));
//       this.search_results[objIndex].rule_3b = '1';
  
//       this.search_results[objIndex].rule_rule = 'Job Status is ' + job_status + ' and Final Date is in the past';
//       this.search_results[objIndex].rule_result =' If the final date is less than now set next date to now '
//       this.search_results[objIndex].update_job_status = 'UPDREQ';
//       this.search_results[objIndex].update_next_date = nowDate
//       this.search_results[objIndex].update_final_date = row.final_date
  
  
//       return 1;
  
//     }

//     if (job_status == 'UPDSENT' && (final_date != null && final_date_formatted.getTime() > currentDate.getTime())) {
//       console.log("date1 is after current date");
  
//       // this.toastr.success('Rule 3c : True');
//       const objIndex = this.search_results.findIndex((obj => obj.subject_id === subject_id));
//       this.search_results[objIndex].rule_3c = '1';
  
//       this.search_results[objIndex].rule_rule = 'Job Status is ' + job_status + ' and Final Date is in the future';
//       this.search_results[objIndex].rule_result ='If the final date is greater than now there will be no changes.'
//       this.search_results[objIndex].update_job_status = 'UPDREQ';
//       this.search_results[objIndex].update_next_date = row.next_date
//       this.search_results[objIndex].update_final_date = row.final_date
      
//       return 1;
  
//   }
// // AOS
//     // If null or not exists
//     if( job_status == 'AOS' && (!final_date || final_date == null) ){
//       // this.toastr.success('Rule 4 : True');
//       const objIndex = this.search_results.findIndex((obj => obj.subject_id === subject_id));
//       this.search_results[objIndex].rule_4 = '1';
//       this.search_results[objIndex].rule_rule = 'Job Status is ' + job_status + ' and Final Date Not Set';
//       this.search_results[objIndex].rule_result ='Status and dates will not be changed.'
//       this.search_results[objIndex].update_job_status = 'AOS';
//       this.search_results[objIndex].update_next_date = row.next_date
//       this.search_results[objIndex].update_final_date = row.final_date

//       return 1;
//     }

//     if (job_status == 'AOS' && (final_date != null && final_date_formatted.getTime() < currentDate.getTime())) {
//       console.log("date1 is before current date");
  
//       // this.toastr.success('Rule 4b : True');
//       const objIndex = this.search_results.findIndex((obj => obj.subject_id === subject_id));
//       this.search_results[objIndex].rule_4b = '1';
  
//       this.search_results[objIndex].rule_rule = 'Job Status is ' + job_status + ' and Final Date is in the past';
//       this.search_results[objIndex].rule_result ='Status and dates will not be changed.'
//       this.search_results[objIndex].update_job_status = 'AOS';
//       this.search_results[objIndex].update_next_date = row.next_date
//       this.search_results[objIndex].update_final_date = row.final_date
  
  
//       return 1;
  
//     }
//     if (job_status == 'AOS' && (final_date != null && final_date_formatted.getTime() > currentDate.getTime())) {
//       console.log("date1 is after current date");
  
//       // this.toastr.success('Rule 4c : True');
//       const objIndex = this.search_results.findIndex((obj => obj.subject_id === subject_id));
//       this.search_results[objIndex].rule_4c = '1';
  
//       this.search_results[objIndex].rule_rule = 'Job Status is ' + job_status + ' and Final Date is in the future';
//       this.search_results[objIndex].rule_result ='Status and dates will not be changed'
//       this.search_results[objIndex].update_job_status = 'AOS';
//       this.search_results[objIndex].update_next_date = row.next_date
//       this.search_results[objIndex].update_final_date = row.final_date
      
//       return 1;
  
//   }

//   // AOA
//   if( job_status == 'AOA' && (!final_date || final_date == null) ){
//     // this.toastr.success('Rule 5 : True');
//     const objIndex = this.search_results.findIndex((obj => obj.subject_id === subject_id));
//     this.search_results[objIndex].rule_5 = '1';
//     this.search_results[objIndex].rule_rule = 'Job Status is ' + job_status + ' and Final Date Not Set';
//     this.search_results[objIndex].rule_result ='If subject status AOA, and final date null or not yet set it to now, Status  and next date is to remain unchanged'
//     this.search_results[objIndex].update_job_status = 'AOA';
//     this.search_results[objIndex].update_next_date = row.next_date
//     this.search_results[objIndex].update_final_date = nowDate

//     return 1;
//   }


//   if (job_status == 'AOA' && (final_date != null && final_date_formatted.getTime() < currentDate.getTime())) {
//     console.log("date1 is before current date");

//     // this.toastr.success('Rule 5b : True');
//     const objIndex = this.search_results.findIndex((obj => obj.subject_id === subject_id));
//     this.search_results[objIndex].rule_5b = '1';

//     this.search_results[objIndex].rule_rule = 'Job Status is ' + job_status + ' and Final Date is in the past';
//     this.search_results[objIndex].rule_result ='If the final date is less than now set next date to the final date.'
//     this.search_results[objIndex].update_job_status = 'AOA';
//     this.search_results[objIndex].update_next_date = row.final_date
//     this.search_results[objIndex].update_final_date = row.final_date


//     return 1;

//   }

//   if (job_status == 'AOA' && (final_date != null && final_date_formatted.getTime() > currentDate.getTime())) {
//     console.log("date1 is after current date");

//     // this.toastr.success('Rule 5c : True');
//     const objIndex = this.search_results.findIndex((obj => obj.subject_id === subject_id));
//     this.search_results[objIndex].rule_5c = '1';

//     this.search_results[objIndex].rule_rule = 'Job Status is ' + job_status + ' and Final Date is in the future';
//     this.search_results[objIndex].rule_result ='Status and dates will not be changed'
//     this.search_results[objIndex].update_job_status = 'AOA';
//     this.search_results[objIndex].update_next_date = row.next_date
//     this.search_results[objIndex].update_final_date = row.final_date
    
//     return 1;
//   }

// }

//   // Else the next date will stay unchanged

    // ::@https://stackoverflow.com/questions/29369512/render-html-entities-string-in-html-with-angular properway to do it (decode html special charactors for dispaly)
  // WORKS as I created my own function from this articel == pretty well convers
  transform2(value: any, args?: any): any {
    const doc = new DOMParser().parseFromString(value, 'text/html');
    return doc.documentElement.textContent;
  }

  private setLegalGridDateFields(element: any): void {
    ['next_date', 'final_date', 'hearing_date', 'judgement_date', 'filing_date', 'instructions_date', 'aos_date']
      .forEach((field) => {
        element[`${field}_display`] = this.legalDate.format(element[field], 'DD/MM/YYYY h:mm a');
        element[`${field}_search`] = this.toLegalGridSearchKey(element[field]);
      });
  }

  private applyLegalGridDateFields(rows: any[]): any[] {
    if (!Array.isArray(rows)) {
      return rows;
    }

    rows.forEach((row) => this.setLegalGridDateFields(row));
    return rows;
  }

  private toLegalGridSearchKey(value: any): string {
    return this.legalDate.format(value, 'YYYY-MM-DD');
  }




  
  searchGridColNextDateToday(name, operator) {
    // const searchText: string = (document.getElementsByClassName('searchtext')[0] as any).value;
    // const searchText: string = name;
    // this.grid.search(searchText);
    
    // clear first
    this.grid.searchSettings.key = '';
    // now update the search uptions // equal // Neq.
    this.searchOptions = {
      fields: ['next_date_search'],
      operator,
      key: this.toLegalGridSearchKey(name),
      ignoreCase: true,
    };
    // now refresh the grid
    this.grid.refresh();
    }

    searchGridColAnyDate( field, name, operator) {
      // const searchText: string = (document.getElementsByClassName('searchtext')[0] as any).value;
      // const searchText: string = name;
      // this.grid.search(searchText);
      
      // clear first
      this.grid.searchSettings.key = '';
      // now update the search uptions // equal // Neq.
      this.searchOptions = {
        fields: [`${field}_search`],
        operator,
        key: this.toLegalGridSearchKey(name),
        ignoreCase: true,
      };
      // now refresh the grid
      this.grid.refresh();
      }



  refreshSearchGrid(){ // refresh the databutton
    this.mapJobTableLive();
    this.grid.refresh();
  };
  
  exportPDFClick(args: ClickEventArgs): void {
    if (args.item.id === 'Grid_pdfexport') { // 'Grid_pdfexport' -> Grid component id + _ + toolbar item name
        this.grid.pdfExport();
    }
  }
  
  
  getBrandBrandTypes(){
    this._demoService.getBrandBrandTypes().subscribe(
      data => { this.brand_types = data;
       let res = data[0];
     },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }
  
  getUsers() {
    this._demoService.getUsers().subscribe(
      data => { this.users = data;
        this.usersPrimary = data;
       let res = data[0];
     },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }



  getSubjectUrgentOutcomeTemplate(suot_id) {
    this._demoService.getSubjectUrgentOutcomeTemplate(suot_id)
    .pipe(
      this.toastr.observe({
        loading: 'Checking...',
        success: 'SUOT 🚀..',
        error: '...😡 '
     })
     )  
    .subscribe(
        res => {
          this.subject_urgent_outcome_template = res;
          let data = res[0]


          this.chosen_template = res[0].email_template_primary_HTML;
          this.chosen_subject = res[0].email_subject_primary;
          this.chosen_template_private = res[0].email_template_private_HTML;
          this.chosen_subject_private = res[0].email_subject_private;
  
          this.chosen_note_template = res[0].note_template_HTML;
          this.chosen_note_template_private = res[0].note_template_HTML_private;
  
          return data
  
              // this.allFileAutomations = JSON.parse(this.system_automation[0].system_file_array);
              // this.allCommunicationsAutomations = JSON.parse(this.system_automation[0].system_communication_array);
              // this.allConditionsAutomations = JSON.parse(this.system_automation[0].system_conditions_array);
  
              // let new_model = {
              //   system_file_array: JSON.parse(this.system_automation[0].system_file_array)
              // }
              // this.getSystemSubjectTemplateDocsArray(new_model);
  
              // let new_model_b = {
              //   system_communication_array: JSON.parse(this.system_automation[0].system_communication_array)
              // }
              // this.getSystemSubjectTemplateDocsArray_Communications(new_model_b);
  
              
              // let new_model_c = {
              //   system_conditions_array: JSON.parse(this.system_automation[0].system_conditions_array)
              // }
              // this.getSystemSubjectTemplateDocsArray_Conditions(new_model_c);
  
  
  
          // this.getSystemLogType(data.system_log_type_id);
        },
        err => console.error(err.status)
      );
  }
  





// New Grid functions Feb 2023

rowSelected(args: RowSelectEventArgs) {

  // console.log('selected data object: ' + JSON.stringify(args.data));
        //  // simply push the object/s seleceted to the  this.search_results array.
        //  if(!this.search_results){this.search_results = [];}; // set so is defined before push if empty
        //  this.search_results.push({
        //    ...args.data
        //  });
        // if (typeof args.data === 'object' && args.data !== null && args.data[0].id >= 0 ){
        //   console.log('We have a header object of data selected');
        // }

        //checks if single object
        if (typeof args.data === 'object' && args.data !== null && !args.data[0] ){
          if(!this.search_results){this.search_results = [];}; // detect if array exists.
          console.log('We have a single object of data selected');

          let row_json =  DataUtil.parse.parseJson(args.data); // working version.
    

            this.search_results.push({
            ...args.data
            });
    
          //try to render on push...
          this.checkSubjectUrgentOutcometemplate(row_json.job_status, row_json, row_json.subject_id)

            this.toastr.info( this.search_results.length + ' Clicked added to search results'); 

        }

        // if an a list of objects need to count and then loop through.
        if (typeof args.data === 'object' && args.data !== null && args.data[0] ){
          console.log('We have a OBJECT of object of data selected');
          const count_selected = this.grid.getSelectedRecords().length;
          console.log('count: ' + count_selected); // lenth is used for myob comparitor array
          const length = Object.keys(args.data).length
          console.log('length: ' + length);
        

          // now loop and insert individually
          if(!this.search_results){this.search_results = [];}; // detect if array exists.
          for(let i=0;i < length; i++) {

            let row_json =  DataUtil.parse.parseJson(args.data[i]); // working version.
            //try to render on push...
         
            // setTimeout(() => {   }, 0); // enough time to load template above -- longer than the loop pause
                  // Check for no agents. if they exist...
                  
                //    if(this.assignedBrandList_paragraphs != null && this.assignedBrandList_paragraphs != '[]') { }
                // this.search_results.push({
                // ...args.data[i]
                // });
                
                // this.checkSubjectUrgentOutcometemplate(row_json.job_status, row_json, row_json.subject_id)
                              // this.runReplaceAllVariableFunctions_Observables(row_json, row_json.subject_id) // TESTING TO SEE IF RUNS IN A LOOP WITH NO DELAYS
          


            }
           this.toastr.info( this.search_results.length + ' Clicked added to search results');
          }



  const selectedrowindex: number[] = this.grid.getSelectedRowIndexes();  // Get the selected row indexes.
  // alert(selectedrowindex); // To alert the selected row indexes.
  const selectedrecords: object[] = this.grid.getSelectedRecords();  // Get the selected records.
  this.selectedrecords = this.grid.getSelectedRecords();


  }




        // we also need to create a row deselect event to remove from args
        rowDeSelected(args: RowSelectEventArgs) {

          
          const selectedrowindex: number[] = this.grid.getSelectedRowIndexes();  // Get the selected row indexes.
          // alert(selectedrowindex); // To alert the selected row indexes.
          const selectedrecords: object[] = this.grid.getSelectedRecords();  // Get the selected records.
          this.selectedrecords = this.grid.getSelectedRecords();

          // console.log('selected data object: ' + JSON.stringify(args.data));
                //  // simply push the object/s seleceted to the  this.search_results array.
              //    if(!this.search_results){this.search_results = [];}; // set so is defined before push if empty
              //  // clear the the search results. forst then re-add.
              //  this.search_results = [];
              //    this.search_results.push({
              //      ...args.data
              //    });
 
              let argData = args.data;
          if (typeof argData === 'object' && argData !== null && !argData[0] && argData !== '[]' ){
            console.log('We have a single object of data de-selected');
            let base_search_results = this.search_results
            
            // this.search_results = []; 
            // this.search_results.push({
            //   ...args.data
            //   });
            
 

              // leave items where not selected --- somehow add the ones that were already clicked before they all were removed.
              this.search_results =  this.search_results.filter(function (order) {
                // return true for salary greater than equals to 25000
                console.log('leaving IDs= ' + args.data['subject_number'] + ' != ' + order.subject_number);
                return order.subject_number != args.data['subject_number'];
              });
              this.toastr.warning( ' Subject Remved from the action list'); 
 

          // remove
          // filter and remove the selected ones from the object first.
              // let remove_unselected = this.comparitor_grid.getSelectedRowIndexes();
              // // let uniqueArray = this.search_results.filter((v,i,a)=>a.findIndex(t=>(t.id === remove_unselected))===i);
            
          }    


          // if an a list of objects need to count and then loop through.
          if (typeof args.data === 'object' && args.data !== null && args.data[0] ){
            console.log('We have a OBJECT of object of data DE-selected');
            const count_selected = this.grid.getSelectedRecords().length;
            console.log('count: ' + count_selected); // both count methods work.
            // const length = Object.keys(args.data).length
            // console.log('length: ' + length);
          
            // now loop and insert individually
       //     this.search_results = []; 
            for(let i=0;i < count_selected; i++) {
              // for(let i=0;i < count_selected; i++) { // made i 1 because was alwsays missing one
            //   this.search_results.push({
            //  ...args.data[i]
            //   });

              // leave items where not selected 
                  // this.search_results =  this.search_results.filter(function (order) {
                  // // return true for salary greater than equals to 25000
                  // console.log('leaving IDs= ' + args.data['i'].id + ' != ' + order.id);
                  // return order.id != args.data['id'];
                  // });
                  // this.search_results = this.search_results;

                               // leave items where not selected --- somehow add the ones that were already clicked before they all were removed.
              this.search_results =  this.search_results.filter(function (order) {
                // return true for salary greater than equals to 25000
                console.log('leaving IDs= ' + args.data[i]['subject_number'] + ' != ' + order.subject_number);
                return order.subject_number != args.data[i]['subject_number'];
              });
             

              }

              this.toastr.warning( ' Subjects Remved from the action list'); 
          
            }


        
          }




    clearSearchResults(){
      this.search_results = [];
      // this.comparitor_array_A = [];
      // this.comparitor_array_A_FULL = [];
      // this.comparitor_array_B = [];
      // this.comparitor_array_B_FULL = [];
      this.toastr.info('Clearing All Comparitor FULL arrays complete.')
    }

// How to make a sequence
    // https://stackoverflow.com/questions/53560652/how-to-make-a-sequence-of-http-requests-in-angular-6-using-rxjs

  //   firstPOSTCallToAPI('url', data).pipe(
  //     // concatMap(result1 => secondPOSTCallToAPI('url', result1))
  //       // concatMap( result2 => thirdPOSTCallToAPI('url', result2))
  //       //  concatMap(result3 => fourthPOSTCallToAPI('url', result3))
  //     ....
  // ).subscribe(
  //     success => { /* display success msg */ },
  //     errorData => { /* display error msg */ }
  // );



  // ::@https://medium.com/@dangeabunea/how-to-perform-multiple-http-requests-in-angular-318bd6844dae
  // Frist Method.
/*
Function works and does what it says first and then second.
*/
  seqReqests(model, subject_id){

  // this.http.get<[]>('assets/countries.json')
  // this.http.get<[]>(this._demoService.$api_get_url + '/api/job/subject/agents/brands/assigned/'  + subject_id )
  this.http.get<[]>(this._demoService.$api_get_url + '/api/job/subject/agents/brands/assigned/'  + subject_id )
    .subscribe((countries) => {
      // first call
      // this.http.get<[]>('assets/cities.json')
   return this.http.get<[]>( this._demoService.$api_get_url + '/api/job/service_rule/' + model.job_service_rule_id, this.httpOptions)
      .subscribe((cities) => {
        // second call => all data loaded
        console.log('brandsAssigned: ' + countries);
        console.log('ServiceRules: ' + cities);
        this.resultMessage = `Fetched ${countries.length} Countries and ${cities.length} cities sequentially`
       }


    );
     });

  } // end function


// Same function Using Folk Join. -- THIS ONE LOOKS TO BE THE GOODS. -- Making calls observables.
paraReqests(model,subject_id){
  // const $countries = this.http.get<[]>('assets/countries.json');
  const $countries = this.http.get<[]>(this._demoService.$api_get_url + '/api/job/subject/agents/brands/assigned/'  + subject_id );
  // const $cities = this.http.get<[]>('assets/cities.json');
  const $cities = this.http.get<[]>( this._demoService.$api_get_url + '/api/job/service_rule/' + model.job_service_rule_id, this.httpOptions);

  forkJoin([$countries, $cities]).subscribe(([countries, cities]) => {
    // All data available
    // console.log(countries);
    // console.log(cities);
    this.resultMessage = `Fetched ${countries.length} Countries and ${cities.length} cities`;
  });
}




// Explination :: This fuction works loading all reqests in parallel. then joining them. - Wonder if this is going to resolve for multiple reqiests.
// THIS FUNCTION DOES NOT WOKR IN A LOOP SCENARIO as I need a pause. - or I get a 500 LOOP detected from the server. -- added pipe(delay(220)) to the folkjoin this worked.!!!
// ::@ https://ultimatecourses.com/blog/rxjs-forkjoin-combine-observables
// Starting a new function and entirely new approach to how to get the data from the server.

runReplaceAllVariableFunctions_Observables(model, subject_id, get_suot_id){
 
const $subject_urgent_outcome_template = this.http.get<[]>( this._demoService.$api_get_url + '/api/subject_urgent_outcome_template/' + get_suot_id, this.httpOptions);

  const $assignedBrandList_paragraphs = this.http.get<[]>(this._demoService.$api_get_url + '/api/job/subject/agents/brands/assigned/'  + subject_id );
  // const $cities = this.http.get<[]>('assets/cities.json');
  const $job_service_rule_paragraphs = this.http.get<[]>( this._demoService.$api_get_url + '/api/job/service_rule/' + model.job_service_rule_id, this.httpOptions);
  const $job_service_timeframe_paragraphs = this.http.get<[]>( this._demoService.$api_get_url + '/api/job/service_timeframe/get/' + model.job_service_timeframe_id, this.httpOptions);
  const $subject_service_type_model_paragraphs = this.http.get<[]>(this._demoService.$api_get_url + '/api/job/subject/service_type/' + model.subject_service_type_id);
  const $subject_contact_numbers_paragraphs =  this.http.get<[]>( this._demoService.$api_get_url + '/api/job/subject/contact_numbers/' + subject_id, this.httpOptions);
  const $subject_contact_emails_paragraphs = this.http.get<[]>( this._demoService.$api_get_url + '/api/job/subject/contact_emails/' + subject_id, this.httpOptions);
 const $subject_service_list_paragraphs = this.http.get<[]>(this._demoService.$api_get_url + '/api/job/subject/service/allquieries/' + subject_id);
 const $service_paragraphs_model = this.http.get<[]>(this._demoService.$api_get_url + '/api/job/subject/services_only/any/' + subject_id);
 // this one has muluple nested requests/joins below --- Need to get this response and then load the rest...
 const $job_data_paragraphs = this.http.get<[]>(this._demoService.$api_get_url + '/api/job/get/' +  model.job_id );

 const $current_user_paragraphs = this.http.get<[]>(this._demoService.$api_get_url + '/api/user/' + this.gfunc.sessionUserId);   // this.gfunc.sessionUserId
 const $job_owner_client_paragraphs = this.http.get<[]>(this._demoService.$api_get_url + '/api/brands/get/' + 97); // SHARMANS ALWAYS
 /*
     
      this.getSubjectUrgentOutcomeTemplate(get_suot_id); // aded

this.getBrand(res.brand_report_id);
           this.getBrand_invoice_Q(res.brand_invoice_id)
           this.getBrand_owner_Q(97);
            this.getCurrentUser_Q(this.gfunc.sessionUserId)
           this.getUserBrand_Q(res.brand_report_user_id)
            this.getJobReportUserContact_Q(res.brand_report_user_id)
*/

// $subject_urgent_outcome_template,
forkJoin([ $assignedBrandList_paragraphs.pipe(delay(0)), $job_service_rule_paragraphs.pipe(delay(0)), $job_service_timeframe_paragraphs.pipe(delay(0)),$subject_service_type_model_paragraphs.pipe(delay(0)),$subject_contact_numbers_paragraphs.pipe(delay(0)),$subject_contact_emails_paragraphs.pipe(delay(0)),$subject_service_list_paragraphs.pipe(delay(0)),$service_paragraphs_model.pipe(delay(0)),$job_data_paragraphs.pipe(delay(0)), $current_user_paragraphs.pipe(delay(0)), $job_owner_client_paragraphs.pipe(delay(0)), $subject_urgent_outcome_template.pipe(delay(0)) ])
.pipe(
  this.toastr.observe({
    loading: 'Checking... All Merge Filed Calls',
    success: '🚀',
    error: '...😡  FAILED...' + model.subject_number
 })
 )
//  subject_urgent_outcome_template
.subscribe(([assignedBrandList_paragraphs, job_service_rule_paragraphs, job_service_timeframe_paragraphs,subject_service_type_model_paragraphs,subject_contact_numbers_paragraphs,subject_contact_emails_paragraphs,subject_service_list_paragraphs,service_paragraphs_model,job_data_paragraphs,current_user_paragraphs,job_owner_client_paragraphs,subject_urgent_outcome_template]) => {
 
    // I can now set the original this. variables from the observables made above.
    this.subject_urgent_outcome_template = null; // clear firsd
this.subject_urgent_outcome_template = subject_urgent_outcome_template;    ///--- set all the holing data for merger variables first subsription - dependants are set and run in the nest.
this.assignedBrandList_paragraphs = assignedBrandList_paragraphs
this.job_service_rule_paragraphs = job_service_rule_paragraphs
this.job_service_timeframe_paragraphs= job_service_timeframe_paragraphs
this.subject_service_type_model_paragraphs = subject_service_type_model_paragraphs
this.subject_contact_numbers_paragraphs = subject_contact_numbers_paragraphs
this.subject_contact_emails_paragraphs = subject_contact_emails_paragraphs
this.subject_service_list_paragraphs = subject_service_list_paragraphs
this.service_paragraphs_model = service_paragraphs_model
this.job_data_paragraphs = job_data_paragraphs
this.current_user_paragraphs = current_user_paragraphs
this.job_owner_client_paragraphs = job_owner_client_paragraphs


 
        // aNOTHER oBSERVABLE... HERE? AND -- nested? -- once the syscription above is loaded run the nested subscrption and FolkJoin.
      console.log('this.job_data_paragraphs[0].brand_report_id: ' + this.job_data_paragraphs[0].brand_report_id)
        const $brand_data = this.http.get<[]>(this._demoService.$api_get_url + '/api/brands/get/' + this.job_data_paragraphs[0].brand_report_id );
        const $job_report_client_user_paragraphs = this.http.get<[]>(this._demoService.$api_get_url + '/api/brands/get/' + this.job_data_paragraphs[0].brand_report_user_id );
        const $job_invoice_client_paragraphs = this.http.get<[]>(this._demoService.$api_get_url + '/api/brands/get/' + this.job_data_paragraphs[0].brand_invoice_id);
        // const $job_owner_client_paragraphs = this.http.get<[]>(this._demoService.$api_get_url + '/api/brands/get/' + 97); // SHARMANS ALWAYS
        // const $current_user_paragraphs = this.http.get<[]>(this._demoService.$api_get_url + '/api/user/' + this.gfunc.sessionUserId);   // this.gfunc.sessionUserId // was not loading here so moved to outer.
        const $user_brand_paragraphs = this.http.get<[]>(this._demoService.$api_get_url + '/api/brands/get/' + this.job_data_paragraphs[0].brand_report_user_id);
      
      // $subject_urgent_outcome_template,
      forkJoin([ 
        $brand_data.pipe(delay(0)),
        $job_invoice_client_paragraphs.pipe(delay(0)),
        // $job_owner_client_paragraphs.pipe(delay(4400)),
        // $current_user_paragraphs.pipe(delay(4600)),
        $user_brand_paragraphs.pipe(delay(0)),
        $job_report_client_user_paragraphs.pipe(delay(0)), ])
        .pipe(
          this.toastr.observe({
            loading: 'Checking... nest',
            success: '🚀',
            error: '...😡  nest...' + model.subject_number
         })
         )
      .subscribe(([job_invoice_client_paragraphs, brand_data, job_report_client_user_paragraphs, user_brand_paragraphs]) => {

        this.job_report_client_user_paragraphs = job_report_client_user_paragraphs;
        if(!this.job_report_client_user_paragraphs[0]){this.job_report_client_user_paragraphs = '[]'} // set so does not break if there are no users selected. -- This works if need to set to nulls!
        this.brand_data = brand_data;
        this.job_invoice_client_paragraphs = job_invoice_client_paragraphs;
        // this.job_owner_client_paragraphs = job_owner_client_paragraphs
        // this.current_user_paragraphs = current_user_paragraphs
        this.user_brand_paragraphs = user_brand_paragraphs
                        // Start Test // do all the if statments here if it works.

                        let get_suot_id = null
                        let chosen_template = null
                        let chosen_subject = null
                        let chosen_template_private = null
                        let chosen_subject_private = null
                        let chosen_note_template = null
                        let chosen_note_template_private = null;


                        // write a function(job_status, uuot_id) // pass this so only have to write once!!!

                        /*



 AOA                     */

                        // if OPEN
    if(model.job_status == 'OPEN' && model.allocated_to != ""){ 
      get_suot_id = 1;

    if(this.chosen_template != null){}
    
            chosen_template = this.subject_urgent_outcome_template[0].email_template_primary_HTML;
            chosen_subject = this.subject_urgent_outcome_template[0].email_subject_primary;
            chosen_template_private = this.subject_urgent_outcome_template[0].email_template_private_HTML;
            chosen_subject_private = this.subject_urgent_outcome_template[0].email_subject_private;
    
            chosen_note_template = this.subject_urgent_outcome_template[0].note_template_HTML;
            chosen_note_template_private = this.subject_urgent_outcome_template[0].note_template_private_HTML;


    // console.log('Assigned Agent: ' + this.assignedBrandList_paragraphs[0].name)
    // let is_privacy_emails = this.assignedBrandList_paragraphs[0].is_privacy_emails
    // let is_privacy_notes = this.assignedBrandList_paragraphs[0].is_privacy_notes

    console.log('Assigned Agent: ' + model.allocated_to_array[0].name)
    let is_privacy_emails = model.allocated_to_array[0].is_privacy_emails
    let is_privacy_notes = model.allocated_to_array[0].is_privacy_notes


    let email_template_primary_HTML_rendered = null;
    let email_subject_primary_rendered = null;
    let note_template_HTML_rendered = null;


        // Render/Run MergeReplace Functions
        if(is_privacy_emails == 1){
          email_template_primary_HTML_rendered =  this.runReplaceAllVariables(chosen_template_private, model)
          email_subject_primary_rendered =  this.runReplaceAllVariables(chosen_subject_private, model)
          }else{
            email_template_primary_HTML_rendered =  this.runReplaceAllVariables(chosen_template, model)
            email_subject_primary_rendered =  this.runReplaceAllVariables(chosen_subject, model)
          }

          // note_template_HTML_rendered =  this.runReplaceAllVariables(chosen_note_template, model)

          console.log('Is privacy Notes: ' + is_privacy_notes)

          if(is_privacy_notes == '1'){
            note_template_HTML_rendered =  this.runReplaceAllVariables(chosen_note_template_private, model)
            }else{
            note_template_HTML_rendered =  this.runReplaceAllVariables(chosen_note_template, model)
            }


    // this.toastr.info('Chosen SUOT : ' + get_suot_id);



    let objIndex = this.search_results.findIndex((obj => obj.subject_id === subject_id));
    this.search_results[objIndex].email_template_primary_HTML_rendered = this.transform2(email_template_primary_HTML_rendered);
    this.search_results[objIndex].email_subject_primary_rendered = this.transform2(email_subject_primary_rendered);
    this.search_results[objIndex].note_template_HTML_rendered = this.transform2(note_template_HTML_rendered);
    this.search_results[objIndex].suot_id = this.subject_urgent_outcome_template[0].suot_id;
    this.search_results[objIndex].suot_agent_id = model.allocated_to_array[0].brand_id;

    // this.toastr.info('objIndex : ' + objIndex);

    // this.search_results[objIndex].email_template_primary_HTML = this.transform2(chosen_template);
      }
      if(model.job_status == 'UPDREQ' && model.allocated_to != ""){ 
        get_suot_id = 2;

      if(this.chosen_template != null){}
      chosen_template = this.subject_urgent_outcome_template[0].email_template_primary_HTML;
      chosen_subject = this.subject_urgent_outcome_template[0].email_subject_primary;
      chosen_template_private = this.subject_urgent_outcome_template[0].email_template_private_HTML;
      chosen_subject_private = this.subject_urgent_outcome_template[0].email_subject_private;

      chosen_note_template = this.subject_urgent_outcome_template[0].note_template_HTML;
      chosen_note_template_private = this.subject_urgent_outcome_template[0].note_template_private_HTML;

      // console.log('Assigned Agent: ' + this.assignedBrandList_paragraphs[0].name)
      // let is_privacy_emails = this.assignedBrandList_paragraphs[0].is_privacy_emails
      // let is_privacy_notes = this.assignedBrandList_paragraphs[0].is_privacy_notes

      console.log('Assigned Agent: ' + model.allocated_to_array[0].name)
      let is_privacy_emails = model.allocated_to_array[0].is_privacy_emails
      let is_privacy_notes = model.allocated_to_array[0].is_privacy_notes


      let email_template_primary_HTML_rendered = null;
      let email_subject_primary_rendered = null;
      let note_template_HTML_rendered = null;


          // Render/Run MergeReplace Functions
          if(is_privacy_emails == 1){
            email_template_primary_HTML_rendered =  this.runReplaceAllVariables(chosen_template_private, model)
            email_subject_primary_rendered =  this.runReplaceAllVariables(chosen_subject_private, model)
            }else{
              email_template_primary_HTML_rendered =  this.runReplaceAllVariables(chosen_template, model)
              email_subject_primary_rendered =  this.runReplaceAllVariables(chosen_subject, model)
            }


          // note_template_HTML_rendered =  this.runReplaceAllVariables(chosen_note_template, model)

          console.log('Is privacy Notes: ' + is_privacy_notes)

          if(is_privacy_notes == '1'){
            note_template_HTML_rendered =  this.runReplaceAllVariables(chosen_note_template_private, model)
            }else{
            note_template_HTML_rendered =  this.runReplaceAllVariables(chosen_note_template, model)
            }


      // this.toastr.info('Chosen SUOT : ' + get_suot_id);


      const objIndex = this.search_results.findIndex((obj => obj.subject_id === subject_id));
      this.search_results[objIndex].email_template_primary_HTML_rendered = this.transform2(email_template_primary_HTML_rendered);
      this.search_results[objIndex].email_subject_primary_rendered = this.transform2(email_subject_primary_rendered);
      this.search_results[objIndex].note_template_HTML_rendered = this.transform2(note_template_HTML_rendered);
      this.search_results[objIndex].suot_id = this.subject_urgent_outcome_template[0].suot_id;
      this.search_results[objIndex].suot_agent_id = model.allocated_to_array[0].brand_id;

      // this.search_results[objIndex].email_template_primary_HTML = this.transform2(chosen_template);
        }
        if(model.job_status == 'UPDSENT' && model.allocated_to != ""){ 
          get_suot_id = 3;

        if(this.chosen_template != null){}
        chosen_template = this.subject_urgent_outcome_template[0].email_template_primary_HTML;
        chosen_subject = this.subject_urgent_outcome_template[0].email_subject_primary;
        chosen_template_private = this.subject_urgent_outcome_template[0].email_template_private_HTML;
        chosen_subject_private = this.subject_urgent_outcome_template[0].email_subject_private;

        chosen_note_template = this.subject_urgent_outcome_template[0].note_template_HTML;
        chosen_note_template_private = this.subject_urgent_outcome_template[0].note_template_private_HTML;



        // console.log('Assigned Agent: ' + this.assignedBrandList_paragraphs[0].name)
        // let is_privacy_emails = this.assignedBrandList_paragraphs[0].is_privacy_emails
        // let is_privacy_notes = this.assignedBrandList_paragraphs[0].is_privacy_notes

        console.log('Assigned Agent: ' + model.allocated_to_array[0].name)
        let is_privacy_emails = model.allocated_to_array[0].is_privacy_emails
        let is_privacy_notes = model.allocated_to_array[0].is_privacy_notes


        let email_template_primary_HTML_rendered = null;
        let email_subject_primary_rendered = null;
        let note_template_HTML_rendered = null;


            // Render/Run MergeReplace Functions
            if(is_privacy_emails == 1){
              email_template_primary_HTML_rendered =  this.runReplaceAllVariables(chosen_template_private, model)
              email_subject_primary_rendered =  this.runReplaceAllVariables(chosen_subject_private, model)
              }else{
                email_template_primary_HTML_rendered =  this.runReplaceAllVariables(chosen_template, model)
                email_subject_primary_rendered =  this.runReplaceAllVariables(chosen_subject, model)
              }

          // note_template_HTML_rendered =  this.runReplaceAllVariables(chosen_note_template, model)

          console.log('Is privacy Notes: ' + is_privacy_notes)

          if(is_privacy_notes == '1'){
            note_template_HTML_rendered =  this.runReplaceAllVariables(chosen_note_template_private, model)
            }else{
            note_template_HTML_rendered =  this.runReplaceAllVariables(chosen_note_template, model)
            }


        // this.toastr.info('Chosen SUOT : ' + get_suot_id);


        const objIndex = this.search_results.findIndex((obj => obj.subject_id === subject_id));
        this.search_results[objIndex].email_template_primary_HTML_rendered = this.transform2(email_template_primary_HTML_rendered);
        this.search_results[objIndex].email_subject_primary_rendered = this.transform2(email_subject_primary_rendered);
        this.search_results[objIndex].note_template_HTML_rendered = this.transform2(note_template_HTML_rendered);
        this.search_results[objIndex].suot_id = this.subject_urgent_outcome_template[0].suot_id;
        this.search_results[objIndex].suot_agent_id = model.allocated_to_array[0].brand_id;

        // this.search_results[objIndex].email_template_primary_HTML = this.transform2(chosen_template);
          }
          if(model.job_status == 'AOS' && model.allocated_to != ""){ 
            get_suot_id = 4;

          if(this.chosen_template != null){}
          chosen_template = this.subject_urgent_outcome_template[0].email_template_primary_HTML;
          chosen_subject = this.subject_urgent_outcome_template[0].email_subject_primary;
          chosen_template_private = this.subject_urgent_outcome_template[0].email_template_private_HTML;
          chosen_subject_private = this.subject_urgent_outcome_template[0].email_subject_private;
  
          chosen_note_template = this.subject_urgent_outcome_template[0].note_template_HTML;
          chosen_note_template_private = this.subject_urgent_outcome_template[0].note_template_private_HTML;



          // console.log('Assigned Agent: ' + this.assignedBrandList_paragraphs[0].name)
          // let is_privacy_emails = this.assignedBrandList_paragraphs[0].is_privacy_emails
          // let is_privacy_notes = this.assignedBrandList_paragraphs[0].is_privacy_notes

          console.log('Assigned Agent: ' + model.allocated_to_array[0].name)
          let is_privacy_emails = model.allocated_to_array[0].is_privacy_emails
          let is_privacy_notes = model.allocated_to_array[0].is_privacy_notes


          let email_template_primary_HTML_rendered = null;
          let email_subject_primary_rendered = null;
          let note_template_HTML_rendered = null;


              // Render/Run MergeReplace Functions
              if(is_privacy_emails == 1){
                email_template_primary_HTML_rendered =  this.runReplaceAllVariables(chosen_template_private, model)
                email_subject_primary_rendered =  this.runReplaceAllVariables(chosen_subject_private, model)
                }else{
                  email_template_primary_HTML_rendered =  this.runReplaceAllVariables(chosen_template, model)
                  email_subject_primary_rendered =  this.runReplaceAllVariables(chosen_subject, model)
                }

          // note_template_HTML_rendered =  this.runReplaceAllVariables(chosen_note_template, model)

          console.log('Is privacy Notes: ' + is_privacy_notes)

          if(is_privacy_notes == '1'){
            note_template_HTML_rendered =  this.runReplaceAllVariables(chosen_note_template_private, model)
            }else{
            note_template_HTML_rendered =  this.runReplaceAllVariables(chosen_note_template, model)
            }

          // this.toastr.info('Chosen SUOT : ' + get_suot_id);


          const objIndex = this.search_results.findIndex((obj => obj.subject_id === subject_id));
          this.search_results[objIndex].email_template_primary_HTML_rendered = this.transform2(email_template_primary_HTML_rendered);
          this.search_results[objIndex].email_subject_primary_rendered = this.transform2(email_subject_primary_rendered);
          this.search_results[objIndex].note_template_HTML_rendered = this.transform2(note_template_HTML_rendered);
          this.search_results[objIndex].suot_id = this.subject_urgent_outcome_template[0].suot_id;
          this.search_results[objIndex].suot_agent_id = model.allocated_to_array[0].brand_id;

          // this.search_results[objIndex].email_template_primary_HTML = this.transform2(chosen_template);
            }

      // AOA test
      if(model.job_status == 'AOA' && model.allocated_to != ""){ 
        get_suot_id = 5;

      if(this.chosen_template != null){}
      chosen_template = this.subject_urgent_outcome_template[0].email_template_primary_HTML;
      chosen_subject = this.subject_urgent_outcome_template[0].email_subject_primary;
      chosen_template_private = this.subject_urgent_outcome_template[0].email_template_private_HTML;
      chosen_subject_private = this.subject_urgent_outcome_template[0].email_subject_private;

      chosen_note_template = this.subject_urgent_outcome_template[0].note_template_HTML;
      chosen_note_template_private = this.subject_urgent_outcome_template[0].note_template_private_HTML;



      // console.log('Assigned Agent: ' + this.assignedBrandList_paragraphs[0].name)
      // let is_privacy_emails = this.assignedBrandList_paragraphs[0].is_privacy_emails
      // let is_privacy_notes = this.assignedBrandList_paragraphs[0].is_privacy_notes

      console.log('Assigned Agent: ' + model.allocated_to_array[0].name)
      let is_privacy_emails = model.allocated_to_array[0].is_privacy_emails
      let is_privacy_notes = model.allocated_to_array[0].is_privacy_notes


      let email_template_primary_HTML_rendered = null;
      let email_subject_primary_rendered = null;
      let note_template_HTML_rendered = null;


          // Render/Run MergeReplace Functions
          if(is_privacy_emails == 1){
            email_template_primary_HTML_rendered =  this.runReplaceAllVariables(chosen_template_private, model)
            email_subject_primary_rendered =  this.runReplaceAllVariables(chosen_subject_private, model)
            }else{
              email_template_primary_HTML_rendered =  this.runReplaceAllVariables(chosen_template, model)
              email_subject_primary_rendered =  this.runReplaceAllVariables(chosen_subject, model)
            }

          // note_template_HTML_rendered =  this.runReplaceAllVariables(chosen_note_template, model)

          console.log('Is privacy Notes: ' + is_privacy_notes)

          if(is_privacy_notes == '1'){
            note_template_HTML_rendered =  this.runReplaceAllVariables(chosen_note_template_private, model)
            }else{
            note_template_HTML_rendered =  this.runReplaceAllVariables(chosen_note_template, model)
            }


      // this.toastr.info('Chosen SUOT : ' + get_suot_id);

      
      const objIndex = this.search_results.findIndex((obj => obj.subject_id === subject_id));
      this.search_results[objIndex].email_template_primary_HTML_rendered = this.transform2(email_template_primary_HTML_rendered);
      this.search_results[objIndex].email_subject_primary_rendered = this.transform2(email_subject_primary_rendered);
      this.search_results[objIndex].note_template_HTML_rendered = this.transform2(note_template_HTML_rendered);
      this.search_results[objIndex].suot_id = this.subject_urgent_outcome_template[0].suot_id;
      this.search_results[objIndex].suot_agent_id = model.allocated_to_array[0].brand_id;

      // this.search_results[objIndex].email_template_primary_HTML = this.transform2(chosen_template);
        }

                        // end test



        
      });
        // end nest
 
  // All data available --- External Subscription of Variable Results. -- Run Replace Functions insude the nest.
  console.log(assignedBrandList_paragraphs);
  console.log(job_data_paragraphs);
  this.resultMessage = `Fetched ${assignedBrandList_paragraphs.length} assignedBrandList_paragraphs and ${job_data_paragraphs.length} job_data_paragraphs`;


  // console.log('Current User: ' + JSON.stringify(this.current_user_paragraphs));




// Dependant Queries ipon job data -- these load too late!!!!!!!! need to fix... somehow.
// this.getBrand(this.job_data_paragraphs[0].brand_report_id);
// this.getBrand_invoice_Q(this.job_data_paragraphs[0].brand_invoice_id)
// this.getBrand_owner_Q(97);
// this.getCurrentUser_Q(this.gfunc.sessionUserId)
// this.getUserBrand_Q(this.job_data_paragraphs[0].brand_report_user_id)
// this.getJobReportUserContact_Q(this.job_data_paragraphs[0].brand_report_user_id)
// this.delay(3000);

    // Promise.all([
    //   // Promise.resolve(3),
    //   // new Promise((resolve, reject) => setTimeout(resolve, 3000, 'foo')),
    //   // 42
    // new Promise((resolve, reject) => this.getJobReportUserContact_Q(this.job_data_paragraphs[0].brand_report_user_id))
    // ]).then(
      
      
    //   values => console.log(values)
      
      
    //   ); // end of promise to lookup dependants.



// (async () => {
//   this.getClients(); // load clients first
//   this.getJobTypes();
//   this.getJobSubjectsAll();
//   this.getBrandUsers('94'); // for sharmans only
//   this.getJobAgentsAllAssigned();
//   this.getBrands(); //
//   this.getJobAgentsAllAssigned();
//   this.getSubjectAgentsAssignedAll();
//   await this.delay(3000);
//  })(); // end async function  

// console.log('job_data_paragraphs' + JSON.stringify(this.job_data_paragraphs))



return;


});

}

// end new function to render variables with fork join and subscriptions


  runReplaceAllVariableFunctions(model, subject_id){
      // The response is a full subject model.
      let res = null; // clear it so that agents are not associated when no agents exist
      res = model
           this.getSubjectAgentBrandsAssigned_Q(res.subject_id) // get the first agent ID.????
         

          this.getJobServiceRule_Q(res.job_service_rule_id) //? -- from the send comms model

          this.getJobServiceTimeframe_Q(res.job_service_timeframe_id)
          this.getSubjectServiceType_model_Q(res.subject_service_type_id);

          this.getSubjectContactNumbers_Q(res.subject_id)
          this.getSubjectContactEmails_Q(res.subject_id)
              // Get Subject Agent - F_agent
        

          // load subject services (attemps)
          this.getSubjectAttemptsAll_Q(subject_id) // attmpts and attend
          this.getSubjectServicesOnly_Q(subject_id) // service variables
     
 this.getJob_and_brands_Q(res.job_id, res);
          // mege variables renders
          // end merge calls
    }
    


  // Job and Subject Focus
  runReplaceAllVariables(str, model){
  
              


    if(model.job_type_location_id != '' || model.job_type_location_id != '' ){ 
      this.getJobTypeLocation_Q(model.job_type_location_id);
    }
        
    if(model.job_type_location_id != '' || model.job_type_location_id != '' ){ 
    this.getJobTypeLocation_Q(model.job_type_location_id); // 
    }
    if(model.job_type_court_id != '' || model.job_type_court_id != '' ){ 
        this.getJobTypeCourt_Q(model.job_type_court_id);       // 
    }
    if(model.job_type_document_type_id != '' || model.job_type_document_type_id != '' ){ 
        this.getJobTypeDocumentType_Q(model.job_type_document_type_id)
    }
    if(model.job_type_affidavit_type_id != '' || model.job_type_affidavit_type_id != '' ){ 
        this.getJobTypeAffidavitType_Q(model.job_type_affidavit_type_id);
    }
        // console.log('Brand invoice ID: ' + this.brand_invoice_id);
    
        // Moved to getJob() -- this worked
              // this.getBrand_invoice_Q(model.brand_invoice_id) 
              // this.getBrand_owner_Q('94'); // sharmans id in the database as the app owner SO.
              // this.getJobReportUserContact_Q(model.brand_report_user_id)
              //  this.getCurrentUser_Q(this.gfunc.sessionUserId);
        
      
    
    
          // moved to get()Subject --
              // Get Subject Agent - F_agent
              // this.getSubjectAgentBrandsAssigned_Q(this.subject_id) // get the first agent ID.????
          // this.getJobServiceRule_Q(model.job_service_rule_id) //? -- from the send comms model
          // this.getJobServiceTimeframe_Q(model.job_service_timeframe_id)
          // this.getSubjectServiceType_model_Q(model.subject_service_type_id);
    
          // this.getSubjectContactNumbers_Q(model.subject_id)
          // this.getSubjectContactEmails_Q(model.subject_id)
    
        // console.log('this.job_data_paragraphs: ' + JSON.stringify(this.job_data_paragraphs))
    
    
          if(model.job_id != '' || model.job_id != null){ 
    
            // Uppercese
            if ( this.job_data_paragraphs  && this.job_data_paragraphs != ''  ){
              this.registry_name = this.job_data_paragraphs[0].registry_name;
            let var_job_registry_name = this.job_data_paragraphs[0].registry_name;
            if(var_job_registry_name != null){
            this.job_registry_name_Upper = var_job_registry_name.toUpperCase();
            }
           }
            // Uppercese
            if ( this.job_type_paragraphs && this.job_type_paragraphs != '' ){
              this.job_type_name = this.job_type_paragraphs[0].job_type_name;
            let var_job_type_name = this.job_type_paragraphs[0].job_type_name;
            if(var_job_type_name != null){
            this.job_type_name_Upper = var_job_type_name.toUpperCase();
            }
             }
            // Uppercese
            // console.log('job_type_location_paragraphs: ' + this.job_type_location_paragraphs);
            if ( this.job_type_location_paragraphs && this.job_type_location_paragraphs != '' ){
              this.job_type_location_name = this.job_type_location_paragraphs[0].job_type_location_name;
            let var_job_type_location_name = this.job_type_location_paragraphs[0].job_type_location_name;
            if(var_job_type_location_name != null){
            this.job_type_location_name_Upper = var_job_type_location_name.toUpperCase();
            }
          }
            // Uppercese
            if ( this.job_type_court_paragraphs && this.job_type_court_paragraphs != '' ){
              this.job_type_court_name = this.job_type_court_paragraphs[0].job_type_court_name;
            let var_job_type_court_name = this.job_type_court_paragraphs[0].job_type_court_name;
            if(var_job_type_court_name != null){
            this.job_type_court_name_Upper = var_job_type_court_name.toUpperCase();
            }
          }
            // Uppercese
            if ( this.job_type_document_type_paragraphs && this.job_type_document_type_paragraphs != '' ){
              this.job_type_document_type_name = this.job_type_document_type_paragraphs[0].job_type_document_type_name
              // console.log(this.job_type_document_type_paragraphs)
            let var_job_type_document_type_name = this.job_type_document_type_paragraphs[0].job_type_document_type_name;
            if(var_job_type_document_type_name != null){
            this.job_type_document_type_name_Upper = var_job_type_document_type_name.toUpperCase();
            }
            }
    
            //model.job_subject_type_name.toUpperCase() 
                           
       }     
           
    
    
        
       // just if emtpies.
       if ( this.job_service_rule_paragraphs && this.job_service_rule_paragraphs != '' ){
       this.job_service_rule_name = this.job_service_rule_paragraphs[0].job_service_rule_name 
       this.job_service_rule_description = this.job_service_rule_paragraphs[0].job_service_rule_description 
       }
    
       if ( this.job_service_timeframe_paragraphs && this.job_service_timeframe_paragraphs != '' ){
       this.job_service_timeframe_name = this.job_service_timeframe_paragraphs[0].job_service_timeframe_name
       this.job_service_timeframe_text = this.job_service_timeframe_paragraphs[0].job_service_timeframe_text
       }
    
       if ( this.subject_service_type_model_paragraphs && this.subject_service_type_model_paragraphs != '' ){
       this.subject_service_type_name = this.subject_service_type_model_paragraphs[0].subject_service_type_name 
       this.subject_service_type_description =  this.subject_service_type_model_paragraphs[0].subject_service_type_description
       this.subject_service_type_staff_instructions = this.subject_service_type_model_paragraphs[0].subject_service_type_staff_instructions
       this.subject_service_type_agent_instructions = this.subject_service_type_model_paragraphs[0].subject_service_type_agent_instructions
       this.subject_service_type_instructions = this.subject_service_type_model_paragraphs[0].subject_service_type_instructions 
       }
    
      // Must check for nulls first and set as a variable.
      if(model.job_type_affidavit_type_paragraphs && model.job_type_affidavit_type_paragraphs != '' ){
        this.job_type_affidavit_type_name = this.job_type_affidavit_type_paragraphs[0].job_type_affidavit_type_name
        this.job_type_affidavit_type_name_Upper = this.job_type_affidavit_type_name.toUpperCase();
      }
      if(model.job_subject_type_name && model.job_subject_type_name  != '' ){
        this.job_subject_type_name = model.job_subject_type_name;
        this.job_subject_type_name_Upper = this.job_subject_type_name.toUpperCase();
      }
      
      
      if(model.job_subject_type_id && model.job_subject_type_id != '' ){
        this.getJobSubjectType_Q(model.job_subject_type_id) ;
         }
      
      
      
      // Subject Conversions from model
            // // Uppercese
            if(this.job_type_document_type_paragraphs && this.job_type_document_type_paragraphs != '' ){
            let var_job_type_document_type_name = this.job_type_document_type_paragraphs[0].job_type_document_type_name;
            if(var_job_type_document_type_name != null){
            this.job_type_document_type_name_Upper = var_job_type_document_type_name.toUpperCase();
            }
          }
      
      
      
      
           // Attempt Agent Details
            // if(model.who_service != ''){
            //   this.getBrand_Q(model.who_service);
            //  }
         
             // Job report client
            if(model.brand_report_id != ''){
              this.getBrand_report_Q(model.brand_report_id);
             }
      
      
      
      
      // Set some variables
        // Do checks for subject name / Businesss Name of FUll SUbject Name fields
        let var_subject_name =  model.first_name + ' ' +  model.middlename + ' '+  model.surname;
        let var_subject_name_4_doc = model.first_name +'-'+  model.surname;
        let var_subject_business_name =  model.business_name;
        
        // Subject Name of Business
            if(var_subject_business_name != null){
                let var_trim_subject_business_name = var_subject_business_name.replaceAll(' ', ''); // need javscipt version of trim (all spaces removed)
                // $subject_name = $trim_subject_business_name;
                 var_subject_name = var_subject_business_name; // changed here feb 2023 as subject busines name was printing stripped as variable in affidavid // Not trimmed
                  var_subject_name_4_doc= var_trim_subject_business_name;
                
            }
        
      // Subject Genders -- based on passed model.
      if (model.sex == 'femail' || model.sex  == 'female'){
      this.subject_gender_descriptor = "Female";
      }
      if (model.sex == 'mail'){
      this.subject_gender_descriptor = "Male";
      }
      if (model.sex == '' || model.sex == null){
        this.subject_gender_descriptor = "The Person";
        }
      
    
        
    // this.message_subject = 'Subject: ' +  res.email_subject_header + ' ' + this.subjectFullNameOrBusiness + ' Our Reference: '  + this.subject_number;
    this.message_subject_var = 'Subject: ' +  model.email_subject + ' Our Reference: '  + this.subject_number;
    
    if(model.subject_com_type_id == 3){
      // this.message_subject = 'Reference: ' + this.client_reference + ', ' + 'Subject: ' +  res.email_subject_header + ' ' + this.subjectFullNameOrBusiness + ' Our Reference: '  + this.subject_number;
      this.message_subject_var = 'Reference: ' + this.client_reference + ', ' +  model.email_subject + ' Our Reference: '  + this.subject_number;
    }
      
    // Subject Com Document - Template Variables - if {model.doc_id}
    if(model.doc_id != null){
      // need to set the communication template vars.
      // console.log(JSON.stringify(this.doc_check))
    
      this.doc_name_var = this.doc_check[0].doc_name 
    }
      
      /*   
      // :: Gender Descriptor
      PHP code below.  
      if ($sbj->sex == 'femail' || $sbj->sex  == 'female'){
            $templateProcessor->setValue("subject_" .$sbjx. "_gender_descriptor", "She");
            $templateProcessor->setValue($f_starter. "_gender_descriptor", "She"); // focus
        }
        if ($sbj->sex  == 'male'){
            $templateProcessor->setValue("subject_" .$sbjx. "_gender_descriptor", "He");
            $templateProcessor->setValue($f_starter. "_gender_descriptor", "He"); // focus
        }
      */
      
      
      // Convert HTML -- i did change this...? was commented out 24
          // if(model.special_instructions_HTML == null){
          //   this.job_special_instructions_HTML = model.special_instructions_HTML;
          //   }else{
          //    this.job_special_instructions_HTML = unescape(this.transform2(this.job_data_paragraphs[0].special_instructions_HTML))
          //   }
    
    
    
    
      let rendered_result = str
      .replaceAll('${f_subject_name}', model.subject_name)
      .replaceAll('${f_subject_number}', model.subject_number)
      .replaceAll('${subject_number}', model.subject_number)
    
          // Job Merge Variables.
          .replaceAll('${job_id}', model.job_id)
          .replaceAll('${job_number}', model.job_id)
          .replaceAll('${job_status_code}', this.job_data_paragraphs[0].job_status_code)
          .replaceAll('${owner_trace_code}', this.job_data_paragraphs[0].owner_trace_code)
          .replaceAll('${client_ref}', this.job_data_paragraphs[0].owner_trace_code)
          .replaceAll('${client_reference}', this.job_data_paragraphs[0].owner_trace_code)
          .replaceAll('${your_reference}', this.job_data_paragraphs[0].owner_trace_code)
          .replaceAll('${job_document_number}', this.job_data_paragraphs[0].document_number)
          // .replaceAll('${job_registry_name}', this.job_data_paragraphs[0].registry_name)
          .replaceAll('${job_registry_name}', this.registry_name)
          .replaceAll('${job_registry_name_upper}', this.job_registry_name_Upper) // capitalise
          .replaceAll('${job_special_instrucitons}', this.job_special_instructions_HTML)
    
    
          // .replaceAll('${job_type_name}', this.job_type_paragraphs[0].job_type_name)
          .replaceAll('${job_type_name}', this.job_type_name)
          .replaceAll('${job_type_name_upper}', this.job_type_name_Upper)
    
          // .replaceAll('${job_type_location_name}', this.job_type_location_paragraphs[0].job_type_location_name)
          .replaceAll('${job_type_location_name}', this.job_type_location_name)
          .replaceAll('${job_type_location_name_upper}', this.job_type_location_name_Upper)
          // .replaceAll('${job_type_court_name}', this.job_type_court_paragraphs[0].job_type_court_name)
          .replaceAll('${job_type_court_name}', this.job_type_court_name)
          .replaceAll('${job_type_court_name_upper}', this.job_type_court_name_Upper)
    
          // .replaceAll('${job_type_document_type_name}', this.job_type_document_type_paragraphs[0].job_type_document_type_name)
          .replaceAll('${job_type_document_type_name}', this.job_type_document_type_name)
    
          .replaceAll('${job_type_document_type_name_upper}', this.job_type_document_type_name_Upper)
          .replaceAll('${job_type_affidavit_type_name}', this.job_type_affidavit_type_name )
          .replaceAll('${job_type_affidavit_type_name_upper}', this.job_type_affidavit_type_name_Upper )
    
    
          // .replaceAll('${job_type_location_name}', this.job_type_location_paragraphs[0].job_type_location_name)
          .replaceAll('${job_type_location_name}', this.job_type_location_name)
          .replaceAll('${job_type_location_name_upper}', this.job_type_location_name_Upper)
    
          .replaceAll('${job_type_court_name}', this.job_type_court_name)
          .replaceAll('${job_type_court_name_upper}', this.job_type_court_name_Upper)
          .replaceAll('${job_type_document_type_name}', this.job_type_document_type_name)
          .replaceAll('${job_type_document_type_name_upper}', this.job_type_document_type_name_Upper)
          .replaceAll('${job_type_affidavit_type_name}', this.job_type_affidavit_type_name )
          .replaceAll('${job_type_affidavit_type_name_upper}', this.job_type_affidavit_type_name_Upper )
    
          // JoB Dates - Need to Lookup Job. and use the details.
    
    
          .replaceAll('${job_hearing_date}', this.legalDate.format(this.job_data_paragraphs[0].hearing_date, 'M/D/YYYY'))
          .replaceAll('${job_hearing_date_and_time_full_words_time_first}', this.legalDate.format(this.job_data_paragraphs[0].hearing_date, 'h:mma dddd MMMM Do, YYYY') ) // equivilent to in PHP :: date("g:ia l jS F Y", strtotime($job_hearing_date))
          .replaceAll('${job_hearing_date_and_time_full_words}', this.legalDate.format(this.job_data_paragraphs[0].hearing_date, 'dddd MMMM Do, YYYY h:mma') )
          .replaceAll('${job_hearing_date}', this.legalDate.format(this.job_data_paragraphs[0].hearing_date, 'M/D/YYYY'))
          .replaceAll('${job_hearing_day}', this.legalDate.format(this.job_data_paragraphs[0].hearing_date, 'dddd'))
          .replaceAll('${job_hearing_day_number}', this.legalDate.format(this.job_data_paragraphs[0].hearing_date, 'Do'))
          .replaceAll('${job_hearing_month}', this.legalDate.format(this.job_data_paragraphs[0].hearing_date, 'MMMM'))
          .replaceAll('${job_hearing_month_number}', this.legalDate.format(this.job_data_paragraphs[0].hearing_date, 'Mo'))
          .replaceAll('${job_hearing_month_number_simple}', this.legalDate.format(this.job_data_paragraphs[0].hearing_date, 'M'))
          .replaceAll('${job_hearing_year}', this.legalDate.format(this.job_data_paragraphs[0].hearing_date, 'YYYY'))
          .replaceAll('${job_hearing_time}', this.legalDate.format(this.job_data_paragraphs[0].hearing_date, 'h:mma'))
    
          .replaceAll('${job_judgement_date}', this.legalDate.format(this.job_data_paragraphs[0].judgement_date, 'M/D/YYYY'))
          .replaceAll('${job_judgement_date_and_time_full_words_time_first}', this.legalDate.format(this.job_data_paragraphs[0].judgement_date, 'h:mma dddd MMMM Do, YYYY') ) 
          .replaceAll('${job_judgement_date_and_time_full_words}', this.legalDate.format(this.job_data_paragraphs[0].judgement_date, 'h:mma dddd MMMM Do, YYYY') ) 
          .replaceAll('${job_judgement_date}', this.legalDate.format(this.job_data_paragraphs[0].judgement_date, 'M/D/YYYY'))
          .replaceAll('${job_judgement_day}', this.legalDate.format(this.job_data_paragraphs[0].judgement_date, 'dddd'))
          .replaceAll('${job_judgement_day_number}', this.legalDate.format(this.job_data_paragraphs[0].judgement_date, 'Do'))
          .replaceAll('${job_judgement_month}', this.legalDate.format(this.job_data_paragraphs[0].judgement_date, 'MMMM'))
          .replaceAll('${job_judgement_month_number}', this.legalDate.format(this.job_data_paragraphs[0].judgement_date, 'Mo'))
          .replaceAll('${job_judgement_month_number_simple}', this.legalDate.format(this.job_data_paragraphs[0].judgement_date, 'M'))
          .replaceAll('${job_judgement_year}', this.legalDate.format(this.job_data_paragraphs[0].judgement_date, 'YYYY'))
          .replaceAll('${job_judgement_time}', this.legalDate.format(this.job_data_paragraphs[0].judgement_date, 'h:mma'))

          .replaceAll('${job_filing_date}', this.legalDate.format(this.job_data_paragraphs[0].filing_date, 'M/D/YYYY'))
          .replaceAll('${job_filing_date_and_time_full_words_time_first}', this.legalDate.format(this.job_data_paragraphs[0].filing_date, 'h:mma dddd MMMM Do, YYYY') ) 
          .replaceAll('${job_filing_date_and_time_full_words}', this.legalDate.format(this.job_data_paragraphs[0].filing_date, 'h:mma dddd MMMM Do, YYYY') ) 
          .replaceAll('${job_filing_date}', this.legalDate.format(this.job_data_paragraphs[0].filing_date, 'M/D/YYYY'))
          .replaceAll('${job_filing_day}', this.legalDate.format(this.job_data_paragraphs[0].filing_date, 'dddd'))
          .replaceAll('${job_filing_day_number}', this.legalDate.format(this.job_data_paragraphs[0].filing_date, 'Do'))
          .replaceAll('${job_filing_month}', this.legalDate.format(this.job_data_paragraphs[0].filing_date, 'MMMM'))
          .replaceAll('${job_filing_month_number}', this.legalDate.format(this.job_data_paragraphs[0].filing_date, 'Mo'))
          .replaceAll('${job_filing_month_number_simple}', this.legalDate.format(this.job_data_paragraphs[0].filing_date, 'M'))
          .replaceAll('${job_filing_year}', this.legalDate.format(this.job_data_paragraphs[0].filing_date, 'YYYY'))
          .replaceAll('${job_filing_time}', this.legalDate.format(this.job_data_paragraphs[0].filing_date, 'h:mma'))
    
    
          .replaceAll('${job_instructions_date}', this.legalDate.format(this.job_data_paragraphs[0].instructions_date, 'M/D/YYYY'))
          .replaceAll('${job_instructions_date_and_time_full_words_time_first}', this.legalDate.format(this.job_data_paragraphs[0].instructions_date, 'h:mma dddd MMMM Do, YYYY') ) 
          .replaceAll('${job_instructions_date_and_time_full_words}', this.legalDate.format(this.job_data_paragraphs[0].instructions_date, 'h:mma dddd MMMM Do, YYYY') ) 
          .replaceAll('${job_instructions_date}', this.legalDate.format(this.job_data_paragraphs[0].instructions_date, 'M/D/YYYY'))
          .replaceAll('${job_instructions_day}', this.legalDate.format(this.job_data_paragraphs[0].instructions_date, 'dddd'))
          .replaceAll('${job_instructions_day_number}', this.legalDate.format(this.job_data_paragraphs[0].instructions_date, 'Do'))
          .replaceAll('${job_instructions_month}', this.legalDate.format(this.job_data_paragraphs[0].instructions_date, 'MMMM'))
          .replaceAll('${job_instructions_month_number}', this.legalDate.format(this.job_data_paragraphs[0].instructions_date, 'Mo'))
          .replaceAll('${job_instructions_month_number_simple}', this.legalDate.format(this.job_data_paragraphs[0].instructions_date, 'M'))
          .replaceAll('${job_instructions_year}', this.legalDate.format(this.job_data_paragraphs[0].instructions_date, 'YYYY'))
          .replaceAll('${job_instructions_time}', this.legalDate.format(this.job_data_paragraphs[0].instructions_date, 'h:mma'))

          .replaceAll('${job_aos_date}', this.legalDate.format(this.job_data_paragraphs[0].aos_date, 'M/D/YYYY'))
          .replaceAll('${job_aos_date_and_time_full_words_time_first}', this.legalDate.format(this.job_data_paragraphs[0].aos_date, 'h:mma dddd MMMM Do, YYYY') ) 
          .replaceAll('${job_aos_date_and_time_full_words}', this.legalDate.format(this.job_data_paragraphs[0].aos_date, 'h:mma dddd MMMM Do, YYYY') ) 
          .replaceAll('${job_aos_date}', this.legalDate.format(this.job_data_paragraphs[0].aos_date, 'M/D/YYYY'))
          .replaceAll('${job_aos_day}', this.legalDate.format(this.job_data_paragraphs[0].aos_date, 'dddd'))
          .replaceAll('${job_aos_day_number}', this.legalDate.format(this.job_data_paragraphs[0].aos_date, 'Do'))
          .replaceAll('${job_aos_month}', this.legalDate.format(this.job_data_paragraphs[0].aos_date, 'MMMM'))
          .replaceAll('${job_aos_month_number}', this.legalDate.format(this.job_data_paragraphs[0].aos_date, 'Mo'))
          .replaceAll('${job_aos_month_number_simple}', this.legalDate.format(this.job_data_paragraphs[0].aos_date, 'M'))
          .replaceAll('${job_aos_year}', this.legalDate.format(this.job_data_paragraphs[0].aos_date, 'YYYY'))
          .replaceAll('${job_aos_time}', this.legalDate.format(this.job_data_paragraphs[0].aos_date, 'h:mma'))
    
          // Missing Report Client Name - And Report Client Details for the paragraph
               .replaceAll('${job_report_client_name}', this.brand_data[0].name)
               .replaceAll('${job_client_report_name}', this.brand_data[0].name)
               .replaceAll('${job_client_report_name_upper}', this.brand_data[0].name)
    
               .replaceAll('${job_client_report_phone}', this.brand_data[0].phone)
               .replaceAll('${job_client_report_address_1}', this.brand_data[0].address_1)
               .replaceAll('${job_client_report_address_2}', this.brand_data[0].address_2)
               .replaceAll('${job_client_report_suburb}', this.brand_data[0].suburb)
               .replaceAll('${job_client_report_state}', this.brand_data[0].state)
               .replaceAll('${job_client_report_postcode}', this.brand_data[0].postcode)
               .replaceAll('${job_client_report_country}', this.brand_data[0].country)
               .replaceAll('${job_client_report_brand_type_id}', this.brand_data[0].brand_type_id)
               .replaceAll('${job_client_report_notes}', this.brand_data[0].brand_notes)
               .replaceAll('${job_client_report_fax}', this.brand_data[0].fax)
               .replaceAll('${job_client_report_email}', this.brand_data[0].email)
               .replaceAll('${job_client_report_website}', this.brand_data[0].website)
               .replaceAll('${job_client_report_postal_address_1}', this.brand_data[0].postal_address_1)
               .replaceAll('${job_client_report_postal_address_2}', this.brand_data[0].postal_address_2)
               .replaceAll('${job_client_report_postal_suburb}', this.brand_data[0].postal_suburb)
               .replaceAll('${job_client_report_postal_state}', this.brand_data[0].postal_state)
               .replaceAll('${job_client_report_postal_postcode}', this.brand_data[0].postal_postcode)
               .replaceAll('${job_client_report_postal_country}', this.brand_data[0].postal_country)
               .replaceAll('${job_client_report_myob_id}', this.brand_data[0].myob_id)
               .replaceAll('${job_client_report_accounts_email_address}', this.brand_data[0].accounts_email_address)
               .replaceAll('${job_client_report_brand_type}', this.brand_data[0].brand_type_id)
    
               .replaceAll('${job_invoice_client_name}', this.job_invoice_client_paragraphs[0].name)
               .replaceAll('${job_client_invoice_name}', this.job_invoice_client_paragraphs[0].name)
               .replaceAll('${job_client_invoice_name_upper}', this.job_invoice_client_paragraphs[0].name)
    
               .replaceAll('${job_client_invoice_phone}', this.job_invoice_client_paragraphs[0].phone)
               .replaceAll('${job_client_invoice_address_1}', this.job_invoice_client_paragraphs[0].address_1)
               .replaceAll('${job_client_invoice_address_2}', this.job_invoice_client_paragraphs[0].address_2)
               .replaceAll('${job_client_invoice_suburb}', this.job_invoice_client_paragraphs[0].suburb)
               .replaceAll('${job_client_invoice_state}', this.job_invoice_client_paragraphs[0].state)
               .replaceAll('${job_client_invoice_postcode}', this.job_invoice_client_paragraphs[0].postcode)
               .replaceAll('${job_client_invoice_country}', this.job_invoice_client_paragraphs[0].country)
               .replaceAll('${job_client_invoice_brand_type_id}', this.job_invoice_client_paragraphs[0].brand_type_id)
               .replaceAll('${job_client_invoice_notes}', this.job_invoice_client_paragraphs[0].brand_notes)
               .replaceAll('${job_client_invoice_fax}', this.job_invoice_client_paragraphs[0].fax)
               .replaceAll('${job_client_invoice_email}', this.job_invoice_client_paragraphs[0].email)
               .replaceAll('${job_client_invoice_website}', this.job_invoice_client_paragraphs[0].website)
               .replaceAll('${job_client_invoice_postal_address_1}', this.job_invoice_client_paragraphs[0].postal_address_1)
               .replaceAll('${job_client_invoice_postal_address_2}', this.job_invoice_client_paragraphs[0].postal_address_2)
               .replaceAll('${job_client_invoice_postal_suburb}', this.job_invoice_client_paragraphs[0].postal_suburb)
               .replaceAll('${job_client_invoice_postal_state}', this.job_invoice_client_paragraphs[0].postal_state)
               .replaceAll('${job_client_invoice_postal_postcode}', this.job_invoice_client_paragraphs[0].postal_postcode)
               .replaceAll('${job_client_invoice_postal_country}', this.job_invoice_client_paragraphs[0].postal_country)
               .replaceAll('${job_client_invoice_myob_id}', this.job_invoice_client_paragraphs[0].myob_id)
               .replaceAll('${job_client_invoice_accounts_email_address}', this.job_invoice_client_paragraphs[0].accounts_email_address)
               .replaceAll('${job_client_invoice_brand_type}', this.job_invoice_client_paragraphs[0].brand_type_id)
    
    
               .replaceAll('${job_owner_name}', this.job_owner_client_paragraphs[0].name)
               .replaceAll('${job_owner_name}', this.job_owner_client_paragraphs[0].name)
               .replaceAll('${job_owner_name_upper}', this.job_owner_client_paragraphs[0].name)
    
               .replaceAll('${job_owner_phone}', this.job_owner_client_paragraphs[0].phone)
               .replaceAll('${job_owner_address_1}', this.job_owner_client_paragraphs[0].address_1)
               .replaceAll('${job_owner_address_2}', this.job_owner_client_paragraphs[0].address_2)
               .replaceAll('${job_owner_suburb}', this.job_owner_client_paragraphs[0].suburb)
               .replaceAll('${job_owner_state}', this.job_owner_client_paragraphs[0].state)
               .replaceAll('${job_owner_postcode}', this.job_owner_client_paragraphs[0].postcode)
               .replaceAll('${job_owner_country}', this.job_owner_client_paragraphs[0].country)
               .replaceAll('${job_owner_brand_type_id}', this.job_owner_client_paragraphs[0].brand_type_id)
               .replaceAll('${job_owner_notes}', this.job_owner_client_paragraphs[0].brand_notes)
               .replaceAll('${job_owner_fax}', this.job_owner_client_paragraphs[0].fax)
               .replaceAll('${job_owner_email}', this.job_owner_client_paragraphs[0].email)
               .replaceAll('${job_owner_website}', this.job_owner_client_paragraphs[0].website)
               .replaceAll('${job_owner_postal_address_1}', this.job_owner_client_paragraphs[0].postal_address_1)
               .replaceAll('${job_owner_postal_address_2}', this.job_owner_client_paragraphs[0].postal_address_2)
               .replaceAll('${job_owner_postal_suburb}', this.job_owner_client_paragraphs[0].postal_suburb)
               .replaceAll('${job_owner_postal_state}', this.job_owner_client_paragraphs[0].postal_state)
               .replaceAll('${job_owner_postal_postcode}', this.job_owner_client_paragraphs[0].postal_postcode)
               .replaceAll('${job_owner_postal_country}', this.job_owner_client_paragraphs[0].postal_country)
               .replaceAll('${job_owner_myob_id}', this.job_owner_client_paragraphs[0].myob_id)
               .replaceAll('${job_owner_accounts_email_address}', this.job_owner_client_paragraphs[0].accounts_email_address)
               .replaceAll('${job_owner_brand_type}', this.job_owner_client_paragraphs[0].brand_type_id)
    
              
        /// NEED TO FIX IF NOT SET CREATES ERRORS IN LOADING TEMPLATES>
    
               .replaceAll('${job_client_report_user_first_name}',  this.job_report_client_user_paragraphs[0].first_name)
               .replaceAll('${job_client_report_user_name_surname}', this.job_report_client_user_paragraphs[0].surname)
               .replaceAll('${job_client_report_user_surname}', this.job_report_client_user_paragraphs[0].surname)
    
               .replaceAll('${job_client_report_user_name}', this.job_report_client_user_paragraphs[0].username)
               .replaceAll('${job_client_report_user_name_upper}', this.job_report_client_user_paragraphs[0].username)
               .replaceAll('${job_client_report_user_phone}', this.job_report_client_user_paragraphs[0].phone)
               .replaceAll('${job_client_report_user_address_1}', this.job_report_client_user_paragraphs[0].address_1)
               .replaceAll('${job_client_report_user_address_2}', this.job_report_client_user_paragraphs[0].address_2)
               .replaceAll('${job_client_report_user_suburb}', this.job_report_client_user_paragraphs[0].suburb)
               .replaceAll('${job_client_report_user_state}', this.job_report_client_user_paragraphs[0].state)
               .replaceAll('${job_client_report_user_postcode}', this.job_report_client_user_paragraphs[0].postcode)
               .replaceAll('${job_client_report_user_country}', this.job_report_client_user_paragraphs[0].country)
               .replaceAll('${job_client_report_user_brand_type_id}', this.job_report_client_user_paragraphs[0].brand_type_id)
               .replaceAll('${job_client_report_user_notes}', this.job_report_client_user_paragraphs[0].brand_notes)
               .replaceAll('${job_client_report_user_fax}', this.job_report_client_user_paragraphs[0].fax)
               .replaceAll('${job_client_report_user_email}', this.job_report_client_user_paragraphs[0].email_address)
               .replaceAll('${job_client_report_user_website}', this.job_report_client_user_paragraphs[0].website)
               .replaceAll('${job_client_report_user_postal_address_1}', this.job_report_client_user_paragraphs[0].postal_address_1)
               .replaceAll('${job_client_report_user_postal_address_2}', this.job_report_client_user_paragraphs[0].postal_address_2)
               .replaceAll('${job_client_report_user_postal_suburb}', this.job_report_client_user_paragraphs[0].postal_suburb)
               .replaceAll('${job_client_report_user_postal_state}', this.job_report_client_user_paragraphs[0].postal_state)
               .replaceAll('${job_client_report_user_postal_postcode}', this.job_report_client_user_paragraphs[0].postal_postcode)
               .replaceAll('${job_client_report_user_postal_country}', this.job_report_client_user_paragraphs[0].postal_country)
    
    
               .replaceAll('${f_user_first_name}',  this.current_user_paragraphs[0].first_name)
               .replaceAll('${f_user_name_surname}', this.current_user_paragraphs[0].surname)
               .replaceAll('${f_user_surname}', this.current_user_paragraphs[0].surname)
    
               .replaceAll('${f_user_name}', this.current_user_paragraphs[0].username)
               .replaceAll('${f_user_name_upper}', this.current_user_paragraphs[0].username)
               .replaceAll('${f_user_phone}', this.current_user_paragraphs[0].phone)
               .replaceAll('${f_user_address_1}', this.current_user_paragraphs[0].address_1)
               .replaceAll('${f_user_address_2}', this.current_user_paragraphs[0].address_2)
               .replaceAll('${f_user_suburb}', this.current_user_paragraphs[0].suburb)
               .replaceAll('${f_user_state}', this.current_user_paragraphs[0].state)
               .replaceAll('${f_user_postcode}', this.current_user_paragraphs[0].postcode)
               .replaceAll('${f_user_country}', this.current_user_paragraphs[0].country)
               .replaceAll('${f_user_brand_type_id}', this.current_user_paragraphs[0].brand_type_id)
               .replaceAll('${f_user_notes}', this.current_user_paragraphs[0].brand_notes)
               .replaceAll('${f_user_fax}', this.current_user_paragraphs[0].fax)
               .replaceAll('${f_user_email}', this.current_user_paragraphs[0].email_address)
               .replaceAll('${f_user_website}', this.current_user_paragraphs[0].website)
               .replaceAll('${f_user_postal_address_1}', this.current_user_paragraphs[0].postal_address_1)
               .replaceAll('${f_user_postal_address_2}', this.current_user_paragraphs[0].postal_address_2)
               .replaceAll('${f_user_postal_suburb}', this.current_user_paragraphs[0].postal_suburb)
               .replaceAll('${f_user_postal_state}', this.current_user_paragraphs[0].postal_state)
               .replaceAll('${f_user_postal_postcode}', this.current_user_paragraphs[0].postal_postcode)
               .replaceAll('${f_user_postal_country}', this.current_user_paragraphs[0].postal_country)
    
               .replaceAll('${f_user_email_signature}', this.current_user_paragraphs[0].email_signature_HTML_rendered) // plain and not encoded.
    
    
    // Current Subjcet as a passed commnunication model.
    .replaceAll('${f_subject_subject_id}', model.subject_id )
    .replaceAll('${f_subject_job_id}', model.job_id )
    .replaceAll('${f_subject_first_name}', model.first_name )
    .replaceAll('${f_subject_surname}', model.surname )
    .replaceAll('${f_subject_title}', model.title )
    .replaceAll('${f_subject_is_active}', model.is_active )
    
    .replaceAll('${f_subject_next_date}', model.next_date )
    .replaceAll('${f_subject_next_date_and_time_full_words_time_first}', this.legalDate.format(model.next_date, 'h:mma dddd MMMM Do, YYYY') ) 
    .replaceAll('${f_subject_next_date_and_time_full_words}', this.legalDate.format(model.next_date, 'h:mma dddd MMMM Do, YYYY') ) 
    .replaceAll('${f_subject_next_date_full_words_time_first}', this.legalDate.format(model.next_date, 'h:mma dddd MMMM Do, YYYY') ) 
    .replaceAll('${f_subject_next_date}', this.legalDate.format(model.next_date, 'M/D/YYYY'))
    .replaceAll('${f_subject_next_day}', this.legalDate.format(model.next_date, 'dddd'))
    .replaceAll('${f_subject_next_day_number}', this.legalDate.format(model.next_date, 'Do'))
    .replaceAll('${f_subject_next_month}', this.legalDate.format(model.next_date, 'MMMM'))
    .replaceAll('${f_subject_next_month_number}', this.legalDate.format(model.next_date, 'Mo'))
    .replaceAll('${f_subject_next_month_number_simple}', this.legalDate.format(model.next_date, 'M'))
    .replaceAll('${f_subject_next_year}', this.legalDate.format(model.next_date, 'YYYY'))
    .replaceAll('${f_subject_next_time}', this.legalDate.format(model.next_date, 'h:mma'))
    
    .replaceAll('${f_subject_final_date}', model.final_date )
    .replaceAll('${f_subject_final_date_and_time_full_words_time_first}', this.legalDate.format(model.final_date, 'h:mma dddd MMMM Do, YYYY') ) 
    .replaceAll('${f_subject_final_date_and_time_full_words}', this.legalDate.format(model.final_date, 'h:mma dddd MMMM Do, YYYY') ) 
    .replaceAll('${f_subject_final_date_full_words_time_first}', this.legalDate.format(model.final_date, 'h:mma dddd MMMM Do, YYYY') ) 
    .replaceAll('${f_subject_final_date}', this.legalDate.format(model.final_date, 'M/D/YYYY'))
    .replaceAll('${f_subject_final_day}', this.legalDate.format(model.final_date, 'dddd'))
    .replaceAll('${f_subject_final_day_number}', this.legalDate.format(model.final_date, 'Do'))
    .replaceAll('${f_subject_final_month}', this.legalDate.format(model.final_date, 'MMMM'))
    .replaceAll('${f_subject_final_month_number}', this.legalDate.format(model.final_date, 'Mo'))
    .replaceAll('${f_subject_final_month_number_simple}', this.legalDate.format(model.final_date, 'M'))
    .replaceAll('${f_subject_final_year}', this.legalDate.format(model.final_date, 'YYYY'))
    .replaceAll('${f_subject_final_time}', this.legalDate.format(model.final_date, 'h:mma'))
    
    .replaceAll('${f_subject_job_status_id}', model.job_status_id )
    .replaceAll('${f_subject_street_address}', model.street_address )
    .replaceAll('${f_subject_suburb}', model.suburb )
    .replaceAll('${f_subject_state}', model.state )
    .replaceAll('${f_subject_postcode}', model.postcode )
    .replaceAll('${f_subjectphone_h}', model.f_subjectphone_h )
    .replaceAll('${f_subject_email}', model.email )
    
    .replaceAll('${f_subject_dob}', model.dob )
    .replaceAll('${f_subject_dob_and_time_full_words_time_first}', moment(model.dob).format('h:mma dddd MMMM Do, YYYY') ) 
    .replaceAll('${f_subject_dob_and_time_full_words}', moment(model.dob).format('h:mma dddd MMMM Do, YYYY') ) 
    .replaceAll('${f_subject_dob_full_words}', moment(model.dob).format('dddd MMMM Do, YYYY') ) 
    .replaceAll('${f_subject_dob_full_words_time_first}', moment(model.dob).format('h:mma dddd MMMM Do, YYYY') ) 
    .replaceAll('${f_subject_dob}', moment(model.dob).format('M/D/YYYY'))
    .replaceAll('${f_subject_dob_day}', moment(model.dob).format('dddd'))
    .replaceAll('${f_subject_dob_day_number}', moment(model.dob).format('Do'))
    .replaceAll('${f_subject_dob_month}', moment(model.dob).format('MMMM'))
    .replaceAll('${f_subject_dob_month_number}', moment(model.dob).format('Mo'))
    .replaceAll('${f_subject_dob_month_number_simple}', moment(model.dob).format('M'))
    .replaceAll('${f_subject_dob_year}', moment(model.dob).format('YYYY'))
    .replaceAll('${f_subject_dob_time}', moment(model.dob).format('h:mma'))
    
    .replaceAll('${f_subject_phone_m}', model.phone_m )
    .replaceAll('${f_subject_subject_type_id}', model.subject_type_id )
    
    // .replaceAll('${f_subject_file_number}', model.file_number )
    .replaceAll('${f_subject_file_number}', this.ordinalInWord(model.file_number) ) // Ordinal eg First... need to capitasie.
    
    .replaceAll('${f_subject_special_instructions}', model.special_instructions )
    .replaceAll('${f_subject_job_status}', model.job_status )
    .replaceAll('${f_subject_reference_number}', model.reference_number )
    .replaceAll('${f_subject_job_reference_number}', model.job_reference_number )
    .replaceAll('${f_subject_subject_number}', model.subject_number )
    .replaceAll('${f_subject_created_by}', model.created_by )
    .replaceAll('${f_subject_created_date}', model.created_date )
    .replaceAll('${f_subject_updated_date}', model.updated_date )
    .replaceAll('${f_subject_updated_by}', model.updated_by )
    .replaceAll('${f_subject_completed_date}', model.completed_date )
    .replaceAll('${f_subject_completed_by}', model.completed_by )
    .replaceAll('${f_subject_start_date}', model.start_date )
    .replaceAll('${f_subject_started_by}', model.started_by )
    .replaceAll('${f_subject_time_taken}', model.time_taken )
    .replaceAll('${f_subject_sex}', model.sex )
    
    // .replaceAll('${f_subject_gender_descriptor}', model.sex )
    .replaceAll('${f_subject_gender_descriptor}', this.subject_gender_descriptor )
    
    
    .replaceAll('${f_subject_finalised}', model.finalised )
    .replaceAll('${f_subject_subject_reference_created}', model.subject_reference_created )
    .replaceAll('${f_subject_brand_report_user_id}', model.brand_report_user_id )
    .replaceAll('${f_subject_job_type_id}', model.job_type_id )
    .replaceAll('${f_subject_job_type_location_id}', model.job_type_location_id )
    .replaceAll('${f_subject_job_type_court_id}', model.job_type_court_id )
    .replaceAll('${f_subject_job_type_document_type_id}', model.job_type_document_type_id )
    .replaceAll('${f_subject_job_type_affidavit_type_id}', model.job_type_affidavit_type_id )
    .replaceAll('${f_subject_business_name}', model.business_name )
    .replaceAll('${f_subject_prev_subject_id}', model.prev_subject_id )
    .replaceAll('${f_subject_next_subject_id}', model.next_subject_id )
    .replaceAll('${f_subject_job_subject_type_id}', model.job_subject_type_id )
    .replaceAll('${f_subject_subject_report_order_number}', model.subject_report_order_number )
    .replaceAll('${f_subject_job_service_rule_id}', model.job_service_rule_id )
    
          .replaceAll('${f_subject_job_service_rule_name}', this.job_service_rule_name )
          .replaceAll('${f_subject_job_service_rule_description}', this.job_service_rule_description )
    
    
          .replaceAll('${f_subject_job_service_timeframe_id}', model.job_service_timeframe_id )
          .replaceAll('${f_subject_job_service_timeframe_name}', this.job_service_timeframe_name )
          .replaceAll('${f_subject_job_service_timeframe_text}', this.job_service_timeframe_text )
    
          .replaceAll('${f_subject_subject_service_type_id}', model.subject_service_type_id )
          .replaceAll('${f_subject_subject_service_type_name}', this.subject_service_type_name )
          .replaceAll('${f_subject_subject_service_type_description}', this.subject_service_type_description )
          .replaceAll('${f_subject_subject_service_type_staff_instructions}', this.subject_service_type_staff_instructions )
          .replaceAll('${f_subject_subject_service_type_agent_instructions}', this.subject_service_type_agent_instructions )
          .replaceAll('${f_subject_subject_service_type_instructions}', this.subject_service_type_instructions )
    
    
    .replaceAll('${f_subject_service_company_name}', model.service_company_name )
    .replaceAll('${f_subject_service_directors_name}', model.service_directors_name )
    .replaceAll('${f_subject_service_prison_name}', model.service_prison_name )
    .replaceAll('${f_subject_service_law_firm_name}', model.service_law_firm_name )
    .replaceAll('${f_subject_service_solicitor_name}', model.service_solicitor_name )
    .replaceAll('${f_subject_middle_name}', model.middle_name )
    .replaceAll('${f_subject_special_instructions_HTML}', model.special_instructions_HTML )
    
    // .replaceAll('${f_subject_job_subject_type_name}', model.job_subject_type_name )
    .replaceAll('${f_subject_subject_type_name}', this.job_subject_type_name )
    .replaceAll('${f_subject_subject_type_name_upper}', this.job_subject_type_name_Upper)
    
    // .replaceAll('${f_subject_job__type}', model.job_type )
    .replaceAll('${f_subject_subject_type}', model.job_type )
    
    .replaceAll('${f_subject_brand_invoice_id}', model.brand_invoice_id )
    .replaceAll('${f_subject_brand_report_id}', model.brand_report_id )
    .replaceAll('${f_subject_instructions_date}', model.instructions_date )
    .replaceAll('${f_subject_hearing_date}', model.hearing_date )
    .replaceAll('${f_subject_judgement_date}', model.judgement_date )
    .replaceAll('${f_subject_filing_date}', model.filing_date )
    .replaceAll('${f_subject_client_reference}', model.client_reference )
    .replaceAll('${f_subject_brand_report_name}', model.brand_report_name )
    .replaceAll('${f_subject_brand_invoice_name}', model.brand_invoice_name )
    
    .replaceAll('${f_subject_subject_name}', model.subject_name )
    .replaceAll('${f_subject_name_upper}', model.subject_name.toUpperCase() )
    .replaceAll('${subject_name}', model.subject_name )
    .replaceAll('${subject_name_upper}', model.subject_name.toUpperCase() )
    
    .replaceAll('${f_subject_contact_numbers}', this.subject_contact_numbers)
    .replaceAll('${f_subject_contact_emails}', this.subject_contact_emails)
    
    
    
    
    
    // Subject Focus Agent
                // .replaceAll('${f_subject_agent_name}', this.assignedBrandList_paragraphs[0].first_name + ' ' + this.assignedBrandList_paragraphs[0].middle_name + ' ' + this.assignedBrandList_paragraphs[0].surname )
                // .replaceAll('${f_subject_agent_name_upper}', this.assignedBrandList_paragraphs[0].name  )
                // .replaceAll('${f_subject_agent_first_name}', this.assignedBrandList_paragraphs[0].first_name)
                // .replaceAll('${f_subject_agent_middle_name}', this.assignedBrandList_paragraphs[0].middle_name)
                // .replaceAll('${f_subject_agent_surname}', this.assignedBrandList_paragraphs[0].surname)
    
                // .replaceAll('${f_subject_agent_address_1}', this.assignedBrandList_paragraphs[0].address_1)
                // .replaceAll('${f_subject_agent_address_2}', this.assignedBrandList_paragraphs[0].address_2)
                // .replaceAll('${f_subject_agent_suburb}', this.assignedBrandList_paragraphs[0].suburb)
                // .replaceAll('${f_subject_agent_state}', this.assignedBrandList_paragraphs[0].state)
                // .replaceAll('${f_subject_agent_postcode}', this.assignedBrandList_paragraphs[0].postcode)
                // .replaceAll('${f_subject_agent_country}', this.assignedBrandList_paragraphs[0].country)
    
    
                // .replaceAll('${f_subject_agent_postal_address_1}', this.assignedBrandList_paragraphs[0].address_1)
                // .replaceAll('${f_subject_agent_postal_address_2}', this.assignedBrandList_paragraphs[0].address_2)
                // .replaceAll('${f_subject_agent_postal_suburb}', this.assignedBrandList_paragraphs[0].suburb)
                // .replaceAll('${f_subject_agent_postal_state}', this.assignedBrandList_paragraphs[0].state)
                // .replaceAll('${f_subject_agent_postal_postcode}', this.assignedBrandList_paragraphs[0].postcode)
                // .replaceAll('${f_subject_agent_postal_country}', this.assignedBrandList_paragraphs[0].country)
    
                // .replaceAll('${f_subject_agent_adddress_full}', this.assignedBrandList_paragraphs[0].address_1 + ' ' + this.assignedBrandList_paragraphs[0].address_2 + ' ' + this.assignedBrandList_paragraphs[0].suburb + ' ' + this.assignedBrandList_paragraphs[0].state + ', ' + this.assignedBrandList_paragraphs[0].postcode )
                // .replaceAll('${f_subject_agent_qualification}', this.assignedBrandList_paragraphs[0].qualification)
                // .replaceAll('${f_subject_agent_qualification_number}', this.assignedBrandList_paragraphs[0].qualification_number)
    
                // .replaceAll('${f_subject_agent_myob_id}', this.assignedBrandList_paragraphs[0].myob_id)
                // .replaceAll('${f_subject_agent_brand_type}', this.assignedBrandList_paragraphs[0].brand_type_id)
    
                // .replaceAll('${f_subject_agent_phone}', this.assignedBrandList_paragraphs[0].phone)
                // .replaceAll('${f_subject_agent_fax}', this.assignedBrandList_paragraphs[0].fax)
                // .replaceAll('${f_subject_agent_website}', this.assignedBrandList_paragraphs[0].website)
                // .replaceAll('${f_subject_agent_accounts_email_address}', this.assignedBrandList_paragraphs[0].accounts_email_address)
    
                // .replaceAll('${f_subject_agent_qualification_renewal_date}', moment(this.assignedBrandList_paragraphs[0].qualification_renewal_date).format('M/D/YYYY') )
                // .replaceAll('${f_subject_agent_qualification_renewal_date_full_words}', moment(this.assignedBrandList_paragraphs[0].qualification_renewal_date).format('dddd MMMM Do, YYYY h:mma') )
    

// changed this for subjects urgent.                
                .replaceAll('${f_subject_agent_name}', model.allocated_to_array[0].first_name + ' ' + model.allocated_to_array[0].middle_name + ' ' + model.allocated_to_array[0].surname )
                .replaceAll('${f_subject_agent_name_upper}', model.allocated_to_array[0].name  )
                .replaceAll('${f_subject_agent_first_name}', this.assignedBrandList_paragraphs[0].first_name)
                .replaceAll('${f_subject_agent_middle_name}', this.assignedBrandList_paragraphs[0].middle_name)
                .replaceAll('${f_subject_agent_surname}', this.assignedBrandList_paragraphs[0].surname)
    
                .replaceAll('${f_subject_agent_address_1}', this.assignedBrandList_paragraphs[0].address_1)
                .replaceAll('${f_subject_agent_address_2}', this.assignedBrandList_paragraphs[0].address_2)
                .replaceAll('${f_subject_agent_suburb}', this.assignedBrandList_paragraphs[0].suburb)
                .replaceAll('${f_subject_agent_state}', this.assignedBrandList_paragraphs[0].state)
                .replaceAll('${f_subject_agent_postcode}', this.assignedBrandList_paragraphs[0].postcode)
                .replaceAll('${f_subject_agent_country}', this.assignedBrandList_paragraphs[0].country)
    
    
                .replaceAll('${f_subject_agent_postal_address_1}', this.assignedBrandList_paragraphs[0].address_1)
                .replaceAll('${f_subject_agent_postal_address_2}', this.assignedBrandList_paragraphs[0].address_2)
                .replaceAll('${f_subject_agent_postal_suburb}', this.assignedBrandList_paragraphs[0].suburb)
                .replaceAll('${f_subject_agent_postal_state}', this.assignedBrandList_paragraphs[0].state)
                .replaceAll('${f_subject_agent_postal_postcode}', this.assignedBrandList_paragraphs[0].postcode)
                .replaceAll('${f_subject_agent_postal_country}', this.assignedBrandList_paragraphs[0].country)
    
                .replaceAll('${f_subject_agent_adddress_full}', this.assignedBrandList_paragraphs[0].address_1 + ' ' + this.assignedBrandList_paragraphs[0].address_2 + ' ' + this.assignedBrandList_paragraphs[0].suburb + ' ' + this.assignedBrandList_paragraphs[0].state + ', ' + this.assignedBrandList_paragraphs[0].postcode )
                .replaceAll('${f_subject_agent_qualification}', this.assignedBrandList_paragraphs[0].qualification)
                .replaceAll('${f_subject_agent_qualification_number}', this.assignedBrandList_paragraphs[0].qualification_number)
    
                .replaceAll('${f_subject_agent_myob_id}', this.assignedBrandList_paragraphs[0].myob_id)
                .replaceAll('${f_subject_agent_brand_type}', this.assignedBrandList_paragraphs[0].brand_type_id)
    
                .replaceAll('${f_subject_agent_phone}', this.assignedBrandList_paragraphs[0].phone)
                .replaceAll('${f_subject_agent_fax}', this.assignedBrandList_paragraphs[0].fax)
                .replaceAll('${f_subject_agent_website}', this.assignedBrandList_paragraphs[0].website)
                .replaceAll('${f_subject_agent_accounts_email_address}', this.assignedBrandList_paragraphs[0].accounts_email_address)
    
                .replaceAll('${f_subject_agent_qualification_renewal_date}', moment(this.assignedBrandList_paragraphs[0].qualification_renewal_date).format('M/D/YYYY') )
                .replaceAll('${f_subject_agent_qualification_renewal_date_full_words}', moment(this.assignedBrandList_paragraphs[0].qualification_renewal_date).format('dddd MMMM Do, YYYY h:mma') )
    
    // Sent from the allRecipeints Atray Function when adding recipeints
            .replaceAll('${recipient_name}', model.recipient_name )
            .replaceAll('${recipient_email_address}', model.recipient_email_address )
            .replaceAll('${recipient_brand_id}', model.recipient_brand_id )
            .replaceAll('${recipient_brand_type_id}', model.recipient_brand_type_id )
            .replaceAll('${recipient_user_id}', model.recipient_user_id )
            .replaceAll('${recipient_user_level_id}', model.recipient_user_level_id )
            .replaceAll('${recipient_type_name}', model.recipient_type_name )
           
            // .replaceAll('${message_subject}', this.message_subject_var )
            .replaceAll('${message_subject}', this.message_subject ) // set from the old system
            .replaceAll('${doc_name}', this.doc_name_var  ) // set from the old system
         
    
    
    
    // hide anything null or undefined.
    .replaceAll('${undefined}', '')
    .replaceAll('${null}', '')
    .replaceAll('undefined', '') // makes all undefined print empty
    .replaceAll('null', '') // makes all undefined print empty
    .replaceAll('Invalid date', '') // makes all undefined print empty
    
    
    // model.email_template_primary_HTML_rendered
    // email_subject_primary_rendered
    
    // Convert the results to a form field value.
    // model.email_template_primary_HTML_rendered = rendered_result;
    
    
    // TOD IMPLIMENT BELOW!!!!!!!!!!
    
    // return rendered_result;
            if(this.attempts_paragraphs_model != undefined){
            // return this.runReplaceAllVariables_AttemptsOnly(rendered_result, model) // returns after running all the attempts.
            rendered_result = this.runReplaceAllVariables_AttemptsOnly_keystarter(rendered_result, model, 'f_attempt', 2) // returns after running all the attempts.
            if(model.attempt_type_id == 2){
            rendered_result = this.runReplaceAllVariables_AttemptsOnly_keystarter(rendered_result, model, 'f_attend', 2) // returns after running all the attempts.
            }
            if(model.attempt_type_id == 1){
            rendered_result = this.runReplaceAllVariables_ServicesOnly_keystarter(rendered_result, model, 'f_service', 1) // returns after running all the attempts.
            }
          }else{
            //   return rendered_result; // just return without rendering the attempts
            }
    

    return rendered_result; // just return without rendering the attempts

    
    }



    runReplaceAllVariables_AttemptsOnly_keystarter(str, model, keystarter, subject_attempt_type_id){


      // // Filters objects for nul and undefined values.
      // const obj = this.attempts_paragraphs_model;
      // const filteredObject = _.pickBy(obj, v =>  v.subject_attempt_type_id === subject_attempt_type_id);
      // // console.log = (obj) => document.write(JSON.stringify(filteredObject, null, 2));
      // console.log('FilteredObject', JSON.stringify(filteredObject));



// Filter the array for attempt_type_id = 1 or 2 service or attemdamce -- Do a filter on the final RESULTS IF F SERVICE!!!!! 
// Do a simple loadash filter on attempts_paragraphs model.'

// change the data for a service
if (subject_attempt_type_id = 1)
{


}


  // Already loaded in the job/subject lookup
  // if(this.attempts_paragraphs_model.job_subject_type_id){
  //   this.getJobSubjectType_Q(this.attempts_paragraphs_model.job_subject_type_id) ;
  // }
  // let var_subject_type_name;
  // if(this.subject_job_subject_type != null){
  // var_subject_type_name = this.subject_job_subject_type.job_subject_type_name
  // } else{
  // var_subject_type_name = '';
  // }


// NEED TO DETERMINE THE attempt_type === data

    // FIX THIS AND WE CAN USE FOR ALL. -- By getting   if(this.attempts_paragraphs_model){ to refresh or reset the data lookip as it needs to ne differemt for a service or attedance

// ATTEMPS
  // Current Attempt Variables Setups
  // Uppercase.
  if(this.attempts_paragraphs_model){

    let var_subject_attempt_type_name = this.attempts_paragraphs_model.subject_attempt_type_name
    if(var_subject_attempt_type_name != null){ // uppercase must be validated if not null
     this.var_subject_attempt_type_name_Upper = var_subject_attempt_type_name.toUpperCase();
    }
  
  } // end if attemps paragraphs model.

if(this.attempts_paragraphs_model.person_spoken_with_advised_HTML == null){this.person_spoken_with_advised_HTML = this.attempts_paragraphs_model.person_spoken_with_advised; }else{this.person_spoken_with_advised_HTML = this.transform2(this.attempts_paragraphs_model.person_spoken_with_advised_HTML);}
if(this.attempts_paragraphs_model.vehicles_notes_HTML == null){this.vehicles_notes_HTML = this.attempts_paragraphs_model.vehicles_notes; }else{this.vehicles_notes_HTML = this.transform2(this.attempts_paragraphs_model.vehicles_notes_HTML);}
if(this.attempts_paragraphs_model.neighbours_notes_HTML == null){this.neighbours_notes_HTML = this.attempts_paragraphs_model.neighbours_notes; }else{this.neighbours_notes_HTML = this.transform2(this.attempts_paragraphs_model.neighbours_notes_HTML);}
if(this.attempts_paragraphs_model.calling_card_notes_HTML == null){this.calling_card_notes_HTML = this.attempts_paragraphs_model.calling_card_notes; }else{this.calling_card_notes_HTML = this.transform2(this.attempts_paragraphs_model.calling_card_notes_HTML);}
if(this.attempts_paragraphs_model.postal_mail_notes_HTML == null){this.postal_mail_notes_HTML = this.attempts_paragraphs_model.postal_mail_notes; }else{this.postal_mail_notes_HTML = this.transform2(this.attempts_paragraphs_model.postal_mail_notes_HTML);}
if(this.attempts_paragraphs_model.phone_call_notes_HTML == null){this.phone_call_notes_HTML = this.attempts_paragraphs_model.phone_call_notes; }else{this.phone_call_notes_HTML = this.transform2(this.attempts_paragraphs_model.phone_call_notes_HTML);}
if(this.attempts_paragraphs_model.attempts_notes_HTML == null){this.attempts_notes_HTML = this.attempts_paragraphs_model.attempts_notes; }else{this.attempts_notes_HTML = this.transform2(this.attempts_paragraphs_model.attempts_notes_HTML);}
if(this.attempts_paragraphs_model.email_contents_HTML == null){this.email_contents_HTML = this.attempts_paragraphs_model.email_contents; }else{this.email_contents_HTML = this.transform2(this.attempts_paragraphs_model.email_contents_HTML);}
if(this.attempts_paragraphs_model.general_notes_HTML == null){
  this.set_general_notes = this.attempts_paragraphs_model.general_notes;
  }else{
   this.set_general_notes = this.transform2(this.attempts_paragraphs_model.general_notes_HTML)
  }
  if(this.attempts_paragraphs_model.property_forsale_or_lease_sign_details_HTML == null){this.property_forsale_or_lease_sign_details_HTML = this.attempts_paragraphs_model.property_forsale_or_lease_sign_details; }else{this.property_forsale_or_lease_sign_details_HTML = this.transform2(this.attempts_paragraphs_model.property_forsale_or_lease_sign_details_HTML);}  
  if(this.attempts_paragraphs_model.property_mail_details_HTML == null){this.property_mail_details_HTML = this.attempts_paragraphs_model.property_mail_details; }else{this.property_mail_details_HTML = this.transform2(this.attempts_paragraphs_model.property_mail_details_HTML);}
  if(this.attempts_paragraphs_model.property_vehicles_sighted_details_HTML == null){this.property_vehicles_sighted_details_HTML = this.attempts_paragraphs_model.property_vehicles_sighted_details; }else{this.property_vehicles_sighted_details_HTML = this.transform2(this.attempts_paragraphs_model.property_vehicles_sighted_details_HTML);}  
  if(this.attempts_paragraphs_model.property_pets_details_HTML == null){this.property_pets_details_HTML = this.attempts_paragraphs_model.property_pets_details; }else{this.property_pets_details_HTML = this.transform2(this.attempts_paragraphs_model.property_pets_details_HTML);}

  if(this.attempts_paragraphs_model.property_occupancy_details_HTML == null){this.property_occupancy_details_HTML = this.attempts_paragraphs_model.property_occupancy_details; }else{this.property_occupancy_details_HTML = this.transform2(this.attempts_paragraphs_model.property_occupancy_details_HTML);}
  
  if(this.attempts_paragraphs_model.property_condition_HTML == null){this.property_condition_HTML = this.attempts_paragraphs_model.property_condition; }else{this.property_condition_HTML = this.transform2(this.attempts_paragraphs_model.property_condition_HTML);}
if(this.attempts_paragraphs_model.property_occupied_details_HTML == null){this.property_occupied_details_HTML = this.attempts_paragraphs_model.property_occupied_details; }else{this.property_occupied_details_HTML = this.transform2(this.attempts_paragraphs_model.property_occupied_details_HTML);}
if(this.attempts_paragraphs_model.property_type_details_HTML == null){this.set_property_type_details_HTML = this.attempts_paragraphs_model.property_type_details; }else{this.set_property_type_details_HTML = this.transform2(this.attempts_paragraphs_model.property_type_details_HTML);}



 // Do checks for subject name / Businesss Name of FUll SUbject Name fields
 let var_subject_name =  this.attempts_paragraphs_model.first_name + ' ' +  this.attempts_paragraphs_model.middlename + ' '+  this.attempts_paragraphs_model.surname;
 let var_subject_name_4_doc = this.attempts_paragraphs_model.first_name +'-'+  this.attempts_paragraphs_model.surname;
 let var_subject_business_name =  this.attempts_paragraphs_model.business_name;
 
 // Subject Name of Business
     if(var_subject_business_name != null){
         let var_trim_subject_business_name = var_subject_business_name.replaceAll(' ', ''); // need javscipt version of trim (all spaces removed)
         // $subject_name = $trim_subject_business_name;
          var_subject_name = var_subject_business_name; // changed here feb 2023 as subject busines name was printing stripped as variable in affidavid // Not trimmed
           var_subject_name_4_doc= var_trim_subject_business_name;
         
     }



if(this.attempts_paragraphs_model.service_paragraph_rendered == null){
  this.set_service_paragraph_rendered = '';
 }else{
  this.set_service_paragraph_rendered = this.transform2(this.attempts_paragraphs_model.service_paragraph_rendered); // does not require encodeing
}

// Property Images
if(this.attempts_paragraphs_model.property_images != '[]' || this.attempts_paragraphs_model.property_images != null){
  this.property_images = JSON.parse(this.attempts_paragraphs_model.property_images)



  let newArr = this.property_images;
  let  count_of_items = Object.keys(newArr).length;

  // let  count_of_items = 25;
  //   let  count_of_items = Object.keys(newArr).length;
  // //     for(let i=0;i < count_of_items; i++) { 
  // //     let res = newArr[i];
  // // }
 
  if(count_of_items >= 1){this.propery_image_0  = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[0].file_server_location +  '/' + this.property_images[0].file_name + '"></img>'}else{this.propery_image_0=''}
  if(count_of_items >= 2){this.propery_image_1   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[1].file_server_location +  '/' + this.property_images[1].file_name + '"></img>'}else{this.propery_image_1=''}
  if(count_of_items >= 3){this.propery_image_2   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[2].file_server_location +  '/' + this.property_images[2].file_name + '"></img>'}else{this.propery_image_2=''}
  if(count_of_items >= 4){this.propery_image_3   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[3].file_server_location +  '/' + this.property_images[3].file_name + '"></img>'}else{this.propery_image_3=''}
  if(count_of_items >= 5){this.propery_image_4   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[4].file_server_location +  '/' + this.property_images[4].file_name + '"></img>'}else{this.propery_image_4=''}
  if(count_of_items >= 6){this.propery_image_5   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[5].file_server_location +  '/' + this.property_images[5].file_name + '"></img>'}else{this.propery_image_5=''}
  if(count_of_items >= 7){this.propery_image_6   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[6].file_server_location +  '/' + this.property_images[6].file_name + '"></img>'}else{this.propery_image_6=''}
  if(count_of_items >= 8){this.propery_image_7   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[7].file_server_location +  '/' + this.property_images[7].file_name + '"></img>'}else{this.propery_image_7=''}
  if(count_of_items >= 9){this.propery_image_8   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[8].file_server_location +  '/' + this.property_images[8].file_name + '"></img>'}else{this.propery_image_8=''}
  if(count_of_items >= 10){this.propery_image_9   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[9].file_server_location +  '/' + this.property_images[9].file_name + '"></img>'}else{this.propery_image_9=''}
  if(count_of_items >= 11){this.propery_image_10   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[10].file_server_location +  '/' + this.property_images[10].file_name + '"></img>'}else{this.propery_image_10=''}
  if(count_of_items >= 11){this.propery_image_11   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[11].file_server_location +  '/' + this.property_images[11].file_name + '"></img>'}else{this.propery_image_11=''}
  if(count_of_items >= 11){this.propery_image_12   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[12].file_server_location +  '/' + this.property_images[12].file_name + '"></img>'}else{this.propery_image_12=''}
  if(count_of_items >= 11){this.propery_image_13   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[13].file_server_location +  '/' + this.property_images[13].file_name + '"></img>'}else{this.propery_image_13=''}
  if(count_of_items >= 11){this.propery_image_14   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[14].file_server_location +  '/' + this.property_images[14].file_name + '"></img>'}else{this.propery_image_14=''}
  if(count_of_items >= 11){this.propery_image_15   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[15].file_server_location +  '/' + this.property_images[15].file_name + '"></img>'}else{this.propery_image_15=''}
  if(count_of_items >= 11){this.propery_image_16   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[16].file_server_location +  '/' + this.property_images[16].file_name + '"></img>'}else{this.propery_image_16=''}
  if(count_of_items >= 11){this.propery_image_17   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[17].file_server_location +  '/' + this.property_images[17].file_name + '"></img>'}else{this.propery_image_17=''}
  if(count_of_items >= 11){this.propery_image_18   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[18].file_server_location +  '/' + this.property_images[18].file_name + '"></img>'}else{this.propery_image_18=''}
  if(count_of_items >= 11){this.propery_image_19   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[19].file_server_location +  '/' + this.property_images[19].file_name + '"></img>'}else{this.propery_image_19=''}
  if(count_of_items >= 11){this.propery_image_20   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[20].file_server_location +  '/' + this.property_images[20].file_name + '"></img>'}else{this.propery_image_20=''}
  if(count_of_items >= 11){this.propery_image_21   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[21].file_server_location +  '/' + this.property_images[21].file_name + '"></img>'}else{this.propery_image_21=''}
  if(count_of_items >= 11){this.propery_image_22   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[22].file_server_location +  '/' + this.property_images[22].file_name + '"></img>'}else{this.propery_image_22=''}
  if(count_of_items >= 11){this.propery_image_23   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[23].file_server_location +  '/' + this.property_images[23].file_name + '"></img>'}else{this.propery_image_23=''}
  if(count_of_items >= 11){this.propery_image_24   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[24].file_server_location +  '/' + this.property_images[24].file_name + '"></img>'}else{this.propery_image_24=''}
  if(count_of_items >= 11){this.propery_image_25   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[25].file_server_location +  '/' + this.property_images[25].file_name + '"></img>'}else{this.propery_image_25=''}
   


  

  // Loop function to set the images set the ones that exist and then set nulls to the ones that dont. -- similar to the php function in the doucment imaee replacement function 
  // loop 0 - 25 and only set if exisis or '' if not.


}

if(this.attempts_paragraphs_model.property_sign_images != '[]' && this.attempts_paragraphs_model.property_sign_images != null){
  this.property_sign_images = JSON.parse(this.attempts_paragraphs_model.property_sign_images)
  let newArr = this.property_sign_images;
  let  count_of_items = Object.keys(newArr).length;

  if(count_of_items >= 1){this.property_sign_image_0  = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[0].file_server_location +  '/' + this.property_sign_images[0].file_name + '"></img>'}else{this.property_sign_image_0=''}
  if(count_of_items >= 2){this.property_sign_image_1   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[1].file_server_location +  '/' + this.property_sign_images[1].file_name + '"></img>'}else{this.property_sign_image_1=''}
  if(count_of_items >= 3){this.property_sign_image_2   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[2].file_server_location +  '/' + this.property_sign_images[2].file_name + '"></img>'}else{this.property_sign_image_2=''}
  if(count_of_items >= 4){this.property_sign_image_3   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[3].file_server_location +  '/' + this.property_sign_images[3].file_name + '"></img>'}else{this.property_sign_image_3=''}
  if(count_of_items >= 5){this.property_sign_image_4   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[4].file_server_location +  '/' + this.property_sign_images[4].file_name + '"></img>'}else{this.property_sign_image_4=''}
  if(count_of_items >= 6){this.property_sign_image_5   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[5].file_server_location +  '/' + this.property_sign_images[5].file_name + '"></img>'}else{this.property_sign_image_5=''}
  if(count_of_items >= 7){this.property_sign_image_6   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[6].file_server_location +  '/' + this.property_sign_images[6].file_name + '"></img>'}else{this.property_sign_image_6=''}
  if(count_of_items >= 8){this.property_sign_image_7   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[7].file_server_location +  '/' + this.property_sign_images[7].file_name + '"></img>'}else{this.property_sign_image_7=''}
  if(count_of_items >= 9){this.property_sign_image_8   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[8].file_server_location +  '/' + this.property_sign_images[8].file_name + '"></img>'}else{this.property_sign_image_8=''}
  if(count_of_items >= 10){this.property_sign_image_9   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[9].file_server_location +  '/' + this.property_sign_images[9].file_name + '"></img>'}else{this.property_sign_image_9=''}
  if(count_of_items >= 11){this.property_sign_image_10   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[10].file_server_location +  '/' + this.property_sign_images[10].file_name + '"></img>'}else{this.property_sign_image_10=''}
  if(count_of_items >= 11){this.property_sign_image_11   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[11].file_server_location +  '/' + this.property_sign_images[11].file_name + '"></img>'}else{this.property_sign_image_11=''}
  if(count_of_items >= 11){this.property_sign_image_12   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[12].file_server_location +  '/' + this.property_sign_images[12].file_name + '"></img>'}else{this.property_sign_image_12=''}
  if(count_of_items >= 11){this.property_sign_image_13   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[13].file_server_location +  '/' + this.property_sign_images[13].file_name + '"></img>'}else{this.property_sign_image_13=''}
  if(count_of_items >= 11){this.property_sign_image_14   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[14].file_server_location +  '/' + this.property_sign_images[14].file_name + '"></img>'}else{this.property_sign_image_14=''}
  if(count_of_items >= 11){this.property_sign_image_15   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[15].file_server_location +  '/' + this.property_sign_images[15].file_name + '"></img>'}else{this.property_sign_image_15=''}
  if(count_of_items >= 11){this.property_sign_image_16   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[16].file_server_location +  '/' + this.property_sign_images[16].file_name + '"></img>'}else{this.property_sign_image_16=''}
  if(count_of_items >= 11){this.property_sign_image_17   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[17].file_server_location +  '/' + this.property_sign_images[17].file_name + '"></img>'}else{this.property_sign_image_17=''}
  if(count_of_items >= 11){this.property_sign_image_18   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[18].file_server_location +  '/' + this.property_sign_images[18].file_name + '"></img>'}else{this.property_sign_image_18=''}
  if(count_of_items >= 11){this.property_sign_image_19   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[19].file_server_location +  '/' + this.property_sign_images[19].file_name + '"></img>'}else{this.property_sign_image_19=''}
  if(count_of_items >= 11){this.property_sign_image_20   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[20].file_server_location +  '/' + this.property_sign_images[20].file_name + '"></img>'}else{this.property_sign_image_20=''}
  if(count_of_items >= 11){this.property_sign_image_21   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[21].file_server_location +  '/' + this.property_sign_images[21].file_name + '"></img>'}else{this.property_sign_image_21=''}
  if(count_of_items >= 11){this.property_sign_image_22   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[22].file_server_location +  '/' + this.property_sign_images[22].file_name + '"></img>'}else{this.property_sign_image_22=''}
  if(count_of_items >= 11){this.property_sign_image_23   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[23].file_server_location +  '/' + this.property_sign_images[23].file_name + '"></img>'}else{this.property_sign_image_23=''}
  if(count_of_items >= 11){this.property_sign_image_24   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[24].file_server_location +  '/' + this.property_sign_images[24].file_name + '"></img>'}else{this.property_sign_image_24=''}
  if(count_of_items >= 11){this.property_sign_image_25   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[25].file_server_location +  '/' + this.property_sign_images[25].file_name + '"></img>'}else{this.property_sign_image_25=''}
}
  
if(this.attempts_paragraphs_model.property_mail_images != '[]' && this.attempts_paragraphs_model.property_mail_images != null ){
  this.property_mail_images = JSON.parse(this.attempts_paragraphs_model.property_mail_images)
  let newArr = this.property_mail_images;
  let  count_of_items = Object.keys(newArr).length;

  if(count_of_items >= 1){this.property_mail_image_0  = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[0].file_server_location +  '/' + this.property_mail_images[0].file_name + '"></img>'}else{this.property_mail_image_0=''}
  if(count_of_items >= 2){this.property_mail_image_1   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[1].file_server_location +  '/' + this.property_mail_images[1].file_name + '"></img>'}else{this.property_mail_image_1=''}
  if(count_of_items >= 3){this.property_mail_image_2   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[2].file_server_location +  '/' + this.property_mail_images[2].file_name + '"></img>'}else{this.property_mail_image_2=''}
  if(count_of_items >= 4){this.property_mail_image_3   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[3].file_server_location +  '/' + this.property_mail_images[3].file_name + '"></img>'}else{this.property_mail_image_3=''}
  if(count_of_items >= 5){this.property_mail_image_4   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[4].file_server_location +  '/' + this.property_mail_images[4].file_name + '"></img>'}else{this.property_mail_image_4=''}
  if(count_of_items >= 6){this.property_mail_image_5   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[5].file_server_location +  '/' + this.property_mail_images[5].file_name + '"></img>'}else{this.property_mail_image_5=''}
  if(count_of_items >= 7){this.property_mail_image_6   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[6].file_server_location +  '/' + this.property_mail_images[6].file_name + '"></img>'}else{this.property_mail_image_6=''}
  if(count_of_items >= 8){this.property_mail_image_7   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[7].file_server_location +  '/' + this.property_mail_images[7].file_name + '"></img>'}else{this.property_mail_image_7=''}
  if(count_of_items >= 9){this.property_mail_image_8   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[8].file_server_location +  '/' + this.property_mail_images[8].file_name + '"></img>'}else{this.property_mail_image_8=''}
  if(count_of_items >= 10){this.property_mail_image_9   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[9].file_server_location +  '/' + this.property_mail_images[9].file_name + '"></img>'}else{this.property_mail_image_9=''}
  if(count_of_items >= 11){this.property_mail_image_10   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[10].file_server_location +  '/' + this.property_mail_images[10].file_name + '"></img>'}else{this.property_mail_image_10=''}
  if(count_of_items >= 11){this.property_mail_image_11   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[11].file_server_location +  '/' + this.property_mail_images[11].file_name + '"></img>'}else{this.property_mail_image_11=''}
  if(count_of_items >= 11){this.property_mail_image_12   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[12].file_server_location +  '/' + this.property_mail_images[12].file_name + '"></img>'}else{this.property_mail_image_12=''}
  if(count_of_items >= 11){this.property_mail_image_13   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[13].file_server_location +  '/' + this.property_mail_images[13].file_name + '"></img>'}else{this.property_mail_image_13=''}
  if(count_of_items >= 11){this.property_mail_image_14   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[14].file_server_location +  '/' + this.property_mail_images[14].file_name + '"></img>'}else{this.property_mail_image_14=''}
  if(count_of_items >= 11){this.property_mail_image_15   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[15].file_server_location +  '/' + this.property_mail_images[15].file_name + '"></img>'}else{this.property_mail_image_15=''}
  if(count_of_items >= 11){this.property_mail_image_16   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[16].file_server_location +  '/' + this.property_mail_images[16].file_name + '"></img>'}else{this.property_mail_image_16=''}
  if(count_of_items >= 11){this.property_mail_image_17   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[17].file_server_location +  '/' + this.property_mail_images[17].file_name + '"></img>'}else{this.property_mail_image_17=''}
  if(count_of_items >= 11){this.property_mail_image_18   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[18].file_server_location +  '/' + this.property_mail_images[18].file_name + '"></img>'}else{this.property_mail_image_18=''}
  if(count_of_items >= 11){this.property_mail_image_19   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[19].file_server_location +  '/' + this.property_mail_images[19].file_name + '"></img>'}else{this.property_mail_image_19=''}
  if(count_of_items >= 11){this.property_mail_image_20   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[20].file_server_location +  '/' + this.property_mail_images[20].file_name + '"></img>'}else{this.property_mail_image_20=''}
  if(count_of_items >= 11){this.property_mail_image_21   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[21].file_server_location +  '/' + this.property_mail_images[21].file_name + '"></img>'}else{this.property_mail_image_21=''}
  if(count_of_items >= 11){this.property_mail_image_22   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[22].file_server_location +  '/' + this.property_mail_images[22].file_name + '"></img>'}else{this.property_mail_image_22=''}
  if(count_of_items >= 11){this.property_mail_image_23   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[23].file_server_location +  '/' + this.property_mail_images[23].file_name + '"></img>'}else{this.property_mail_image_23=''}
  if(count_of_items >= 11){this.property_mail_image_24   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[24].file_server_location +  '/' + this.property_mail_images[24].file_name + '"></img>'}else{this.property_mail_image_24=''}
  if(count_of_items >= 11){this.property_mail_image_25   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[25].file_server_location +  '/' + this.property_mail_images[25].file_name + '"></img>'}else{this.property_mail_image_25=''}
}
  
if(this.attempts_paragraphs_model.property_vehicles_images != '[]' && this.attempts_paragraphs_model.property_vehicles_images != null){
  this.property_vehicles_images = JSON.parse(this.attempts_paragraphs_model.property_vehicles_images)
  let newArr = this.property_vehicles_images;
  let  count_of_items = Object.keys(newArr).length;

  if(count_of_items >= 1){this.property_vehicles_image_0  = '<img src="' + this.gfunc.fileURL + '/' + this.property_vehicles_images[0].file_server_location +  '/' + this.property_vehicles_images[0].file_name + '"></img>'}else{this.property_vehicles_image_0=''}
  if(count_of_items >= 2){this.property_vehicles_image_1   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[1].file_server_location +  '/' + this.property_vehicles_images[1].file_name + '"></img>'}else{this.property_vehicles_image_1=''}
  if(count_of_items >= 3){this.property_vehicles_image_2   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[2].file_server_location +  '/' + this.property_vehicles_images[2].file_name + '"></img>'}else{this.property_vehicles_image_2=''}
  if(count_of_items >= 4){this.property_vehicles_image_3   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[3].file_server_location +  '/' + this.property_vehicles_images[3].file_name + '"></img>'}else{this.property_vehicles_image_3=''}
  if(count_of_items >= 5){this.property_vehicles_image_4   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[4].file_server_location +  '/' + this.property_vehicles_images[4].file_name + '"></img>'}else{this.property_vehicles_image_4=''}
  if(count_of_items >= 6){this.property_vehicles_image_5   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[5].file_server_location +  '/' + this.property_vehicles_images[5].file_name + '"></img>'}else{this.property_vehicles_image_5=''}
  if(count_of_items >= 7){this.property_vehicles_image_6   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[6].file_server_location +  '/' + this.property_vehicles_images[6].file_name + '"></img>'}else{this.property_vehicles_image_6=''}
  if(count_of_items >= 8){this.property_vehicles_image_7   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[7].file_server_location +  '/' + this.property_vehicles_images[7].file_name + '"></img>'}else{this.property_vehicles_image_7=''}
  if(count_of_items >= 9){this.property_vehicles_image_8   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[8].file_server_location +  '/' + this.property_vehicles_images[8].file_name + '"></img>'}else{this.property_vehicles_image_8=''}
  if(count_of_items >= 10){this.property_vehicles_image_9   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[9].file_server_location +  '/' + this.property_vehicles_images[9].file_name + '"></img>'}else{this.property_vehicles_image_9=''}
  if(count_of_items >= 11){this.property_vehicles_image_10   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[10].file_server_location +  '/' + this.property_vehicles_images[10].file_name + '"></img>'}else{this.property_vehicles_image_10=''}
  if(count_of_items >= 11){this.property_vehicles_image_11   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[11].file_server_location +  '/' + this.property_vehicles_images[11].file_name + '"></img>'}else{this.property_vehicles_image_11=''}
  if(count_of_items >= 11){this.property_vehicles_image_12   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[12].file_server_location +  '/' + this.property_vehicles_images[12].file_name + '"></img>'}else{this.property_vehicles_image_12=''}
  if(count_of_items >= 11){this.property_vehicles_image_13   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[13].file_server_location +  '/' + this.property_vehicles_images[13].file_name + '"></img>'}else{this.property_vehicles_image_13=''}
  if(count_of_items >= 11){this.property_vehicles_image_14   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[14].file_server_location +  '/' + this.property_vehicles_images[14].file_name + '"></img>'}else{this.property_vehicles_image_14=''}
  if(count_of_items >= 11){this.property_vehicles_image_15   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[15].file_server_location +  '/' + this.property_vehicles_images[15].file_name + '"></img>'}else{this.property_vehicles_image_15=''}
  if(count_of_items >= 11){this.property_vehicles_image_16   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[16].file_server_location +  '/' + this.property_vehicles_images[16].file_name + '"></img>'}else{this.property_vehicles_image_16=''}
  if(count_of_items >= 11){this.property_vehicles_image_17   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[17].file_server_location +  '/' + this.property_vehicles_images[17].file_name + '"></img>'}else{this.property_vehicles_image_17=''}
  if(count_of_items >= 11){this.property_vehicles_image_18   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[18].file_server_location +  '/' + this.property_vehicles_images[18].file_name + '"></img>'}else{this.property_vehicles_image_18=''}
  if(count_of_items >= 11){this.property_vehicles_image_19   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[19].file_server_location +  '/' + this.property_vehicles_images[19].file_name + '"></img>'}else{this.property_vehicles_image_19=''}
  if(count_of_items >= 11){this.property_vehicles_image_20   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[20].file_server_location +  '/' + this.property_vehicles_images[20].file_name + '"></img>'}else{this.property_vehicles_image_20=''}
  if(count_of_items >= 11){this.property_vehicles_image_21   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[21].file_server_location +  '/' + this.property_vehicles_images[21].file_name + '"></img>'}else{this.property_vehicles_image_21=''}
  if(count_of_items >= 11){this.property_vehicles_image_22   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[22].file_server_location +  '/' + this.property_vehicles_images[22].file_name + '"></img>'}else{this.property_vehicles_image_22=''}
  if(count_of_items >= 11){this.property_vehicles_image_23   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[23].file_server_location +  '/' + this.property_vehicles_images[23].file_name + '"></img>'}else{this.property_vehicles_image_23=''}
  if(count_of_items >= 11){this.property_vehicles_image_24   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[24].file_server_location +  '/' + this.property_vehicles_images[24].file_name + '"></img>'}else{this.property_vehicles_image_24=''}
  if(count_of_items >= 11){this.property_vehicles_image_25   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[25].file_server_location +  '/' + this.property_vehicles_images[25].file_name + '"></img>'}else{this.property_vehicles_image_25=''}
}


if(this.attempts_paragraphs_model.property_pets_images != '[]' && this.attempts_paragraphs_model.property_pets_images != null){
  this.property_pets_images = JSON.parse(this.attempts_paragraphs_model.property_pets_images)
  let newArr = this.property_pets_images;
  let  count_of_items = Object.keys(newArr).length;

  if(count_of_items >= 1){this.property_pets_image_0  = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[0].file_server_location +  '/' + this.property_pets_images[0].file_name + '"></img>'}else{this.property_pets_image_0=''}
  if(count_of_items >= 2){this.property_pets_image_1   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[1].file_server_location +  '/' + this.property_pets_images[1].file_name + '"></img>'}else{this.property_pets_image_1=''}
  if(count_of_items >= 3){this.property_pets_image_2   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[2].file_server_location +  '/' + this.property_pets_images[2].file_name + '"></img>'}else{this.property_pets_image_2=''}
  if(count_of_items >= 4){this.property_pets_image_3   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[3].file_server_location +  '/' + this.property_pets_images[3].file_name + '"></img>'}else{this.property_pets_image_3=''}
  if(count_of_items >= 5){this.property_pets_image_4   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[4].file_server_location +  '/' + this.property_pets_images[4].file_name + '"></img>'}else{this.property_pets_image_4=''}
  if(count_of_items >= 6){this.property_pets_image_5   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[5].file_server_location +  '/' + this.property_pets_images[5].file_name + '"></img>'}else{this.property_pets_image_5=''}
  if(count_of_items >= 7){this.property_pets_image_6   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[6].file_server_location +  '/' + this.property_pets_images[6].file_name + '"></img>'}else{this.property_pets_image_6=''}
  if(count_of_items >= 8){this.property_pets_image_7   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[7].file_server_location +  '/' + this.property_pets_images[7].file_name + '"></img>'}else{this.property_pets_image_7=''}
  if(count_of_items >= 9){this.property_pets_image_8   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[8].file_server_location +  '/' + this.property_pets_images[8].file_name + '"></img>'}else{this.property_pets_image_8=''}
  if(count_of_items >= 10){this.property_pets_image_9   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[9].file_server_location +  '/' + this.property_pets_images[9].file_name + '"></img>'}else{this.property_pets_image_9=''}
  if(count_of_items >= 11){this.property_pets_image_10   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[10].file_server_location +  '/' + this.property_pets_images[10].file_name + '"></img>'}else{this.property_pets_image_10=''}
  if(count_of_items >= 11){this.property_pets_image_11   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[11].file_server_location +  '/' + this.property_pets_images[11].file_name + '"></img>'}else{this.property_pets_image_11=''}
  if(count_of_items >= 11){this.property_pets_image_12   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[12].file_server_location +  '/' + this.property_pets_images[12].file_name + '"></img>'}else{this.property_pets_image_12=''}
  if(count_of_items >= 11){this.property_pets_image_13   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[13].file_server_location +  '/' + this.property_pets_images[13].file_name + '"></img>'}else{this.property_pets_image_13=''}
  if(count_of_items >= 11){this.property_pets_image_14   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[14].file_server_location +  '/' + this.property_pets_images[14].file_name + '"></img>'}else{this.property_pets_image_14=''}
  if(count_of_items >= 11){this.property_pets_image_15   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[15].file_server_location +  '/' + this.property_pets_images[15].file_name + '"></img>'}else{this.property_pets_image_15=''}
  if(count_of_items >= 11){this.property_pets_image_16   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[16].file_server_location +  '/' + this.property_pets_images[16].file_name + '"></img>'}else{this.property_pets_image_16=''}
  if(count_of_items >= 11){this.property_pets_image_17   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[17].file_server_location +  '/' + this.property_pets_images[17].file_name + '"></img>'}else{this.property_pets_image_17=''}
  if(count_of_items >= 11){this.property_pets_image_18   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[18].file_server_location +  '/' + this.property_pets_images[18].file_name + '"></img>'}else{this.property_pets_image_18=''}
  if(count_of_items >= 11){this.property_pets_image_19   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[19].file_server_location +  '/' + this.property_pets_images[19].file_name + '"></img>'}else{this.property_pets_image_19=''}
  if(count_of_items >= 11){this.property_pets_image_20   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[20].file_server_location +  '/' + this.property_pets_images[20].file_name + '"></img>'}else{this.property_pets_image_20=''}
  if(count_of_items >= 11){this.property_pets_image_21   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[21].file_server_location +  '/' + this.property_pets_images[21].file_name + '"></img>'}else{this.property_pets_image_21=''}
  if(count_of_items >= 11){this.property_pets_image_22   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[22].file_server_location +  '/' + this.property_pets_images[22].file_name + '"></img>'}else{this.property_pets_image_22=''}
  if(count_of_items >= 11){this.property_pets_image_23   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[23].file_server_location +  '/' + this.property_pets_images[23].file_name + '"></img>'}else{this.property_pets_image_23=''}
  if(count_of_items >= 11){this.property_pets_image_24   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[24].file_server_location +  '/' + this.property_pets_images[24].file_name + '"></img>'}else{this.property_pets_image_24=''}
  if(count_of_items >= 11){this.property_pets_image_25   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[25].file_server_location +  '/' + this.property_pets_images[25].file_name + '"></img>'}else{this.property_pets_image_25=''}
}


if(this.attempts_paragraphs_model.property_occupancy_images != '[]' && this.attempts_paragraphs_model.property_occupancy_images != null){
  this.property_occupancy_images = JSON.parse(this.attempts_paragraphs_model.property_occupancy_images)
  let newArr = this.property_occupancy_images;
  let  count_of_items = Object.keys(newArr).length;

  if(count_of_items >= 1){this.property_occupancy_image_0  = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[0].file_server_location +  '/' + this.property_occupancy_images[0].file_name + '"></img>'}else{this.property_occupancy_image_0=''}
  if(count_of_items >= 2){this.property_occupancy_image_1   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[1].file_server_location +  '/' + this.property_occupancy_images[1].file_name + '"></img>'}else{this.property_occupancy_image_1=''}
  if(count_of_items >= 3){this.property_occupancy_image_2   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[2].file_server_location +  '/' + this.property_occupancy_images[2].file_name + '"></img>'}else{this.property_occupancy_image_2=''}
  if(count_of_items >= 4){this.property_occupancy_image_3   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[3].file_server_location +  '/' + this.property_occupancy_images[3].file_name + '"></img>'}else{this.property_occupancy_image_3=''}
  if(count_of_items >= 5){this.property_occupancy_image_4   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[4].file_server_location +  '/' + this.property_occupancy_images[4].file_name + '"></img>'}else{this.property_occupancy_image_4=''}
  if(count_of_items >= 6){this.property_occupancy_image_5   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[5].file_server_location +  '/' + this.property_occupancy_images[5].file_name + '"></img>'}else{this.property_occupancy_image_5=''}
  if(count_of_items >= 7){this.property_occupancy_image_6   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[6].file_server_location +  '/' + this.property_occupancy_images[6].file_name + '"></img>'}else{this.property_occupancy_image_6=''}
  if(count_of_items >= 8){this.property_occupancy_image_7   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[7].file_server_location +  '/' + this.property_occupancy_images[7].file_name + '"></img>'}else{this.property_occupancy_image_7=''}
  if(count_of_items >= 9){this.property_occupancy_image_8   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[8].file_server_location +  '/' + this.property_occupancy_images[8].file_name + '"></img>'}else{this.property_occupancy_image_8=''}
  if(count_of_items >= 10){this.property_occupancy_image_9   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[9].file_server_location +  '/' + this.property_occupancy_images[9].file_name + '"></img>'}else{this.property_occupancy_image_9=''}
  if(count_of_items >= 11){this.property_occupancy_image_10   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[10].file_server_location +  '/' + this.property_occupancy_images[10].file_name + '"></img>'}else{this.property_occupancy_image_10=''}
  if(count_of_items >= 11){this.property_occupancy_image_11   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[11].file_server_location +  '/' + this.property_occupancy_images[11].file_name + '"></img>'}else{this.property_occupancy_image_11=''}
  if(count_of_items >= 11){this.property_occupancy_image_12   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[12].file_server_location +  '/' + this.property_occupancy_images[12].file_name + '"></img>'}else{this.property_occupancy_image_12=''}
  if(count_of_items >= 11){this.property_occupancy_image_13   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[13].file_server_location +  '/' + this.property_occupancy_images[13].file_name + '"></img>'}else{this.property_occupancy_image_13=''}
  if(count_of_items >= 11){this.property_occupancy_image_14   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[14].file_server_location +  '/' + this.property_occupancy_images[14].file_name + '"></img>'}else{this.property_occupancy_image_14=''}
  if(count_of_items >= 11){this.property_occupancy_image_15   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[15].file_server_location +  '/' + this.property_occupancy_images[15].file_name + '"></img>'}else{this.property_occupancy_image_15=''}
  if(count_of_items >= 11){this.property_occupancy_image_16   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[16].file_server_location +  '/' + this.property_occupancy_images[16].file_name + '"></img>'}else{this.property_occupancy_image_16=''}
  if(count_of_items >= 11){this.property_occupancy_image_17   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[17].file_server_location +  '/' + this.property_occupancy_images[17].file_name + '"></img>'}else{this.property_occupancy_image_17=''}
  if(count_of_items >= 11){this.property_occupancy_image_18   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[18].file_server_location +  '/' + this.property_occupancy_images[18].file_name + '"></img>'}else{this.property_occupancy_image_18=''}
  if(count_of_items >= 11){this.property_occupancy_image_19   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[19].file_server_location +  '/' + this.property_occupancy_images[19].file_name + '"></img>'}else{this.property_occupancy_image_19=''}
  if(count_of_items >= 11){this.property_occupancy_image_20   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[20].file_server_location +  '/' + this.property_occupancy_images[20].file_name + '"></img>'}else{this.property_occupancy_image_20=''}
  if(count_of_items >= 11){this.property_occupancy_image_21   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[21].file_server_location +  '/' + this.property_occupancy_images[21].file_name + '"></img>'}else{this.property_occupancy_image_21=''}
  if(count_of_items >= 11){this.property_occupancy_image_22   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[22].file_server_location +  '/' + this.property_occupancy_images[22].file_name + '"></img>'}else{this.property_occupancy_image_22=''}
  if(count_of_items >= 11){this.property_occupancy_image_23   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[23].file_server_location +  '/' + this.property_occupancy_images[23].file_name + '"></img>'}else{this.property_occupancy_image_23=''}
  if(count_of_items >= 11){this.property_occupancy_image_24   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[24].file_server_location +  '/' + this.property_occupancy_images[24].file_name + '"></img>'}else{this.property_occupancy_image_24=''}
  if(count_of_items >= 11){this.property_occupancy_image_25   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[25].file_server_location +  '/' + this.property_occupancy_images[25].file_name + '"></img>'}else{this.property_occupancy_image_25=''}
}

if(this.attempts_paragraphs_model.property_condition_images != '[]' && this.attempts_paragraphs_model.property_condition_images != null ){
  this.property_condition_images = JSON.parse(this.attempts_paragraphs_model.property_condition_images)
  let newArr = this.property_condition_images;
  let  count_of_items = Object.keys(newArr).length;

  if(count_of_items >= 1){this.property_condition_image_0  = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[0].file_server_location +  '/' + this.property_condition_images[0].file_name + '"></img>'}else{this.property_condition_image_0=''}
  if(count_of_items >= 2){this.property_condition_image_1   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[1].file_server_location +  '/' + this.property_condition_images[1].file_name + '"></img>'}else{this.property_condition_image_1=''}
  if(count_of_items >= 3){this.property_condition_image_2   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[2].file_server_location +  '/' + this.property_condition_images[2].file_name + '"></img>'}else{this.property_condition_image_2=''}
  if(count_of_items >= 4){this.property_condition_image_3   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[3].file_server_location +  '/' + this.property_condition_images[3].file_name + '"></img>'}else{this.property_condition_image_3=''}
  if(count_of_items >= 5){this.property_condition_image_4   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[4].file_server_location +  '/' + this.property_condition_images[4].file_name + '"></img>'}else{this.property_condition_image_4=''}
  if(count_of_items >= 6){this.property_condition_image_5   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[5].file_server_location +  '/' + this.property_condition_images[5].file_name + '"></img>'}else{this.property_condition_image_5=''}
  if(count_of_items >= 7){this.property_condition_image_6   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[6].file_server_location +  '/' + this.property_condition_images[6].file_name + '"></img>'}else{this.property_condition_image_6=''}
  if(count_of_items >= 8){this.property_condition_image_7   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[7].file_server_location +  '/' + this.property_condition_images[7].file_name + '"></img>'}else{this.property_condition_image_7=''}
  if(count_of_items >= 9){this.property_condition_image_8   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[8].file_server_location +  '/' + this.property_condition_images[8].file_name + '"></img>'}else{this.property_condition_image_8=''}
  if(count_of_items >= 10){this.property_condition_image_9   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[9].file_server_location +  '/' + this.property_condition_images[9].file_name + '"></img>'}else{this.property_condition_image_9=''}
  if(count_of_items >= 11){this.property_condition_image_10   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[10].file_server_location +  '/' + this.property_condition_images[10].file_name + '"></img>'}else{this.property_condition_image_10=''}
  if(count_of_items >= 11){this.property_condition_image_11   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[11].file_server_location +  '/' + this.property_condition_images[11].file_name + '"></img>'}else{this.property_condition_image_11=''}
  if(count_of_items >= 11){this.property_condition_image_12   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[12].file_server_location +  '/' + this.property_condition_images[12].file_name + '"></img>'}else{this.property_condition_image_12=''}
  if(count_of_items >= 11){this.property_condition_image_13   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[13].file_server_location +  '/' + this.property_condition_images[13].file_name + '"></img>'}else{this.property_condition_image_13=''}
  if(count_of_items >= 11){this.property_condition_image_14   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[14].file_server_location +  '/' + this.property_condition_images[14].file_name + '"></img>'}else{this.property_condition_image_14=''}
  if(count_of_items >= 11){this.property_condition_image_15   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[15].file_server_location +  '/' + this.property_condition_images[15].file_name + '"></img>'}else{this.property_condition_image_15=''}
  if(count_of_items >= 11){this.property_condition_image_16   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[16].file_server_location +  '/' + this.property_condition_images[16].file_name + '"></img>'}else{this.property_condition_image_16=''}
  if(count_of_items >= 11){this.property_condition_image_17   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[17].file_server_location +  '/' + this.property_condition_images[17].file_name + '"></img>'}else{this.property_condition_image_17=''}
  if(count_of_items >= 11){this.property_condition_image_18   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[18].file_server_location +  '/' + this.property_condition_images[18].file_name + '"></img>'}else{this.property_condition_image_18=''}
  if(count_of_items >= 11){this.property_condition_image_19   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[19].file_server_location +  '/' + this.property_condition_images[19].file_name + '"></img>'}else{this.property_condition_image_19=''}
  if(count_of_items >= 11){this.property_condition_image_20   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[20].file_server_location +  '/' + this.property_condition_images[20].file_name + '"></img>'}else{this.property_condition_image_20=''}
  if(count_of_items >= 11){this.property_condition_image_21   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[21].file_server_location +  '/' + this.property_condition_images[21].file_name + '"></img>'}else{this.property_condition_image_21=''}
  if(count_of_items >= 11){this.property_condition_image_22   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[22].file_server_location +  '/' + this.property_condition_images[22].file_name + '"></img>'}else{this.property_condition_image_22=''}
  if(count_of_items >= 11){this.property_condition_image_23   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[23].file_server_location +  '/' + this.property_condition_images[23].file_name + '"></img>'}else{this.property_condition_image_23=''}
  if(count_of_items >= 11){this.property_condition_image_24   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[24].file_server_location +  '/' + this.property_condition_images[24].file_name + '"></img>'}else{this.property_condition_image_24=''}
  if(count_of_items >= 11){this.property_condition_image_25   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[25].file_server_location +  '/' + this.property_condition_images[25].file_name + '"></img>'}else{this.property_condition_image_25=''}
}


if(this.attempts_paragraphs_model.property_type_images != '[]' && this.attempts_paragraphs_model.property_type_images != null){
  this.property_type_images = JSON.parse(this.attempts_paragraphs_model.property_type_images)
  let newArr = this.property_type_images;
  let  count_of_items = Object.keys(newArr).length;

  if(count_of_items >= 1){this.property_type_image_0  = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[0].file_server_location +  '/' + this.property_type_images[0].file_name + '"></img>'}else{this.property_type_image_0=''}
  if(count_of_items >= 2){this.property_type_image_1   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[1].file_server_location +  '/' + this.property_type_images[1].file_name + '"></img>'}else{this.property_type_image_1=''}
  if(count_of_items >= 3){this.property_type_image_2   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[2].file_server_location +  '/' + this.property_type_images[2].file_name + '"></img>'}else{this.property_type_image_2=''}
  if(count_of_items >= 4){this.property_type_image_3   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[3].file_server_location +  '/' + this.property_type_images[3].file_name + '"></img>'}else{this.property_type_image_3=''}
  if(count_of_items >= 5){this.property_type_image_4   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[4].file_server_location +  '/' + this.property_type_images[4].file_name + '"></img>'}else{this.property_type_image_4=''}
  if(count_of_items >= 6){this.property_type_image_5   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[5].file_server_location +  '/' + this.property_type_images[5].file_name + '"></img>'}else{this.property_type_image_5=''}
  if(count_of_items >= 7){this.property_type_image_6   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[6].file_server_location +  '/' + this.property_type_images[6].file_name + '"></img>'}else{this.property_type_image_6=''}
  if(count_of_items >= 8){this.property_type_image_7   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[7].file_server_location +  '/' + this.property_type_images[7].file_name + '"></img>'}else{this.property_type_image_7=''}
  if(count_of_items >= 9){this.property_type_image_8   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[8].file_server_location +  '/' + this.property_type_images[8].file_name + '"></img>'}else{this.property_type_image_8=''}
  if(count_of_items >= 10){this.property_type_image_9   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[9].file_server_location +  '/' + this.property_type_images[9].file_name + '"></img>'}else{this.property_type_image_9=''}
  if(count_of_items >= 11){this.property_type_image_10   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[10].file_server_location +  '/' + this.property_type_images[10].file_name + '"></img>'}else{this.property_type_image_10=''}
  if(count_of_items >= 11){this.property_type_image_11   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[11].file_server_location +  '/' + this.property_type_images[11].file_name + '"></img>'}else{this.property_type_image_11=''}
  if(count_of_items >= 11){this.property_type_image_12   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[12].file_server_location +  '/' + this.property_type_images[12].file_name + '"></img>'}else{this.property_type_image_12=''}
  if(count_of_items >= 11){this.property_type_image_13   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[13].file_server_location +  '/' + this.property_type_images[13].file_name + '"></img>'}else{this.property_type_image_13=''}
  if(count_of_items >= 11){this.property_type_image_14   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[14].file_server_location +  '/' + this.property_type_images[14].file_name + '"></img>'}else{this.property_type_image_14=''}
  if(count_of_items >= 11){this.property_type_image_15   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[15].file_server_location +  '/' + this.property_type_images[15].file_name + '"></img>'}else{this.property_type_image_15=''}
  if(count_of_items >= 11){this.property_type_image_16   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[16].file_server_location +  '/' + this.property_type_images[16].file_name + '"></img>'}else{this.property_type_image_16=''}
  if(count_of_items >= 11){this.property_type_image_17   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[17].file_server_location +  '/' + this.property_type_images[17].file_name + '"></img>'}else{this.property_type_image_17=''}
  if(count_of_items >= 11){this.property_type_image_18   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[18].file_server_location +  '/' + this.property_type_images[18].file_name + '"></img>'}else{this.property_type_image_18=''}
  if(count_of_items >= 11){this.property_type_image_19   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[19].file_server_location +  '/' + this.property_type_images[19].file_name + '"></img>'}else{this.property_type_image_19=''}
  if(count_of_items >= 11){this.property_type_image_20   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[20].file_server_location +  '/' + this.property_type_images[20].file_name + '"></img>'}else{this.property_type_image_20=''}
  if(count_of_items >= 11){this.property_type_image_21   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[21].file_server_location +  '/' + this.property_type_images[21].file_name + '"></img>'}else{this.property_type_image_21=''}
  if(count_of_items >= 11){this.property_type_image_22   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[22].file_server_location +  '/' + this.property_type_images[22].file_name + '"></img>'}else{this.property_type_image_22=''}
  if(count_of_items >= 11){this.property_type_image_23   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[23].file_server_location +  '/' + this.property_type_images[23].file_name + '"></img>'}else{this.property_type_image_23=''}
  if(count_of_items >= 11){this.property_type_image_24   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[24].file_server_location +  '/' + this.property_type_images[24].file_name + '"></img>'}else{this.property_type_image_24=''}
  if(count_of_items >= 11){this.property_type_image_25   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[25].file_server_location +  '/' + this.property_type_images[25].file_name + '"></img>'}else{this.property_type_image_25=''}
}




if(this.attempts_paragraphs_model.service_file_array != '[]' && this.attempts_paragraphs_model.service_file_array != null){
  this.service_file_array_images = JSON.parse(this.attempts_paragraphs_model.service_file_array)
  let newArr = this.service_file_array_images;
  let  count_of_items = Object.keys(newArr).length;

  if(count_of_items >= 1){this.service_file_array_image_0  = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[0].file_server_location +  '/' + this.service_file_array_images[0].file_name + '"></img>'}else{this.service_file_array_image_0=''}
  if(count_of_items >= 2){this.service_file_array_image_1   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[1].file_server_location +  '/' + this.service_file_array_images[1].file_name + '"></img>'}else{this.service_file_array_image_1=''}
  if(count_of_items >= 3){this.service_file_array_image_2   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[2].file_server_location +  '/' + this.service_file_array_images[2].file_name + '"></img>'}else{this.service_file_array_image_2=''}
  if(count_of_items >= 4){this.service_file_array_image_3   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[3].file_server_location +  '/' + this.service_file_array_images[3].file_name + '"></img>'}else{this.service_file_array_image_3=''}
  if(count_of_items >= 5){this.service_file_array_image_4   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[4].file_server_location +  '/' + this.service_file_array_images[4].file_name + '"></img>'}else{this.service_file_array_image_4=''}
  if(count_of_items >= 6){this.service_file_array_image_5   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[5].file_server_location +  '/' + this.service_file_array_images[5].file_name + '"></img>'}else{this.service_file_array_image_5=''}
  if(count_of_items >= 7){this.service_file_array_image_6   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[6].file_server_location +  '/' + this.service_file_array_images[6].file_name + '"></img>'}else{this.service_file_array_image_6=''}
  if(count_of_items >= 8){this.service_file_array_image_7   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[7].file_server_location +  '/' + this.service_file_array_images[7].file_name + '"></img>'}else{this.service_file_array_image_7=''}
  if(count_of_items >= 9){this.service_file_array_image_8   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[8].file_server_location +  '/' + this.service_file_array_images[8].file_name + '"></img>'}else{this.service_file_array_image_8=''}
  if(count_of_items >= 10){this.service_file_array_image_9   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[9].file_server_location +  '/' + this.service_file_array_images[9].file_name + '"></img>'}else{this.service_file_array_image_9=''}
  if(count_of_items >= 11){this.service_file_array_image_10   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[10].file_server_location +  '/' + this.service_file_array_images[10].file_name + '"></img>'}else{this.service_file_array_image_10=''}
  if(count_of_items >= 11){this.service_file_array_image_11   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[11].file_server_location +  '/' + this.service_file_array_images[11].file_name + '"></img>'}else{this.service_file_array_image_11=''}
  if(count_of_items >= 11){this.service_file_array_image_12   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[12].file_server_location +  '/' + this.service_file_array_images[12].file_name + '"></img>'}else{this.service_file_array_image_12=''}
  if(count_of_items >= 11){this.service_file_array_image_13   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[13].file_server_location +  '/' + this.service_file_array_images[13].file_name + '"></img>'}else{this.service_file_array_image_13=''}
  if(count_of_items >= 11){this.service_file_array_image_14   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[14].file_server_location +  '/' + this.service_file_array_images[14].file_name + '"></img>'}else{this.service_file_array_image_14=''}
  if(count_of_items >= 11){this.service_file_array_image_15   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[15].file_server_location +  '/' + this.service_file_array_images[15].file_name + '"></img>'}else{this.service_file_array_image_15=''}
  if(count_of_items >= 11){this.service_file_array_image_16   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[16].file_server_location +  '/' + this.service_file_array_images[16].file_name + '"></img>'}else{this.service_file_array_image_16=''}
  if(count_of_items >= 11){this.service_file_array_image_17   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[17].file_server_location +  '/' + this.service_file_array_images[17].file_name + '"></img>'}else{this.service_file_array_image_17=''}
  if(count_of_items >= 11){this.service_file_array_image_18   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[18].file_server_location +  '/' + this.service_file_array_images[18].file_name + '"></img>'}else{this.service_file_array_image_18=''}
  if(count_of_items >= 11){this.service_file_array_image_19   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[19].file_server_location +  '/' + this.service_file_array_images[19].file_name + '"></img>'}else{this.service_file_array_image_19=''}
  if(count_of_items >= 11){this.service_file_array_image_20   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[20].file_server_location +  '/' + this.service_file_array_images[20].file_name + '"></img>'}else{this.service_file_array_image_20=''}
  if(count_of_items >= 11){this.service_file_array_image_21   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[21].file_server_location +  '/' + this.service_file_array_images[21].file_name + '"></img>'}else{this.service_file_array_image_21=''}
  if(count_of_items >= 11){this.service_file_array_image_22   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[22].file_server_location +  '/' + this.service_file_array_images[22].file_name + '"></img>'}else{this.service_file_array_image_22=''}
  if(count_of_items >= 11){this.service_file_array_image_23   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[23].file_server_location +  '/' + this.service_file_array_images[23].file_name + '"></img>'}else{this.service_file_array_image_23=''}
  if(count_of_items >= 11){this.service_file_array_image_24   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[24].file_server_location +  '/' + this.service_file_array_images[24].file_name + '"></img>'}else{this.service_file_array_image_24=''}
  if(count_of_items >= 11){this.service_file_array_image_25   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[25].file_server_location +  '/' + this.service_file_array_images[25].file_name + '"></img>'}else{this.service_file_array_image_25=''}
}

  const rendered_result = str



      .replaceAll( '${' + keystarter + '_type_id}', this.attempts_paragraphs_model.subject_attempt_type_id)
      .replaceAll( '${' + keystarter + '_type_name}', this.attempts_paragraphs_model.subject_attempt_type_name ) // run a function with return;
      .replaceAll( '${' + keystarter + '_subject_attempt_type_name}', this.attempts_paragraphs_model.subject_attempt_type_name ) // run a function with return;
      .replaceAll( '${' + keystarter + '_type_name_upper}', this.var_subject_attempt_type_name_Upper) // all if statments set a this/g/ varaibales

      .replaceAll( '${' + keystarter + '_subject_service_method_id}', this.attempts_paragraphs_model.subject_service_method_id)
      .replaceAll( '${' + keystarter + '_subject_service_method_name}', this.attempts_paragraphs_model.subject_service_method_name ) // tested above.
      .replaceAll( '${' + keystarter + '_service_method}', this.attempts_paragraphs_model.subject_service_method_name ) // tested above.
      .replaceAll( '${' + keystarter + '_service_method_id}', this.attempts_paragraphs_model.subject_service_method_id) // tested above.


      .replaceAll( '${' + keystarter + '_date_service}', moment(this.attempts_paragraphs_model.date_service).format('M/D/YYYY'))
      .replaceAll( '${' + keystarter + '_date_service_full_words_time_first}', this.attempts_paragraphs_model.time_service_text + ' ' + moment(this.attempts_paragraphs_model.date_service).format('dddd MMMM Do, YYYY') ) 
      .replaceAll( '${' + keystarter + '_date_service_and_time_full_words}', moment(this.attempts_paragraphs_model.date_service).format('dddd MMMM Do, YYYY') + ' ' + this.attempts_paragraphs_model.time_service_text ) 
      .replaceAll( '${' + keystarter + '_date_service_full_words}', moment(this.attempts_paragraphs_model.date_service).format('dddd MMMM Do, YYYY') + ' ' + model.time_service_text ) 

      .replaceAll( '${' + keystarter + '_day}', moment(this.attempts_paragraphs_model.date_service).format('dddd'))
      .replaceAll( '${' + keystarter + '_day_number}', moment(this.attempts_paragraphs_model.date_service).format('Do'))
      .replaceAll( '${' + keystarter + '_day_number_simple}', moment(this.attempts_paragraphs_model.date_service).format('D'))
      .replaceAll( '${' + keystarter + '_month}', moment(this.attempts_paragraphs_model.date_service).format('MMMM'))
      .replaceAll( '${' + keystarter + '_month_number}', moment(this.attempts_paragraphs_model.date_service).format('Mo'))
      .replaceAll( '${' + keystarter + '_month_number_simple}', moment(this.attempts_paragraphs_model.date_service).format('M'))
      .replaceAll( '${' + keystarter + '_year}', moment(this.attempts_paragraphs_model.date_service).format('YYYY'))

      .replaceAll( '${' + keystarter + '_service_local}', this.attempts_paragraphs_model.service_local) // region Australia/Perth of service undertaken
      .replaceAll( '${' + keystarter + '_time}', this.attempts_paragraphs_model.time_service_text) //$_set_service_time - Fixed and set time of attempt and service

      .replaceAll( '${' + keystarter + '_paragraph_rendered}',  this.set_service_paragraph_rendered) //$_set_service_time - Fixed and set time of attempt and service

      .replaceAll( '${' + keystarter + '_subject_name}', var_subject_name)
      .replaceAll( '${' + keystarter + '_subject_number}', this.attempts_paragraphs_model.subject_number)
      .replaceAll( '${' + keystarter + '_subject_name_4_doc}', var_subject_name_4_doc)
      .replaceAll( '${' + keystarter + '_subject_business_name}', var_subject_business_name)
      .replaceAll( '${' + keystarter + '_business_name}', var_subject_business_name)

  // Subject Attempt Address
  .replaceAll( '${' + keystarter + '_address_1}', this.attempts_paragraphs_model.address_1)
  .replaceAll( '${' + keystarter + '_address_2}', this.attempts_paragraphs_model.address_2)
  .replaceAll( '${' + keystarter + '_suburb}', this.attempts_paragraphs_model.suburb)
  .replaceAll( '${' + keystarter + '_state}', this.attempts_paragraphs_model.state)
  .replaceAll( '${' + keystarter + '_postcode}', this.attempts_paragraphs_model.postcode)
  .replaceAll( '${' + keystarter + '_address_full}', this.attempts_paragraphs_model.address_1 +  ' ' + this.attempts_paragraphs_model.address_2 +  ' ' + this.attempts_paragraphs_model.suburb +  ' ' + this.attempts_paragraphs_model.state +  ',  ' + this.attempts_paragraphs_model.postcode )
  // Sav
  .replaceAll( '${' + keystarter + '_sav_address_full}', this.attempts_paragraphs_model.address_1 +  ' ' + this.attempts_paragraphs_model.address_2 +  ' ' + this.attempts_paragraphs_model.suburb +  ' ' + this.attempts_paragraphs_model.state +  ',  ' + this.attempts_paragraphs_model.postcode )
  // New address
  .replaceAll( '${' + keystarter + '_new_business_name}', this.attempts_paragraphs_model.new_business_name)
  .replaceAll( '${' + keystarter + '_new_address_1}', this.attempts_paragraphs_model.new_address_1)
  .replaceAll( '${' + keystarter + '_new_address_2}', this.attempts_paragraphs_model.new_address_2)
  .replaceAll( '${' + keystarter + '_new_suburb}', this.attempts_paragraphs_model.new_suburb)
  .replaceAll( '${' + keystarter + '_new_state}', this.attempts_paragraphs_model.new_state)
  .replaceAll( '${' + keystarter + '_new_postcode}', this.attempts_paragraphs_model.new_postcode)
  .replaceAll( '${' + keystarter + '_new_address_full}', this.attempts_paragraphs_model.new_address_1 +  ' ' + this.attempts_paragraphs_model.new_address_2 +  ' ' + this.attempts_paragraphs_model.new_suburb +  ' ' + this.attempts_paragraphs_model.new_state +  ',  ' + this.attempts_paragraphs_model.new_postcode )
  
  .replaceAll( '${' + keystarter + '_service_number}', this.attempts_paragraphs_model.service_number)

  .replaceAll( '${' + keystarter + '_service_outcome_name}', this.attempts_paragraphs_model.subject_service_outcome_name)
  .replaceAll( '${' + keystarter + '_exact_service_method_name}', this.attempts_paragraphs_model.exact_service_method_name) //
  .replaceAll( '${' + keystarter + '_subject_type_name}', this.job_subject_type_name) // set in the job lookup.
  .replaceAll( '${' + keystarter + '_subject_type_name_upper}', this.job_subject_type_name_Upper) // set in the job lookup.
  .replaceAll( '${' + keystarter + '_location_status_name}', this.attempts_paragraphs_model.subject_location_status_name)
  .replaceAll( '${' + keystarter + '_location_status_found_name}', this.attempts_paragraphs_model.subject_location_status_found_name)

  .replaceAll( '${' + keystarter + '_fellow_occupants_name}', this.attempts_paragraphs_model.fellow_occupants_name)
  .replaceAll( '${' + keystarter + '_fellow_occupants_sex}', this.attempts_paragraphs_model.fellow_occupants_sex)
  .replaceAll( '${' + keystarter + '_fellow_occupants_name_label}', 'Fellow Occupants Name: ' +  this.attempts_paragraphs_model.fellow_occupants_name)
  .replaceAll( '${' + keystarter + '_subject_relationship_name}', this.attempts_paragraphs_model.subject_service_fellow_relationship)

  .replaceAll( '${' + keystarter + '_person_spoken_with}', this.attempts_paragraphs_model.person_spoken_with)
  .replaceAll( '${' + keystarter + '_person_type}', this.attempts_paragraphs_model.person_type)
  .replaceAll( '${' + keystarter + '_person_spoken_with_advised}',   this.person_spoken_with_advised_HTML ) 

  .replaceAll( '${' + keystarter + '_vehicles}', this.attempts_paragraphs_model.vehicles)
.replaceAll( '${' + keystarter + '_vehicles_notes}',   this.vehicles_notes_HTML ) // replace original only use this for create.

.replaceAll( '${' + keystarter + '_neighbours}', this.attempts_paragraphs_model.neighbours)
.replaceAll( '${' + keystarter + '_neighbours_notes}',   this.neighbours_notes_HTML ) // replace original only use this for create.

.replaceAll( '${' + keystarter + '_calling_card}', this.attempts_paragraphs_model.calling_card)
.replaceAll( '${' + keystarter + '_calling_card_notes}',   this.calling_card_notes_HTML ) // replace original only use this for create.

.replaceAll( '${' + keystarter + '_postal_mail}', this.attempts_paragraphs_model.postal_mail)
.replaceAll( '${' + keystarter + '_postal_mail_notes}',   this.postal_mail_notes_HTML ) // replace original only use this for create.

.replaceAll( '${' + keystarter + '_phone_call}', this.attempts_paragraphs_model.phone_call)
.replaceAll( '${' + keystarter + '_phone_call_notes}',   this.phone_call_notes_HTML ) // replace original only use this for create.

.replaceAll( '${' + keystarter + '_attempts}', this.attempts_paragraphs_model.attempts)
.replaceAll( '${' + keystarter + '_attempts_notes}',   this.attempts_notes_HTML ) // replace original only use this for create.

.replaceAll( '${' + keystarter + '_authorised_employee_name}', this.attempts_paragraphs_model.authorised_employee_name)
.replaceAll( '${' + keystarter + '_authorised_employee_job_title}', this.attempts_paragraphs_model.authorised_employee_job_title)
.replaceAll( '${' + keystarter + '_authorised_employee_sex}', this.attempts_paragraphs_model.authorised_employee_sex)
.replaceAll( '${' + keystarter + '_office_business_name}', this.attempts_paragraphs_model.office_business_name)

.replaceAll( '${' + keystarter + '_witness_name}', this.attempts_paragraphs_model.witness_name)
.replaceAll( '${' + keystarter + '_witness_business_name}', this.attempts_paragraphs_model.witness_business_name)
.replaceAll( '${' + keystarter + '_witness_address}', this.attempts_paragraphs_model.witness_address_1 + ' ' + this.attempts_paragraphs_model.witness_address_2 + ' ' +  this.attempts_paragraphs_model.witness_suburb + ' ' + this.attempts_paragraphs_model.witness_state + ', ' + this.attempts_paragraphs_model.witness_postcode  ) // 
.replaceAll( '${' + keystarter + '_witness_address_1}', this.attempts_paragraphs_model.witness_address_1)
.replaceAll( '${' + keystarter + '_witness_address_2}', this.attempts_paragraphs_model.witness_address_2)
.replaceAll( '${' + keystarter + '_witness_state}', this.attempts_paragraphs_model.witness_state)
.replaceAll( '${' + keystarter + '_witness_suburb}', this.attempts_paragraphs_model.witness_suburb)
.replaceAll( '${' + keystarter + '_witness_country}', this.attempts_paragraphs_model.witness_country)
.replaceAll( '${' + keystarter + '_witness_postcode}', this.attempts_paragraphs_model.witness_postcode)

.replaceAll( '${' + keystarter + '_person_in_charge_of_prison_name}', this.attempts_paragraphs_model.person_in_charge_of_prison_name)
.replaceAll( '${' + keystarter + '_person_in_charge_of_prison_occupation}', this.attempts_paragraphs_model.person_in_charge_of_prison_occupation)

.replaceAll( '${' + keystarter + '_ubject_contact_email_id}', this.attempts_paragraphs_model.subject_contact_email_id)
.replaceAll( '${' + keystarter + '_email_address_served}', this.attempts_paragraphs_model.email_address_served)
.replaceAll( '${' + keystarter + '_email_contents}', this.email_contents_HTML ) // replace original only use this for create.

.replaceAll( '${' + keystarter + '_director_name}', this.attempts_paragraphs_model.director_name)
.replaceAll( '${' + keystarter + '_service_under_order}', this.attempts_paragraphs_model.service_under_order)

.replaceAll( '${' + keystarter + '_phone_number}', this.attempts_paragraphs_model.phone_number)



  // Agent Details
  .replaceAll( '${' + keystarter + '_agent_name}', this.subject_service_agent.first_name + ' ' + this.subject_service_agent.middle_name + ' ' + this.subject_service_agent.surname )
  .replaceAll( '${' + keystarter + '_agent_first_name}', this.subject_service_agent.first_name)
  .replaceAll( '${' + keystarter + '_agent_middle_name}', this.subject_service_agent.middle_name)
  .replaceAll( '${' + keystarter + '_agent_surname}', this.subject_service_agent.surname)
  
  .replaceAll( '${' + keystarter + '_agent_address_1}', this.subject_service_agent.address_1)
  .replaceAll( '${' + keystarter + '_agent_address_2}', this.subject_service_agent.address_2)
  .replaceAll( '${' + keystarter + '_agent_suburb}', this.subject_service_agent.suburb)
  .replaceAll( '${' + keystarter + '_agent_state}', this.subject_service_agent.state)
  .replaceAll( '${' + keystarter + '_agent_postcode}', this.subject_service_agent.postcode)
  .replaceAll( '${' + keystarter + '_agent_address_full}', this.subject_service_agent.address_1 + ' ' + this.subject_service_agent.address_2 + ' ' + this.subject_service_agent.suburb + ' ' + this.subject_service_agent.state + ', ' + this.subject_service_agent.postcode )
  .replaceAll( '${' + keystarter + '_agent_qualification}', this.subject_service_agent.qualification)
  .replaceAll( '${' + keystarter + '_agent_qualification_number}', this.subject_service_agent.qualification_number)
  
  .replaceAll( '${' + keystarter + '_agent_qualification_renewal_date}', moment(this.subject_service_agent.qualification_renewal_date).format('M/D/YYYY') )
  .replaceAll( '${' + keystarter + '_agent_qualification_renewal_date_full_words}', moment(this.subject_service_agent.qualification_renewal_date).format('dddd MMMM Do, YYYY h:mma') )

  .replaceAll( '${' + keystarter + '_general_notes}',  this.set_general_notes ) // replace original only use this for create.

  .replaceAll( '${' + keystarter + '_is_count}', this.attempts_paragraphs_model.is_count)
  .replaceAll( '${' + keystarter + '_property_images}', this.attempts_paragraphs_model.property_images)
  .replaceAll( '${' + keystarter + '_attach_file_array_name}', this.attempts_paragraphs_model.attach_file_array_name)
  .replaceAll( '${' + keystarter + '_property_occupied}', this.attempts_paragraphs_model.property_occupied)

  .replaceAll( '${' + keystarter + '_property_forsale_or_lease_sign}', this.attempts_paragraphs_model.property_forsale_or_lease_sign)
  .replaceAll( '${' + keystarter + '_property_sign_images}', this.attempts_paragraphs_model.property_sign_images)
.replaceAll( '${' + keystarter + '_property_forsale_or_lease_sign_details}',   this.property_forsale_or_lease_sign_details_HTML) // replace original only use this for create.
.replaceAll( '${' + keystarter + '_property_agent_name}', this.attempts_paragraphs_model.property_agent_name)
.replaceAll( '${' + keystarter + '_property_agency_name}', this.attempts_paragraphs_model.property_agency_name)
.replaceAll( '${' + keystarter + '_property_agency_contact_numbers}', this.attempts_paragraphs_model.property_agency_contact_numbers)


.replaceAll( '${' + keystarter + '_property_mail}', this.attempts_paragraphs_model.property_mail)
.replaceAll( '${' + keystarter + '_property_mail_images}', this.attempts_paragraphs_model.property_mail_images)
.replaceAll( '${' + keystarter + '_property_mail_details}', this.property_mail_details_HTML ) // replace original only use this for create.

.replaceAll( '${' + keystarter + '_property_vehicles_sighted}', this.attempts_paragraphs_model.property_vehicles_sighted)
.replaceAll( '${' + keystarter + '_property_vehicles_sighted_details}', this.property_vehicles_sighted_details_HTML ) // replace original only use this for create.
  .replaceAll( '${' + keystarter + '_property_vehicles_images}', this.attempts_paragraphs_model.property_vehicles_images)
  .replaceAll( '${' + keystarter + '_property_v_make}', this.attempts_paragraphs_model.property_v_make)
  .replaceAll( '${' + keystarter + '_property_v_model}', this.attempts_paragraphs_model.property_v_model)
  .replaceAll( '${' + keystarter + '_property_v_plate}', this.attempts_paragraphs_model.property_v_plate)
  .replaceAll( '${' + keystarter + '_property_v_rego_state}', this.attempts_paragraphs_model.property_v_rego_state)

  .replaceAll( '${' + keystarter + '_property_pets}', this.attempts_paragraphs_model.property_pets)
.replaceAll( '${' + keystarter + '_property_pets_details}', this.property_pets_details_HTML ) // replace original only use this for create.
  .replaceAll( '${' + keystarter + '_property_pets_images}', this.attempts_paragraphs_model.property_pets_images)

.replaceAll( '${' + keystarter + '_property_occupancy}', this.attempts_paragraphs_model.property_occupancy)
.replaceAll( '${' + keystarter + '_property_occupancy_details}', this.property_occupancy_details_HTML ) // replace original only use this for create.
.replaceAll( '${' + keystarter + '_property_occupancy_images}', this.attempts_paragraphs_model.property_occupancy_images)
.replaceAll( '${' + keystarter + '_property_o_name}', this.attempts_paragraphs_model.property_o_name)
.replaceAll( '${' + keystarter + '_property_o_contact_numbers}', this.attempts_paragraphs_model.property_o_contact_numbers)
.replaceAll( '${' + keystarter + '_property_o_lease_details}', this.attempts_paragraphs_model.property_o_lease_details)
.replaceAll( '${' + keystarter + '_property_o_lease_date}', this.attempts_paragraphs_model.property_o_lease_date)
.replaceAll( '${' + keystarter + '_property_o_landlord_contacts}', this.attempts_paragraphs_model.property_o_landlord_contacts)

.replaceAll( '${' + keystarter + '_property_condition}', this.property_condition_HTML ) // replace original only use this for create.
  .replaceAll( '${' + keystarter + '_property_condition_images}', this.attempts_paragraphs_model.property_condition_images)

.replaceAll( '${' + keystarter + '_property_occupied_details}', this.property_occupied_details_HTML) // replace original only use this for create.

.replaceAll( '${' + keystarter + '_property_type_id}', this.attempts_paragraphs_model.property_type_id)
.replaceAll( '${' + keystarter + '_property_type_details}', this.set_property_type_details_HTML) // replace original only use this for create.
.replaceAll( '${' + keystarter + '_property_type_images}', this.attempts_paragraphs_model.property_type_images)

.replaceAll( '${' + keystarter + '_property_type_name}', this.attempts_paragraphs_model.property_type_name)

.replaceAll( '${' + keystarter + '_service_file_array}', this.attempts_paragraphs_model.service_file_array)


// Images // <img src="pic_trulli.jpg" alt="Italian Trulli">
// this.attempts_paragraphs_model.property_images - runs a loop functino above to set image variables
.replaceAll( '${' + keystarter + '_property_image_0}',  this.propery_image_0 )
.replaceAll( '${' + keystarter + '_property_image_1}',  this.propery_image_1 )
.replaceAll( '${' + keystarter + '_property_image_2}',  this.propery_image_2 )
.replaceAll( '${' + keystarter + '_property_image_3}',  this.propery_image_3 )
.replaceAll( '${' + keystarter + '_property_image_4}',  this.propery_image_4 )
.replaceAll( '${' + keystarter + '_property_image_5}',  this.propery_image_5 )
.replaceAll( '${' + keystarter + '_property_image_6}',  this.propery_image_6 )
.replaceAll( '${' + keystarter + '_property_image_7}',  this.propery_image_7 )
.replaceAll( '${' + keystarter + '_property_image_8}',  this.propery_image_8 )
.replaceAll( '${' + keystarter + '_property_image_9}',  this.propery_image_9 )
.replaceAll( '${' + keystarter + '_property_image_10}',  this.propery_image_10 )
.replaceAll( '${' + keystarter + '_property_image_11}',  this.propery_image_11 )
.replaceAll( '${' + keystarter + '_property_image_12}',  this.propery_image_12 )
.replaceAll( '${' + keystarter + '_property_image_13}',  this.propery_image_13 )
.replaceAll( '${' + keystarter + '_property_image_14}',  this.propery_image_14 )
.replaceAll( '${' + keystarter + '_property_image_15}',  this.propery_image_15 )
.replaceAll( '${' + keystarter + '_property_image_16}',  this.propery_image_16 )
.replaceAll( '${' + keystarter + '_property_image_17}',  this.propery_image_17 )
.replaceAll( '${' + keystarter + '_property_image_18}',  this.propery_image_18 )
.replaceAll( '${' + keystarter + '_property_image_19}',  this.propery_image_19 )
.replaceAll( '${' + keystarter + '_property_image_20}',  this.propery_image_20 )
.replaceAll( '${' + keystarter + '_property_image_21}',  this.propery_image_21 )
.replaceAll( '${' + keystarter + '_property_image_22}',  this.propery_image_22 )
.replaceAll( '${' + keystarter + '_property_image_23}',  this.propery_image_23 )
.replaceAll( '${' + keystarter + '_property_image_24}',  this.propery_image_24 )
.replaceAll( '${' + keystarter + '_property_image_25}',  this.propery_image_25 )


.replaceAll( '${' + keystarter + '_property_sign_image_0}',  this.property_sign_image_0 )
.replaceAll( '${' + keystarter + '_property_sign_image_1}',  this.property_sign_image_1 )
.replaceAll( '${' + keystarter + '_property_sign_image_2}',  this.property_sign_image_2 )
.replaceAll( '${' + keystarter + '_property_sign_image_3}',  this.property_sign_image_3 )
.replaceAll( '${' + keystarter + '_property_sign_image_4}',  this.property_sign_image_4 )
.replaceAll( '${' + keystarter + '_property_sign_image_5}',  this.property_sign_image_5 )
.replaceAll( '${' + keystarter + '_property_sign_image_6}',  this.property_sign_image_6 )
.replaceAll( '${' + keystarter + '_property_sign_image_7}',  this.property_sign_image_7 )
.replaceAll( '${' + keystarter + '_property_sign_image_8}',  this.property_sign_image_8 )
.replaceAll( '${' + keystarter + '_property_sign_image_9}',  this.property_sign_image_9 )
.replaceAll( '${' + keystarter + '_property_sign_image_10}',  this.property_sign_image_10 )
.replaceAll( '${' + keystarter + '_property_sign_image_11}',  this.property_sign_image_11 )
.replaceAll( '${' + keystarter + '_property_sign_image_12}',  this.property_sign_image_12 )
.replaceAll( '${' + keystarter + '_property_sign_image_13}',  this.property_sign_image_13 )
.replaceAll( '${' + keystarter + '_property_sign_image_14}',  this.property_sign_image_14 )
.replaceAll( '${' + keystarter + '_property_sign_image_15}',  this.property_sign_image_15 )
.replaceAll( '${' + keystarter + '_property_sign_image_16}',  this.property_sign_image_16 )
.replaceAll( '${' + keystarter + '_property_sign_image_17}',  this.property_sign_image_17 )
.replaceAll( '${' + keystarter + '_property_sign_image_18}',  this.property_sign_image_18 )
.replaceAll( '${' + keystarter + '_property_sign_image_19}',  this.property_sign_image_19 )
.replaceAll( '${' + keystarter + '_property_sign_image_20}',  this.property_sign_image_20 )
.replaceAll( '${' + keystarter + '_property_sign_image_21}',  this.property_sign_image_21 )
.replaceAll( '${' + keystarter + '_property_sign_image_22}',  this.property_sign_image_22 )
.replaceAll( '${' + keystarter + '_property_sign_image_23}',  this.property_sign_image_23 )
.replaceAll( '${' + keystarter + '_property_sign_image_24}',  this.property_sign_image_24 )
.replaceAll( '${' + keystarter + '_property_sign_image_25}',  this.property_sign_image_25 )


.replaceAll( '${' + keystarter + '_property_mail_image_0}',  this.property_mail_image_0 )
.replaceAll( '${' + keystarter + '_property_mail_image_1}',  this.property_mail_image_1 )
.replaceAll( '${' + keystarter + '_property_mail_image_2}',  this.property_mail_image_2 )
.replaceAll( '${' + keystarter + '_property_mail_image_3}',  this.property_mail_image_3 )
.replaceAll( '${' + keystarter + '_property_mail_image_4}',  this.property_mail_image_4 )
.replaceAll( '${' + keystarter + '_property_mail_image_5}',  this.property_mail_image_5 )
.replaceAll( '${' + keystarter + '_property_mail_image_6}',  this.property_mail_image_6 )
.replaceAll( '${' + keystarter + '_property_mail_image_7}',  this.property_mail_image_7 )
.replaceAll( '${' + keystarter + '_property_mail_image_8}',  this.property_mail_image_8 )
.replaceAll( '${' + keystarter + '_property_mail_image_9}',  this.property_mail_image_9 )
.replaceAll( '${' + keystarter + '_property_mail_image_10}',  this.property_mail_image_10 )
.replaceAll( '${' + keystarter + '_property_mail_image_11}',  this.property_mail_image_11 )
.replaceAll( '${' + keystarter + '_property_mail_image_12}',  this.property_mail_image_12 )
.replaceAll( '${' + keystarter + '_property_mail_image_13}',  this.property_mail_image_13 )
.replaceAll( '${' + keystarter + '_property_mail_image_14}',  this.property_mail_image_14 )
.replaceAll( '${' + keystarter + '_property_mail_image_15}',  this.property_mail_image_15 )
.replaceAll( '${' + keystarter + '_property_mail_image_16}',  this.property_mail_image_16 )
.replaceAll( '${' + keystarter + '_property_mail_image_17}',  this.property_mail_image_17 )
.replaceAll( '${' + keystarter + '_property_mail_image_18}',  this.property_mail_image_18 )
.replaceAll( '${' + keystarter + '_property_mail_image_19}',  this.property_mail_image_19 )
.replaceAll( '${' + keystarter + '_property_mail_image_20}',  this.property_mail_image_20 )
.replaceAll( '${' + keystarter + '_property_mail_image_21}',  this.property_mail_image_21 )
.replaceAll( '${' + keystarter + '_property_mail_image_22}',  this.property_mail_image_22 )
.replaceAll( '${' + keystarter + '_property_mail_image_23}',  this.property_mail_image_23 )
.replaceAll( '${' + keystarter + '_property_mail_image_24}',  this.property_mail_image_24 )
.replaceAll( '${' + keystarter + '_property_mail_image_25}',  this.property_mail_image_25 )


.replaceAll( '${' + keystarter + '_property_vehicles_image_0}',  this.property_vehicles_image_0 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_1}',  this.property_vehicles_image_1 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_2}',  this.property_vehicles_image_2 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_3}',  this.property_vehicles_image_3 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_4}',  this.property_vehicles_image_4 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_5}',  this.property_vehicles_image_5 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_6}',  this.property_vehicles_image_6 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_7}',  this.property_vehicles_image_7 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_8}',  this.property_vehicles_image_8 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_9}',  this.property_vehicles_image_9 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_10}',  this.property_vehicles_image_10 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_11}',  this.property_vehicles_image_11 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_12}',  this.property_vehicles_image_12 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_13}',  this.property_vehicles_image_13 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_14}',  this.property_vehicles_image_14 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_15}',  this.property_vehicles_image_15 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_16}',  this.property_vehicles_image_16 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_17}',  this.property_vehicles_image_17 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_18}',  this.property_vehicles_image_18 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_19}',  this.property_vehicles_image_19 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_20}',  this.property_vehicles_image_20 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_21}',  this.property_vehicles_image_21 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_22}',  this.property_vehicles_image_22 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_23}',  this.property_vehicles_image_23 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_24}',  this.property_vehicles_image_24 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_25}',  this.property_vehicles_image_25 )


.replaceAll( '${' + keystarter + '_property_pets_image_0}',  this.property_pets_image_0 )
.replaceAll( '${' + keystarter + '_property_pets_image_1}',  this.property_pets_image_1 )
.replaceAll( '${' + keystarter + '_property_pets_image_2}',  this.property_pets_image_2 )
.replaceAll( '${' + keystarter + '_property_pets_image_3}',  this.property_pets_image_3 )
.replaceAll( '${' + keystarter + '_property_pets_image_4}',  this.property_pets_image_4 )
.replaceAll( '${' + keystarter + '_property_pets_image_5}',  this.property_pets_image_5 )
.replaceAll( '${' + keystarter + '_property_pets_image_6}',  this.property_pets_image_6 )
.replaceAll( '${' + keystarter + '_property_pets_image_7}',  this.property_pets_image_7 )
.replaceAll( '${' + keystarter + '_property_pets_image_8}',  this.property_pets_image_8 )
.replaceAll( '${' + keystarter + '_property_pets_image_9}',  this.property_pets_image_9 )
.replaceAll( '${' + keystarter + '_property_pets_image_10}',  this.property_pets_image_10 )
.replaceAll( '${' + keystarter + '_property_pets_image_11}',  this.property_pets_image_11 )
.replaceAll( '${' + keystarter + '_property_pets_image_12}',  this.property_pets_image_12 )
.replaceAll( '${' + keystarter + '_property_pets_image_13}',  this.property_pets_image_13 )
.replaceAll( '${' + keystarter + '_property_pets_image_14}',  this.property_pets_image_14 )
.replaceAll( '${' + keystarter + '_property_pets_image_15}',  this.property_pets_image_15 )
.replaceAll( '${' + keystarter + '_property_pets_image_16}',  this.property_pets_image_16 )
.replaceAll( '${' + keystarter + '_property_pets_image_17}',  this.property_pets_image_17 )
.replaceAll( '${' + keystarter + '_property_pets_image_18}',  this.property_pets_image_18 )
.replaceAll( '${' + keystarter + '_property_pets_image_19}',  this.property_pets_image_19 )
.replaceAll( '${' + keystarter + '_property_pets_image_20}',  this.property_pets_image_20 )
.replaceAll( '${' + keystarter + '_property_pets_image_21}',  this.property_pets_image_21 )
.replaceAll( '${' + keystarter + '_property_pets_image_22}',  this.property_pets_image_22 )
.replaceAll( '${' + keystarter + '_property_pets_image_23}',  this.property_pets_image_23 )
.replaceAll( '${' + keystarter + '_property_pets_image_24}',  this.property_pets_image_24 )
.replaceAll( '${' + keystarter + '_property_pets_image_25}',  this.property_pets_image_25 )

.replaceAll( '${' + keystarter + '_property_occupancy_image_0}',  this.property_occupancy_image_0 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_1}',  this.property_occupancy_image_1 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_2}',  this.property_occupancy_image_2 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_3}',  this.property_occupancy_image_3 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_4}',  this.property_occupancy_image_4 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_5}',  this.property_occupancy_image_5 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_6}',  this.property_occupancy_image_6 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_7}',  this.property_occupancy_image_7 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_8}',  this.property_occupancy_image_8 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_9}',  this.property_occupancy_image_9 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_10}',  this.property_occupancy_image_10 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_11}',  this.property_occupancy_image_11 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_12}',  this.property_occupancy_image_12 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_13}',  this.property_occupancy_image_13 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_14}',  this.property_occupancy_image_14 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_15}',  this.property_occupancy_image_15 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_16}',  this.property_occupancy_image_16 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_17}',  this.property_occupancy_image_17 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_18}',  this.property_occupancy_image_18 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_19}',  this.property_occupancy_image_19 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_20}',  this.property_occupancy_image_20 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_21}',  this.property_occupancy_image_21 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_22}',  this.property_occupancy_image_22 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_23}',  this.property_occupancy_image_23 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_24}',  this.property_occupancy_image_24 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_25}',  this.property_occupancy_image_25 )

.replaceAll( '${' + keystarter + '_property_condition_image_0}',  this.property_condition_image_0 )
.replaceAll( '${' + keystarter + '_property_condition_image_1}',  this.property_condition_image_1 )
.replaceAll( '${' + keystarter + '_property_condition_image_2}',  this.property_condition_image_2 )
.replaceAll( '${' + keystarter + '_property_condition_image_3}',  this.property_condition_image_3 )
.replaceAll( '${' + keystarter + '_property_condition_image_4}',  this.property_condition_image_4 )
.replaceAll( '${' + keystarter + '_property_condition_image_5}',  this.property_condition_image_5 )
.replaceAll( '${' + keystarter + '_property_condition_image_6}',  this.property_condition_image_6 )
.replaceAll( '${' + keystarter + '_property_condition_image_7}',  this.property_condition_image_7 )
.replaceAll( '${' + keystarter + '_property_condition_image_8}',  this.property_condition_image_8 )
.replaceAll( '${' + keystarter + '_property_condition_image_9}',  this.property_condition_image_9 )
.replaceAll( '${' + keystarter + '_property_condition_image_10}',  this.property_condition_image_10 )
.replaceAll( '${' + keystarter + '_property_condition_image_11}',  this.property_condition_image_11 )
.replaceAll( '${' + keystarter + '_property_condition_image_12}',  this.property_condition_image_12 )
.replaceAll( '${' + keystarter + '_property_condition_image_13}',  this.property_condition_image_13 )
.replaceAll( '${' + keystarter + '_property_condition_image_14}',  this.property_condition_image_14 )
.replaceAll( '${' + keystarter + '_property_condition_image_15}',  this.property_condition_image_15 )
.replaceAll( '${' + keystarter + '_property_condition_image_16}',  this.property_condition_image_16 )
.replaceAll( '${' + keystarter + '_property_condition_image_17}',  this.property_condition_image_17 )
.replaceAll( '${' + keystarter + '_property_condition_image_18}',  this.property_condition_image_18 )
.replaceAll( '${' + keystarter + '_property_condition_image_19}',  this.property_condition_image_19 )
.replaceAll( '${' + keystarter + '_property_condition_image_20}',  this.property_condition_image_20 )
.replaceAll( '${' + keystarter + '_property_condition_image_21}',  this.property_condition_image_21 )
.replaceAll( '${' + keystarter + '_property_condition_image_22}',  this.property_condition_image_22 )
.replaceAll( '${' + keystarter + '_property_condition_image_23}',  this.property_condition_image_23 )
.replaceAll( '${' + keystarter + '_property_condition_image_24}',  this.property_condition_image_24 )
.replaceAll( '${' + keystarter + '_property_condition_image_25}',  this.property_condition_image_25 )

.replaceAll( '${' + keystarter + '_property_type_image_0}',  this.property_type_image_0 )
.replaceAll( '${' + keystarter + '_property_type_image_1}',  this.property_type_image_1 )
.replaceAll( '${' + keystarter + '_property_type_image_2}',  this.property_type_image_2 )
.replaceAll( '${' + keystarter + '_property_type_image_3}',  this.property_type_image_3 )
.replaceAll( '${' + keystarter + '_property_type_image_4}',  this.property_type_image_4 )
.replaceAll( '${' + keystarter + '_property_type_image_5}',  this.property_type_image_5 )
.replaceAll( '${' + keystarter + '_property_type_image_6}',  this.property_type_image_6 )
.replaceAll( '${' + keystarter + '_property_type_image_7}',  this.property_type_image_7 )
.replaceAll( '${' + keystarter + '_property_type_image_8}',  this.property_type_image_8 )
.replaceAll( '${' + keystarter + '_property_type_image_9}',  this.property_type_image_9 )
.replaceAll( '${' + keystarter + '_property_type_image_10}',  this.property_type_image_10 )
.replaceAll( '${' + keystarter + '_property_type_image_11}',  this.property_type_image_11 )
.replaceAll( '${' + keystarter + '_property_type_image_12}',  this.property_type_image_12 )
.replaceAll( '${' + keystarter + '_property_type_image_13}',  this.property_type_image_13 )
.replaceAll( '${' + keystarter + '_property_type_image_14}',  this.property_type_image_14 )
.replaceAll( '${' + keystarter + '_property_type_image_15}',  this.property_type_image_15 )
.replaceAll( '${' + keystarter + '_property_type_image_16}',  this.property_type_image_16 )
.replaceAll( '${' + keystarter + '_property_type_image_17}',  this.property_type_image_17 )
.replaceAll( '${' + keystarter + '_property_type_image_18}',  this.property_type_image_18 )
.replaceAll( '${' + keystarter + '_property_type_image_19}',  this.property_type_image_19 )
.replaceAll( '${' + keystarter + '_property_type_image_20}',  this.property_type_image_20 )
.replaceAll( '${' + keystarter + '_property_type_image_21}',  this.property_type_image_21 )
.replaceAll( '${' + keystarter + '_property_type_image_22}',  this.property_type_image_22 )
.replaceAll( '${' + keystarter + '_property_type_image_23}',  this.property_type_image_23 )
.replaceAll( '${' + keystarter + '_property_type_image_24}',  this.property_type_image_24 )
.replaceAll( '${' + keystarter + '_property_type_image_25}',  this.property_type_image_25 )

.replaceAll( '${' + keystarter + '_service_file_array_image_0}',  this.service_file_array_image_0 )
.replaceAll( '${' + keystarter + '_service_file_array_image_1}',  this.service_file_array_image_1 )
.replaceAll( '${' + keystarter + '_service_file_array_image_2}',  this.service_file_array_image_2 )
.replaceAll( '${' + keystarter + '_service_file_array_image_3}',  this.service_file_array_image_3 )
.replaceAll( '${' + keystarter + '_service_file_array_image_4}',  this.service_file_array_image_4 )
.replaceAll( '${' + keystarter + '_service_file_array_image_5}',  this.service_file_array_image_5 )
.replaceAll( '${' + keystarter + '_service_file_array_image_6}',  this.service_file_array_image_6 )
.replaceAll( '${' + keystarter + '_service_file_array_image_7}',  this.service_file_array_image_7 )
.replaceAll( '${' + keystarter + '_service_file_array_image_8}',  this.service_file_array_image_8 )
.replaceAll( '${' + keystarter + '_service_file_array_image_9}',  this.service_file_array_image_9 )
.replaceAll( '${' + keystarter + '_service_file_array_image_10}',  this.service_file_array_image_10 )
.replaceAll( '${' + keystarter + '_service_file_array_image_11}',  this.service_file_array_image_11 )
.replaceAll( '${' + keystarter + '_service_file_array_image_12}',  this.service_file_array_image_12 )
.replaceAll( '${' + keystarter + '_service_file_array_image_13}',  this.service_file_array_image_13 )
.replaceAll( '${' + keystarter + '_service_file_array_image_14}',  this.service_file_array_image_14 )
.replaceAll( '${' + keystarter + '_service_file_array_image_15}',  this.service_file_array_image_15 )
.replaceAll( '${' + keystarter + '_service_file_array_image_16}',  this.service_file_array_image_16 )
.replaceAll( '${' + keystarter + '_service_file_array_image_17}',  this.service_file_array_image_17 )
.replaceAll( '${' + keystarter + '_service_file_array_image_18}',  this.service_file_array_image_18 )
.replaceAll( '${' + keystarter + '_service_file_array_image_19}',  this.service_file_array_image_19 )
.replaceAll( '${' + keystarter + '_service_file_array_image_20}',  this.service_file_array_image_20 )
.replaceAll( '${' + keystarter + '_service_file_array_image_21}',  this.service_file_array_image_21 )
.replaceAll( '${' + keystarter + '_service_file_array_image_22}',  this.service_file_array_image_22 )
.replaceAll( '${' + keystarter + '_service_file_array_image_23}',  this.service_file_array_image_23 )
.replaceAll( '${' + keystarter + '_service_file_array_image_24}',  this.service_file_array_image_24 )
.replaceAll( '${' + keystarter + '_service_file_array_image_25}',  this.service_file_array_image_25 )



// hide anything null or undefined.
.replaceAll('${undefined}', '')
.replaceAll('${null}', '')
.replaceAll('undefined', '') // makes all undefined print empty
.replaceAll('null', '') // makes all undefined print empty
.replaceAll('Invalid date', '') // makes all undefined print empty


// model.email_template_primary_HTML_rendered
// email_subject_primary_rendered


// Convert the results to a form field value.
// model.email_template_primary_HTML_rendered = rendered_result;
return rendered_result;

}


runReplaceAllVariables_ServicesOnly_keystarter(str, model, keystarter, subject_attempt_type_id){


  // // Filters objects for nul and undefined values.
  // const obj = this.attempts_paragraphs_model;
  // const filteredObject = _.pickBy(obj, v =>  v.subject_attempt_type_id === subject_attempt_type_id);
  // // console.log = (obj) => document.write(JSON.stringify(filteredObject, null, 2));
  // console.log('FilteredObject', JSON.stringify(filteredObject));



// Filter the array for attempt_type_id = 1 or 2 service or attemdamce -- Do a filter on the final RESULTS IF F SERVICE!!!!! 
// Do a simple loadash filter on attempts_paragraphs model.'

// change the data for a service
if (subject_attempt_type_id = 1)
{


}


// Already loaded in the job/subject lookup
// if(this.attempts_paragraphs_model.job_subject_type_id){
//   this.getJobSubjectType_Q(this.attempts_paragraphs_model.job_subject_type_id) ;
// }
// let var_subject_type_name;
// if(this.subject_job_subject_type != null){
// var_subject_type_name = this.subject_job_subject_type.job_subject_type_name
// } else{
// var_subject_type_name = '';
// }


// NEED TO DETERMINE THE attempt_type === data

// FIX THIS AND WE CAN USE FOR ALL. -- By getting   if(this.attempts_paragraphs_model){ to refresh or reset the data lookip as it needs to ne differemt for a service or attedance

// ATTEMPS
// Current Attempt Variables Setups
// Uppercase.
if(this.service_paragraphs_model){

let var_subject_attempt_type_name = this.service_paragraphs_model.subject_attempt_type_name
if(var_subject_attempt_type_name != null){ // uppercase must be validated if not null
 this.var_subject_attempt_type_name_Upper = var_subject_attempt_type_name.toUpperCase();
}
} // end if service paragraphs model. 


if(this.service_paragraphs_model.person_spoken_with_advised_HTML == null){this.person_spoken_with_advised_HTML = this.service_paragraphs_model.person_spoken_with_advised; }else{this.person_spoken_with_advised_HTML = this.transform2(this.service_paragraphs_model.person_spoken_with_advised_HTML);}
if(this.service_paragraphs_model.vehicles_notes_HTML == null){this.vehicles_notes_HTML = this.service_paragraphs_model.vehicles_notes; }else{this.vehicles_notes_HTML = this.transform2(this.service_paragraphs_model.vehicles_notes_HTML);}
if(this.service_paragraphs_model.neighbours_notes_HTML == null){this.neighbours_notes_HTML = this.service_paragraphs_model.neighbours_notes; }else{this.neighbours_notes_HTML = this.transform2(this.service_paragraphs_model.neighbours_notes_HTML);}
if(this.service_paragraphs_model.calling_card_notes_HTML == null){this.calling_card_notes_HTML = this.service_paragraphs_model.calling_card_notes; }else{this.calling_card_notes_HTML = this.transform2(this.service_paragraphs_model.calling_card_notes_HTML);}
if(this.service_paragraphs_model.postal_mail_notes_HTML == null){this.postal_mail_notes_HTML = this.service_paragraphs_model.postal_mail_notes; }else{this.postal_mail_notes_HTML = this.transform2(this.service_paragraphs_model.postal_mail_notes_HTML);}
if(this.service_paragraphs_model.phone_call_notes_HTML == null){this.phone_call_notes_HTML = this.service_paragraphs_model.phone_call_notes; }else{this.phone_call_notes_HTML = this.transform2(this.service_paragraphs_model.phone_call_notes_HTML);}
if(this.service_paragraphs_model.attempts_notes_HTML == null){this.attempts_notes_HTML = this.service_paragraphs_model.attempts_notes; }else{this.attempts_notes_HTML = this.transform2(this.service_paragraphs_model.attempts_notes_HTML);}
if(this.service_paragraphs_model.email_contents_HTML == null){this.email_contents_HTML = this.service_paragraphs_model.email_contents; }else{this.email_contents_HTML = this.transform2(this.service_paragraphs_model.email_contents_HTML);}
if(this.service_paragraphs_model.general_notes_HTML == null){
this.set_general_notes = this.service_paragraphs_model.general_notes;
}else{
this.set_general_notes = this.transform2(this.service_paragraphs_model.general_notes_HTML)
}
if(this.service_paragraphs_model.property_forsale_or_lease_sign_details_HTML == null){this.property_forsale_or_lease_sign_details_HTML = this.service_paragraphs_model.property_forsale_or_lease_sign_details; }else{this.property_forsale_or_lease_sign_details_HTML = this.transform2(this.service_paragraphs_model.property_forsale_or_lease_sign_details_HTML);}  
if(this.service_paragraphs_model.property_mail_details_HTML == null){this.property_mail_details_HTML = this.service_paragraphs_model.property_mail_details; }else{this.property_mail_details_HTML = this.transform2(this.service_paragraphs_model.property_mail_details_HTML);}
if(this.service_paragraphs_model.property_vehicles_sighted_details_HTML == null){this.property_vehicles_sighted_details_HTML = this.service_paragraphs_model.property_vehicles_sighted_details; }else{this.property_vehicles_sighted_details_HTML = this.transform2(this.service_paragraphs_model.property_vehicles_sighted_details_HTML);}  
if(this.service_paragraphs_model.property_pets_details_HTML == null){this.property_pets_details_HTML = this.service_paragraphs_model.property_pets_details; }else{this.property_pets_details_HTML = this.transform2(this.service_paragraphs_model.property_pets_details_HTML);}

if(this.service_paragraphs_model.property_occupancy_details_HTML == null){this.property_occupancy_details_HTML = this.service_paragraphs_model.property_occupancy_details; }else{this.property_occupancy_details_HTML = this.transform2(this.service_paragraphs_model.property_occupancy_details_HTML);}

if(this.service_paragraphs_model.property_condition_HTML == null){this.property_condition_HTML = this.service_paragraphs_model.property_condition; }else{this.property_condition_HTML = this.transform2(this.service_paragraphs_model.property_condition_HTML);}
if(this.service_paragraphs_model.property_occupied_details_HTML == null){this.property_occupied_details_HTML = this.service_paragraphs_model.property_occupied_details; }else{this.property_occupied_details_HTML = this.transform2(this.service_paragraphs_model.property_occupied_details_HTML);}
if(this.service_paragraphs_model.property_type_details_HTML == null){this.set_property_type_details_HTML = this.service_paragraphs_model.property_type_details; }else{this.set_property_type_details_HTML = this.transform2(this.service_paragraphs_model.property_type_details_HTML);}



// Do checks for subject name / Businesss Name of FUll SUbject Name fields
let var_subject_name =  this.service_paragraphs_model.first_name + ' ' +  this.service_paragraphs_model.middlename + ' '+  this.service_paragraphs_model.surname;
let var_subject_name_4_doc = this.service_paragraphs_model.first_name +'-'+  this.service_paragraphs_model.surname;
let var_subject_business_name =  this.service_paragraphs_model.business_name;

// Subject Name of Business
 if(var_subject_business_name != null){
     let var_trim_subject_business_name = var_subject_business_name.replaceAll(' ', ''); // need javscipt version of trim (all spaces removed)
     // $subject_name = $trim_subject_business_name;
      var_subject_name = var_subject_business_name; // changed here feb 2023 as subject busines name was printing stripped as variable in affidavid // Not trimmed
       var_subject_name_4_doc= var_trim_subject_business_name;
     
 }



if(this.service_paragraphs_model.service_paragraph_rendered == null){
this.set_service_paragraph_rendered = '';
}else{
// this.set_service_paragraph_rendered = this.service_paragraphs_model.service_paragraph_rendered; // does not require encodeing
this.set_service_paragraph_rendered = this.transform2(this.service_paragraphs_model.service_paragraph_rendered); // does not require encodeing

}

// Property Images
if(this.service_paragraphs_model.property_images != '[]' || this.service_paragraphs_model.property_images != null){
this.property_images = JSON.parse(this.service_paragraphs_model.property_images)



let newArr = this.property_images;
let  count_of_items = Object.keys(newArr).length;

// let  count_of_items = 25;
//   let  count_of_items = Object.keys(newArr).length;
// //     for(let i=0;i < count_of_items; i++) { 
// //     let res = newArr[i];
// // }

if(count_of_items >= 1){this.propery_image_0  = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[0].file_server_location +  '/' + this.property_images[0].file_name + '"></img>'}else{this.propery_image_0=''}
if(count_of_items >= 2){this.propery_image_1   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[1].file_server_location +  '/' + this.property_images[1].file_name + '"></img>'}else{this.propery_image_1=''}
if(count_of_items >= 3){this.propery_image_2   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[2].file_server_location +  '/' + this.property_images[2].file_name + '"></img>'}else{this.propery_image_2=''}
if(count_of_items >= 4){this.propery_image_3   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[3].file_server_location +  '/' + this.property_images[3].file_name + '"></img>'}else{this.propery_image_3=''}
if(count_of_items >= 5){this.propery_image_4   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[4].file_server_location +  '/' + this.property_images[4].file_name + '"></img>'}else{this.propery_image_4=''}
if(count_of_items >= 6){this.propery_image_5   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[5].file_server_location +  '/' + this.property_images[5].file_name + '"></img>'}else{this.propery_image_5=''}
if(count_of_items >= 7){this.propery_image_6   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[6].file_server_location +  '/' + this.property_images[6].file_name + '"></img>'}else{this.propery_image_6=''}
if(count_of_items >= 8){this.propery_image_7   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[7].file_server_location +  '/' + this.property_images[7].file_name + '"></img>'}else{this.propery_image_7=''}
if(count_of_items >= 9){this.propery_image_8   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[8].file_server_location +  '/' + this.property_images[8].file_name + '"></img>'}else{this.propery_image_8=''}
if(count_of_items >= 10){this.propery_image_9   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[9].file_server_location +  '/' + this.property_images[9].file_name + '"></img>'}else{this.propery_image_9=''}
if(count_of_items >= 11){this.propery_image_10   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[10].file_server_location +  '/' + this.property_images[10].file_name + '"></img>'}else{this.propery_image_10=''}
if(count_of_items >= 11){this.propery_image_11   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[11].file_server_location +  '/' + this.property_images[11].file_name + '"></img>'}else{this.propery_image_11=''}
if(count_of_items >= 11){this.propery_image_12   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[12].file_server_location +  '/' + this.property_images[12].file_name + '"></img>'}else{this.propery_image_12=''}
if(count_of_items >= 11){this.propery_image_13   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[13].file_server_location +  '/' + this.property_images[13].file_name + '"></img>'}else{this.propery_image_13=''}
if(count_of_items >= 11){this.propery_image_14   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[14].file_server_location +  '/' + this.property_images[14].file_name + '"></img>'}else{this.propery_image_14=''}
if(count_of_items >= 11){this.propery_image_15   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[15].file_server_location +  '/' + this.property_images[15].file_name + '"></img>'}else{this.propery_image_15=''}
if(count_of_items >= 11){this.propery_image_16   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[16].file_server_location +  '/' + this.property_images[16].file_name + '"></img>'}else{this.propery_image_16=''}
if(count_of_items >= 11){this.propery_image_17   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[17].file_server_location +  '/' + this.property_images[17].file_name + '"></img>'}else{this.propery_image_17=''}
if(count_of_items >= 11){this.propery_image_18   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[18].file_server_location +  '/' + this.property_images[18].file_name + '"></img>'}else{this.propery_image_18=''}
if(count_of_items >= 11){this.propery_image_19   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[19].file_server_location +  '/' + this.property_images[19].file_name + '"></img>'}else{this.propery_image_19=''}
if(count_of_items >= 11){this.propery_image_20   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[20].file_server_location +  '/' + this.property_images[20].file_name + '"></img>'}else{this.propery_image_20=''}
if(count_of_items >= 11){this.propery_image_21   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[21].file_server_location +  '/' + this.property_images[21].file_name + '"></img>'}else{this.propery_image_21=''}
if(count_of_items >= 11){this.propery_image_22   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[22].file_server_location +  '/' + this.property_images[22].file_name + '"></img>'}else{this.propery_image_22=''}
if(count_of_items >= 11){this.propery_image_23   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[23].file_server_location +  '/' + this.property_images[23].file_name + '"></img>'}else{this.propery_image_23=''}
if(count_of_items >= 11){this.propery_image_24   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[24].file_server_location +  '/' + this.property_images[24].file_name + '"></img>'}else{this.propery_image_24=''}
if(count_of_items >= 11){this.propery_image_25   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[25].file_server_location +  '/' + this.property_images[25].file_name + '"></img>'}else{this.propery_image_25=''}





// Loop function to set the images set the ones that exist and then set nulls to the ones that dont. -- similar to the php function in the doucment imaee replacement function 
// loop 0 - 25 and only set if exisis or '' if not.


}

if(this.service_paragraphs_model.property_sign_images != '[]' && this.service_paragraphs_model.property_sign_images != null){
this.property_sign_images = JSON.parse(this.service_paragraphs_model.property_sign_images)
let newArr = this.property_sign_images;
let  count_of_items = Object.keys(newArr).length;

if(count_of_items >= 1){this.property_sign_image_0  = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[0].file_server_location +  '/' + this.property_sign_images[0].file_name + '"></img>'}else{this.property_sign_image_0=''}
if(count_of_items >= 2){this.property_sign_image_1   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[1].file_server_location +  '/' + this.property_sign_images[1].file_name + '"></img>'}else{this.property_sign_image_1=''}
if(count_of_items >= 3){this.property_sign_image_2   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[2].file_server_location +  '/' + this.property_sign_images[2].file_name + '"></img>'}else{this.property_sign_image_2=''}
if(count_of_items >= 4){this.property_sign_image_3   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[3].file_server_location +  '/' + this.property_sign_images[3].file_name + '"></img>'}else{this.property_sign_image_3=''}
if(count_of_items >= 5){this.property_sign_image_4   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[4].file_server_location +  '/' + this.property_sign_images[4].file_name + '"></img>'}else{this.property_sign_image_4=''}
if(count_of_items >= 6){this.property_sign_image_5   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[5].file_server_location +  '/' + this.property_sign_images[5].file_name + '"></img>'}else{this.property_sign_image_5=''}
if(count_of_items >= 7){this.property_sign_image_6   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[6].file_server_location +  '/' + this.property_sign_images[6].file_name + '"></img>'}else{this.property_sign_image_6=''}
if(count_of_items >= 8){this.property_sign_image_7   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[7].file_server_location +  '/' + this.property_sign_images[7].file_name + '"></img>'}else{this.property_sign_image_7=''}
if(count_of_items >= 9){this.property_sign_image_8   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[8].file_server_location +  '/' + this.property_sign_images[8].file_name + '"></img>'}else{this.property_sign_image_8=''}
if(count_of_items >= 10){this.property_sign_image_9   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[9].file_server_location +  '/' + this.property_sign_images[9].file_name + '"></img>'}else{this.property_sign_image_9=''}
if(count_of_items >= 11){this.property_sign_image_10   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[10].file_server_location +  '/' + this.property_sign_images[10].file_name + '"></img>'}else{this.property_sign_image_10=''}
if(count_of_items >= 11){this.property_sign_image_11   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[11].file_server_location +  '/' + this.property_sign_images[11].file_name + '"></img>'}else{this.property_sign_image_11=''}
if(count_of_items >= 11){this.property_sign_image_12   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[12].file_server_location +  '/' + this.property_sign_images[12].file_name + '"></img>'}else{this.property_sign_image_12=''}
if(count_of_items >= 11){this.property_sign_image_13   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[13].file_server_location +  '/' + this.property_sign_images[13].file_name + '"></img>'}else{this.property_sign_image_13=''}
if(count_of_items >= 11){this.property_sign_image_14   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[14].file_server_location +  '/' + this.property_sign_images[14].file_name + '"></img>'}else{this.property_sign_image_14=''}
if(count_of_items >= 11){this.property_sign_image_15   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[15].file_server_location +  '/' + this.property_sign_images[15].file_name + '"></img>'}else{this.property_sign_image_15=''}
if(count_of_items >= 11){this.property_sign_image_16   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[16].file_server_location +  '/' + this.property_sign_images[16].file_name + '"></img>'}else{this.property_sign_image_16=''}
if(count_of_items >= 11){this.property_sign_image_17   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[17].file_server_location +  '/' + this.property_sign_images[17].file_name + '"></img>'}else{this.property_sign_image_17=''}
if(count_of_items >= 11){this.property_sign_image_18   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[18].file_server_location +  '/' + this.property_sign_images[18].file_name + '"></img>'}else{this.property_sign_image_18=''}
if(count_of_items >= 11){this.property_sign_image_19   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[19].file_server_location +  '/' + this.property_sign_images[19].file_name + '"></img>'}else{this.property_sign_image_19=''}
if(count_of_items >= 11){this.property_sign_image_20   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[20].file_server_location +  '/' + this.property_sign_images[20].file_name + '"></img>'}else{this.property_sign_image_20=''}
if(count_of_items >= 11){this.property_sign_image_21   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[21].file_server_location +  '/' + this.property_sign_images[21].file_name + '"></img>'}else{this.property_sign_image_21=''}
if(count_of_items >= 11){this.property_sign_image_22   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[22].file_server_location +  '/' + this.property_sign_images[22].file_name + '"></img>'}else{this.property_sign_image_22=''}
if(count_of_items >= 11){this.property_sign_image_23   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[23].file_server_location +  '/' + this.property_sign_images[23].file_name + '"></img>'}else{this.property_sign_image_23=''}
if(count_of_items >= 11){this.property_sign_image_24   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[24].file_server_location +  '/' + this.property_sign_images[24].file_name + '"></img>'}else{this.property_sign_image_24=''}
if(count_of_items >= 11){this.property_sign_image_25   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[25].file_server_location +  '/' + this.property_sign_images[25].file_name + '"></img>'}else{this.property_sign_image_25=''}
}

if(this.service_paragraphs_model.property_mail_images != '[]' && this.service_paragraphs_model.property_mail_images != null ){
this.property_mail_images = JSON.parse(this.service_paragraphs_model.property_mail_images)
let newArr = this.property_mail_images;
let  count_of_items = Object.keys(newArr).length;

if(count_of_items >= 1){this.property_mail_image_0  = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[0].file_server_location +  '/' + this.property_mail_images[0].file_name + '"></img>'}else{this.property_mail_image_0=''}
if(count_of_items >= 2){this.property_mail_image_1   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[1].file_server_location +  '/' + this.property_mail_images[1].file_name + '"></img>'}else{this.property_mail_image_1=''}
if(count_of_items >= 3){this.property_mail_image_2   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[2].file_server_location +  '/' + this.property_mail_images[2].file_name + '"></img>'}else{this.property_mail_image_2=''}
if(count_of_items >= 4){this.property_mail_image_3   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[3].file_server_location +  '/' + this.property_mail_images[3].file_name + '"></img>'}else{this.property_mail_image_3=''}
if(count_of_items >= 5){this.property_mail_image_4   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[4].file_server_location +  '/' + this.property_mail_images[4].file_name + '"></img>'}else{this.property_mail_image_4=''}
if(count_of_items >= 6){this.property_mail_image_5   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[5].file_server_location +  '/' + this.property_mail_images[5].file_name + '"></img>'}else{this.property_mail_image_5=''}
if(count_of_items >= 7){this.property_mail_image_6   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[6].file_server_location +  '/' + this.property_mail_images[6].file_name + '"></img>'}else{this.property_mail_image_6=''}
if(count_of_items >= 8){this.property_mail_image_7   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[7].file_server_location +  '/' + this.property_mail_images[7].file_name + '"></img>'}else{this.property_mail_image_7=''}
if(count_of_items >= 9){this.property_mail_image_8   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[8].file_server_location +  '/' + this.property_mail_images[8].file_name + '"></img>'}else{this.property_mail_image_8=''}
if(count_of_items >= 10){this.property_mail_image_9   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[9].file_server_location +  '/' + this.property_mail_images[9].file_name + '"></img>'}else{this.property_mail_image_9=''}
if(count_of_items >= 11){this.property_mail_image_10   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[10].file_server_location +  '/' + this.property_mail_images[10].file_name + '"></img>'}else{this.property_mail_image_10=''}
if(count_of_items >= 11){this.property_mail_image_11   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[11].file_server_location +  '/' + this.property_mail_images[11].file_name + '"></img>'}else{this.property_mail_image_11=''}
if(count_of_items >= 11){this.property_mail_image_12   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[12].file_server_location +  '/' + this.property_mail_images[12].file_name + '"></img>'}else{this.property_mail_image_12=''}
if(count_of_items >= 11){this.property_mail_image_13   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[13].file_server_location +  '/' + this.property_mail_images[13].file_name + '"></img>'}else{this.property_mail_image_13=''}
if(count_of_items >= 11){this.property_mail_image_14   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[14].file_server_location +  '/' + this.property_mail_images[14].file_name + '"></img>'}else{this.property_mail_image_14=''}
if(count_of_items >= 11){this.property_mail_image_15   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[15].file_server_location +  '/' + this.property_mail_images[15].file_name + '"></img>'}else{this.property_mail_image_15=''}
if(count_of_items >= 11){this.property_mail_image_16   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[16].file_server_location +  '/' + this.property_mail_images[16].file_name + '"></img>'}else{this.property_mail_image_16=''}
if(count_of_items >= 11){this.property_mail_image_17   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[17].file_server_location +  '/' + this.property_mail_images[17].file_name + '"></img>'}else{this.property_mail_image_17=''}
if(count_of_items >= 11){this.property_mail_image_18   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[18].file_server_location +  '/' + this.property_mail_images[18].file_name + '"></img>'}else{this.property_mail_image_18=''}
if(count_of_items >= 11){this.property_mail_image_19   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[19].file_server_location +  '/' + this.property_mail_images[19].file_name + '"></img>'}else{this.property_mail_image_19=''}
if(count_of_items >= 11){this.property_mail_image_20   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[20].file_server_location +  '/' + this.property_mail_images[20].file_name + '"></img>'}else{this.property_mail_image_20=''}
if(count_of_items >= 11){this.property_mail_image_21   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[21].file_server_location +  '/' + this.property_mail_images[21].file_name + '"></img>'}else{this.property_mail_image_21=''}
if(count_of_items >= 11){this.property_mail_image_22   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[22].file_server_location +  '/' + this.property_mail_images[22].file_name + '"></img>'}else{this.property_mail_image_22=''}
if(count_of_items >= 11){this.property_mail_image_23   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[23].file_server_location +  '/' + this.property_mail_images[23].file_name + '"></img>'}else{this.property_mail_image_23=''}
if(count_of_items >= 11){this.property_mail_image_24   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[24].file_server_location +  '/' + this.property_mail_images[24].file_name + '"></img>'}else{this.property_mail_image_24=''}
if(count_of_items >= 11){this.property_mail_image_25   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[25].file_server_location +  '/' + this.property_mail_images[25].file_name + '"></img>'}else{this.property_mail_image_25=''}
}

if(this.service_paragraphs_model.property_vehicles_images != '[]' && this.service_paragraphs_model.property_vehicles_images != null){
this.property_vehicles_images = JSON.parse(this.service_paragraphs_model.property_vehicles_images)
let newArr = this.property_vehicles_images;
let  count_of_items = Object.keys(newArr).length;

if(count_of_items >= 1){this.property_vehicles_image_0  = '<img src="' + this.gfunc.fileURL + '/' + this.property_vehicles_images[0].file_server_location +  '/' + this.property_vehicles_images[0].file_name + '"></img>'}else{this.property_vehicles_image_0=''}
if(count_of_items >= 2){this.property_vehicles_image_1   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[1].file_server_location +  '/' + this.property_vehicles_images[1].file_name + '"></img>'}else{this.property_vehicles_image_1=''}
if(count_of_items >= 3){this.property_vehicles_image_2   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[2].file_server_location +  '/' + this.property_vehicles_images[2].file_name + '"></img>'}else{this.property_vehicles_image_2=''}
if(count_of_items >= 4){this.property_vehicles_image_3   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[3].file_server_location +  '/' + this.property_vehicles_images[3].file_name + '"></img>'}else{this.property_vehicles_image_3=''}
if(count_of_items >= 5){this.property_vehicles_image_4   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[4].file_server_location +  '/' + this.property_vehicles_images[4].file_name + '"></img>'}else{this.property_vehicles_image_4=''}
if(count_of_items >= 6){this.property_vehicles_image_5   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[5].file_server_location +  '/' + this.property_vehicles_images[5].file_name + '"></img>'}else{this.property_vehicles_image_5=''}
if(count_of_items >= 7){this.property_vehicles_image_6   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[6].file_server_location +  '/' + this.property_vehicles_images[6].file_name + '"></img>'}else{this.property_vehicles_image_6=''}
if(count_of_items >= 8){this.property_vehicles_image_7   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[7].file_server_location +  '/' + this.property_vehicles_images[7].file_name + '"></img>'}else{this.property_vehicles_image_7=''}
if(count_of_items >= 9){this.property_vehicles_image_8   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[8].file_server_location +  '/' + this.property_vehicles_images[8].file_name + '"></img>'}else{this.property_vehicles_image_8=''}
if(count_of_items >= 10){this.property_vehicles_image_9   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[9].file_server_location +  '/' + this.property_vehicles_images[9].file_name + '"></img>'}else{this.property_vehicles_image_9=''}
if(count_of_items >= 11){this.property_vehicles_image_10   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[10].file_server_location +  '/' + this.property_vehicles_images[10].file_name + '"></img>'}else{this.property_vehicles_image_10=''}
if(count_of_items >= 11){this.property_vehicles_image_11   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[11].file_server_location +  '/' + this.property_vehicles_images[11].file_name + '"></img>'}else{this.property_vehicles_image_11=''}
if(count_of_items >= 11){this.property_vehicles_image_12   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[12].file_server_location +  '/' + this.property_vehicles_images[12].file_name + '"></img>'}else{this.property_vehicles_image_12=''}
if(count_of_items >= 11){this.property_vehicles_image_13   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[13].file_server_location +  '/' + this.property_vehicles_images[13].file_name + '"></img>'}else{this.property_vehicles_image_13=''}
if(count_of_items >= 11){this.property_vehicles_image_14   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[14].file_server_location +  '/' + this.property_vehicles_images[14].file_name + '"></img>'}else{this.property_vehicles_image_14=''}
if(count_of_items >= 11){this.property_vehicles_image_15   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[15].file_server_location +  '/' + this.property_vehicles_images[15].file_name + '"></img>'}else{this.property_vehicles_image_15=''}
if(count_of_items >= 11){this.property_vehicles_image_16   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[16].file_server_location +  '/' + this.property_vehicles_images[16].file_name + '"></img>'}else{this.property_vehicles_image_16=''}
if(count_of_items >= 11){this.property_vehicles_image_17   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[17].file_server_location +  '/' + this.property_vehicles_images[17].file_name + '"></img>'}else{this.property_vehicles_image_17=''}
if(count_of_items >= 11){this.property_vehicles_image_18   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[18].file_server_location +  '/' + this.property_vehicles_images[18].file_name + '"></img>'}else{this.property_vehicles_image_18=''}
if(count_of_items >= 11){this.property_vehicles_image_19   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[19].file_server_location +  '/' + this.property_vehicles_images[19].file_name + '"></img>'}else{this.property_vehicles_image_19=''}
if(count_of_items >= 11){this.property_vehicles_image_20   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[20].file_server_location +  '/' + this.property_vehicles_images[20].file_name + '"></img>'}else{this.property_vehicles_image_20=''}
if(count_of_items >= 11){this.property_vehicles_image_21   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[21].file_server_location +  '/' + this.property_vehicles_images[21].file_name + '"></img>'}else{this.property_vehicles_image_21=''}
if(count_of_items >= 11){this.property_vehicles_image_22   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[22].file_server_location +  '/' + this.property_vehicles_images[22].file_name + '"></img>'}else{this.property_vehicles_image_22=''}
if(count_of_items >= 11){this.property_vehicles_image_23   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[23].file_server_location +  '/' + this.property_vehicles_images[23].file_name + '"></img>'}else{this.property_vehicles_image_23=''}
if(count_of_items >= 11){this.property_vehicles_image_24   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[24].file_server_location +  '/' + this.property_vehicles_images[24].file_name + '"></img>'}else{this.property_vehicles_image_24=''}
if(count_of_items >= 11){this.property_vehicles_image_25   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[25].file_server_location +  '/' + this.property_vehicles_images[25].file_name + '"></img>'}else{this.property_vehicles_image_25=''}
}


if(this.service_paragraphs_model.property_pets_images != '[]' && this.service_paragraphs_model.property_pets_images != null){
this.property_pets_images = JSON.parse(this.service_paragraphs_model.property_pets_images)
let newArr = this.property_pets_images;
let  count_of_items = Object.keys(newArr).length;

if(count_of_items >= 1){this.property_pets_image_0  = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[0].file_server_location +  '/' + this.property_pets_images[0].file_name + '"></img>'}else{this.property_pets_image_0=''}
if(count_of_items >= 2){this.property_pets_image_1   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[1].file_server_location +  '/' + this.property_pets_images[1].file_name + '"></img>'}else{this.property_pets_image_1=''}
if(count_of_items >= 3){this.property_pets_image_2   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[2].file_server_location +  '/' + this.property_pets_images[2].file_name + '"></img>'}else{this.property_pets_image_2=''}
if(count_of_items >= 4){this.property_pets_image_3   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[3].file_server_location +  '/' + this.property_pets_images[3].file_name + '"></img>'}else{this.property_pets_image_3=''}
if(count_of_items >= 5){this.property_pets_image_4   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[4].file_server_location +  '/' + this.property_pets_images[4].file_name + '"></img>'}else{this.property_pets_image_4=''}
if(count_of_items >= 6){this.property_pets_image_5   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[5].file_server_location +  '/' + this.property_pets_images[5].file_name + '"></img>'}else{this.property_pets_image_5=''}
if(count_of_items >= 7){this.property_pets_image_6   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[6].file_server_location +  '/' + this.property_pets_images[6].file_name + '"></img>'}else{this.property_pets_image_6=''}
if(count_of_items >= 8){this.property_pets_image_7   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[7].file_server_location +  '/' + this.property_pets_images[7].file_name + '"></img>'}else{this.property_pets_image_7=''}
if(count_of_items >= 9){this.property_pets_image_8   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[8].file_server_location +  '/' + this.property_pets_images[8].file_name + '"></img>'}else{this.property_pets_image_8=''}
if(count_of_items >= 10){this.property_pets_image_9   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[9].file_server_location +  '/' + this.property_pets_images[9].file_name + '"></img>'}else{this.property_pets_image_9=''}
if(count_of_items >= 11){this.property_pets_image_10   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[10].file_server_location +  '/' + this.property_pets_images[10].file_name + '"></img>'}else{this.property_pets_image_10=''}
if(count_of_items >= 11){this.property_pets_image_11   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[11].file_server_location +  '/' + this.property_pets_images[11].file_name + '"></img>'}else{this.property_pets_image_11=''}
if(count_of_items >= 11){this.property_pets_image_12   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[12].file_server_location +  '/' + this.property_pets_images[12].file_name + '"></img>'}else{this.property_pets_image_12=''}
if(count_of_items >= 11){this.property_pets_image_13   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[13].file_server_location +  '/' + this.property_pets_images[13].file_name + '"></img>'}else{this.property_pets_image_13=''}
if(count_of_items >= 11){this.property_pets_image_14   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[14].file_server_location +  '/' + this.property_pets_images[14].file_name + '"></img>'}else{this.property_pets_image_14=''}
if(count_of_items >= 11){this.property_pets_image_15   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[15].file_server_location +  '/' + this.property_pets_images[15].file_name + '"></img>'}else{this.property_pets_image_15=''}
if(count_of_items >= 11){this.property_pets_image_16   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[16].file_server_location +  '/' + this.property_pets_images[16].file_name + '"></img>'}else{this.property_pets_image_16=''}
if(count_of_items >= 11){this.property_pets_image_17   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[17].file_server_location +  '/' + this.property_pets_images[17].file_name + '"></img>'}else{this.property_pets_image_17=''}
if(count_of_items >= 11){this.property_pets_image_18   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[18].file_server_location +  '/' + this.property_pets_images[18].file_name + '"></img>'}else{this.property_pets_image_18=''}
if(count_of_items >= 11){this.property_pets_image_19   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[19].file_server_location +  '/' + this.property_pets_images[19].file_name + '"></img>'}else{this.property_pets_image_19=''}
if(count_of_items >= 11){this.property_pets_image_20   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[20].file_server_location +  '/' + this.property_pets_images[20].file_name + '"></img>'}else{this.property_pets_image_20=''}
if(count_of_items >= 11){this.property_pets_image_21   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[21].file_server_location +  '/' + this.property_pets_images[21].file_name + '"></img>'}else{this.property_pets_image_21=''}
if(count_of_items >= 11){this.property_pets_image_22   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[22].file_server_location +  '/' + this.property_pets_images[22].file_name + '"></img>'}else{this.property_pets_image_22=''}
if(count_of_items >= 11){this.property_pets_image_23   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[23].file_server_location +  '/' + this.property_pets_images[23].file_name + '"></img>'}else{this.property_pets_image_23=''}
if(count_of_items >= 11){this.property_pets_image_24   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[24].file_server_location +  '/' + this.property_pets_images[24].file_name + '"></img>'}else{this.property_pets_image_24=''}
if(count_of_items >= 11){this.property_pets_image_25   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[25].file_server_location +  '/' + this.property_pets_images[25].file_name + '"></img>'}else{this.property_pets_image_25=''}
}


if(this.service_paragraphs_model.property_occupancy_images != '[]' && this.service_paragraphs_model.property_occupancy_images != null){
this.property_occupancy_images = JSON.parse(this.service_paragraphs_model.property_occupancy_images)
let newArr = this.property_occupancy_images;
let  count_of_items = Object.keys(newArr).length;

if(count_of_items >= 1){this.property_occupancy_image_0  = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[0].file_server_location +  '/' + this.property_occupancy_images[0].file_name + '"></img>'}else{this.property_occupancy_image_0=''}
if(count_of_items >= 2){this.property_occupancy_image_1   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[1].file_server_location +  '/' + this.property_occupancy_images[1].file_name + '"></img>'}else{this.property_occupancy_image_1=''}
if(count_of_items >= 3){this.property_occupancy_image_2   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[2].file_server_location +  '/' + this.property_occupancy_images[2].file_name + '"></img>'}else{this.property_occupancy_image_2=''}
if(count_of_items >= 4){this.property_occupancy_image_3   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[3].file_server_location +  '/' + this.property_occupancy_images[3].file_name + '"></img>'}else{this.property_occupancy_image_3=''}
if(count_of_items >= 5){this.property_occupancy_image_4   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[4].file_server_location +  '/' + this.property_occupancy_images[4].file_name + '"></img>'}else{this.property_occupancy_image_4=''}
if(count_of_items >= 6){this.property_occupancy_image_5   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[5].file_server_location +  '/' + this.property_occupancy_images[5].file_name + '"></img>'}else{this.property_occupancy_image_5=''}
if(count_of_items >= 7){this.property_occupancy_image_6   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[6].file_server_location +  '/' + this.property_occupancy_images[6].file_name + '"></img>'}else{this.property_occupancy_image_6=''}
if(count_of_items >= 8){this.property_occupancy_image_7   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[7].file_server_location +  '/' + this.property_occupancy_images[7].file_name + '"></img>'}else{this.property_occupancy_image_7=''}
if(count_of_items >= 9){this.property_occupancy_image_8   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[8].file_server_location +  '/' + this.property_occupancy_images[8].file_name + '"></img>'}else{this.property_occupancy_image_8=''}
if(count_of_items >= 10){this.property_occupancy_image_9   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[9].file_server_location +  '/' + this.property_occupancy_images[9].file_name + '"></img>'}else{this.property_occupancy_image_9=''}
if(count_of_items >= 11){this.property_occupancy_image_10   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[10].file_server_location +  '/' + this.property_occupancy_images[10].file_name + '"></img>'}else{this.property_occupancy_image_10=''}
if(count_of_items >= 11){this.property_occupancy_image_11   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[11].file_server_location +  '/' + this.property_occupancy_images[11].file_name + '"></img>'}else{this.property_occupancy_image_11=''}
if(count_of_items >= 11){this.property_occupancy_image_12   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[12].file_server_location +  '/' + this.property_occupancy_images[12].file_name + '"></img>'}else{this.property_occupancy_image_12=''}
if(count_of_items >= 11){this.property_occupancy_image_13   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[13].file_server_location +  '/' + this.property_occupancy_images[13].file_name + '"></img>'}else{this.property_occupancy_image_13=''}
if(count_of_items >= 11){this.property_occupancy_image_14   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[14].file_server_location +  '/' + this.property_occupancy_images[14].file_name + '"></img>'}else{this.property_occupancy_image_14=''}
if(count_of_items >= 11){this.property_occupancy_image_15   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[15].file_server_location +  '/' + this.property_occupancy_images[15].file_name + '"></img>'}else{this.property_occupancy_image_15=''}
if(count_of_items >= 11){this.property_occupancy_image_16   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[16].file_server_location +  '/' + this.property_occupancy_images[16].file_name + '"></img>'}else{this.property_occupancy_image_16=''}
if(count_of_items >= 11){this.property_occupancy_image_17   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[17].file_server_location +  '/' + this.property_occupancy_images[17].file_name + '"></img>'}else{this.property_occupancy_image_17=''}
if(count_of_items >= 11){this.property_occupancy_image_18   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[18].file_server_location +  '/' + this.property_occupancy_images[18].file_name + '"></img>'}else{this.property_occupancy_image_18=''}
if(count_of_items >= 11){this.property_occupancy_image_19   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[19].file_server_location +  '/' + this.property_occupancy_images[19].file_name + '"></img>'}else{this.property_occupancy_image_19=''}
if(count_of_items >= 11){this.property_occupancy_image_20   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[20].file_server_location +  '/' + this.property_occupancy_images[20].file_name + '"></img>'}else{this.property_occupancy_image_20=''}
if(count_of_items >= 11){this.property_occupancy_image_21   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[21].file_server_location +  '/' + this.property_occupancy_images[21].file_name + '"></img>'}else{this.property_occupancy_image_21=''}
if(count_of_items >= 11){this.property_occupancy_image_22   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[22].file_server_location +  '/' + this.property_occupancy_images[22].file_name + '"></img>'}else{this.property_occupancy_image_22=''}
if(count_of_items >= 11){this.property_occupancy_image_23   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[23].file_server_location +  '/' + this.property_occupancy_images[23].file_name + '"></img>'}else{this.property_occupancy_image_23=''}
if(count_of_items >= 11){this.property_occupancy_image_24   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[24].file_server_location +  '/' + this.property_occupancy_images[24].file_name + '"></img>'}else{this.property_occupancy_image_24=''}
if(count_of_items >= 11){this.property_occupancy_image_25   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[25].file_server_location +  '/' + this.property_occupancy_images[25].file_name + '"></img>'}else{this.property_occupancy_image_25=''}
}

if(this.service_paragraphs_model.property_condition_images != '[]' && this.service_paragraphs_model.property_condition_images != null ){
this.property_condition_images = JSON.parse(this.service_paragraphs_model.property_condition_images)
let newArr = this.property_condition_images;
let  count_of_items = Object.keys(newArr).length;

if(count_of_items >= 1){this.property_condition_image_0  = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[0].file_server_location +  '/' + this.property_condition_images[0].file_name + '"></img>'}else{this.property_condition_image_0=''}
if(count_of_items >= 2){this.property_condition_image_1   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[1].file_server_location +  '/' + this.property_condition_images[1].file_name + '"></img>'}else{this.property_condition_image_1=''}
if(count_of_items >= 3){this.property_condition_image_2   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[2].file_server_location +  '/' + this.property_condition_images[2].file_name + '"></img>'}else{this.property_condition_image_2=''}
if(count_of_items >= 4){this.property_condition_image_3   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[3].file_server_location +  '/' + this.property_condition_images[3].file_name + '"></img>'}else{this.property_condition_image_3=''}
if(count_of_items >= 5){this.property_condition_image_4   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[4].file_server_location +  '/' + this.property_condition_images[4].file_name + '"></img>'}else{this.property_condition_image_4=''}
if(count_of_items >= 6){this.property_condition_image_5   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[5].file_server_location +  '/' + this.property_condition_images[5].file_name + '"></img>'}else{this.property_condition_image_5=''}
if(count_of_items >= 7){this.property_condition_image_6   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[6].file_server_location +  '/' + this.property_condition_images[6].file_name + '"></img>'}else{this.property_condition_image_6=''}
if(count_of_items >= 8){this.property_condition_image_7   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[7].file_server_location +  '/' + this.property_condition_images[7].file_name + '"></img>'}else{this.property_condition_image_7=''}
if(count_of_items >= 9){this.property_condition_image_8   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[8].file_server_location +  '/' + this.property_condition_images[8].file_name + '"></img>'}else{this.property_condition_image_8=''}
if(count_of_items >= 10){this.property_condition_image_9   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[9].file_server_location +  '/' + this.property_condition_images[9].file_name + '"></img>'}else{this.property_condition_image_9=''}
if(count_of_items >= 11){this.property_condition_image_10   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[10].file_server_location +  '/' + this.property_condition_images[10].file_name + '"></img>'}else{this.property_condition_image_10=''}
if(count_of_items >= 11){this.property_condition_image_11   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[11].file_server_location +  '/' + this.property_condition_images[11].file_name + '"></img>'}else{this.property_condition_image_11=''}
if(count_of_items >= 11){this.property_condition_image_12   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[12].file_server_location +  '/' + this.property_condition_images[12].file_name + '"></img>'}else{this.property_condition_image_12=''}
if(count_of_items >= 11){this.property_condition_image_13   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[13].file_server_location +  '/' + this.property_condition_images[13].file_name + '"></img>'}else{this.property_condition_image_13=''}
if(count_of_items >= 11){this.property_condition_image_14   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[14].file_server_location +  '/' + this.property_condition_images[14].file_name + '"></img>'}else{this.property_condition_image_14=''}
if(count_of_items >= 11){this.property_condition_image_15   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[15].file_server_location +  '/' + this.property_condition_images[15].file_name + '"></img>'}else{this.property_condition_image_15=''}
if(count_of_items >= 11){this.property_condition_image_16   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[16].file_server_location +  '/' + this.property_condition_images[16].file_name + '"></img>'}else{this.property_condition_image_16=''}
if(count_of_items >= 11){this.property_condition_image_17   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[17].file_server_location +  '/' + this.property_condition_images[17].file_name + '"></img>'}else{this.property_condition_image_17=''}
if(count_of_items >= 11){this.property_condition_image_18   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[18].file_server_location +  '/' + this.property_condition_images[18].file_name + '"></img>'}else{this.property_condition_image_18=''}
if(count_of_items >= 11){this.property_condition_image_19   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[19].file_server_location +  '/' + this.property_condition_images[19].file_name + '"></img>'}else{this.property_condition_image_19=''}
if(count_of_items >= 11){this.property_condition_image_20   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[20].file_server_location +  '/' + this.property_condition_images[20].file_name + '"></img>'}else{this.property_condition_image_20=''}
if(count_of_items >= 11){this.property_condition_image_21   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[21].file_server_location +  '/' + this.property_condition_images[21].file_name + '"></img>'}else{this.property_condition_image_21=''}
if(count_of_items >= 11){this.property_condition_image_22   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[22].file_server_location +  '/' + this.property_condition_images[22].file_name + '"></img>'}else{this.property_condition_image_22=''}
if(count_of_items >= 11){this.property_condition_image_23   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[23].file_server_location +  '/' + this.property_condition_images[23].file_name + '"></img>'}else{this.property_condition_image_23=''}
if(count_of_items >= 11){this.property_condition_image_24   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[24].file_server_location +  '/' + this.property_condition_images[24].file_name + '"></img>'}else{this.property_condition_image_24=''}
if(count_of_items >= 11){this.property_condition_image_25   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[25].file_server_location +  '/' + this.property_condition_images[25].file_name + '"></img>'}else{this.property_condition_image_25=''}
}


if(this.service_paragraphs_model.property_type_images != '[]' && this.service_paragraphs_model.property_type_images != null){
this.property_type_images = JSON.parse(this.service_paragraphs_model.property_type_images)
let newArr = this.property_type_images;
let  count_of_items = Object.keys(newArr).length;

if(count_of_items >= 1){this.property_type_image_0  = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[0].file_server_location +  '/' + this.property_type_images[0].file_name + '"></img>'}else{this.property_type_image_0=''}
if(count_of_items >= 2){this.property_type_image_1   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[1].file_server_location +  '/' + this.property_type_images[1].file_name + '"></img>'}else{this.property_type_image_1=''}
if(count_of_items >= 3){this.property_type_image_2   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[2].file_server_location +  '/' + this.property_type_images[2].file_name + '"></img>'}else{this.property_type_image_2=''}
if(count_of_items >= 4){this.property_type_image_3   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[3].file_server_location +  '/' + this.property_type_images[3].file_name + '"></img>'}else{this.property_type_image_3=''}
if(count_of_items >= 5){this.property_type_image_4   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[4].file_server_location +  '/' + this.property_type_images[4].file_name + '"></img>'}else{this.property_type_image_4=''}
if(count_of_items >= 6){this.property_type_image_5   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[5].file_server_location +  '/' + this.property_type_images[5].file_name + '"></img>'}else{this.property_type_image_5=''}
if(count_of_items >= 7){this.property_type_image_6   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[6].file_server_location +  '/' + this.property_type_images[6].file_name + '"></img>'}else{this.property_type_image_6=''}
if(count_of_items >= 8){this.property_type_image_7   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[7].file_server_location +  '/' + this.property_type_images[7].file_name + '"></img>'}else{this.property_type_image_7=''}
if(count_of_items >= 9){this.property_type_image_8   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[8].file_server_location +  '/' + this.property_type_images[8].file_name + '"></img>'}else{this.property_type_image_8=''}
if(count_of_items >= 10){this.property_type_image_9   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[9].file_server_location +  '/' + this.property_type_images[9].file_name + '"></img>'}else{this.property_type_image_9=''}
if(count_of_items >= 11){this.property_type_image_10   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[10].file_server_location +  '/' + this.property_type_images[10].file_name + '"></img>'}else{this.property_type_image_10=''}
if(count_of_items >= 11){this.property_type_image_11   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[11].file_server_location +  '/' + this.property_type_images[11].file_name + '"></img>'}else{this.property_type_image_11=''}
if(count_of_items >= 11){this.property_type_image_12   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[12].file_server_location +  '/' + this.property_type_images[12].file_name + '"></img>'}else{this.property_type_image_12=''}
if(count_of_items >= 11){this.property_type_image_13   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[13].file_server_location +  '/' + this.property_type_images[13].file_name + '"></img>'}else{this.property_type_image_13=''}
if(count_of_items >= 11){this.property_type_image_14   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[14].file_server_location +  '/' + this.property_type_images[14].file_name + '"></img>'}else{this.property_type_image_14=''}
if(count_of_items >= 11){this.property_type_image_15   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[15].file_server_location +  '/' + this.property_type_images[15].file_name + '"></img>'}else{this.property_type_image_15=''}
if(count_of_items >= 11){this.property_type_image_16   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[16].file_server_location +  '/' + this.property_type_images[16].file_name + '"></img>'}else{this.property_type_image_16=''}
if(count_of_items >= 11){this.property_type_image_17   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[17].file_server_location +  '/' + this.property_type_images[17].file_name + '"></img>'}else{this.property_type_image_17=''}
if(count_of_items >= 11){this.property_type_image_18   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[18].file_server_location +  '/' + this.property_type_images[18].file_name + '"></img>'}else{this.property_type_image_18=''}
if(count_of_items >= 11){this.property_type_image_19   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[19].file_server_location +  '/' + this.property_type_images[19].file_name + '"></img>'}else{this.property_type_image_19=''}
if(count_of_items >= 11){this.property_type_image_20   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[20].file_server_location +  '/' + this.property_type_images[20].file_name + '"></img>'}else{this.property_type_image_20=''}
if(count_of_items >= 11){this.property_type_image_21   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[21].file_server_location +  '/' + this.property_type_images[21].file_name + '"></img>'}else{this.property_type_image_21=''}
if(count_of_items >= 11){this.property_type_image_22   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[22].file_server_location +  '/' + this.property_type_images[22].file_name + '"></img>'}else{this.property_type_image_22=''}
if(count_of_items >= 11){this.property_type_image_23   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[23].file_server_location +  '/' + this.property_type_images[23].file_name + '"></img>'}else{this.property_type_image_23=''}
if(count_of_items >= 11){this.property_type_image_24   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[24].file_server_location +  '/' + this.property_type_images[24].file_name + '"></img>'}else{this.property_type_image_24=''}
if(count_of_items >= 11){this.property_type_image_25   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[25].file_server_location +  '/' + this.property_type_images[25].file_name + '"></img>'}else{this.property_type_image_25=''}
}




if(this.service_paragraphs_model.service_file_array != '[]' && this.service_paragraphs_model.service_file_array != null){
this.service_file_array_images = JSON.parse(this.service_paragraphs_model.service_file_array)
let newArr = this.service_file_array_images;
let  count_of_items = Object.keys(newArr).length;

if(count_of_items >= 1){this.service_file_array_image_0  = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[0].file_server_location +  '/' + this.service_file_array_images[0].file_name + '"></img>'}else{this.service_file_array_image_0=''}
if(count_of_items >= 2){this.service_file_array_image_1   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[1].file_server_location +  '/' + this.service_file_array_images[1].file_name + '"></img>'}else{this.service_file_array_image_1=''}
if(count_of_items >= 3){this.service_file_array_image_2   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[2].file_server_location +  '/' + this.service_file_array_images[2].file_name + '"></img>'}else{this.service_file_array_image_2=''}
if(count_of_items >= 4){this.service_file_array_image_3   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[3].file_server_location +  '/' + this.service_file_array_images[3].file_name + '"></img>'}else{this.service_file_array_image_3=''}
if(count_of_items >= 5){this.service_file_array_image_4   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[4].file_server_location +  '/' + this.service_file_array_images[4].file_name + '"></img>'}else{this.service_file_array_image_4=''}
if(count_of_items >= 6){this.service_file_array_image_5   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[5].file_server_location +  '/' + this.service_file_array_images[5].file_name + '"></img>'}else{this.service_file_array_image_5=''}
if(count_of_items >= 7){this.service_file_array_image_6   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[6].file_server_location +  '/' + this.service_file_array_images[6].file_name + '"></img>'}else{this.service_file_array_image_6=''}
if(count_of_items >= 8){this.service_file_array_image_7   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[7].file_server_location +  '/' + this.service_file_array_images[7].file_name + '"></img>'}else{this.service_file_array_image_7=''}
if(count_of_items >= 9){this.service_file_array_image_8   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[8].file_server_location +  '/' + this.service_file_array_images[8].file_name + '"></img>'}else{this.service_file_array_image_8=''}
if(count_of_items >= 10){this.service_file_array_image_9   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[9].file_server_location +  '/' + this.service_file_array_images[9].file_name + '"></img>'}else{this.service_file_array_image_9=''}
if(count_of_items >= 11){this.service_file_array_image_10   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[10].file_server_location +  '/' + this.service_file_array_images[10].file_name + '"></img>'}else{this.service_file_array_image_10=''}
if(count_of_items >= 11){this.service_file_array_image_11   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[11].file_server_location +  '/' + this.service_file_array_images[11].file_name + '"></img>'}else{this.service_file_array_image_11=''}
if(count_of_items >= 11){this.service_file_array_image_12   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[12].file_server_location +  '/' + this.service_file_array_images[12].file_name + '"></img>'}else{this.service_file_array_image_12=''}
if(count_of_items >= 11){this.service_file_array_image_13   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[13].file_server_location +  '/' + this.service_file_array_images[13].file_name + '"></img>'}else{this.service_file_array_image_13=''}
if(count_of_items >= 11){this.service_file_array_image_14   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[14].file_server_location +  '/' + this.service_file_array_images[14].file_name + '"></img>'}else{this.service_file_array_image_14=''}
if(count_of_items >= 11){this.service_file_array_image_15   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[15].file_server_location +  '/' + this.service_file_array_images[15].file_name + '"></img>'}else{this.service_file_array_image_15=''}
if(count_of_items >= 11){this.service_file_array_image_16   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[16].file_server_location +  '/' + this.service_file_array_images[16].file_name + '"></img>'}else{this.service_file_array_image_16=''}
if(count_of_items >= 11){this.service_file_array_image_17   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[17].file_server_location +  '/' + this.service_file_array_images[17].file_name + '"></img>'}else{this.service_file_array_image_17=''}
if(count_of_items >= 11){this.service_file_array_image_18   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[18].file_server_location +  '/' + this.service_file_array_images[18].file_name + '"></img>'}else{this.service_file_array_image_18=''}
if(count_of_items >= 11){this.service_file_array_image_19   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[19].file_server_location +  '/' + this.service_file_array_images[19].file_name + '"></img>'}else{this.service_file_array_image_19=''}
if(count_of_items >= 11){this.service_file_array_image_20   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[20].file_server_location +  '/' + this.service_file_array_images[20].file_name + '"></img>'}else{this.service_file_array_image_20=''}
if(count_of_items >= 11){this.service_file_array_image_21   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[21].file_server_location +  '/' + this.service_file_array_images[21].file_name + '"></img>'}else{this.service_file_array_image_21=''}
if(count_of_items >= 11){this.service_file_array_image_22   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[22].file_server_location +  '/' + this.service_file_array_images[22].file_name + '"></img>'}else{this.service_file_array_image_22=''}
if(count_of_items >= 11){this.service_file_array_image_23   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[23].file_server_location +  '/' + this.service_file_array_images[23].file_name + '"></img>'}else{this.service_file_array_image_23=''}
if(count_of_items >= 11){this.service_file_array_image_24   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[24].file_server_location +  '/' + this.service_file_array_images[24].file_name + '"></img>'}else{this.service_file_array_image_24=''}
if(count_of_items >= 11){this.service_file_array_image_25   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[25].file_server_location +  '/' + this.service_file_array_images[25].file_name + '"></img>'}else{this.service_file_array_image_25=''}
}

const rendered_result = str



  .replaceAll( '${' + keystarter + '_type_id}', this.service_paragraphs_model.subject_attempt_type_id)
  .replaceAll( '${' + keystarter + '_type_name}', this.service_paragraphs_model.subject_attempt_type_name ) // run a function with return;
  .replaceAll( '${' + keystarter + '_subject_attempt_type_name}', this.service_paragraphs_model.subject_attempt_type_name ) // run a function with return;
  .replaceAll( '${' + keystarter + '_type_name_upper}', this.var_subject_attempt_type_name_Upper) // all if statments set a this/g/ varaibales

  .replaceAll( '${' + keystarter + '_subject_service_method_id}', this.service_paragraphs_model.subject_service_method_id)
  .replaceAll( '${' + keystarter + '_subject_service_method_name}', this.service_paragraphs_model.subject_service_method_name ) // tested above.
  .replaceAll( '${' + keystarter + '_service_method}', this.service_paragraphs_model.subject_service_method_name ) // tested above.
  .replaceAll( '${' + keystarter + '_service_method_id}', this.service_paragraphs_model.subject_service_method_id) // tested above.


  .replaceAll( '${' + keystarter + '_date_service}', moment(this.service_paragraphs_model.date_service).format('M/D/YYYY'))
  .replaceAll( '${' + keystarter + '_date_service_full_words_time_first}', this.service_paragraphs_model.time_service_text + ' ' + moment(this.service_paragraphs_model.date_service).format('dddd MMMM Do, YYYY') ) 
  .replaceAll( '${' + keystarter + '_date_service_and_time_full_words}', moment(this.service_paragraphs_model.date_service).format('dddd MMMM Do, YYYY') + ' ' + this.service_paragraphs_model.time_service_text ) 
  .replaceAll( '${' + keystarter + '_date_service_full_words}', moment(this.service_paragraphs_model.date_service).format('dddd MMMM Do, YYYY') + ' ' + model.time_service_text ) 

  .replaceAll( '${' + keystarter + '_day}', moment(this.service_paragraphs_model.date_service).format('dddd'))
  .replaceAll( '${' + keystarter + '_day_number}', moment(this.service_paragraphs_model.date_service).format('Do'))
  .replaceAll( '${' + keystarter + '_day_number_simple}', moment(this.service_paragraphs_model.date_service).format('D'))
  .replaceAll( '${' + keystarter + '_month}', moment(this.service_paragraphs_model.date_service).format('MMMM'))
  .replaceAll( '${' + keystarter + '_month_number}', moment(this.service_paragraphs_model.date_service).format('Mo'))
  .replaceAll( '${' + keystarter + '_month_number_simple}', moment(this.service_paragraphs_model.date_service).format('M'))
  .replaceAll( '${' + keystarter + '_year}', moment(this.service_paragraphs_model.date_service).format('YYYY'))

  .replaceAll( '${' + keystarter + '_service_local}', this.service_paragraphs_model.service_local) // region Australia/Perth of service undertaken
  .replaceAll( '${' + keystarter + '_time}', this.service_paragraphs_model.time_service_text) //$_set_service_time - Fixed and set time of attempt and service

  .replaceAll( '${' + keystarter + '_paragraph_rendered}',  this.set_service_paragraph_rendered) //$_set_service_time - Fixed and set time of attempt and service

  .replaceAll( '${' + keystarter + '_subject_name}', var_subject_name)
  .replaceAll( '${' + keystarter + '_subject_number}', this.service_paragraphs_model.subject_number)
  .replaceAll( '${' + keystarter + '_subject_name_4_doc}', var_subject_name_4_doc)
  .replaceAll( '${' + keystarter + '_subject_business_name}', var_subject_business_name)
  .replaceAll( '${' + keystarter + '_business_name}', var_subject_business_name)

// Subject Attempt Address
.replaceAll( '${' + keystarter + '_address_1}', this.service_paragraphs_model.address_1)
.replaceAll( '${' + keystarter + '_address_2}', this.service_paragraphs_model.address_2)
.replaceAll( '${' + keystarter + '_suburb}', this.service_paragraphs_model.suburb)
.replaceAll( '${' + keystarter + '_state}', this.service_paragraphs_model.state)
.replaceAll( '${' + keystarter + '_postcode}', this.service_paragraphs_model.postcode)
.replaceAll( '${' + keystarter + '_address_full}', this.service_paragraphs_model.address_1 +  ' ' + this.service_paragraphs_model.address_2 +  ' ' + this.service_paragraphs_model.suburb +  ' ' + this.service_paragraphs_model.state +  ',  ' + this.service_paragraphs_model.postcode )
// Sav
.replaceAll( '${' + keystarter + '_sav_address_full}', this.service_paragraphs_model.address_1 +  ' ' + this.service_paragraphs_model.address_2 +  ' ' + this.service_paragraphs_model.suburb +  ' ' + this.service_paragraphs_model.state +  ',  ' + this.service_paragraphs_model.postcode )
// New address
.replaceAll( '${' + keystarter + '_new_business_name}', this.service_paragraphs_model.new_business_name)
.replaceAll( '${' + keystarter + '_new_address_1}', this.service_paragraphs_model.new_address_1)
.replaceAll( '${' + keystarter + '_new_address_2}', this.service_paragraphs_model.new_address_2)
.replaceAll( '${' + keystarter + '_new_suburb}', this.service_paragraphs_model.new_suburb)
.replaceAll( '${' + keystarter + '_new_state}', this.service_paragraphs_model.new_state)
.replaceAll( '${' + keystarter + '_new_postcode}', this.service_paragraphs_model.new_postcode)
.replaceAll( '${' + keystarter + '_new_address_full}', this.service_paragraphs_model.new_address_1 +  ' ' + this.service_paragraphs_model.new_address_2 +  ' ' + this.service_paragraphs_model.new_suburb +  ' ' + this.service_paragraphs_model.new_state +  ',  ' + this.service_paragraphs_model.new_postcode )

.replaceAll( '${' + keystarter + '_service_number}', this.service_paragraphs_model.service_number)

.replaceAll( '${' + keystarter + '_service_outcome_name}', this.service_paragraphs_model.subject_service_outcome_name)
.replaceAll( '${' + keystarter + '_exact_service_method_name}', this.service_paragraphs_model.exact_service_method_name) //
.replaceAll( '${' + keystarter + '_subject_type_name}', this.job_subject_type_name) // set in the job lookup.
.replaceAll( '${' + keystarter + '_subject_type_name_upper}', this.job_subject_type_name_Upper) // set in the job lookup.
.replaceAll( '${' + keystarter + '_location_status_name}', this.service_paragraphs_model.subject_location_status_name)
.replaceAll( '${' + keystarter + '_location_status_found_name}', this.service_paragraphs_model.subject_location_status_found_name)

.replaceAll( '${' + keystarter + '_fellow_occupants_name}', this.service_paragraphs_model.fellow_occupants_name)
.replaceAll( '${' + keystarter + '_fellow_occupants_sex}', this.service_paragraphs_model.fellow_occupants_sex)
.replaceAll( '${' + keystarter + '_fellow_occupants_name_label}', 'Fellow Occupants Name: ' +  this.service_paragraphs_model.fellow_occupants_name)
.replaceAll( '${' + keystarter + '_subject_relationship_name}', this.service_paragraphs_model.subject_service_fellow_relationship)

.replaceAll( '${' + keystarter + '_person_spoken_with}', this.service_paragraphs_model.person_spoken_with)
.replaceAll( '${' + keystarter + '_person_type}', this.service_paragraphs_model.person_type)
.replaceAll( '${' + keystarter + '_person_spoken_with_advised}',   this.person_spoken_with_advised_HTML ) 

.replaceAll( '${' + keystarter + '_vehicles}', this.service_paragraphs_model.vehicles)
.replaceAll( '${' + keystarter + '_vehicles_notes}',   this.vehicles_notes_HTML ) // replace original only use this for create.

.replaceAll( '${' + keystarter + '_neighbours}', this.service_paragraphs_model.neighbours)
.replaceAll( '${' + keystarter + '_neighbours_notes}',   this.neighbours_notes_HTML ) // replace original only use this for create.

.replaceAll( '${' + keystarter + '_calling_card}', this.service_paragraphs_model.calling_card)
.replaceAll( '${' + keystarter + '_calling_card_notes}',   this.calling_card_notes_HTML ) // replace original only use this for create.

.replaceAll( '${' + keystarter + '_postal_mail}', this.service_paragraphs_model.postal_mail)
.replaceAll( '${' + keystarter + '_postal_mail_notes}',   this.postal_mail_notes_HTML ) // replace original only use this for create.

.replaceAll( '${' + keystarter + '_phone_call}', this.service_paragraphs_model.phone_call)
.replaceAll( '${' + keystarter + '_phone_call_notes}',   this.phone_call_notes_HTML ) // replace original only use this for create.

.replaceAll( '${' + keystarter + '_attempts}', this.service_paragraphs_model.attempts)
.replaceAll( '${' + keystarter + '_attempts_notes}',   this.attempts_notes_HTML ) // replace original only use this for create.

.replaceAll( '${' + keystarter + '_authorised_employee_name}', this.service_paragraphs_model.authorised_employee_name)
.replaceAll( '${' + keystarter + '_authorised_employee_job_title}', this.service_paragraphs_model.authorised_employee_job_title)
.replaceAll( '${' + keystarter + '_authorised_employee_sex}', this.service_paragraphs_model.authorised_employee_sex)
.replaceAll( '${' + keystarter + '_office_business_name}', this.service_paragraphs_model.office_business_name)

.replaceAll( '${' + keystarter + '_witness_name}', this.service_paragraphs_model.witness_name)
.replaceAll( '${' + keystarter + '_witness_business_name}', this.service_paragraphs_model.witness_business_name)
.replaceAll( '${' + keystarter + '_witness_address}', this.service_paragraphs_model.witness_address_1 + ' ' + this.service_paragraphs_model.witness_address_2 + ' ' +  this.service_paragraphs_model.witness_suburb + ' ' + this.service_paragraphs_model.witness_state + ', ' + this.service_paragraphs_model.witness_postcode  ) // 
.replaceAll( '${' + keystarter + '_witness_address_1}', this.service_paragraphs_model.witness_address_1)
.replaceAll( '${' + keystarter + '_witness_address_2}', this.service_paragraphs_model.witness_address_2)
.replaceAll( '${' + keystarter + '_witness_state}', this.service_paragraphs_model.witness_state)
.replaceAll( '${' + keystarter + '_witness_suburb}', this.service_paragraphs_model.witness_suburb)
.replaceAll( '${' + keystarter + '_witness_country}', this.service_paragraphs_model.witness_country)
.replaceAll( '${' + keystarter + '_witness_postcode}', this.service_paragraphs_model.witness_postcode)

.replaceAll( '${' + keystarter + '_person_in_charge_of_prison_name}', this.service_paragraphs_model.person_in_charge_of_prison_name)
.replaceAll( '${' + keystarter + '_person_in_charge_of_prison_occupation}', this.service_paragraphs_model.person_in_charge_of_prison_occupation)

.replaceAll( '${' + keystarter + '_ubject_contact_email_id}', this.service_paragraphs_model.subject_contact_email_id)
.replaceAll( '${' + keystarter + '_email_address_served}', this.service_paragraphs_model.email_address_served)
.replaceAll( '${' + keystarter + '_email_contents}', this.email_contents_HTML ) // replace original only use this for create.

.replaceAll( '${' + keystarter + '_director_name}', this.service_paragraphs_model.director_name)
.replaceAll( '${' + keystarter + '_service_under_order}', this.service_paragraphs_model.service_under_order)

.replaceAll( '${' + keystarter + '_phone_number}', this.service_paragraphs_model.phone_number)



// Agent Details
.replaceAll( '${' + keystarter + '_agent_name}', this.subject_service_agent.first_name + ' ' + this.subject_service_agent.middle_name + ' ' + this.subject_service_agent.surname )
.replaceAll( '${' + keystarter + '_agent_first_name}', this.subject_service_agent.first_name)
.replaceAll( '${' + keystarter + '_agent_middle_name}', this.subject_service_agent.middle_name)
.replaceAll( '${' + keystarter + '_agent_surname}', this.subject_service_agent.surname)

.replaceAll( '${' + keystarter + '_agent_address_1}', this.subject_service_agent.address_1)
.replaceAll( '${' + keystarter + '_agent_address_2}', this.subject_service_agent.address_2)
.replaceAll( '${' + keystarter + '_agent_suburb}', this.subject_service_agent.suburb)
.replaceAll( '${' + keystarter + '_agent_state}', this.subject_service_agent.state)
.replaceAll( '${' + keystarter + '_agent_postcode}', this.subject_service_agent.postcode)
.replaceAll( '${' + keystarter + '_agent_address_full}', this.subject_service_agent.address_1 + ' ' + this.subject_service_agent.address_2 + ' ' + this.subject_service_agent.suburb + ' ' + this.subject_service_agent.state + ', ' + this.subject_service_agent.postcode )
.replaceAll( '${' + keystarter + '_agent_qualification}', this.subject_service_agent.qualification)
.replaceAll( '${' + keystarter + '_agent_qualification_number}', this.subject_service_agent.qualification_number)

.replaceAll( '${' + keystarter + '_agent_qualification_renewal_date}', moment(this.subject_service_agent.qualification_renewal_date).format('M/D/YYYY') )
.replaceAll( '${' + keystarter + '_agent_qualification_renewal_date_full_words}', moment(this.subject_service_agent.qualification_renewal_date).format('dddd MMMM Do, YYYY h:mma') )

.replaceAll( '${' + keystarter + '_general_notes}',  this.set_general_notes ) // replace original only use this for create.

.replaceAll( '${' + keystarter + '_is_count}', this.service_paragraphs_model.is_count)
.replaceAll( '${' + keystarter + '_property_images}', this.service_paragraphs_model.property_images)
.replaceAll( '${' + keystarter + '_attach_file_array_name}', this.service_paragraphs_model.attach_file_array_name)
.replaceAll( '${' + keystarter + '_property_occupied}', this.service_paragraphs_model.property_occupied)

.replaceAll( '${' + keystarter + '_property_forsale_or_lease_sign}', this.service_paragraphs_model.property_forsale_or_lease_sign)
.replaceAll( '${' + keystarter + '_property_sign_images}', this.service_paragraphs_model.property_sign_images)
.replaceAll( '${' + keystarter + '_property_forsale_or_lease_sign_details}',   this.property_forsale_or_lease_sign_details_HTML) // replace original only use this for create.
.replaceAll( '${' + keystarter + '_property_agent_name}', this.service_paragraphs_model.property_agent_name)
.replaceAll( '${' + keystarter + '_property_agency_name}', this.service_paragraphs_model.property_agency_name)
.replaceAll( '${' + keystarter + '_property_agency_contact_numbers}', this.service_paragraphs_model.property_agency_contact_numbers)


.replaceAll( '${' + keystarter + '_property_mail}', this.service_paragraphs_model.property_mail)
.replaceAll( '${' + keystarter + '_property_mail_images}', this.service_paragraphs_model.property_mail_images)
.replaceAll( '${' + keystarter + '_property_mail_details}', this.property_mail_details_HTML ) // replace original only use this for create.

.replaceAll( '${' + keystarter + '_property_vehicles_sighted}', this.service_paragraphs_model.property_vehicles_sighted)
.replaceAll( '${' + keystarter + '_property_vehicles_sighted_details}', this.property_vehicles_sighted_details_HTML ) // replace original only use this for create.
.replaceAll( '${' + keystarter + '_property_vehicles_images}', this.service_paragraphs_model.property_vehicles_images)
.replaceAll( '${' + keystarter + '_property_v_make}', this.service_paragraphs_model.property_v_make)
.replaceAll( '${' + keystarter + '_property_v_model}', this.service_paragraphs_model.property_v_model)
.replaceAll( '${' + keystarter + '_property_v_plate}', this.service_paragraphs_model.property_v_plate)
.replaceAll( '${' + keystarter + '_property_v_rego_state}', this.service_paragraphs_model.property_v_rego_state)

.replaceAll( '${' + keystarter + '_property_pets}', this.service_paragraphs_model.property_pets)
.replaceAll( '${' + keystarter + '_property_pets_details}', this.property_pets_details_HTML ) // replace original only use this for create.
.replaceAll( '${' + keystarter + '_property_pets_images}', this.service_paragraphs_model.property_pets_images)

.replaceAll( '${' + keystarter + '_property_occupancy}', this.service_paragraphs_model.property_occupancy)
.replaceAll( '${' + keystarter + '_property_occupancy_details}', this.property_occupancy_details_HTML ) // replace original only use this for create.
.replaceAll( '${' + keystarter + '_property_occupancy_images}', this.service_paragraphs_model.property_occupancy_images)
.replaceAll( '${' + keystarter + '_property_o_name}', this.service_paragraphs_model.property_o_name)
.replaceAll( '${' + keystarter + '_property_o_contact_numbers}', this.service_paragraphs_model.property_o_contact_numbers)
.replaceAll( '${' + keystarter + '_property_o_lease_details}', this.service_paragraphs_model.property_o_lease_details)
.replaceAll( '${' + keystarter + '_property_o_lease_date}', this.service_paragraphs_model.property_o_lease_date)
.replaceAll( '${' + keystarter + '_property_o_landlord_contacts}', this.service_paragraphs_model.property_o_landlord_contacts)

.replaceAll( '${' + keystarter + '_property_condition}', this.property_condition_HTML ) // replace original only use this for create.
.replaceAll( '${' + keystarter + '_property_condition_images}', this.service_paragraphs_model.property_condition_images)

.replaceAll( '${' + keystarter + '_property_occupied_details}', this.property_occupied_details_HTML) // replace original only use this for create.

.replaceAll( '${' + keystarter + '_property_type_id}', this.service_paragraphs_model.property_type_id)
.replaceAll( '${' + keystarter + '_property_type_details}', this.set_property_type_details_HTML) // replace original only use this for create.
.replaceAll( '${' + keystarter + '_property_type_images}', this.service_paragraphs_model.property_type_images)

.replaceAll( '${' + keystarter + '_property_type_name}', this.service_paragraphs_model.property_type_name)

.replaceAll( '${' + keystarter + '_service_file_array}', this.service_paragraphs_model.service_file_array)


// Images // <img src="pic_trulli.jpg" alt="Italian Trulli">
// this.service_paragraphs_model.property_images - runs a loop functino above to set image variables
.replaceAll( '${' + keystarter + '_property_image_0}',  this.propery_image_0 )
.replaceAll( '${' + keystarter + '_property_image_1}',  this.propery_image_1 )
.replaceAll( '${' + keystarter + '_property_image_2}',  this.propery_image_2 )
.replaceAll( '${' + keystarter + '_property_image_3}',  this.propery_image_3 )
.replaceAll( '${' + keystarter + '_property_image_4}',  this.propery_image_4 )
.replaceAll( '${' + keystarter + '_property_image_5}',  this.propery_image_5 )
.replaceAll( '${' + keystarter + '_property_image_6}',  this.propery_image_6 )
.replaceAll( '${' + keystarter + '_property_image_7}',  this.propery_image_7 )
.replaceAll( '${' + keystarter + '_property_image_8}',  this.propery_image_8 )
.replaceAll( '${' + keystarter + '_property_image_9}',  this.propery_image_9 )
.replaceAll( '${' + keystarter + '_property_image_10}',  this.propery_image_10 )
.replaceAll( '${' + keystarter + '_property_image_11}',  this.propery_image_11 )
.replaceAll( '${' + keystarter + '_property_image_12}',  this.propery_image_12 )
.replaceAll( '${' + keystarter + '_property_image_13}',  this.propery_image_13 )
.replaceAll( '${' + keystarter + '_property_image_14}',  this.propery_image_14 )
.replaceAll( '${' + keystarter + '_property_image_15}',  this.propery_image_15 )
.replaceAll( '${' + keystarter + '_property_image_16}',  this.propery_image_16 )
.replaceAll( '${' + keystarter + '_property_image_17}',  this.propery_image_17 )
.replaceAll( '${' + keystarter + '_property_image_18}',  this.propery_image_18 )
.replaceAll( '${' + keystarter + '_property_image_19}',  this.propery_image_19 )
.replaceAll( '${' + keystarter + '_property_image_20}',  this.propery_image_20 )
.replaceAll( '${' + keystarter + '_property_image_21}',  this.propery_image_21 )
.replaceAll( '${' + keystarter + '_property_image_22}',  this.propery_image_22 )
.replaceAll( '${' + keystarter + '_property_image_23}',  this.propery_image_23 )
.replaceAll( '${' + keystarter + '_property_image_24}',  this.propery_image_24 )
.replaceAll( '${' + keystarter + '_property_image_25}',  this.propery_image_25 )


.replaceAll( '${' + keystarter + '_property_sign_image_0}',  this.property_sign_image_0 )
.replaceAll( '${' + keystarter + '_property_sign_image_1}',  this.property_sign_image_1 )
.replaceAll( '${' + keystarter + '_property_sign_image_2}',  this.property_sign_image_2 )
.replaceAll( '${' + keystarter + '_property_sign_image_3}',  this.property_sign_image_3 )
.replaceAll( '${' + keystarter + '_property_sign_image_4}',  this.property_sign_image_4 )
.replaceAll( '${' + keystarter + '_property_sign_image_5}',  this.property_sign_image_5 )
.replaceAll( '${' + keystarter + '_property_sign_image_6}',  this.property_sign_image_6 )
.replaceAll( '${' + keystarter + '_property_sign_image_7}',  this.property_sign_image_7 )
.replaceAll( '${' + keystarter + '_property_sign_image_8}',  this.property_sign_image_8 )
.replaceAll( '${' + keystarter + '_property_sign_image_9}',  this.property_sign_image_9 )
.replaceAll( '${' + keystarter + '_property_sign_image_10}',  this.property_sign_image_10 )
.replaceAll( '${' + keystarter + '_property_sign_image_11}',  this.property_sign_image_11 )
.replaceAll( '${' + keystarter + '_property_sign_image_12}',  this.property_sign_image_12 )
.replaceAll( '${' + keystarter + '_property_sign_image_13}',  this.property_sign_image_13 )
.replaceAll( '${' + keystarter + '_property_sign_image_14}',  this.property_sign_image_14 )
.replaceAll( '${' + keystarter + '_property_sign_image_15}',  this.property_sign_image_15 )
.replaceAll( '${' + keystarter + '_property_sign_image_16}',  this.property_sign_image_16 )
.replaceAll( '${' + keystarter + '_property_sign_image_17}',  this.property_sign_image_17 )
.replaceAll( '${' + keystarter + '_property_sign_image_18}',  this.property_sign_image_18 )
.replaceAll( '${' + keystarter + '_property_sign_image_19}',  this.property_sign_image_19 )
.replaceAll( '${' + keystarter + '_property_sign_image_20}',  this.property_sign_image_20 )
.replaceAll( '${' + keystarter + '_property_sign_image_21}',  this.property_sign_image_21 )
.replaceAll( '${' + keystarter + '_property_sign_image_22}',  this.property_sign_image_22 )
.replaceAll( '${' + keystarter + '_property_sign_image_23}',  this.property_sign_image_23 )
.replaceAll( '${' + keystarter + '_property_sign_image_24}',  this.property_sign_image_24 )
.replaceAll( '${' + keystarter + '_property_sign_image_25}',  this.property_sign_image_25 )


.replaceAll( '${' + keystarter + '_property_mail_image_0}',  this.property_mail_image_0 )
.replaceAll( '${' + keystarter + '_property_mail_image_1}',  this.property_mail_image_1 )
.replaceAll( '${' + keystarter + '_property_mail_image_2}',  this.property_mail_image_2 )
.replaceAll( '${' + keystarter + '_property_mail_image_3}',  this.property_mail_image_3 )
.replaceAll( '${' + keystarter + '_property_mail_image_4}',  this.property_mail_image_4 )
.replaceAll( '${' + keystarter + '_property_mail_image_5}',  this.property_mail_image_5 )
.replaceAll( '${' + keystarter + '_property_mail_image_6}',  this.property_mail_image_6 )
.replaceAll( '${' + keystarter + '_property_mail_image_7}',  this.property_mail_image_7 )
.replaceAll( '${' + keystarter + '_property_mail_image_8}',  this.property_mail_image_8 )
.replaceAll( '${' + keystarter + '_property_mail_image_9}',  this.property_mail_image_9 )
.replaceAll( '${' + keystarter + '_property_mail_image_10}',  this.property_mail_image_10 )
.replaceAll( '${' + keystarter + '_property_mail_image_11}',  this.property_mail_image_11 )
.replaceAll( '${' + keystarter + '_property_mail_image_12}',  this.property_mail_image_12 )
.replaceAll( '${' + keystarter + '_property_mail_image_13}',  this.property_mail_image_13 )
.replaceAll( '${' + keystarter + '_property_mail_image_14}',  this.property_mail_image_14 )
.replaceAll( '${' + keystarter + '_property_mail_image_15}',  this.property_mail_image_15 )
.replaceAll( '${' + keystarter + '_property_mail_image_16}',  this.property_mail_image_16 )
.replaceAll( '${' + keystarter + '_property_mail_image_17}',  this.property_mail_image_17 )
.replaceAll( '${' + keystarter + '_property_mail_image_18}',  this.property_mail_image_18 )
.replaceAll( '${' + keystarter + '_property_mail_image_19}',  this.property_mail_image_19 )
.replaceAll( '${' + keystarter + '_property_mail_image_20}',  this.property_mail_image_20 )
.replaceAll( '${' + keystarter + '_property_mail_image_21}',  this.property_mail_image_21 )
.replaceAll( '${' + keystarter + '_property_mail_image_22}',  this.property_mail_image_22 )
.replaceAll( '${' + keystarter + '_property_mail_image_23}',  this.property_mail_image_23 )
.replaceAll( '${' + keystarter + '_property_mail_image_24}',  this.property_mail_image_24 )
.replaceAll( '${' + keystarter + '_property_mail_image_25}',  this.property_mail_image_25 )


.replaceAll( '${' + keystarter + '_property_vehicles_image_0}',  this.property_vehicles_image_0 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_1}',  this.property_vehicles_image_1 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_2}',  this.property_vehicles_image_2 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_3}',  this.property_vehicles_image_3 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_4}',  this.property_vehicles_image_4 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_5}',  this.property_vehicles_image_5 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_6}',  this.property_vehicles_image_6 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_7}',  this.property_vehicles_image_7 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_8}',  this.property_vehicles_image_8 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_9}',  this.property_vehicles_image_9 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_10}',  this.property_vehicles_image_10 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_11}',  this.property_vehicles_image_11 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_12}',  this.property_vehicles_image_12 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_13}',  this.property_vehicles_image_13 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_14}',  this.property_vehicles_image_14 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_15}',  this.property_vehicles_image_15 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_16}',  this.property_vehicles_image_16 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_17}',  this.property_vehicles_image_17 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_18}',  this.property_vehicles_image_18 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_19}',  this.property_vehicles_image_19 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_20}',  this.property_vehicles_image_20 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_21}',  this.property_vehicles_image_21 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_22}',  this.property_vehicles_image_22 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_23}',  this.property_vehicles_image_23 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_24}',  this.property_vehicles_image_24 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_25}',  this.property_vehicles_image_25 )


.replaceAll( '${' + keystarter + '_property_pets_image_0}',  this.property_pets_image_0 )
.replaceAll( '${' + keystarter + '_property_pets_image_1}',  this.property_pets_image_1 )
.replaceAll( '${' + keystarter + '_property_pets_image_2}',  this.property_pets_image_2 )
.replaceAll( '${' + keystarter + '_property_pets_image_3}',  this.property_pets_image_3 )
.replaceAll( '${' + keystarter + '_property_pets_image_4}',  this.property_pets_image_4 )
.replaceAll( '${' + keystarter + '_property_pets_image_5}',  this.property_pets_image_5 )
.replaceAll( '${' + keystarter + '_property_pets_image_6}',  this.property_pets_image_6 )
.replaceAll( '${' + keystarter + '_property_pets_image_7}',  this.property_pets_image_7 )
.replaceAll( '${' + keystarter + '_property_pets_image_8}',  this.property_pets_image_8 )
.replaceAll( '${' + keystarter + '_property_pets_image_9}',  this.property_pets_image_9 )
.replaceAll( '${' + keystarter + '_property_pets_image_10}',  this.property_pets_image_10 )
.replaceAll( '${' + keystarter + '_property_pets_image_11}',  this.property_pets_image_11 )
.replaceAll( '${' + keystarter + '_property_pets_image_12}',  this.property_pets_image_12 )
.replaceAll( '${' + keystarter + '_property_pets_image_13}',  this.property_pets_image_13 )
.replaceAll( '${' + keystarter + '_property_pets_image_14}',  this.property_pets_image_14 )
.replaceAll( '${' + keystarter + '_property_pets_image_15}',  this.property_pets_image_15 )
.replaceAll( '${' + keystarter + '_property_pets_image_16}',  this.property_pets_image_16 )
.replaceAll( '${' + keystarter + '_property_pets_image_17}',  this.property_pets_image_17 )
.replaceAll( '${' + keystarter + '_property_pets_image_18}',  this.property_pets_image_18 )
.replaceAll( '${' + keystarter + '_property_pets_image_19}',  this.property_pets_image_19 )
.replaceAll( '${' + keystarter + '_property_pets_image_20}',  this.property_pets_image_20 )
.replaceAll( '${' + keystarter + '_property_pets_image_21}',  this.property_pets_image_21 )
.replaceAll( '${' + keystarter + '_property_pets_image_22}',  this.property_pets_image_22 )
.replaceAll( '${' + keystarter + '_property_pets_image_23}',  this.property_pets_image_23 )
.replaceAll( '${' + keystarter + '_property_pets_image_24}',  this.property_pets_image_24 )
.replaceAll( '${' + keystarter + '_property_pets_image_25}',  this.property_pets_image_25 )

.replaceAll( '${' + keystarter + '_property_occupancy_image_0}',  this.property_occupancy_image_0 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_1}',  this.property_occupancy_image_1 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_2}',  this.property_occupancy_image_2 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_3}',  this.property_occupancy_image_3 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_4}',  this.property_occupancy_image_4 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_5}',  this.property_occupancy_image_5 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_6}',  this.property_occupancy_image_6 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_7}',  this.property_occupancy_image_7 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_8}',  this.property_occupancy_image_8 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_9}',  this.property_occupancy_image_9 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_10}',  this.property_occupancy_image_10 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_11}',  this.property_occupancy_image_11 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_12}',  this.property_occupancy_image_12 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_13}',  this.property_occupancy_image_13 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_14}',  this.property_occupancy_image_14 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_15}',  this.property_occupancy_image_15 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_16}',  this.property_occupancy_image_16 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_17}',  this.property_occupancy_image_17 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_18}',  this.property_occupancy_image_18 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_19}',  this.property_occupancy_image_19 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_20}',  this.property_occupancy_image_20 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_21}',  this.property_occupancy_image_21 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_22}',  this.property_occupancy_image_22 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_23}',  this.property_occupancy_image_23 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_24}',  this.property_occupancy_image_24 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_25}',  this.property_occupancy_image_25 )

.replaceAll( '${' + keystarter + '_property_condition_image_0}',  this.property_condition_image_0 )
.replaceAll( '${' + keystarter + '_property_condition_image_1}',  this.property_condition_image_1 )
.replaceAll( '${' + keystarter + '_property_condition_image_2}',  this.property_condition_image_2 )
.replaceAll( '${' + keystarter + '_property_condition_image_3}',  this.property_condition_image_3 )
.replaceAll( '${' + keystarter + '_property_condition_image_4}',  this.property_condition_image_4 )
.replaceAll( '${' + keystarter + '_property_condition_image_5}',  this.property_condition_image_5 )
.replaceAll( '${' + keystarter + '_property_condition_image_6}',  this.property_condition_image_6 )
.replaceAll( '${' + keystarter + '_property_condition_image_7}',  this.property_condition_image_7 )
.replaceAll( '${' + keystarter + '_property_condition_image_8}',  this.property_condition_image_8 )
.replaceAll( '${' + keystarter + '_property_condition_image_9}',  this.property_condition_image_9 )
.replaceAll( '${' + keystarter + '_property_condition_image_10}',  this.property_condition_image_10 )
.replaceAll( '${' + keystarter + '_property_condition_image_11}',  this.property_condition_image_11 )
.replaceAll( '${' + keystarter + '_property_condition_image_12}',  this.property_condition_image_12 )
.replaceAll( '${' + keystarter + '_property_condition_image_13}',  this.property_condition_image_13 )
.replaceAll( '${' + keystarter + '_property_condition_image_14}',  this.property_condition_image_14 )
.replaceAll( '${' + keystarter + '_property_condition_image_15}',  this.property_condition_image_15 )
.replaceAll( '${' + keystarter + '_property_condition_image_16}',  this.property_condition_image_16 )
.replaceAll( '${' + keystarter + '_property_condition_image_17}',  this.property_condition_image_17 )
.replaceAll( '${' + keystarter + '_property_condition_image_18}',  this.property_condition_image_18 )
.replaceAll( '${' + keystarter + '_property_condition_image_19}',  this.property_condition_image_19 )
.replaceAll( '${' + keystarter + '_property_condition_image_20}',  this.property_condition_image_20 )
.replaceAll( '${' + keystarter + '_property_condition_image_21}',  this.property_condition_image_21 )
.replaceAll( '${' + keystarter + '_property_condition_image_22}',  this.property_condition_image_22 )
.replaceAll( '${' + keystarter + '_property_condition_image_23}',  this.property_condition_image_23 )
.replaceAll( '${' + keystarter + '_property_condition_image_24}',  this.property_condition_image_24 )
.replaceAll( '${' + keystarter + '_property_condition_image_25}',  this.property_condition_image_25 )

.replaceAll( '${' + keystarter + '_property_type_image_0}',  this.property_type_image_0 )
.replaceAll( '${' + keystarter + '_property_type_image_1}',  this.property_type_image_1 )
.replaceAll( '${' + keystarter + '_property_type_image_2}',  this.property_type_image_2 )
.replaceAll( '${' + keystarter + '_property_type_image_3}',  this.property_type_image_3 )
.replaceAll( '${' + keystarter + '_property_type_image_4}',  this.property_type_image_4 )
.replaceAll( '${' + keystarter + '_property_type_image_5}',  this.property_type_image_5 )
.replaceAll( '${' + keystarter + '_property_type_image_6}',  this.property_type_image_6 )
.replaceAll( '${' + keystarter + '_property_type_image_7}',  this.property_type_image_7 )
.replaceAll( '${' + keystarter + '_property_type_image_8}',  this.property_type_image_8 )
.replaceAll( '${' + keystarter + '_property_type_image_9}',  this.property_type_image_9 )
.replaceAll( '${' + keystarter + '_property_type_image_10}',  this.property_type_image_10 )
.replaceAll( '${' + keystarter + '_property_type_image_11}',  this.property_type_image_11 )
.replaceAll( '${' + keystarter + '_property_type_image_12}',  this.property_type_image_12 )
.replaceAll( '${' + keystarter + '_property_type_image_13}',  this.property_type_image_13 )
.replaceAll( '${' + keystarter + '_property_type_image_14}',  this.property_type_image_14 )
.replaceAll( '${' + keystarter + '_property_type_image_15}',  this.property_type_image_15 )
.replaceAll( '${' + keystarter + '_property_type_image_16}',  this.property_type_image_16 )
.replaceAll( '${' + keystarter + '_property_type_image_17}',  this.property_type_image_17 )
.replaceAll( '${' + keystarter + '_property_type_image_18}',  this.property_type_image_18 )
.replaceAll( '${' + keystarter + '_property_type_image_19}',  this.property_type_image_19 )
.replaceAll( '${' + keystarter + '_property_type_image_20}',  this.property_type_image_20 )
.replaceAll( '${' + keystarter + '_property_type_image_21}',  this.property_type_image_21 )
.replaceAll( '${' + keystarter + '_property_type_image_22}',  this.property_type_image_22 )
.replaceAll( '${' + keystarter + '_property_type_image_23}',  this.property_type_image_23 )
.replaceAll( '${' + keystarter + '_property_type_image_24}',  this.property_type_image_24 )
.replaceAll( '${' + keystarter + '_property_type_image_25}',  this.property_type_image_25 )

.replaceAll( '${' + keystarter + '_service_file_array_image_0}',  this.service_file_array_image_0 )
.replaceAll( '${' + keystarter + '_service_file_array_image_1}',  this.service_file_array_image_1 )
.replaceAll( '${' + keystarter + '_service_file_array_image_2}',  this.service_file_array_image_2 )
.replaceAll( '${' + keystarter + '_service_file_array_image_3}',  this.service_file_array_image_3 )
.replaceAll( '${' + keystarter + '_service_file_array_image_4}',  this.service_file_array_image_4 )
.replaceAll( '${' + keystarter + '_service_file_array_image_5}',  this.service_file_array_image_5 )
.replaceAll( '${' + keystarter + '_service_file_array_image_6}',  this.service_file_array_image_6 )
.replaceAll( '${' + keystarter + '_service_file_array_image_7}',  this.service_file_array_image_7 )
.replaceAll( '${' + keystarter + '_service_file_array_image_8}',  this.service_file_array_image_8 )
.replaceAll( '${' + keystarter + '_service_file_array_image_9}',  this.service_file_array_image_9 )
.replaceAll( '${' + keystarter + '_service_file_array_image_10}',  this.service_file_array_image_10 )
.replaceAll( '${' + keystarter + '_service_file_array_image_11}',  this.service_file_array_image_11 )
.replaceAll( '${' + keystarter + '_service_file_array_image_12}',  this.service_file_array_image_12 )
.replaceAll( '${' + keystarter + '_service_file_array_image_13}',  this.service_file_array_image_13 )
.replaceAll( '${' + keystarter + '_service_file_array_image_14}',  this.service_file_array_image_14 )
.replaceAll( '${' + keystarter + '_service_file_array_image_15}',  this.service_file_array_image_15 )
.replaceAll( '${' + keystarter + '_service_file_array_image_16}',  this.service_file_array_image_16 )
.replaceAll( '${' + keystarter + '_service_file_array_image_17}',  this.service_file_array_image_17 )
.replaceAll( '${' + keystarter + '_service_file_array_image_18}',  this.service_file_array_image_18 )
.replaceAll( '${' + keystarter + '_service_file_array_image_19}',  this.service_file_array_image_19 )
.replaceAll( '${' + keystarter + '_service_file_array_image_20}',  this.service_file_array_image_20 )
.replaceAll( '${' + keystarter + '_service_file_array_image_21}',  this.service_file_array_image_21 )
.replaceAll( '${' + keystarter + '_service_file_array_image_22}',  this.service_file_array_image_22 )
.replaceAll( '${' + keystarter + '_service_file_array_image_23}',  this.service_file_array_image_23 )
.replaceAll( '${' + keystarter + '_service_file_array_image_24}',  this.service_file_array_image_24 )
.replaceAll( '${' + keystarter + '_service_file_array_image_25}',  this.service_file_array_image_25 )



// hide anything null or undefined.
.replaceAll('${undefined}', '')
.replaceAll('${null}', '')
.replaceAll('undefined', '') // makes all undefined print empty
.replaceAll('null', '') // makes all undefined print empty
.replaceAll('Invalid date', '') // makes all undefined print empty


// model.email_template_primary_HTML_rendered
// email_subject_primary_rendered


// Convert the results to a form field value.
// model.email_template_primary_HTML_rendered = rendered_result;
return rendered_result;

}




    getJobServiceRule_Q(job_service_rule_id) {
      this._demoService.getJobServiceRule(job_service_rule_id).subscribe(
         data => { this.job_service_rule_paragraphs = data; 
          let res = data[0];
          if (job_service_rule_id <= 0 ){
            this.selected_job_service_rule_description = 'Not Applicable';
          };
          if (job_service_rule_id >= 1 ){
          this.selected_job_service_rule_description = res.job_service_rule_description;
          }
        },
         err => console.error(err),
         // () => console.log('done loading Trace Types')
       );
     }


     getJobServiceTimeframe_Q(job_service_timeframe_id) {
      this._demoService.getJobServiceTimeframe(job_service_timeframe_id).subscribe(
         data => { this.job_service_timeframe_paragraphs = data; 
          let res = data[0];
          // if (job_service_timeframe_id <= 0 ){
          //   this.selected_job_service_timeframe_description = 'Not Applicable';
          // };
          // this.selected_job_service_timeframe_description = res.job_service_rule_time_frame_text;
        },
         err => console.error(err),
         // () => console.log('done loading Trace Types')
       );
     }

     getSubjectServiceType_model_Q(subject_service_type_id) {
      this._demoService.getSubjectServiceType(subject_service_type_id).subscribe(
         data => { 
          this.subject_service_type_model_paragraphs = data;
          // let res = data[0];
          // if ( subject_service_type_id <= 0 ){
          //   this.selected_subject_service_type_description = 'Please Set to default Individual Above';
          //   this.selected_subject_service_type_description = '';
          //   this.selected_subject_service_type_instructions = '';
          //   this.selected_subject_service_type_staff_instructions = '';
    
          // } 
          // this.selected_subject_service_type_description = res.subject_service_type_description;
          // this.selected_subject_service_type_instructions = res.subject_service_type_instructions;
          // this.selected_subject_service_type_staff_instructions = res.subject_service_type_staff_instructions;
    
          // // initiate the change of service rule if different or select from drop down.
          // if (subject_service_type_id > 1) {
          // this.setJobServiceRule(res.job_service_rule_id_change_to);
          // this.getJobServiceRule(res.job_service_rule_id_change_to); // sets the descruption information on change.
          // }
    
        },
         err => console.error(err),
         // () => console.log('done loading Trace Types')
       );
     }



     getSubjectContactNumbers_Q(subject_id) {
      this._demoService.getSubjectContactNumbers(subject_id)
      .pipe(
        this.toastr.observe({
          loading: 'Checking...',
          success: '6 🚀..',
          error: '...😡 '
       })
       )
      .subscribe(
         data => { this.subject_contact_numbers_paragraphs = data;
        
          let count_of_items = this.subject_contact_numbers_paragraphs.length
          let c = 0; // count
          this.subject_contact_numbers = '';
          while (c < count_of_items) {
            this.subject_contact_numbers += this.subject_contact_numbers_paragraphs[c].subject_contact_phone_number + ', '
            c++;
          }
  
  
        },
         err => console.error(err),
          () => {
            // console.log('done loading SCN');
                        }
            );
     }
  
  
  
     getSubjectContactEmails_Q(subject_id) {
      this._demoService.getSubjectContactEmails(subject_id)
      .pipe(
        this.toastr.observe({
          loading: 'Checking...',
          success: '7 🚀..',
          error: '...😡 '
       })
       )
      .subscribe(
         data => { this.subject_contact_emails_paragraphs = data; 
          let count_of_items = this.subject_contact_emails_paragraphs.length
          let c = 0; // count
          this.subject_contact_emails = '';
          while (c < count_of_items) {
            this.subject_contact_emails += this.subject_contact_emails_paragraphs[c].subject_contact_email_address + ', '
            c++;
          }
        
        },
         err => console.error(err),
          () => {
            // console.log('done loading SR');
                        }
            );
     }
    


    getSubjectAgentBrandsAssigned_Q(subject_id) {
      this.assignedBrandList_paragraphs = null; // clear first to ensure getting correct agent.
      this._demoService.getSubjectAgentBrandsAssigned(subject_id)
      .pipe(
        this.toastr.observe({
          loading: 'Checking...',
          success: '🚀.. loaded assignedBrandList_paragraphs',
          error: '...😡 assignedBrandList_paragraphs FAILED...' + subject_id
       })
       )
      .subscribe(
        (data) => {
        this.assignedBrandList_paragraphs = data;
  console.log(this.assignedBrandList_paragraphs)
  
          // this.allEmailRecipients = data;
this.toastr.success('assignedBrandList_paragraphs looded')
  
          // let newArr = data
          // let  count_of_items = Object.keys(newArr).length;
          //   // need to do a loop of subject_billing items (.length)
          //   for (let i = 0; i < count_of_items; i++) {
          //   let res = newArr[i];
          //   this.allRecipients.push({
          //     recipient_name: res.name + ' - Agent',
          //     recipient_email_address: res.email,
          //     recipient_brand_id: res.brand_id,
          //     recipient_brand_type_id: res.brand_type_id,
          //     recipient_user_id: null,
          //     recipient_user_level_id: null,
          //     recipient_type_name: 'Agent',
          //   });
          //   } // end for loop
          // this.allRecipients = this.allRecipients; // ?? this may be causing errors.
  
  
        },
        (err) => console.error(err),
        // () => console.log('Loaded Assigned Agents Loaded.')
      );
    }
   


    
// gets the list of users assiciated for drop down.
getSubjectAttemptsAll_Q(subject_id) {
  this._demoService.getSubjectServiceAll(subject_id)
  .pipe(
    this.toastr.observe({
      loading: 'Checking...',
      success: '8 🚀..',
      error: '...😡 '
   })
   )
  .subscribe(
     data => { 
      this.subject_service_list_paragraphs = data;
      this.attempts_paragraphs_model = data[0] // single record

      if(this.attempts_paragraphs_model != '[]' && this.attempts_paragraphs_model != null && this.attempts_paragraphs_model != '' ){
        this.getBrand_Q(this.attempts_paragraphs_model.who_service_id);
       }

    },
     err => console.error(err),
     () => console.log('Candidates Loaded.')
   );
 }


 // gets the list of users assiciated for drop down.
getSubjectServicesOnly_Q(subject_id) {
  this._demoService.getSubjectServicesOnly(subject_id)
  .pipe(
    this.toastr.observe({
      loading: 'Checking...',
      success: '9 🚀..',
      error: '...😡 '
   })
   )
  .subscribe(
     data => { 
      // this.subject_service_list_paragraphs = data;
      this.service_paragraphs_model = data[0] // single record

      if(this.service_paragraphs_model != '[]'  && this.service_paragraphs_model != null && this.service_paragraphs_model != '' ){
        this.getBrand_Q(this.service_paragraphs_model.who_service_id);
       }

    },
     err => console.error(err),
     () => console.log('Candidates Loaded.')
   );
 }



     // Look up Subject Service Agent
     getBrand_Q(brand_id) {
      this._demoService.getBrandById(brand_id).subscribe(
        (data) => {
          // this.brand_data = data;
  
          let res = data[0];
          // this.subject_service_agent = DataUtil.parse.parseJson(res);
          this.subject_service_agent = data[0];
          // this.allClientEmailRecipients = data;
  
this.toastr.success('Subject Service Agent Details Q')

          // let newArr = data
          // let  count_of_items = Object.keys(newArr).length;
          //   // need to do a loop of subject_billing items (.length)
          //   for (let i = 0; i < count_of_items; i++) {
          //   let res = newArr[i];
          //   this.allRecipients.push({
          //     recipient_name: res.name + ' - Client Report',
          //     recipient_email_address: res.email,
          //     recipient_brand_id: res.brand_id,
          //     recipient_brand_type_id: res.brand_type_id,
          //     recipient_user_id: null,
          //     recipient_user_level_id: null,
          //     recipient_type_name: 'Client Report',
          //   });
          //   } // end for loop
          // this.allRecipients = this.allRecipients; // ?? this may be causing errors.
  
        },
        (err) => console.error(err),
        () => console.log('Brand Loaded.')
      );
    }





// Job Variables.
getJobTypeLocations_Q(job_type_id) {
  this._demoService.getJobTypeLocations(job_type_id).subscribe(
    (data) => {
      this.job_type_locations_paragraphs = data;
    },
    (err) => console.error(err)
    // () => console.log('done loading Trace Types')
  );
}

getJobTypeLocation_Q(job_type_location_id) {
  this._demoService.getJobTypeLocation(job_type_location_id).subscribe(
    (data) => {
      this.job_type_location_paragraphs = data;
      // this.toastr.success('Locations loaded')
    },
    (err) => console.error(err)
    // () => console.log('done loading Trace Types')
  );
}


getJobType_Q(job_type_id) {
  this._demoService.getJobType(job_type_id).subscribe(
    (data) => {
      this.job_type_paragraphs = data;
    },
    (err) => console.error(err)
    // () => console.log('done loading Trace Types')
  );
}

getJobTypeCourts_Q(job_type_location_id) {
  this._demoService.getJobTypeCourts(job_type_location_id).subscribe(
    (data) => {
      this.job_type_courts_paragraphs = data;
    },
    (err) => console.error(err)
    // () => console.log('done loading Trace Types')
  );
}



getJobTypeCourt_Q(job_type_court_id) {
  this._demoService.getJobTypeCourt(job_type_court_id).subscribe(
    (data) => {
      this.job_type_court_paragraphs = data;
    },
    (err) => console.error(err)
    // () => console.log('done loading Trace Types')
  );
}



getJobTypeDocumentType_Q(job_type_document_type_id) {
  this._demoService.getJobTypeDocumentType(job_type_document_type_id).subscribe(
    (data) => {
      this.job_type_document_type_paragraphs = data;
    },
    (err) => console.error(err)
    // () => console.log('done loading Trace Types')
  );
}




getJobTypeAffidavitType_Q(job_type_affidavit_type_id) {
  this._demoService
    .getJobTypeAffidavit(job_type_affidavit_type_id)
    .subscribe(
      (data) => {
        this.job_type_affidavit_type_paragraphs = data;
      },
      (err) => console.error(err)
      // () => console.log('done loading Trace Types')
    );
}


getJobReportUserContact_Q(brand_report_user_id) {
  this._demoService.getUsersById(brand_report_user_id)
  .pipe(
    this.toastr.observe({
      loading: 'Checking...',
      success: ' 🚀.. loaded job_report_client_user_paragraphs',
      error: '...😡 '
   })
   )
  .subscribe(
     data => { 
          this.job_report_client_user_paragraphs = data;


    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }


 getCurrentUser_Q(user_id) {
  this._demoService.getUsersById(user_id)
  .pipe(
    this.toastr.observe({
      loading: 'Checking...',
      success: '4 🚀..',
      error: '...😡 '
   })
   )
  .subscribe(
     data => { 
          this.current_user_paragraphs = data;


    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }

 getJob_and_brands_Q(job_id, model) {
  this._demoService.getJobID(job_id)
  .pipe(
    this.toastr.observe({
      loading: 'Checking...',
      success: '10 🚀.. loaded job_data_paragraphs',
      error: '...😡 job_data_paragraphs FAILED...' + model.subject_number
   })
   )
  .subscribe(
    (data) => {
      // this.job_data = data;
      let res = data[0];
      this.job_data_paragraphs = DataUtil.parse.parseJson(data);
      this.toastr.success('Job Data Loaded For Vars')

           // Brand Report User -- for the merge variables.
           this.getBrand(res.brand_report_id);
           this.getBrand_invoice_Q(res.brand_invoice_id)
           this.getBrand_owner_Q(97);
            this.getCurrentUser_Q(this.gfunc.sessionUserId)
           this.getUserBrand_Q(res.brand_report_user_id)
            this.getJobReportUserContact_Q(res.brand_report_user_id)

      // this.job_data_paragraphs = data;
      // if (job_service_timeframe_id <= 0 ){
      //   this.selected_job_service_timeframe_description = 'Not Applicable';
      // };
      // this.selected_job_service_timeframe_description = res.job_service_rule_time_frame_text;
    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }


 // Subject Type Name Lookup
getJobSubjectType_Q(job_subject_type_id) {
  this._demoService.getJobSubjectType(job_subject_type_id).subscribe(
     data => { 
      let res = data[0]
      this.job_subject_type = data;
      this.subject_job_subject_type = DataUtil.parse.parseJson(res);
  
    
    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
  }


  getBrand_report_Q(brand_id) {
    this._demoService.getBrandById(brand_id).subscribe(
      (data) => {
        // this.brand_data = data;

        let res = data[0];
        this.job_report_client = DataUtil.parse.parseJson(data);
        // this.allClientEmailRecipients = data;

        // let newArr = data
        // let  count_of_items = Object.keys(newArr).length;
        //   // need to do a loop of subject_billing items (.length)
        //   for (let i = 0; i < count_of_items; i++) {
        //   let res = newArr[i];
        //   this.allRecipients.push({
        //     recipient_name: res.name + ' - Client Report',
        //     recipient_email_address: res.email,
        //     recipient_brand_id: res.brand_id,
        //     recipient_brand_type_id: res.brand_type_id,
        //     recipient_user_id: null,
        //     recipient_user_level_id: null,
        //     recipient_type_name: 'Client Report',
        //   });
        //   } // end for loop
        // this.allRecipients = this.allRecipients; // ?? this may be causing errors.

      },
      (err) => console.error(err),
      () => console.log('Brand report Client Loaded.')
    );
  }

  private getBrand(brand_id) {
    this._demoService.getBrandById(brand_id)
    .pipe(
      this.toastr.observe({
        loading: 'Checking...',
        success: '1 🚀..',
        error: '...😡 '
     })
     )
    .subscribe(
      (data) => {
        this.brand_data = data;
        // this.job_data_paragraphs = data; // set here for the variables/paragraphs

        this.allClientEmailRecipients = data;

        // let newArr = data
        // let  count_of_items = Object.keys(newArr).length;
        //   // need to do a loop of subject_billing items (.length)
        //   for (let i = 0; i < count_of_items; i++) {
        //   let res = newArr[i];
        //   this.allRecipients.push({
        //     recipient_name: res.name + ' - Client Report',
        //     recipient_email_address: res.email,
        //     recipient_brand_id: res.brand_id,
        //     recipient_brand_type_id: res.brand_type_id,
        //     recipient_user_id: null,
        //     recipient_user_level_id: null,
        //     recipient_type_name: 'Client Report',
        //   });
        //   } // end for loop
        // this.allRecipients = this.allRecipients; // ?? this may be causing errors.

      },
      (err) => console.error(err),
      () => console.log('Brand Loaded.')
    );
  }

  private getBrandAccount(brand_id) {
    this._demoService.getBrandById(brand_id).subscribe(
      (data) => {
        this.brand_account_data = data;

        this.allClientInvoiceEmailRecipients = data;


        // let newArr = data
        // let  count_of_items = Object.keys(newArr).length;
        //   // need to do a loop of subject_billing items (.length)
        //   for (let i = 0; i < count_of_items; i++) {
        //   let res = newArr[i];
        //   this.allRecipients.push({
        //     recipient_name: res.name + ' - Client Accounts',
        //     recipient_email_address: res.email,
        //     recipient_brand_id: res.brand_id,
        //     recipient_brand_type_id: res.brand_type_id,
        //     recipient_user_id: null,
        //     recipient_user_level_id: null,
        //     recipient_type_name: 'Client Accounts',
        //   });
        //   } // end for loop
        // this.allRecipients = this.allRecipients; // ?? this may be causing errors.


      },
      (err) => console.error(err),
      () => console.log('Brand Loaded.')
    );
  }

  getBrand_invoice_Q(brand_id) {
    this._demoService.getBrandById(brand_id)
    .pipe(
      this.toastr.observe({
        loading: 'Checking...',
        success: '2 🚀..',
        error: '...😡 '
     })
     )
    .subscribe(
      (data) => {
        // this.brand_data = data;

        let res = data[0];
        // this.job_invoice_client_paragraphs = DataUtil.parse.parseJson(data);
        this.job_invoice_client_paragraphs = data;

      },
      (err) => console.error(err),
      () => console.log('Brand Invoice Loaded.')
    );
  }

  getBrand_owner_Q(brand_id) {
    this._demoService.getBrandById(brand_id)
    .pipe(
      this.toastr.observe({
        loading: 'Checking...',
        success: '3 🚀..',
        error: '...😡 '
     })
     )
    .subscribe(
      (data) => {
        // this.brand_data = data;

        let res = data[0];
        this.job_owner_client_paragraphs = DataUtil.parse.parseJson(data);

      },
      (err) => console.error(err),
      () => console.log('Brand Owner Loaded.')
    );
  }


  getUserBrand_Q(brand_id) {
    this._demoService.getBrandById(brand_id).subscribe(
      (data) => {
        // this.brand_data = data;

        let res = data[0];
        this.user_brand_paragraphs = DataUtil.parse.parseJson(data);

      },
      (err) => console.error(err),
      () => console.log('Brand Owner Loaded.')
    );
  }



// Start of Javascript Ordinaals -- First Second third etc - only goes to 10 so far
// :: @https://stackoverflow.com/questions/15998005/ordinals-in-words-javascript
ordinalInWord( cardinal ) {
  var ordinals = [ 'Zeroth', 'First', 'Second', 'Third', 'Fourth', 'Fifth', 'Sixth', 'Seventh', 'Eighth', 'Nineth', 'Tenth' /* and so on up to "twentieth" */ ];
  var tens = {
      20: 'twenty',
      30: 'thirty',
      40: 'forty' /* and so on up to 90 */
  };
  var ordinalTens = {
      30: 'thirtieth',
      40: 'fortieth',
      50: 'fiftieth' /* and so on */
  };

  if( cardinal <= 20 ) {                    
      return ordinals[ cardinal ];
  }

  if( cardinal % 10 === 0 ) {
      return ordinalTens[ cardinal ];
  }

  return tens[ cardinal - ( cardinal % 10 ) ] + ordinals[ cardinal % 10 ];
}

// end of Javascript Ordinals



myFunctionShowHideMe(subject_id) {
  var x = document.getElementById("myDIV" + subject_id);
  if (x.style.display === "none") {
    x.style.display = "block";
  } else {
    x.style.display = "none";
  }
}


myFunctionShowHideUpdates(subject_id) {
  var x = document.getElementById("Updates" + subject_id);
  if (x.style.display === "none") {
    x.style.display = "block";
  } else {
    x.style.display = "none";
  }
}


myFunctionShowHideAny(subject_id, div_id_starter) {
  var x = document.getElementById(div_id_starter + subject_id);
  if (x.style.display === "none") {
    x.style.display = "block";
  } else {
    x.style.display = "none";
  }
}

myFunctionShowHideMe2() {
  var x = document.getElementById("myDIV" );
  if (x.style.display === "none") {
    x.style.display = "block";
  } else {
    x.style.display = "none";
  }
}


private getJobStatusNames() {
  this._demoService.getJobStatusNames()
    .subscribe(
      res => {
        this.job_status_run = res
        this.job_status_data = res
      },
      err => console.error(err.status)
    );
}


getBrandsComboBoxClients(combo_model) {
  this.combo_model.brand_type_id = 2;
 this._demoService.getBrandsComboBox(combo_model).subscribe(
    data => { this.brands_client = data; },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
}

getBrandsComboBoxAgents(combo_model) {
  this.combo_model.brand_type_id = 3;
 this._demoService.getBrandsComboBox(combo_model).subscribe(
    data => { this.brands_agent = data; },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
}



 // drop down action
 sendBrandID(brand_report_id) {
  this.sent_brand_id = brand_report_id;
 
  // reset the form field first.
  // this.model.brand_report_user_id = '';
  // this.brand_users = '';
      // empty the array incase there are no users to prevent prev selection
      this.brand_users = null;
 
  if(brand_report_id >= 1) {
 // this.getBrandUsers(brand_report_id); // updates the selected brand_ ID....
 this._demoService.getBrandUsersByLevel(brand_report_id, 9).subscribe(
   data => { this.brand_users = data;
 
 
     this.brand_users_data = data;
 
 
     let res = data[0];
  },
   err =>  console.error(err),
   // () => console.log('done loading Trace Types')
 );


 // this.model.brand_report_id = brand_report_id;
// need to look up what brands notes are and send to jon notes.
 // console.log('sending Brand ID:' + this.sent_brand_id);
// lookup brand
// set this.model.special_instuctions.
this.getBrandById_instructions(this.sent_brand_id); // sets the model special instuctions in function
 }


}
 
getBrandById_instructions(brand_id){
  this._demoService.getBrandById(brand_id)
  .subscribe(
    res => {this.brand_report_selected = res;
      this.selected_brand_data = res[0];
     this.new_special_instuctions = this.selected_brand_data.brand_notes;
     this.model.special_instructions = this.new_special_instuctions;
     this.model.special_instructions_HTML = this.new_special_instuctions;
     // console.log('instuctions: ' + this.new_special_instuctions);
   
    },
    err => console.error(err.status)
  );
 }

//  private getJobStatusNames() {
//   this._demoService.getJobStatusNames()
//     .subscribe(
//       res => this.job_status = res,
//       err => console.error(err.status)
//     );
// }



sortComparer(reference: string, comparer: string) { 
  // This will be triggered for comparing each value with the reference value 
  // This can be customized to compare the values as per your need and return the corresponding result 

  let r: number = +reference
  let c: number = +comparer
  
  if (r < c) { 
    // console.log('reference ' + reference)  
    // console.log('comparer ' + comparer)  
    return -1; 
      
  } 
  if (r > c) { 
    // console.log('reference gtr ' + reference)  
    // console.log('comparer grt' + comparer)  
      return 1; 
  } 
  //was 0
  return 0; 
} 



getTimeframeSurcharges() {
  this._demoService.getTimeframeSurcharges().subscribe(
     data => { this.timeframe_surcharges = data;  },
     err => console.error(err),
      () => {
        // console.log('done loading Subject Service Types')
       // this.collection = Array (this.job_types, this.job_type_locations); // collection of all data
       // let mappedJSON = JSON.parse(mapped);
       // console.log('Mapped JSON Array: ' + mappedJSON);
      }
        );
 }





    // New functino to test 
    getReportSubjectsUrgentTimeframeSendCSVExport(search_model){
      this.brand_user_join_results = [];
        this.subjects_urgent = [];
        this.grid.searchSettings.key = ''; // resets the grid filters and buttons
        
      //  search_model.brand_type_id = 2;
      //  search_model.access_level = 9;
        const normalizedSearchModel = this.normalizeLegalSearchModel(search_model);
         
        
        this._demoService.getReportSubjectsUrgentTimeframeSendCSVExport(normalizedSearchModel).subscribe(
            data => { this.brand_search = data;
              // pass so that the dates are correct in Sync
              // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
              this.brand_search_results = DataUtil.parse.parseJson(data); 
        // get the users as well and join the records together
     
        // Run this function and use the same json object and keep adding or removing to it if you wish.
        //    this.getReportUsersSearch(search_model);
        
        // now how to join two arrays of objects.
        // maybe pass results in to a new model.
        
        // Count items of brand search to loop through
        let  count_of_brand_items = Object.keys(this.brand_search).length;
        // now loop and push to join model
        for(let i=0;i < count_of_brand_items; i++) {
          let res = this.brand_search_results[i];
        
            // push to holding list of invoice items, all current subject_billing_items. (no filtering as yet.)
            this.brand_user_join_results.push({
              email_address: res.email,
              first_name: res.name,
              surname: res.surname,
              company_name: res.name,
              created: res.created,
                    });

this.subjects_urgent.push({
  // email_address: res.email,
  // first_name: res.name,
  // surname: res.surname,
  // company_name: res.name,
  // created: res.created,
  ...this.brand_search_results[i]
        });

        
        } // end brands loop.
        
        this.brand_user_join_results = this.brand_user_join_results;
        this.subjects_urgent = this.applyLegalGridDateFields(this.subjects_urgent);
        this.subjects_urgent = this.subjects_urgent;
        
             this.grid.refresh();
            },
            error => {
            console.error('Error Loading !' + error.error);
            console.log(error);
            // return Observable.throw(error);
            }
      
          ); }





}
